import axios from 'axios'
import { Logic } from '../Type'
import { Main } from '../Main'
import { RouterObjects } from '../RouterObjects'
import * as Assets from '../../Views/Assets'
import * as Assets_ from '../../Views/Assets_'
import * as Config from '../Config'
import {
    isUserOperator, isUserSiteOwner, isUserSystem, isUserMaster, isUserContractualPartner, utilsTimeValidEmptyNotValid,
    isUserSubEntity, DateAddZeros, numberWithCommas, capitalizeFirstLetter, injectSpaces, IsBuildDefault, IsBuildPasino,
    IsBuildOdds, IsBuildScandibet, IsBuildMyChance, IsBuildOddyzzey, IsBuildTrekronor, IsBuildBettoday, isPureScandibet, IsBuildJackpotsCH, isProduction, getIssueTypes
} from '../Utils'
import * as TableUtils from '../../Views/Reusables/TableUtils'
import { Tournaments2Presentation } from '../../Views/Main/PromoStore/Tournaments'
import Socket1 from '../../Socket/socket-init'
import Socket2 from 'src/Socket/socket-init2'
import * as RouteClasses from '../../Socket/route-classes'
import * as Rewards from '../../Views/Main/PromoStore/Rewards'
import * as Missions from '../../Views/Main/PromoStore/Missions'
import * as TournamentsOddyzzey from '../../Views/Main/PromoStore/TournamentsOddyzzey'
import * as Levels from '../../Views/Main/PromoStore/Levels'
import * as Challenges from '../../Views/Main/PromoStore/Challenges'
import * as Store from '../../Views/Main/PromoStore/Store'
import * as moment from 'moment'
import {
    GamesList, UsersNew, IPlayers, IPlayerGroup, PaymentProcessed, ICommunicationUpdate, /*BonusCampaign,*/ Latest, Jurisdiction, /*Bonus,*/ Player, Raffle, RaffleParticipants, IIssue, AccountStatus, LargeValueDepositsWithdrawal, TemporaryAccountStatus, NoPlayerActivityStatus, Blacklist, MaximumBalance, Retail, RetailAction/*, Notify*/, SAGifts, SACriteria, SAQuestions, NetLimitLossIncreased, NetLimitLossRegistration, TemporaryExclude, TemporaryExcludeOptions, DashboardBackend, SelfExclusion, RecentEventsTypes, IReports, PostalCodes, IIssueInsertAdmin,/*, GameProvider, RgsGameSupplierNew*/
    IssueTypes, /*Games,*/ Option, Point, /*GamesCentralNew,RgsGameSupplierNew GameProviderNew,*/ Casinogame/*, Tag, SCategory*/, GamesListCategory, TransactionStatus, /*WithdrawalRequest, IWithdrawalEvent, WithdrawalHistory, TransactionStatusIndex, BonusDataWageringRequirement, ITransactionFilters*/ IAccountInfo, IIssuesFilters/*, DashboardBackendOptionsDates*/, IBonusWageringRequirement, TimelineEntrySubType, IGeneral, Tournament, TimelineEntryType/*, UsersNew, TransactionStatusNoPending*/, TransactionType, WithdrawalRequest, PaymentProcessedStatus, IUserInfo, IProvisionalOrActive, BonusNew, BonusCampaignNew, FreeGame
} from '../Database/DatabaseData'
import { PlayerCardButtons } from '../RiskComplianceStore/RiskManagement'
import { dashboardSmallTableRows, FourIssues } from '../../Views/Main/MainDashboard/Dashboard'
// import { clearFields as bonusClearFields } from '../../Views/Main/GameStore/Bonus'
// import { clearFields as bonusCampaignClearFields } from '../../Views/Main/GameStore/BonusCampaign'
// import { clearFields as gameProviderClearFields } from '../../Views/Main/GameStore/GameProvidersNew';
// import { clearFields as rgsGameSupplierClearFields } from '../../Views/Main/GameStore/RgsGameSuppliersNew';
import { download } from '../../Views/Main/MainDashboard/Latest'
import { populateRealData } from '../../Views/Main/DataStore/PlayerGroups'
import { IMissionDefinition2 } from './missions/missionModelsNew'
import { ILevelDefinition } from './levels/levelsModelsNew'
import { RewardTypes } from './rewards/rewardsEnums'
import { setLog } from '../../Views/Main/UserManagement/Log'
import Cookies from 'js-cookie'
import * as base64 from 'base-64'
// import {InitializeGamesCentralFiltered} from '../../Views/Main/GameStore/FileExport'
import {setGames} from '../../Views/Main/GameStore/GameListCmsExport'
import * as OddsData from '../OddsStore/OddsState'
import { getPlayerTimeline as GetPlayerTimeline } from '../../Views/Main/PlayerManagement/PlayerCard'
import { setCentralGames } from 'src/Views/Main/GameStore/GameList'
import { setInitialValues as BonusSetInitialValues} from '../../Views/Main/BonusStore/BonusNew'
import { setInitialValues as CampaignSetInitialValues} from '../../Views/Main/BonusStore/BonusCampaignNew'

// import {getStream} from '../../Logic/Database/getStream'
// import {/*onEnd, onEnd2, onProgress, onProgress2, onError, onError2, */onProgress3, onEnd3, onError3} from '../../Views/SideBar/SideBar'
export function checkVeto(playerId: string) {
    Socket1.socket.Send(Config.amManualCheckBlacklist, { playerId })
    getLoadedResources('Socket1 - Send', Config.amManualCheckBlacklist)
}

export function getTransactionHistory(transactionId: number/*, pending?: boolean*/) {
    /*
        if (pending) {
            if (transactionId === Main.Instance.DatabaseDataState.withdrawalHistorySelectedPending) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {withdrawalHistorySelectedPending: undefined, withdrawalHistoryPending: undefined})
            } else {
                Logic.Type.New (Main.Instance.DatabaseDataState, {withdrawalHistoryIsPending: true, TransactionHistoryGet: true, withdrawalHistorySelectedPending: transactionId})
                Socket1.socket.Send(Config.amWithdrawalHistoryGet, {transactionId})
            }
        } else {
    */
    if (transactionId === Main.Instance.DatabaseDataState.withdrawalHistorySelected) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { withdrawalHistorySelected: undefined, withdrawalHistory: undefined })
    } else {
        Logic.Type.New(Main.Instance.DatabaseDataState, { TransactionHistoryGet: true, withdrawalHistorySelected: transactionId })
        Socket1.socket.Send(Config.amWithdrawalHistoryGet, { transactionId })
        getLoadedResources('Socket1 - Send', Config.amWithdrawalHistoryGet)
    }

}

export function changeWithdrawalStatus(newStatus: TransactionStatus, transactionIds: number[], operatorId: number) {
    // console.log(transactionIds)
    // console.log(operatorId)

    Socket1.socket.Send(Config.amWithdrawalsStatusChange, { newStatus, transactionIds, operatorId })
    getLoadedResources('Socket1 - Send', Config.amWithdrawalsStatusChange)
}

export function checkCrif(playerId: string, pep: boolean, address: boolean) {
    Socket1.socket.Send(Config.amCrifCheck, { playerId, pep, address })
    getLoadedResources('Socket1 - Send', Config.amCrifCheck)
    Logic.Type.New(Main.Instance.DatabaseDataState, { manualCrifResponse: true, manualCrifResolved: false, manualCrifError: false })
}

export function resendVerificationEmail(playerId: string) {
    Socket1.socket.Send(Config.amResendEmail, { playerId })
    getLoadedResources('Socket1 - Send', Config.amResendEmail)
    Logic.Type.New(Main.Instance.DatabaseDataState, { resendVerificationEmail: false, manualResendVerification: true })
}

function byCreated(a, b): number {
    return a.created > b.created ? -1 : 1
}

function getUsername(playerId: string): string {
    for (const item of Main.Instance.DatabaseDataState.playerCards) {
        if (item.playerId === playerId) {
            return item.username
        }
    }
    return '?'
}
/*
export function insertRGSGameSupplier(rgsGameSupplierNew: RgsGameSupplierNew) {
    delete (rgsGameSupplierNew.id)
    Logic.Type.New(Main.Instance.DatabaseDataState, { RgsGameSupplierInsertNew: true })
    insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Rgs Game Supplier', rgsGameSupplierNew)
    Socket1.socket.Send(Config.gInsertGameSuppliers, { gameSuppliers: [rgsGameSupplierNew] })
    
}

export function updateRGSGameSupplier(rgsGameSupplierNew: RgsGameSupplierNew) {
    insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Rgs Game Supplier', rgsGameSupplierNew)
    Socket1.socket.Send(Config.gUpdateGameSupplier, { gameSupplier: rgsGameSupplierNew })
    
}

export function deleteRGSGameSupplier(id: number) {
    insertAdminLog(Config.asAdminLogDelete, 'Game Store -> Rgs Game Supplier', { id })
    Socket1.socket.Send(Config.gDeleteGameSupplier, { id })
}
*/
/*
export function insertGameProviderNew(gameProviderNew: GameProviderNew) {
    delete (gameProviderNew.id)
    Logic.Type.New(Main.Instance.DatabaseDataState, { GameProviderInsertNew: true })
    insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Game Provider', gameProviderNew)
    Socket1.socket.Send(Config.gInsertGameProvider, { gameProvider: [gameProviderNew] })
}

export function updateGameProviderNew(gameProviderNew: GameProviderNew) {
    insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Game Provider', gameProviderNew)
    Socket1.socket.Send(Config.gUpdateGameProvider, { gameProvider: gameProviderNew })
}

export function deleteGameProviderNew(id: number) {
    insertAdminLog(Config.asAdminLogDelete, 'Game Store -> Game Provider', { id })
    Socket1.socket.Send(Config.gDeleteGameProvider, { id })
}
*/
export function insertLabel(label: string) {
    // const games: GamesCentralNew[] = [game]
    Logic.Type.New(Main.Instance.DatabaseDataState, { GameLabelsInsert: true })
    // gameLabel_
    // Logic.Type.New (Main.Instance.DatabaseDataState, {CustomUpdate: true, gameLabel_: JSON.stringify(Main.Instance.DatabaseDataState.tags)})
    insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Label', { label })
    Socket1.socket.Send(Config.gInsertLabels, { labels: [{ name: label }] })
}

export function deleteLabel(id: number) {
    insertAdminLog(Config.asAdminLogDelete, 'Game Store -> Label', { id })
    Socket1.socket.Send(Config.gDeleteLabel, { id })
}

export function UpdateCategory(category: GamesListCategory) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { CategoriesUpdate: true })
    insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Category', { category })
    Socket1.socket.Send(Config.gUpdateCategory, { category })
}

export function InsertCategory(name: string) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { CategoriesInsert: true })
    insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Category', { category: name })
    Socket1.socket.Send(Config.gInsertCategories, { categories: [{ name }] })
}

export function insertJurisdiction(jurisdiction: Jurisdiction) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { JurisdictionsInsert: true })
    insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Jurisdiction', { jurisdiction })
    Socket1.socket.Send(Config.gInsertJurisdictions, { jurisdictions: [jurisdiction] })
}
/*
export function updateJurisdiction(jurisdiction: Jurisdiction) {
    Logic.Type.New (Main.Instance.DatabaseDataState, {JurisdictionsUpdate: true})
    Socket1.socket.Send(Config.gUpdateJurisdiction, {jurisdiction})
}
*/
/*
export function insertGame(game: GamesCentralNew) {
    if (game.id) { delete (game.id) }
    if (game.gameId) { delete (game.gameId) }
    Logic.Type.New(Main.Instance.DatabaseDataState, { GamesCentralInsertNew: true })

    insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Games Central', game)

    Socket1.socket.Send(Config.gInsertGame, { games: [game] })
}
*/
/*
export function insertGameList(game: GamesList) {
    if (game.gameId) { delete (game.gameId) }
    Logic.Type.New(Main.Instance.DatabaseDataState, { gamesListInsert: true })
    insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Games Central', game)
    Socket1.socket.Send(Config.gInsertGameList, {game})
}
*/
/*
export function updateGame(game: GamesCentralNew) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { GamesCentralUpdateNew: true })
    insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Games Central', game)
    Socket1.socket.Send(Config.gUpdateGame, { game })
}
*/
export function updateGameList(game: GamesList) {

    Logic.Type.New(Main.Instance.DatabaseDataState, { gamesListUpdate: true })
    insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Games Central', game)
    Socket1.socket.Send(Config.gUpdateGameList, {gameId: game.gameId, betMin: game.betMin, betMax: game.betMax, active: game.active})
}

export function wsUpdate() {
    let proceed: boolean = false

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amUpdatePaymentData) && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdatePaymentData).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.updatePaymentData) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amUpdatePaymentData).resolved) {
                wsGetPlayerCard(Main.Instance.PlayerCardState.id)
            } 
            Logic.Type.New(Main.Instance.DatabaseDataState, {updatePaymentData: false })     
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.bonusCampaignNewUpdate) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).resolved) {
                getLoadedResources('Socket1 - Save', Config.bonusBonusCampaignUpdate)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusCampaignNewUpdate: false,
                    bonusCampaignNewGet: true
                })
                Socket1.socket.Send(Config.bonusBonusCampaignGet, {eventId: 'event_id'})
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).payload.statusCode === 'OK') {
                    CampaignSetInitialValues()
                    alert(Assets.BonusCampaign + ' ' + Assets.Updated)
                } else {
                    alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).payload.statusCode)
                }
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusCampaignNewUpdate: false
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).error : Assets.Failed)

                // Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).loading = 'init'
            }
        } 
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.globallyExcludedTagsSet) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).resolved) {
                getLoadedResources('Socket1 - Save', Config.bonusGloballyExcludedTagsSet)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    globallyExcludedTagsSet: false,
                    globallyExcludedTagsGet: true
                })
                Socket1.socket.Send(Config.bonusGloballyExcludedTagsGet, {eventId: 'event_id'})
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).payload.statusCode === 'OK') {
                    alert(Assets.Updated)
                } else {
                    alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).payload.statusCode)
                }
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    globallyExcludedTagsSet: false
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsSet).error : Assets.Failed)
                // Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignUpdate).loading = 'init'
            }
        } 
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amUpdatePlayerCard) && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdatePlayerCard).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.PlayerCardUpdate === true) {
            insertAdminLog(
                Config.asAdminLogChangeData,
                Config.asAdminLogPlayerCard,
                {
                    playerId: Main.Instance.DatabaseDataState.playerCard.playerId,
                    username: Main.Instance.DatabaseDataState.playerCard.username,
                },
            )
            if (Main.Instance.DatabaseDataState.PlayerCardAccountStatusChanged) {
                insertAdminLog(
                    Config.asAdminLogChangeData,
                    Config.asAdminLogAccountStatus,
                    {
                        playerId: Main.Instance.DatabaseDataState.playerCard.playerId,
                        username: Main.Instance.DatabaseDataState.playerCard.username,
                        oldStatus: Main.Instance.DatabaseDataState.PlayerCardAccountStatusOldStatus,
                        newStatus: Main.Instance.DatabaseDataState.PlayerCardAccountStatusNewStatus,
                    },
                )
            }
            Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerCardUpdate: false, PlayerCardAccountStatusChanged: false, PlayerCardAccountStatusOldStatus: undefined, PlayerCardAccountStatusNewStatus: undefined, playerCard: Main.Instance.DatabaseDataState.playerCard, playerCard_: JSON.stringify(Main.Instance.DatabaseDataState.playerCard) })
            alert(Socket1.socket.Get<RouteClasses.Route>(Config.amUpdatePlayerCard).message)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amPlayerGroups && Main.Instance.DatabaseDataState.PlayerGroupsUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {/*PlayerGroupsGet: true,*/PlayerGroupsUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amProcessedPayments && Main.Instance.DatabaseDataState.PaymentProcessedUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {/*SettingsGet: true,*/ PaymentProcessedUpdate: false })
            proceed = false
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amSettings && Main.Instance.DatabaseDataState.CustomUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {/*SettingsGet: true,*/ CustomUpdate: false })
            proceed = true
        }
    }

    /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amBonus && Main.Instance.DatabaseDataState.BonusUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BonusGet: true, BonusUpdate: false })
            Logic.Type.New(Main.Instance.BonusState, { mode: false })
            bonusClearFields()
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amBonusCampaigns && Main.Instance.DatabaseDataState.BonusCampaignUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BonusCampaignGet: true, BonusCampaignUpdate: false })
            Logic.Type.New(Main.Instance.BonusCampaignState, { mode: false })
            bonusCampaignClearFields()
            proceed = true
        }
    }
    */

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amBonusWageringRequirement && Main.Instance.DatabaseDataState.BonusWageringRequirementUpdate === true) {
            if (Main.Instance.DatabaseDataState.ToUpdateIBonusWageringRequirement) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    ToUpdateIBonusWageringRequirement: false,
                    BonusWageringRequirementUpdate: false
                })

                wsBasicUpdate(Config.amBonusWageringRequirement, Main.Instance.DatabaseDataState.toUpdateIBonusWageringRequirement.id, Main.Instance.DatabaseDataState.toUpdateIBonusWageringRequirement.data)
            } else {
                // console.log (2)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    BonusWageringRequirementGet: true,
                    BonusWageringRequirementUpdate: false,
                    toUpdateIBonusWageringRequirement: undefined
                })
                proceed = true
            }
        }
    }



    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amGameProviders && Main.Instance.DatabaseDataState.GameProviderUpdate === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {GameProviderGet: true, GameProviderUpdate: false})
                Logic.Type.New (Main.Instance.GameProviderState, {mode: false})
                gameProviderClearFields()
                proceed = true
            }
        }
    */
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amRgsGameSupplier && Main.Instance.DatabaseDataState.RgsGameSupplierUpdate === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {RgsGameSupplierGet: true, RgsGameSupplierUpdate: false})
                Logic.Type.New (Main.Instance.GameProviderState, {mode: false})
                rgsGameSupplierClearFields()
                proceed = true
            }
        }
    */
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amRaffle && Main.Instance.DatabaseDataState.RaffleUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleGet: true, RaffleUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amRaffleParticipants && Main.Instance.DatabaseDataState.RaffleParticipantsUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleParticipantsGet: true, RaffleParticipantsUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amLargeValueDeposits && Main.Instance.DatabaseDataState.LargeValueDepositsUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueDepositsGet: true, LargeValueDepositsUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amLargeValueWithdrawals && Main.Instance.DatabaseDataState.LargeValueWithdrawalUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueWithdrawalGet: true, LargeValueWithdrawalUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amTemporaryAccount && Main.Instance.DatabaseDataState.TemporaryAccountStatusUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryAccountStatusGet: true, TemporaryAccountStatusUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amPlayerActivity && Main.Instance.DatabaseDataState.NoPlayerActivityStatusUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NoPlayerActivityStatusGet: true, NoPlayerActivityStatusUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amBlacklist && Main.Instance.DatabaseDataState.BlacklistUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BlacklistGet: true, BlacklistUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amMaximumBalance && Main.Instance.DatabaseDataState.MaximumBalanceUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { MaximumBalanceGet: true, MaximumBalanceUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amRetail && Main.Instance.DatabaseDataState.RetailUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RetailGet: true, RetailUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amRetailActions && Main.Instance.DatabaseDataState.RetailActionsUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RetailActionsGet: true, RetailActionsUpdate: false })
            proceed = true
        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amNotify && Main.Instance.DatabaseDataState.NotifyUpdate === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {NotifyGet: true, NotifyUpdate: false})
                proceed = true
            }
        }
    */
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amSelfAssessmentGifts && Main.Instance.DatabaseDataState.SaGiftsUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SaGiftsGet: true, SaGiftsUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amSelfAssessmentCriteria && Main.Instance.DatabaseDataState.SaCriteriaUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SaCriteriaGet: true, SaCriteriaUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amSelfAssessmentQuestions && Main.Instance.DatabaseDataState.SaQuestionsUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SaQuestionsGet: true, SaQuestionsUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amNetLimitLossIncreased && Main.Instance.DatabaseDataState.NetLimitLossIncreasedUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossIncreasedGet: true, NetLimitLossIncreasedUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amNetLimitLossRegistration && Main.Instance.DatabaseDataState.NetLimitLossRegistrationUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossRegistrationGet: true, NetLimitLossRegistrationUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amTemporaryExclude && Main.Instance.DatabaseDataState.TemporaryExcludeUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeGet: true, TemporaryExcludeUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amTemporaryExcludeOptions && Main.Instance.DatabaseDataState.TemporaryExcludeOptionsUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeOptionsGet: true, TemporaryExcludeOptionsUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amDashboardBackend && Main.Instance.DatabaseDataState.DashboardBackendUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { DashboardBackendGet: true, DashboardBackendUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amSelfExclusion && Main.Instance.DatabaseDataState.SelfExclusionUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SelfExclusionGet: true, SelfExclusionUpdate: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amCounselingCentres && Main.Instance.DatabaseDataState.CounselingCentresUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { CounselingCentresGet: true, CounselingCentresUpdate: false })
            proceed = true
        }
    }
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amGames && Main.Instance.DatabaseDataState.GamesUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { GamesGet: true, GamesUpdate: false })
            proceed = true
        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amGamesCentral && Main.Instance.DatabaseDataState.GamesCentralUpdate === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {GamesGet: true, GamesCentralUpdate: false})
                proceed = true
            }
        }
    */
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gUpdateGame) && Socket1.socket.Get<RouteClasses.Route>(Config.gUpdateGame).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.GamesCentralUpdateNew === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { GamesCentralUpdateNew: false })
            // proceed = true
        }
    }
*/
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gUpdateGameList) && Socket1.socket.Get<RouteClasses.Route>(Config.gUpdateGameList).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.gamesListUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { gamesListUpdate: false })
            // proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.gUpdateCategory) && Socket1.socket.Get<RouteClasses.Route>(Config.gUpdateCategory).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.CategoriesUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { CategoriesUpdate: false, gamesListCategoriesGet: true })
            // proceed = true
        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amCategories && Main.Instance.DatabaseDataState.CategoriesUpdate === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {CategoriesGet: true, CategoriesUpdate: false})
                proceed = true
            }
        }
    */
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table === Config.amPostalCodes && Main.Instance.DatabaseDataState.PostalCodesUpdate === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { PostalCodesGet: true, PostalCodesUpdate: false })
            proceed = true
        }
    }

    if (proceed) {
        Socket1.socket.Send(Config.amBasicGet, { table: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table }, callbackUpdate(Config.amBasicGet, Socket1.socket.Get<RouteClasses.Route>(Config.amBasicUpdate).table))
        
    }
}

function callbackUpdate(route: string, table: string) {
    if (route === Config.amBasicGet) {
        if (table === Config.amSettings) {
            insertAdminLog(
                Config.asAdminLogChangeData,
                Config.asAdminLogSystemSettings,
                {},
            )
            alert(Assets.SettingsWereSuccessfullyUpdated + '.')
        }
    }
}

export function updatePlayerCard(playerCard: Player) {
    // here we need to determine if the account status od the player is changed
    const oldPlayerCard: Player = JSON.parse(Main.Instance.DatabaseDataState.playerCard_)
    if (oldPlayerCard.accountStatus !== /*Main.Instance.DatabaseDataState.*/playerCard.accountStatus) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerCardUpdate: true, PlayerCardAccountStatusChanged: true, PlayerCardAccountStatusOldStatus: AccountStatus[oldPlayerCard.accountStatus], PlayerCardAccountStatusNewStatus: AccountStatus[Main.Instance.DatabaseDataState.playerCard.accountStatus] })
    } else { Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerCardUpdate: true, PlayerCardAccountStatusChanged: false, PlayerCardAccountStatusOldStatus: undefined, PlayerCardAccountStatusNewStatus: undefined }) }
    Socket1.socket.Send(Config.amUpdatePlayerCard, /*Main.Instance.DatabaseDataState.*/playerCard)
    getLoadedResources('Socket1 - Send', Config.amUpdatePlayerCard)
}

export function wsDelete() {
    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignDelete).payload &&Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignDelete).payload.data &&  Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignDelete).resolved) {
            if (Main.Instance.DatabaseDataState.bonusCampaignNewDelete) {
                getLoadedResources('Socket1 - Send', Config.bonusBonusCampaignGet)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusCampaignNewDelete: false,
                    bonusCampaignNewGet: true
                })
                Socket1.socket.Send(Config.bonusBonusCampaignGet, {eventId: 'event_id'})
            }
        }
    }
    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusDelete).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusDelete).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusDelete).resolved) {
            if (Main.Instance.DatabaseDataState.bonusNewDelete) {
                getLoadedResources('Socket1 - Send', Config.bonusBonusGet)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusNewDelete: false,
                    bonusNewGet: true
                })
                Socket1.socket.Send(Config.bonusBonusGet, {eventId: 'event_id', page: 1, limit: 1000})
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesDelete).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesDelete).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesDelete).resolved) {
            if (Main.Instance.DatabaseDataState.freeGameSettingsDelete) {
                getLoadedResources('Socket1 - Send', Config.bonusFreeGamesGet)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    freeGameSettingsDelete: false,
                    freeGameSettingsGet: true
                })
                Socket1.socket.Send(Config.bonusFreeGamesGet, {eventId: 'event_id'})
            }
        }
    }
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amPlayerGroups && Main.Instance.DatabaseDataState.PlayerGroupsDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerGroupsDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amPostalCodes && Main.Instance.DatabaseDataState.PostalCodesDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { PostalCodesDelete: false })
        }
    }
    /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amBonus && Main.Instance.DatabaseDataState.BonusDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BonusDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amBonusCampaigns && Main.Instance.DatabaseDataState.BonusCampaignDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BonusCampaignDelete: false })
        }
    }
    */

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amBonusWageringRequirement && Main.Instance.DatabaseDataState.BonusWageringRequirementDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BonusWageringRequirementDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amProcessedPayments && Main.Instance.DatabaseDataState.PaymentProcessedDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { PaymentProcessedDelete: false })
        }
    }

    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amGameProviders && Main.Instance.DatabaseDataState.GameProviderDelete === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {GameProviderDelete: false})
            }
        }
    */
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amRgsGameSupplier && Main.Instance.DatabaseDataState.RgsGameSupplierDelete === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {RgsGameSupplierDelete: false})
            }
        }
    */
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amRaffle && Main.Instance.DatabaseDataState.RaffleDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amRaffleParticipants && Main.Instance.DatabaseDataState.RaffleParticipantsDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleParticipantsDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amLargeValueDeposits && Main.Instance.DatabaseDataState.LargeValueDepositsDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueDepositsDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amLargeValueWithdrawals && Main.Instance.DatabaseDataState.LargeValueWithdrawalDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueWithdrawalDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amTemporaryAccount && Main.Instance.DatabaseDataState.TemporaryAccountStatusDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryAccountStatusDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amPlayerActivity && Main.Instance.DatabaseDataState.NoPlayerActivityStatusDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NoPlayerActivityStatusDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amBlacklist && Main.Instance.DatabaseDataState.BlacklistDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BlacklistDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amMaximumBalance && Main.Instance.DatabaseDataState.MaximumBalanceDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { MaximumBalanceDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amRetail) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amRetail && Main.Instance.DatabaseDataState.RetailDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RetailDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amRetailActions) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amRetailActions && Main.Instance.DatabaseDataState.RetailActionsDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RetailActionsDelete: false })
        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amNotify && Main.Instance.DatabaseDataState.NotifyDelete === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {NotifyDelete: false})
            }
        }
    */
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amSelfAssessmentGifts && Main.Instance.DatabaseDataState.SaGiftsDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SaGiftsDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amSelfAssessmentCriteria && Main.Instance.DatabaseDataState.SaCriteriaDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SaCriteriaDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amSelfAssessmentQuestions && Main.Instance.DatabaseDataState.SaQuestionsDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SaQuestionsDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amNetLimitLossIncreased && Main.Instance.DatabaseDataState.NetLimitLossIncreasedDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossIncreasedDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amNetLimitLossRegistration && Main.Instance.DatabaseDataState.NetLimitLossRegistrationDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossRegistrationDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amTemporaryExclude && Main.Instance.DatabaseDataState.TemporaryExcludeDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amTemporaryExcludeOptions && Main.Instance.DatabaseDataState.TemporaryExcludeOptionsDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeOptionsDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amDashboardBackend && Main.Instance.DatabaseDataState.DashboardBackendDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { DashboardBackendDelete: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amSelfExclusion && Main.Instance.DatabaseDataState.SelfExclusionDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SelfExclusionDelete: false })
        }
    }
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicDelete).table === Config.amGames && Main.Instance.DatabaseDataState.GamesDelete === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { GamesDelete: false })
        }
    }
*/
}

export function wsInsert() {
    let proceed: boolean = false

    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.freeGameSettingsUpdate) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).payload.data) {
                getLoadedResources('Socket1 - Send', Config.bonusFreeGamesGet)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    freeGameSettingsUpdate: false,
                    freeGameSettingsGet: true
                })
                Socket1.socket.Send(Config.bonusFreeGamesGet, {eventId: 'event_id'})
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).payload.statusCode === 'OK') {
                    alert(Assets.FreeGame + ' ' + Assets.Updated)
                } else {
                    alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).payload.statusCode)
                }
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    freeGameSettingsUpdate: false
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).error : Assets.Failed)

                // Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesSave).loading = 'init'
            }
            
        }
        
    }

    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave))
    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.bonusNewUpdate) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).resolved) {
            
                getLoadedResources('Socket1 - Send', Config.bonusBonusGet)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusNewUpdate: false,
                    bonusNewGet: true
                })
                Socket1.socket.Send(Config.bonusBonusGet, {eventId: 'event_id', page: 1, limit: 1000})
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).payload.statusCode === 'OK') {
                    BonusSetInitialValues()
                    alert(Assets.Bonus + ' ' + Assets.Updated)
                } else {
                    alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).payload.statusCode)
                }
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusNewUpdate: false
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).error : Assets.Failed)
                // Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).loading = 'init'
            }
        } 
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.bonusActivate) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus).resolved) {
            
                getLoadedResources('Socket1 - Send', Config.bonusBonusGet)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusActivate: false,
                    bonusNewGet: true
                })
                Socket1.socket.Send(Config.bonusBonusGet, {eventId: 'event_id', page: 1, limit: 1000})
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus).payload.statusCode === 'OK') {
                    alert(Assets.Bonus + ' ' + Assets.Updated)
                } else {
                    alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus).payload.statusCode)
                }
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusActivate: false
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusActivateBonus).error : Assets.Failed)
                // Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusSave).loading = 'init'
            }
        } 
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.bonusCampaignNewUpdate) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).resolved) {
                getLoadedResources('Socket1 - Send', Config.bonusBonusCampaignGet)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusCampaignNewUpdate: false,
                    bonusCampaignNewGet: true
                })
                Socket1.socket.Send(Config.bonusBonusCampaignGet, {eventId: 'event_id'})
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).payload.statusCode === 'OK') {
                    CampaignSetInitialValues()
                    alert(Assets.BonusCampaign + ' ' + Assets.Updated)
                } else {
                    alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).payload.statusCode)
                }
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    bonusCampaignNewUpdate: false
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).error : Assets.Failed)
                // Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignSave).loading = 'init'
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amPlayerGroups && Main.Instance.DatabaseDataState.PlayerGroupsInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerGroupsGet: true, PlayerGroupsInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amProcessedPayments && Main.Instance.DatabaseDataState.PaymentProcessedInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { PaymentProcessedInsert: false, PaymentProcessedInsert2: true})
            Socket1.socket.Send(Config.amGetProcessedPayments, {page: Main.Instance.DatabaseDataState.paymentProcessed.length + 1, limit: 1, table: "processed_payments"})
            proceed = false
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amCountries && Main.Instance.DatabaseDataState.CountriesInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { CountriesGet: true, CountriesInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amNationalities && Main.Instance.DatabaseDataState.NationalitiesInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NationalitiesGet: true, NationalitiesInsert: false })
            proceed = true
        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amJurisdictions && Main.Instance.DatabaseDataState.JurisdictionsInsert === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {JurisdictionsGet: true, JurisdictionsInsert: false})
                proceed = true
            }
        }
    */
   /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amBonus && Main.Instance.DatabaseDataState.BonusInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BonusGet: true, BonusInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amBonusCampaigns && Main.Instance.DatabaseDataState.BonusCampaignInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BonusCampaignGet: true, BonusCampaignInsert: false })
            proceed = true
        }
    }
    */

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amBonusWageringRequirement && Main.Instance.DatabaseDataState.BonusWageringRequirementInsert === true) {
            // Logic.Type.New (Main.Instance.DatabaseDataState, {BonusWageringRequirementGet: true, BonusWageringRequirementInsert: false})
            // proceed = true
            if (Main.Instance.DatabaseDataState.ToUpdateIBonusWageringRequirement) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    ToUpdateIBonusWageringRequirement: false,
                    BonusWageringRequirementUpdate: false
                })

                wsBasicUpdate(Config.amBonusWageringRequirement, Main.Instance.DatabaseDataState.toUpdateIBonusWageringRequirement.id, Main.Instance.DatabaseDataState.toUpdateIBonusWageringRequirement.data)
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    BonusWageringRequirementGet: true,
                    BonusWageringRequirementInsert: false,
                    toUpdateIBonusWageringRequirement: undefined
                })
                proceed = true
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amCommunicationsUpdate) && Socket1.socket.Get<RouteClasses.Route>(Config.amCommunicationsUpdate).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.CommunicationsUpdate === true) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amCommunicationsUpdate).message && Socket1.socket.Get<RouteClasses.Route>(Config.amCommunicationsUpdate).message.playerCard) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    playerCard: Socket1.socket.Get<RouteClasses.Route>(Config.amCommunicationsUpdate).message.playerCard,
                    // IssuesGet: true,
                    CommunicationsUpdate: false
                })
                // Socket1.socket.Send (Config.amGetIssues, {filters: {resolved: false}, page: Main.Instance.DatabaseDataState.issuesPage, limit: Main.Instance.DatabaseDataState.issuesLimit})
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, { CommunicationsUpdate: false })
            }
        }
    }
    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue))
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue) && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).resolved && Main.Instance.DatabaseDataState.IssuesInsert === true) {
            // here the playercard needs to be returned

            if (Main.Instance.DatabaseDataState.IssuesInsertType === IssueTypes.ChangedEmail) {
                alert(Assets.ChangedEmailIssueIsSaved)
            } else if (Main.Instance.DatabaseDataState.IssuesInsertType === IssueTypes.CRIFAddressChangedOperator) {
                alert(Assets.CrifAddressChangedOperatorStarted)
            } else if (Main.Instance.DatabaseDataState.IssuesInsertType === IssueTypes.PEPCheckNameChanged) {
                alert(Assets.PepNameChangedOperatorStarted)
                /*
                            } else if (Main.Instance.DatabaseDataState.IssuesInsertType === IssueTypes.CRIFCheckMismatch) {
                                alert (Assets.CrifCheckStarted)
                            } else if (Main.Instance.DatabaseDataState.IssuesInsertType === IssueTypes.PEPChangedByOperator) {
                                alert (Assets.PepCheckByOperatorStarted)
                */
            }

            if (Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.playerCard) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    playerCard: Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.playerCard,
                    // IssuesGet: true,
                    IssuesInsert: false,
                    // PlayerTimelineGet: true
                })
                // Socket1.socket.Send (Config.amGetIssues, {filters: {resolved: false}, page: Main.Instance.DatabaseDataState.issuesPage, limit: Main.Instance.DatabaseDataState.issuesLimit})
                // CHANGE wsGetPlayerTimeline(Main.Instance.DatabaseDataState.playerCard.playerId)
                // Socket1.socket.Send (Config.amGetPlayerTimeline, {playerId: Main.Instance.DatabaseDataState.playerCard.playerId})
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    // IssuesGet: true,
                    IssuesInsert: false,
                    // PlayerTimelineGet: true
                })
                // CHANGE wsGetPlayerTimeline(Main.Instance.DatabaseDataState.playerCard.playerId)
                // Socket1.socket.Send (Config.amGetIssues, {filters: {resolved: false}, page: Main.Instance.DatabaseDataState.issuesPage, limit: Main.Instance.DatabaseDataState.issuesLimit})
                // Socket1.socket.Send (Config.amGetPlayerTimeline, {playerId: Main.Instance.DatabaseDataState.playerCard.playerId})
            }
            // wsGetPlayerCard(Main.Instance.DatabaseDataState.playerCard.playerId, true)
        }
    }

    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amManualDeposit))
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amManualWithdrawal) && Socket1.socket.Get<RouteClasses.Route>(Config.amManualWithdrawal).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.ManualWithdrawalInsert === true) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amManualWithdrawal).playerCard) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    ManualWithdrawalInsert: false,
                    // IssuesGet: true,
                    playerCard: Socket1.socket.Get<RouteClasses.Route>(Config.amManualWithdrawal).playerCard
                })
                // Socket1.socket.Send (Config.amGetIssues, {filters: {resolved: false}, page: Main.Instance.DatabaseDataState.issuesPage, limit: Main.Instance.DatabaseDataState.issuesLimit})
                wsGetPlayerTimeline(Socket1.socket.Get<RouteClasses.Route>(Config.amManualWithdrawal).playerCard.playerId/*, Main.Instance.DatabaseDataState.timelineLimit, Main.Instance.DatabaseDataState.timelinePage*/)
            } else {
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.amManualWithdrawal).error && Socket1.socket.Get<RouteClasses.Route>(Config.amManualWithdrawal).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.amManualWithdrawal).error.message : '')
                Logic.Type.New(Main.Instance.DatabaseDataState, { ManualWithdrawalInsert: false })
            }
        }
    }

    
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amManualDeposit) && Socket1.socket.Get<RouteClasses.Route>(Config.amManualDeposit).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.ManualDepositInsert === true) {
            
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amManualDeposit).playerCard) {
                // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amManualDeposit).playerCard)
                if (Main.Instance.Location === '/account-store/mass-manual-deposit') {
                    const inserted = Object.assign ([], Main.Instance.DatabaseDataState.insertedMassManualDeposits)
                    let count = Main.Instance.DatabaseDataState.countMassManualDeposits
                    if (count < Main.Instance.DatabaseDataState.uploadedMassManualDeposits.length) {
                        count ++
                        inserted.push({
                            playerId: Socket1.socket.Get<RouteClasses.Route>(Config.amManualDeposit).playerCard.playerId,
                            username: Socket1.socket.Get<RouteClasses.Route>(Config.amManualDeposit).playerCard.username
                        }) 
    
                        Logic.Type.New(Main.Instance.DatabaseDataState, {insertedMassManualDeposits: inserted, ManualDepositInsert: false, countMassManualDeposits: count})
                        wsInsertMassManualDeposit() 
                    } else {
                        Logic.Type.New(Main.Instance.DatabaseDataState, { ManualDepositInsert: false, countMassManualDeposits: 0, uploadedMassManualDeposits: [], isInsertingMassManualUploads: false})
                    }
                    

                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        ManualDepositInsert: false,
                        // IssuesGet: true,
                        playerCard: Socket1.socket.Get<RouteClasses.Route>(Config.amManualDeposit).playerCard
                    })
                    // Socket1.socket.Send (Config.amGetIssues, {filters: {resolved: false}, page: Main.Instance.DatabaseDataState.issuesPage, limit: Main.Instance.DatabaseDataState.issuesLimit})
                    wsGetPlayerTimeline(Socket1.socket.Get<RouteClasses.Route>(Config.amManualDeposit).playerCard.playerId/*, Main.Instance.DatabaseDataState.timelineLimit, Main.Instance.DatabaseDataState.timelinePage*/)
                }
                
            } else {
                if (Main.Instance.Location === '/account-store/mass-manual-deposit') {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { ManualDepositInsert: false, countMassManualDeposits: 0, uploadedMassManualDeposits: [], isInsertingMassManualUploads: false})
                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { ManualDepositInsert: false })
                }
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.gInsertLabels) && Socket1.socket.Get<RouteClasses.Route>(Config.gInsertLabels).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.GameLabelsInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { gamesListLabelsGet: true, GameLabelsInsert: false })
            Socket1.socket.Send(Config.gGetGameLabels, {})
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.gInsertCategories) && Socket1.socket.Get<RouteClasses.Route>(Config.gInsertCategories).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.CategoriesInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { gamesListCategoriesGet: true, CategoriesInsert: false })
            Socket1.socket.Send(Config.gGetGameCategories, {})
        }
    }
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gInsertJurisdictions) && Socket1.socket.Get<RouteClasses.Route>(Config.gInsertJurisdictions).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.JurisdictionsInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { jurisdictionsListGet: true, JurisdictionsInsert: false })
            Socket1.socket.Send(Config.gGetJurisdictionsList, {})
        }
    }
*/
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gInsertGameSuppliers) && Socket1.socket.Get<RouteClasses.Route>(Config.gInsertGameSuppliers).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.RgsGameSupplierInsertNew === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RgsGameSupplierGetNew: true, RgsGameSupplierInsertNew: false })
            Socket1.socket.Send(Config.gGetGameSuppliers, {})
        }
    }
*/
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gInsertGameProvider) && Socket1.socket.Get<RouteClasses.Route>(Config.gInsertGameProvider).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.GameProviderInsertNew === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { GameProviderGetNew: true, GameProviderInsertNew: false })
            Socket1.socket.Send(Config.gGetGameProviders, {})
        }
    }
    */
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gInsertGame) && Socket1.socket.Get<RouteClasses.Route>(Config.gInsertGame).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.GamesCentralInsertNew === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { GamesCentralGetNew: true, GamesCentralInsertNew: false })
            Socket1.socket.Send(Config.gGetGames, {})
        }
    }
*/
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gInsertGameList) && Socket1.socket.Get<RouteClasses.Route>(Config.gInsertGameList).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.gamesListInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { gamesListGet: true, gamesListInsert: false, gameListNeedsUpdate: true })
            Socket1.socket.Send(Config.gGetGameList, {})
        }
    }
*/

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amRaffle && Main.Instance.DatabaseDataState.RaffleInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleGet: true, RaffleInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amRaffleParticipants && Main.Instance.DatabaseDataState.RaffleParticipantsInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleParticipantsGet: true, RaffleParticipantsInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amLargeValueDeposits && Main.Instance.DatabaseDataState.LargeValueDepositsInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueDepositsGet: true, LargeValueDepositsInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amLargeValueWithdrawals && Main.Instance.DatabaseDataState.LargeValueWithdrawalInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueWithdrawalGet: true, LargeValueWithdrawalInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amTemporaryAccount && Main.Instance.DatabaseDataState.TemporaryAccountStatusInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryAccountStatusGet: true, TemporaryAccountStatusInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amPlayerActivity && Main.Instance.DatabaseDataState.NoPlayerActivityStatusInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NoPlayerActivityStatusGet: true, NoPlayerActivityStatusInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amBlacklist && Main.Instance.DatabaseDataState.BlacklistInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { BlacklistGet: true, BlacklistInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amMaximumBalance && Main.Instance.DatabaseDataState.MaximumBalanceInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { MaximumBalanceGet: true, MaximumBalanceInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amRetail && Main.Instance.DatabaseDataState.RetailInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RetailGet: true, RetailInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amRetailActions && Main.Instance.DatabaseDataState.RetailActionsInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RetailActionsGet: true, RetailActionsInsert: false })
            proceed = true
        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amNotify && Main.Instance.DatabaseDataState.NotifyInsert === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {NotifyGet: true, NotifyInsert: false})
                proceed = true
            }
        }
    */
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amSelfAssessmentGifts && Main.Instance.DatabaseDataState.SaGiftsInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SaGiftsGet: true, SaGiftsInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amSelfAssessmentCriteria && Main.Instance.DatabaseDataState.SaCriteriaInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SaCriteriaGet: true, SaCriteriaInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amSelfAssessmentQuestions && Main.Instance.DatabaseDataState.SaQuestionsInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SaQuestionsGet: true, SaQuestionsInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amNetLimitLossIncreased && Main.Instance.DatabaseDataState.NetLimitLossIncreasedInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossIncreasedGet: true, NetLimitLossIncreasedInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amNetLimitLossRegistration && Main.Instance.DatabaseDataState.NetLimitLossRegistrationInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossRegistrationGet: true, NetLimitLossRegistrationInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amTemporaryExclude && Main.Instance.DatabaseDataState.TemporaryExcludeInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeGet: true, TemporaryExcludeInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amTemporaryExcludeOptions && Main.Instance.DatabaseDataState.TemporaryExcludeOptionsInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeOptionsGet: true, TemporaryExcludeOptionsInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amDashboardBackend && Main.Instance.DatabaseDataState.DashboardBackendInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { DashboardBackendGet: true, DashboardBackendInsert: false })
            proceed = true
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amSelfExclusion && Main.Instance.DatabaseDataState.SelfExclusionInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { SelfExclusionGet: true, SelfExclusionInsert: false })
            proceed = true
        }
    }
    /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amGames && Main.Instance.DatabaseDataState.GamesInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { GamesGet: true, GamesInsert: false })
            proceed = true
        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amGamesCentral && Main.Instance.DatabaseDataState.GamesCentralInsert === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {GamesGet: true, GamesCentralInsert: false})
                proceed = true
            }
        }
    */
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amCategories && Main.Instance.DatabaseDataState.CategoriesInsert === true) {
                Logic.Type.New (Main.Instance.DatabaseDataState, {CategoriesGet: true, CategoriesInsert: false})
                proceed = true
            }
        }
    */
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amPostalCodes && Main.Instance.DatabaseDataState.PostalCodesInsert === true) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { PostalCodesGet: true, PostalCodesInsert: false })
            proceed = true
        }
    }

    if (proceed) {
        Socket1.socket.Send(Config.amBasicGet, { table: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table })
    }
}

export async function updateMatches() {
    const requestMatches: string = Config.oddsServerMatches + '?page=' + Main.Instance.OddsState.matchesPage + '&pageSize=' + Main.Instance.OddsState.matchesPageSize
    const responseMatches = (await axios.get(requestMatches, {headers: {'api-key': Config.keyGetOdds}})).data
    Logic.Type.New (Main.Instance.OddsState, {
        matches: injectResult(responseMatches)
    })
}

export async function initOdds() {
    if (Main.Instance.DatabaseDataState.FlagsStreamAll) {
        if (Main.Instance.OddsState.league === undefined && Main.Instance.Location === '/oddsportal/table-of-leagues') {
            Logic.Type.New (Main.Instance.OddsState, {league: null})
            const requestMatches: string = Config.oddsServerMatches + '?page=' + Main.Instance.OddsState.matchesPage + '&pageSize=' + Main.Instance.OddsState.matchesPageSize
            const responseMatches = Main.Instance.OddsState.matches ? Main.Instance.OddsState.matches : (await axios.get(requestMatches, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseLeagues = (await axios.get(Config.oddsServerLeague, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseSport = Main.Instance.OddsState.sport ? Main.Instance.OddsState.sport : (await axios.get(Config.oddsServerSport, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseBet = Main.Instance.OddsState.bet ? Main.Instance.OddsState.bet : (await axios.get(Config.oddsServerBet, {headers: {'api-key': Config.keyGetOdds}})).data

            Logic.Type.New (Main.Instance.OddsState, {
                matches: injectResult(responseMatches),
                distinctRegion: distinctRegion(responseMatches),
                distinctRegion2: distinctRegion2(responseMatches),
                distinctLeague: distinctLeague(responseMatches),
                distinctLeague2: distinctLeague2(responseMatches),
                distinctSport: distinctSport(responseMatches),

                DistinctRegion: DistinctRegion(responseLeagues, responseSport),
                DistinctRegion2: DistinctRegion2(responseLeagues),
                DistinctLeague: DistinctLeague(responseLeagues, responseSport),
                DistinctLeague2: DistinctLeague2(responseLeagues, responseSport),
                DistinctSport: DistinctSport(responseLeagues, responseSport),

                league: injectDisabledResults(responseLeagues, distinctLeague(responseMatches), responseSport),
                sport: responseSport,
                bet: responseBet
            })
        } else if (Main.Instance.OddsState.matches === undefined && Main.Instance.Location === '/oddsportal/table-of-matches') {
            Logic.Type.New (Main.Instance.OddsState, {matches: null})
            const requestMatches: string = Config.oddsServerMatches + '?page=' + Main.Instance.OddsState.matchesPage + '&pageSize=' + Main.Instance.OddsState.matchesPageSize
            const responseMatches = (await axios.get(requestMatches, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseBookmakers = await Main.Instance.OddsState.bookmakers ? Main.Instance.OddsState.bookmakers : (await axios.get(Config.oddsServerBookmakers, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseBet = Main.Instance.OddsState.bet ? Main.Instance.OddsState.bet : (await axios.get(Config.oddsServerBet, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseLeagues = Main.Instance.OddsState.league ? Main.Instance.OddsState.league : (await axios.get(Config.oddsServerLeague, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseSport = Main.Instance.OddsState.sport ? Main.Instance.OddsState.sport : (await axios.get(Config.oddsServerSport, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseCountries = Main.Instance.OddsState.countries ? Main.Instance.OddsState.countries : (await axios.get(Config.oddsServerCountries, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseCountriesTypes = Main.Instance.OddsState.countriesTypes ? Main.Instance.OddsState.countriesTypes : (await axios.get(Config.oddsServerCountriesTypes, {headers: {'api-key': Config.keyGetOdds}})).data

            Logic.Type.New (Main.Instance.OddsState, {
                matches: injectResult(responseMatches),
                bookmakers: responseBookmakers,
                sport: responseSport,
                countries: injectFlags(responseCountries),
                distinctRegion: distinctRegion(responseMatches),
                distinctRegion2: distinctRegion2(responseMatches),
                distinctLeague: distinctLeague(responseMatches),
                distinctLeague2: distinctLeague2(responseMatches),
                distinctSport: distinctSport(responseMatches),

                DistinctRegion: DistinctRegion(responseLeagues, responseSport),
                DistinctRegion2: DistinctRegion2(responseLeagues),
                DistinctLeague: DistinctLeague(responseLeagues, responseSport),
                DistinctLeague2: DistinctLeague2(responseLeagues, responseSport),
                DistinctSport: DistinctSport(responseLeagues, responseSport),

                countriesTypes: responseCountriesTypes,
                bet: responseBet,
                league: injectDisabledResults(responseLeagues, distinctLeague(responseMatches), responseSport),
            })
        } else if (Main.Instance.OddsState.sport === undefined && Main.Instance.Location === '/oddsportal/table-of-sports') {
            Logic.Type.New (Main.Instance.OddsState, {sport: null})
            const responseSport = (await axios.get(Config.oddsServerSport, {headers: {'api-key': Config.keyGetOdds}})).data
            Logic.Type.New (Main.Instance.OddsState, {
                sport: responseSport
            })

        } else if (Main.Instance.OddsState.countries === undefined && Main.Instance.Location === '/oddsportal/table-of-regions') {
            Logic.Type.New (Main.Instance.OddsState, {countries: null})
            const responseCountries = (await axios.get(Config.oddsServerCountries, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseCountriesTypes = Main.Instance.OddsState.countriesTypes ? Main.Instance.OddsState.countriesTypes : (await axios.get(Config.oddsServerCountriesTypes, {headers: {'api-key': Config.keyGetOdds}})).data
            Logic.Type.New (Main.Instance.OddsState, {
                countries: injectFlags(responseCountries),
                countriesTypes: responseCountriesTypes,
            })
        } else if (Main.Instance.OddsState.bookmakers === undefined && Main.Instance.Location === '/oddsportal/table-of-bookmakers') {
            Logic.Type.New (Main.Instance.OddsState, {bookmakers: null})
            const responseBookmakers = (await axios.get(Config.oddsServerBookmakers, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseCountries = Main.Instance.OddsState.countries ? Main.Instance.OddsState.countries : (await axios.get(Config.oddsServerCountries)).data
            const responseCountriesTypes = Main.Instance.OddsState.countriesTypes ? Main.Instance.OddsState.countriesTypes : (await axios.get(Config.oddsServerCountriesTypes, {headers: {'api-key': Config.keyGetOdds}})).data
            Logic.Type.New (Main.Instance.OddsState, {
                countries: injectFlags(responseCountries),
                countriesTypes: responseCountriesTypes,
                bookmakers: responseBookmakers
            })
        } else if (Main.Instance.OddsState.bet === undefined && Main.Instance.Location === '/oddsportal/table-of-bet-types') {
            Logic.Type.New (Main.Instance.OddsState, {bet: null})
            const responseBet = (await axios.get(Config.oddsServerBet, {headers: {'api-key': Config.keyGetOdds}})).data
            const responseSport = Main.Instance.OddsState.sport ? Main.Instance.OddsState.sport : (await axios.get(Config.oddsServerSport, {headers: {'api-key': Config.keyGetOdds}})).data
            Logic.Type.New (Main.Instance.OddsState, {
                bet: responseBet,
                sport: responseSport
            })
        }
    }
}

function DistinctSport(input: OddsData.League[], sport: OddsData.Sport[]): Array<{sport: string}> {
    // console.log (input)
    const distinctSports: Array<{sport: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctSports) {
                if (item.data.sportid === undefined && ITEM.sport === Assets.Soccer || ITEM.sport === getSportById(item.data.sportid, sport)) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctSports.push({sport: item.data.sportid ? getSportById(item.data.sportid, sport) : Assets.Soccer})
            }
        }
    }
    // console.log (distinctRegions)
    distinctSports.sort((a,b) => a.sport > b.sport ? 1 : -1)
    return distinctSports
}

function DistinctLeague(input: OddsData.League[], sport: OddsData.Sport[]): Array<{sport: string, region: string, league: string}> {
    // console.log (input)
    const distinctLeagues: Array<{sport: string, region: string, league: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctLeagues) {
                if ((item.data.sportid === undefined && ITEM.sport === Assets.Soccer || ITEM.sport === getSportById(item.data.sportid, sport)) && ITEM.region === item.data.section && ITEM.league === item.data.league) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctLeagues.push({sport: item.data.sportid ? getSportById(item.data.sportid, sport) : Assets.Soccer, region: item.data.section, league: item.data.league})
            }
        }
    }
    // console.log (distinctRegions)
    distinctLeagues.sort((a,b) => a.league > b.league ? 1 : -1)
    return distinctLeagues
}

function DistinctLeague2(input: OddsData.League[], sport: OddsData.Sport[]): Array<{league: string}> {
    // console.log (input)
    const distinctLeagues: Array<{league: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctLeagues) {
                if (ITEM.league === item.data.league) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctLeagues.push({league: item.data.league})
            }
        }
    }
    // console.log (distinctRegions)
    distinctLeagues.sort((a,b) => a.league > b.league ? 1 : -1)
    return distinctLeagues
}

function DistinctRegion(input: OddsData.League[], sport: OddsData.Sport[]): Array<{sport: string, region: string}> {
    // console.log (input)
    const distinctRegions: Array<{sport: string, region: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctRegions) {
                if ((item.data.sportid === undefined && ITEM.sport === Assets.Soccer || ITEM.sport === getSportById(item.data.sportid, sport)) && ITEM.region === item.data.section) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctRegions.push({sport: item.data.sportid ? getSportById(item.data.sportid, sport) : Assets.Soccer, region: item.data.section})
            }
        }
    }
    // console.log (distinctRegions)
    distinctRegions.sort((a,b) => a.region > b.region ? 1 : -1)
    return distinctRegions
}

function DistinctRegion2(input: OddsData.League[]): Array<{region: string}> {
    // console.log (input)
    const distinctRegions: Array<{region: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctRegions) {
                if (ITEM.region === item.data.section) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctRegions.push({region: item.data.section})
            }
        }
    }
    // console.log (distinctRegions)
    distinctRegions.sort((a,b) => a.region > b.region ? 1 : -1)
    return distinctRegions
}

function distinctSport(input: OddsData.Match[]): Array<{sport: string}> {
    // console.log (input)
    const distinctSports: Array<{sport: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctSports) {
                if (ITEM.sport === item.sport) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctSports.push({sport: item.sport})
            }
        }
    }
    // console.log (distinctSports)
    distinctSports.sort((a,b) => a.sport > b.sport ? 1 : -1)
    return distinctSports
}

function distinctRegion(input: OddsData.Match[]): Array<{sport: string, region: string}> {
    // console.log (input)
    const distinctRegions: Array<{sport: string, region: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctRegions) {
                if (ITEM.region === item.country && ITEM.sport === item.sport) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctRegions.push({sport: item.sport, region: item.country})
            }
        }
    }
    // console.log (distinctRegions)
    distinctRegions.sort((a,b) => a.region > b.region ? 1 : -1)
    return distinctRegions
}

function distinctRegion2(input: OddsData.Match[]): Array<{region: string}> {
    // console.log (input)
    const distinctRegions: Array<{region: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctRegions) {
                if (ITEM.region === item.country) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctRegions.push({region: item.country})
            }
        }
    }
    // console.log (distinctRegions)
    distinctRegions.sort((a,b) => a.region > b.region ? 1 : -1)
    return distinctRegions
}

function distinctLeague(input: OddsData.Match[]): Array<{sport: string, region: string, league: string}> {
    // console.log (input)
    const distinctLeagues: Array<{sport: string, region: string, league: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctLeagues) {
                if (ITEM.league === item.tournament && ITEM.region === item.country && ITEM.sport === item.sport) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctLeagues.push({sport: item.sport, region: item.country, league: item.tournament})
            }
        }
    }
    distinctLeagues.sort((a,b) => a.league > b.league ? 1 : -1)
    return distinctLeagues
}

function distinctLeague2(input: OddsData.Match[]): Array<{league: string}> {
    // console.log (input)
    const distinctLeagues: Array<{league: string}> = []
    if (input) {
        for (const item of input) {
            let found: boolean = false
            for (const ITEM of distinctLeagues) {
                if (ITEM.league === item.tournament) {
                    found = true
                    break
                }
            }
            if (!found) {
                distinctLeagues.push({league: item.tournament})
            }
        }
    }
    distinctLeagues.sort((a,b) => a.league > b.league ? 1 : -1)
    return distinctLeagues
}

function getSportById(sportid: number, sport: OddsData.Sport[]): string {
    if (sport) {
        for (const item of sport) {
            if (item.id === sportid) {
                return item.name
            }
        }
    }
    return '-'
}

function getSportName (data: OddsData.LeagueData, sport): string {
    // if (data.Sport) {return data.Sport}
    if (data.sportid) {return getSportById(data.sportid, sport)}
    return Assets.Soccer
}

function injectDisabledResults(responseLeagues: OddsData.League[], DistinctLeague_: Array<{sport: string, region: string, league: string}>, sport: OddsData.Sport[]): OddsData.League[] {
    const ResponseLeagues: OddsData.League[] = Object.assign([], responseLeagues)
    for (const Item of ResponseLeagues) {
        let disabled: boolean = true
        if (DistinctLeague) {
            // console.log (Main.Instance.OddsState.distinctLeague)
            for (const item of DistinctLeague_) {
                if (item.league === Item.data.league && item.region === Item.data.section && (Item.data.sportid === undefined && item.sport === Assets.Soccer || getSportById(Item.data.sportid, sport) === item.sport)) {
                    disabled = false
                    break
                }
            }
        }
        Item.disabledResults = disabled
        Item.data.sport = getSportName(Item.data, sport)
    }
    return ResponseLeagues
}

function injectResult(responseMatches: OddsData.Match[]): OddsData.Match[] {
    const ResponseMatches: OddsData.Match[] = Object.assign([], responseMatches)
    if (responseMatches) {
        for (const item of ResponseMatches) {
            if (item.results === null /*|| item.results === 'null'*/) {
                item.result = 'NO'
            } else {
                item.result = 'YES'
            }
            item.Date = item.date.substring(0, 10)
        }
    }
    return ResponseMatches
}

function injectFlags(responseCountries: OddsData.Country[]): OddsData.Country[] {
    // console.log (Main.Instance.DatabaseDataState.FlagsStreamAll)
    // console.log (Main.Instance.DatabaseDataState.FlagsStreamAllOrder)

    const ResponseCountries: OddsData.Country[] = Object.assign([], responseCountries)
    if (responseCountries && Main.Instance.DatabaseDataState.FlagsStreamAll) {
        // console.log (Main.Instance.DatabaseDataState.FlagsStreamAll)
        // console.log (ResponseCountries)
        for (const item of ResponseCountries) {
            for (const Item of Main.Instance.DatabaseDataState.FlagsStreamAll) {
                if (item.code2 && Item.code && item.code2.toLowerCase() === Item.code.toLowerCase() || item.code2 && Item.code2 && item.code2.toLowerCase() === Item.code2.toLowerCase()) {
                    item.flag = Item.image
                    break
                }
            }
        }
    }
    return ResponseCountries
}

function wsInitMyChance() {
    
    if (Main.Instance.FrontendStoreState.strapiPass === undefined) {
        if (Cookies.get('strapiPass')) {
            const strapiPass = Cookies.get('strapiPass')
            Logic.Type.New(Main.Instance.FrontendStoreState, { strapiPass})
        }
        
    }
    if (Main.Instance.DatabaseDataState.usersNew === undefined && Main.Instance.Location === '/user-management/log') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { usersNew: null })
        const usersNew: UsersNew[] = []
        
        axios.get(Config.asNewUser + (parseInt(Main.Instance.LoginState.entityId) === 0 ? '' : '?entityId=' + Main.Instance.LoginState.entityId), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response1) => {
            for (const item of response1.data) {
                usersNew.push(item)
            }
            Logic.Type.New(Main.Instance.DatabaseDataState, {usersNew})
        })
        
    }
    if (Main.Instance.DatabaseDataState.storePurchases === undefined && Main.Instance.Location === '/reports/store-purchases') {
        Logic.Type.New(Main.Instance.DatabaseDataState, {
            storePurchases: null
        })
        Socket1.socket.Send(Config.amGetStorePurchases, {limit: 10, page: 1})
        getLoadedResources('Socket1 - Send', Config.amGetStorePurchases)
        
    }
    if (Main.Instance.DatabaseDataState.levelsStream === undefined && Main.Instance.Location === '/reports/cashback-monday-optins') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { levelsStream: null })
        WsGetLevels()
        
    }
    if (Main.Instance.DatabaseDataState.levelsStream === undefined && Main.Instance.Location === '/users-info') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { levelsStream: null })
        WsGetLevels()
        
    }
    if (Main.Instance.DatabaseDataState.missionLeaderboard === undefined && Main.Instance.Location === '/reports/chances-leaderboard') {
        Logic.Type.New(Main.Instance.DatabaseDataState, {
            missionLeaderboard: null
        })
        Socket1.socket.Send(Config.amGetMissionLeaderboard, {})
        getLoadedResources('Socket1 - Send', Config.amGetMissionLeaderboard)
        
    }
}

function wsInitDefault() {

    if (Socket1 && Main.Instance.DatabaseDataState.custom) {
        // if (key === 'game_Store' || key === 'front___End_Store') {
        if ((Main.Instance.Location.startsWith('/game-store') || Main.Instance.Location.startsWith('/front-end-store')) && Main.Instance.DatabaseDataState.gamesList === undefined) {
            Logic.Type.New (Main.Instance.DatabaseDataState, {gamesList: null})
            wsReinitializeGames()
        } else if (Main.Instance.DatabaseDataState.usersNew === undefined && Main.Instance.Location === '/user-management/log') {
            Logic.Type.New(Main.Instance.DatabaseDataState, { usersNew: null })
            const usersNew: UsersNew[] = []
            axios.get(Config.asNewUser + (parseInt(Main.Instance.LoginState.entityId) === 0 ? '' : '?entityId=' + Main.Instance.LoginState.entityId), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response1) => {
                for (const item of response1.data) {
                    usersNew.push(item)
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, {usersNew})
            })
        }
        // Socket1.socket.Send(Config.amBasicGet, { table: Config.amBonus })
    }
}

function wsInitJackpots() {
    // console.log(Main.Instance.Location)

    if (Socket1 && Main.Instance.DatabaseDataState.custom) {
        // console.log('init')
        if ((Main.Instance.Location.startsWith('/game-store') || Main.Instance.Location.startsWith('/front-end-store') || Main.Instance.Location.startsWith('/reports/game-reports') || Main.Instance.Location.startsWith('/bonus-section')) && Main.Instance.DatabaseDataState.gamesList === undefined) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { gamesList: null })
            wsJackpotsReinitializeGames()
        }
        if ((Main.Instance.DatabaseDataState.ggrReports === undefined || Main.Instance.DatabaseDataState.ggrReportsTotal === undefined) && (Main.Instance.Location === '/reports/ggr-revenue-report' || Main.Instance.Location === '/reports/game-reports-real' || Main.Instance.Location === '/reports/game-reports-test' || Main.Instance.Location === '/reports/player-reports')) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                ggrReports: null,
                ggrReportsTotal: null
            })
            Socket1.socket.Send(Config.amGetReports, {})
            getLoadedResources('Socket1 - Send', Config.amGetReports)
        }

        if (Main.Instance.DatabaseDataState.playersInfo === undefined && (Main.Instance.Location === '/reports/players' || Main.Instance.Location === '/reports/players-registrations')) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { playersInfo: null })
            Socket1.socket.Send(Config.amGetPlayersInfo, {})
            getLoadedResources('Socket1 - Send', Config.amGetPlayersInfo)
        } else if (/*Main.Instance.DatabaseDataState.bonus === undefined*/ Main.Instance.DatabaseDataState.usersNew === undefined && Main.Instance.Location === '/user-management/log') {
            Logic.Type.New(Main.Instance.DatabaseDataState, { usersNew: null })
            const usersNew: UsersNew[] = []
            axios.get(Config.asNewUser + (parseInt(Main.Instance.LoginState.entityId) === 0 ? '' : '?entityId=' + Main.Instance.LoginState.entityId), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response1) => {
                for (const item of response1.data) {
                    usersNew.push(item)
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, {usersNew})
            })
            // Socket1.socket.Send(Config.amBasicGet, { table: Config.amBonus })
            // getLoadedResources('Socket1 - Send', Config.amBasicGet, Config.amBonus)
        } else if (Main.Instance.DatabaseDataState.raffle === undefined && Main.Instance.Location === '/promo-store/raffles') {
            
            Logic.Type.New(Main.Instance.DatabaseDataState, { raffle: null })
            Socket1.socket.Send(Config.amBasicGet, { table: Config.amRaffle })
            getLoadedResources('Socket1 - Send', Config.amGetReports)
        /*
        } else if (Main.Instance.DatabaseDataState.bonus === undefined && (Main.Instance.Location === '/reports/bonus-campaigns' || Main.Instance.Location === '/game-store/bonus-wagering-requirement' || Main.Instance.Location === '/game-store/bonus-campaign' || Main.Instance.Location === '/game-store/bonus')) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { bonus: null })
            Socket1.socket.Send(Config.amBasicGet, { table: Config.amBonus })
            getLoadedResources('Socket1 - Send', Config.amBonus)
        */
        } else if (Main.Instance.DatabaseDataState.paymentProcessed === undefined && (Main.Instance.Location === '/account-store/withdrawal-requests' || Main.Instance.Location === '/account-store/withdrawal-duplicates')) {
            // console.log (new Date())
            Logic.Type.New(Main.Instance.DatabaseDataState, { paymentProcessed: null, PaymentProcessedGet: true })
            // Socket1.socket.Send(Config.amBasicGet, { table: Config.amProcessedPayments })
            // getLoadedResources('Socket1 - Send', Config.amBasicGet, Config.amProcessedPayments)

            Socket1.socket.Send(Config.amGetProcessedPayments, {page: 1, limit: 10, table: "processed_payments"})
            getLoadedResources('Socket1 - Send', Config.amGetProcessedPayments)
            
            // if (Main.Instance.Location === '/account-store/withdrawal-requests') {
            if (Main.Instance.DatabaseDataState.withdrawalRequest1 === undefined && Main.Instance.DatabaseDataState.WithdrawalRequest1 === false) {
                // const r = Config.pipeServer + Config.pipeWithdrawals + '?status=' + TransactionStatus.PENDING + '&token=' + Config.keyGet
                // getStream(r, onProgress, onEnd, onError)
                Socket1.socket.Send(Config.walletGameWithdrawGet, {
                    transactionStatus: TransactionStatus.PENDING,
                    page: 1,
                    pageSize: isProduction() ? 50 : 10
                    // pageSize: isProduction() ? undefined : 100
                })
                Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).loading = 'init'
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    withdrawalRequest1: [],
                    withdrawalRequest1Count: 0,
                    WithdrawalRequest1: true,
                    withdrawalRequest1Page: 1,
                    WithdrawalRequest1Time: Math.floor((new Date()).getTime()/1000)
                })
                getLoadedResources('Socket1 - Send', Config.walletGameWithdrawGet)
            }
            // }
        } else if (Main.Instance.DatabaseDataState.Languages === undefined && Main.Instance.Location === '/settings/generic-settings') {
            Logic.Type.New(Main.Instance.DatabaseDataState, { Languages: null })
            Socket1.socket.Send(Config.amBasicGet, { table: Config.amLanguages })
            getLoadedResources('Socket1 - Send', Config.amBasicGet, Config.amLanguages)
        } else if (Main.Instance.DatabaseDataState.countries === undefined && Main.Instance.Location === '/settings/player-settings') {
            Logic.Type.New(Main.Instance.DatabaseDataState, { countries: null })
            Socket1.socket.Send(Config.amBasicGet, { table: Config.amCountries })
            getLoadedResources('Socket1 - Send', Config.amBasicGet, Config.amCountries)
        /*
        } else if (Main.Instance.DatabaseDataState.jurisdictionsList === undefined && (Main.Instance.Location === '/user-management/log' || Main.Instance.Location === '/settings/games-settings')) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {jurisdictionsList: null})
            Socket1.socket.Send(Config.gGetJurisdictionsList, {})
            getLoadedResources('Socket1 - Send', Config.gGetJurisdictionsList)
        */
        } else if (Main.Instance.DatabaseDataState.gamesListLabels === undefined && Main.Instance.Location === '/settings/games-settings') {
            Logic.Type.New(Main.Instance.DatabaseDataState, {gamesListLabels: null})
            Socket1.socket.Send(Config.gGetGameLabels, {})
            getLoadedResources('Socket1 - Send', Config.gGetGameLabels)
        } else if (Main.Instance.DatabaseDataState.gamesListCategories === undefined && Main.Instance.Location === '/settings/games-settings') {
            Logic.Type.New(Main.Instance.DatabaseDataState, {gamesListCategories: null})
            Socket1.socket.Send(Config.gGetGameCategories, {})
            getLoadedResources('Socket1 - Send', Config.gGetGameCategories)
        } else if (Main.Instance.DatabaseDataState.devices === undefined && Main.Instance.Location === '/settings/games-settings') {
            Logic.Type.New(Main.Instance.DatabaseDataState, {devices: null})
            Socket1.socket.Send(Config.gGetDevices, {})
            getLoadedResources('Socket1 - Send', Config.gGetDevices)
        } else if (Main.Instance.DatabaseDataState.globallyExcludedTags === undefined && Main.Instance.Location === '/settings/bonus-settings') {
            Logic.Type.New(Main.Instance.DatabaseDataState, {globallyExcludedTags: null})
            Socket1.socket.Send(Config.bonusGloballyExcludedTagsGet, {eventId: 'event_id'})
            getLoadedResources('Socket1 - Send', Config.bonusGloballyExcludedTagsGet)
        } 
        if (Main.Instance.Location === '/bonus-section/free-games') {

            if (Main.Instance.DatabaseDataState.gameProviderNew === undefined ) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { gameProviderNew: null })
                Socket1.socket.Send(Config.gGetGameProviders, {})
            }
            if (Main.Instance.DatabaseDataState.gamesList === undefined) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { gamesList: null })    
                Socket1.socket.Send(Config.gGetGameList, {})
            }
        }
        if ((Main.Instance.Location === '/reports/bonus-campaigns' || Main.Instance.Location === '/bonus-section/bonus-offers' || Main.Instance.Location === '/bonus-section/bonus-campaign' || Main.Instance.Location === '/user-management/log') && Main.Instance.DatabaseDataState.bonusNew === undefined) {
            Socket1.socket.Send(Config.bonusBonusGet, {eventId: 'event_id', page: 1, limit: 1000})
            getLoadedResources('Socket1 - Send', Config.bonusBonusGet)
            Logic.Type.New(Main.Instance.DatabaseDataState, { bonusNew: null })
        } 

        if ((Main.Instance.Location === '/bonus-section/bonus-campaign' || Main.Instance.Location === '/reports/bonus-campaigns') && Main.Instance.DatabaseDataState.bonusCampaignNew === undefined) {
            Socket1.socket.Send(Config.bonusBonusCampaignGet, {eventId: 'event_id'})
            getLoadedResources('Socket1 - Send', Config.bonusBonusCampaignGet)
            Logic.Type.New(Main.Instance.DatabaseDataState, { bonusCampaignNew: null }) 
        }

        if (Main.Instance.Location === '/bonus-section/free-games' || Main.Instance.Location === '/bonus-section/bonus-offers') {
            if (Main.Instance.DatabaseDataState.freeGameSettings === undefined) {
                Socket1.socket.Send(Config.bonusFreeGamesGet, {eventId: 'event_id'})
                getLoadedResources('Socket1 - Send', Config.bonusFreeGamesGet)
                Logic.Type.New(Main.Instance.DatabaseDataState, { freeGameSettings: null }) 
            }
            
        }

    }

}

/*
function bygameid(a, b): number {
    return a.gameId > b.gameId ? 1 : -1
}
*/

function byname(a, b): number {
    return /*a.name.toLowerCase() === b.name.toLowerCase() ? a.id > b.id ? 1 : -1 : */a.gameName.toLowerCase() > b.gameName.toLowerCase() ? 1 : -1
}

/*
export function sortGames(byId: boolean) {
    const gamesCentralNew = Object.assign([], Main.Instance.DatabaseDataState.gamesCentralNew)
    gamesCentralNew.sort(byId ? bygameid : byname)
    const gamesCentral_New: string[] = []
    for (const item of gamesCentralNew) {
        gamesCentral_New.push(JSON.stringify(item))
    }

    const gamesCentralFilteredNew = Object.assign([], Main.Instance.DatabaseDataState.gamesCentralFilteredNew)
    gamesCentralFilteredNew.sort(byId ? bygameid : byname)
    const gamesApprovedAllNew = Object.assign([], Main.Instance.DatabaseDataState.gamesApprovedAllNew)
    gamesApprovedAllNew.sort(byId ? bygameid : byname)

    Logic.Type.New(Main.Instance.DatabaseDataState, {
        gamesCentralNew,
        gamesCentral_New,
        gamesCentralFilteredNew,
        gamesApprovedAllNew
    })
}
*/
function byName(a, b): number {
    return a.name === b.name ? a.country > b.country ? 1 : -1 : a.name > b.name ? 1 : -1
}
/*
export function byNAME(a, b): number {
    return a.name.toLowerCase() === b.name.toLowerCase() ? a.provider.name.toLowerCase() > b.provider.name.toLowerCase() ? 1 : -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
}
*/

export function byNAME(a, b): number {
    return a.Name.toLowerCase() === b.Name.toLowerCase() ? a.Provider.toLowerCase() > b.Provider.toLowerCase() ? 1 : -1 : a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : -1
}


function byDateUnix(a, b): number {
    return a.date > b.date ? 1 : -1
}

function getCountry(country: string): string {
    if (Main.Instance.DatabaseDataState.countries) {
        for (const item of Main.Instance.DatabaseDataState.countries) {
            if (item.data.code === country) {
                return item.data.name
            }
        }
    }
    return '?'
}

function getRegion(country: string, region: string): string {
    if (Main.Instance.DatabaseDataState.countries) {
        for (const item of Main.Instance.DatabaseDataState.countries) {
            if (item.data.code === country) {
                for (const Item of item.data.regions) {
                    if (Item.code === region) {
                        return Item.name
                    }
                }
            }
        }
    }
    return '?'
}

function getNationality(nationality: string): string {
    if (Main.Instance.DatabaseDataState.nationalities) {
        for (const item of Main.Instance.DatabaseDataState.nationalities) {
            if (item.data.code3 === nationality) { return item.data.nationality }
        }
    }
    return '?'
}

function getDate(date: number): string {
    if (date === undefined) { return '' }
    const d = new Date(date * 1000)
    return d.toISOString().substring(0, 19).replace('T', ' ')
}

export function wsGet() {
    if (IsBuildJackpotsCH() || IsBuildPasino()) {
        wsInitJackpots()
    }
    if (IsBuildDefault()) {
        wsInitDefault()
    }

    if (IsBuildMyChance()) {
        wsInitMyChance()
    }
/*
    if (IsBuildOdds()) {
        wsInitOdds()
    }
*/
    // Config.amGameSessionsGet
    // JACKPOTS

    // BONUS SERVICE
    if (Socket1 && Socket1.socket) { 
        if (IsBuildPasino() || IsBuildJackpotsCH()) {

            // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus))
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).loading === 'loaded') {
                if (Main.Instance.PlayerCardState.BonusCancel) {
                    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).payload &&
                        Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).payload.data &&
                        Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).resolved /*&&
                        Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancel).message === 'Bonus successfully canceled'*/) {
                        Logic.Type.New(Main.Instance.PlayerCardState, {
                            BonusCancel: false,
                            BonusInfoGet: true,
                        })
                        getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                        alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).payload.statusCode)
                    } else {
                        Logic.Type.New(Main.Instance.PlayerCardState, {
                            BonusCancel: false
                        })
                        alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).error : Assets.Failed)
                        // Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonus).loading = 'init'
                    }
                }
            }

            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).loading === 'loaded') {
                if (Main.Instance.PlayerCardState.BonusCancelAll) {
                    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).payload &&
                        Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).payload.data &&
                        Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).resolved /*&&
                        Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancelAll).message === 'Bonuses successfully canceled'*/) {
                        Logic.Type.New(Main.Instance.PlayerCardState, {
                            BonusCancelAll: false,
                            BonusInfoGet: true
                        })
                        getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                        alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).payload.statusCode)
                    } else {
                        Logic.Type.New(Main.Instance.PlayerCardState, {
                            BonusCancelAll: false
                        })
                        alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).error : Assets.Failed)
                        // Socket1.socket.Get<RouteClasses.Route>(Config.bonusCancelBonusAll).loading = 'init'
                    }
                }
            }

            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusPlayerBonusHistory) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusPlayerBonusHistory).loading === 'loaded') {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusPlayerBonusHistory).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusPlayerBonusHistory).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusPlayerBonusHistory).resolved) {
                    if (!Main.Instance.PlayerCardState.bonusInfo || Main.Instance.PlayerCardState.BonusInfoGet) {
                        Logic.Type.New(Main.Instance.PlayerCardState, {
                            BonusInfoGet: false,
                            // BonusInfo: true,
                            bonusInfo: Socket1.socket.Get<RouteClasses.Route>(Config.bonusPlayerBonusHistory).payload.data.bonusInstances,
                            bonusInfoFreeGames: Socket1.socket.Get<RouteClasses.Route>(Config.bonusPlayerBonusHistory).payload.data.freeGamesInstances
                        })
                        getLoadedResources('Socket1 - Get', Config.bonusPlayerBonusHistory)
                    }
                }
            }
            
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).loading === 'loaded') {
                if (Main.Instance.PlayerCardState.BonusAddManual) {
                    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).resolved) {
                        if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).payload.data.offerState === 'GRANTED') {
                            Logic.Type.New(Main.Instance.PlayerCardState, {
                                BonusAddManual: false,
                                BonusAmount: 0,
                                BonusInfoGet: true,
                            })
                            getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                            alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).payload.data.offerState)
                        } else {
                            Logic.Type.New(Main.Instance.PlayerCardState, {
                                BonusAddManual: false,
                                BonusAmount: 0,
                            })
                            alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).payload.statusCode && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).payload.statusCode.replace(/_/g, ' '))
                        }
                    } else {
                        Logic.Type.New(Main.Instance.PlayerCardState, {
                            BonusAddManual: false,
                            BonusAmount: 0,
                        })
                        alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCustom).error : Assets.Failed)
                        // Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManual).loading = 'init'
                    }
                }  
            }
/*
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).loading === 'loaded') {
                if (Main.Instance.PlayerCardState.BonusAddManualDeposit) {
                    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).resolved) {
                        if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).payload.data.offerState === 'GRANTED') {
                            Logic.Type.New(Main.Instance.PlayerCardState, {
                                BonusAddManualDeposit: false,
                                DepositBonusAmount: 0,
                                BonusId: -1,
                                BonusInfoGet: true,
                            })
                            getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                            alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).payload.statusCode)
                        } else {
                            Logic.Type.New(Main.Instance.PlayerCardState, {
                                BonusAddManualDeposit: false,
                                DepositBonusAmount: 0,
                                BonusId: -1,
                            })
                            alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).payload.statusCode && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).payload.statusCode.replace(/_/g, ' '))
                        }
                    } else {
                        Logic.Type.New(Main.Instance.PlayerCardState, {
                            BonusAddManualDeposit: false,
                            DepositBonusAmount: 0,
                            BonusId: -1,
                        })
                        alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualDeposit).error : Assets.Failed)
                        // Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManual).loading = 'init'
                    }
                }  
            }
*/
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).loading === 'loaded') {
                if (Main.Instance.PlayerCardState.BonusAddManualCode) {
                    if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).resolved) {
                        if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).payload.data.offerState === 'GRANTED') {
                            Logic.Type.New(Main.Instance.PlayerCardState, {

                                BonusAddManualCode: false,
                                BonusCode: '',
                                BonusInfoGet: true,
                                
                            })
                            getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                            alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).payload.data.offerState)
                            
                        } else {

                            Logic.Type.New(Main.Instance.PlayerCardState, {
                                BonusAddManualCode: false,
                                BonusCode: '',
                            })
                            alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).payload.statusCode && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).payload.statusCode.replace(/_/g, ' '))
                            
                        }
                    } else {
                        Logic.Type.New(Main.Instance.PlayerCardState, {
                            BonusAddManualCode: false,
                            BonusCode: '',
                        })
                        alert(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).error ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).error.message ? Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).error.message : Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).error : Assets.Failed)
                        
                        // Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusAddManualCode).loading = 'init'
                    }
                } 
            }
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsGet) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsGet).loading === 'loaded') {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsGet).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsGet).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsGet).resolved) {
                    if (!Main.Instance.DatabaseDataState.globallyExcludedTags || Main.Instance.DatabaseDataState.globallyExcludedTagsGet) {
                        getLoadedResources('Socket1 - Get', Config.bonusGloballyExcludedTagsGet)
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            globallyExcludedTags: Socket1.socket.Get<RouteClasses.Route>(Config.bonusGloballyExcludedTagsGet).payload.data.tags,
                            globallyExcludedTagsGet: false
                        })
                    }
                }
            }
            // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusGet))
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusGet) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusGet).loading === 'loaded') {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusGet).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusGet).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusGet).resolved) {
                    if (!Main.Instance.DatabaseDataState.bonusNew || Main.Instance.DatabaseDataState.bonusNewGet) {
                        getLoadedResources('Socket1 - Get', Config.bonusBonusGet)
                        const bonus: BonusNew[] = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusGet).payload.data)
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            bonusNew: bonus,
                            bonusNewGet: false
                        })
                    }
                }
            }

            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignGet) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignGet).loading === 'loaded') {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignGet).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignGet).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignGet).resolved) {
                    if (!Main.Instance.DatabaseDataState.bonusCampaignNew || Main.Instance.DatabaseDataState.bonusCampaignNewGet) {
                        getLoadedResources('Socket1 - Get', Config.bonusBonusCampaignGet)
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            bonusCampaignNew: Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusCampaignGet).payload.data,
                            bonusCampaignNewGet: false
                        })
                    }
                }
            }
            
            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusTriggeredInfo) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusTriggeredInfo).loading === 'loaded') {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusTriggeredInfo).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusTriggeredInfo).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusTriggeredInfo).resolved) {
                    if (!Main.Instance.DatabaseDataState.bonusCampaignReports || Main.Instance.DatabaseDataState.BonusCampaignReportsGet) {
                        if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusTriggeredInfo).payload.data[0]) {
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                bonusCampaignReportsCount: Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusTriggeredInfo).payload.data[0].totalItems,
                                BonusCampaignReportsGet: false,
                                bonusCampaignReports: Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusTriggeredInfo).payload.data
                            })

                        } else {
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                bonusCampaignReportsCount: 0,
                                BonusCampaignReportsGet: false,
                                bonusCampaignReports: Socket1.socket.Get<RouteClasses.Route>(Config.bonusBonusTriggeredInfo).payload.data
                            })
                        }
                        getLoadedResources('Socket1 - Get', Config.bonusBonusTriggeredInfo)
                    }
                }
            }
            
            

            if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesGet) && Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesGet).loading === 'loaded') {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesGet).payload && Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesGet).payload.data && Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesGet).resolved) {
                    if (!Main.Instance.DatabaseDataState.freeGameSettings || Main.Instance.DatabaseDataState.freeGameSettingsGet) {
                        getLoadedResources('Socket1 - Get', Config.bonusFreeGamesGet)
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            freeGameSettings: Socket1.socket.Get<RouteClasses.Route>(Config.bonusFreeGamesGet).payload.data,
                            freeGameSettingsGet: false
                        })
                    }
                }
            }
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetProcessedPayments) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetProcessedPayments).loading === 'loaded') {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetProcessedPayments).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetProcessedPayments).resolved) {
                    if (Main.Instance.DatabaseDataState.PaymentProcessedGet || Main.Instance.DatabaseDataState.PaymentProcessedInsert2) {
                        getLoadedResources('Socket1 - Get', Config.amGetProcessedPayments)
                        const newData = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amGetProcessedPayments).message)
                        const fetchedData = Object.assign([], Main.Instance.DatabaseDataState.paymentProcessed)
                        const paymentProcessed_ = Object.assign([], Main.Instance.DatabaseDataState.paymentProcessed_)
                        for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetProcessedPayments).message) {
                            paymentProcessed_.push(JSON.stringify(item))
                        }
                        for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetProcessedPayments).message) {
                            fetchedData.push(item)
                        }
                        // more to fetch
                        // console.log(fetchedData)
                        if (newData.length && newData.length === 10) {
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                paymentProcessed: fetchedData,
                                paymentProcessed_
                            })
                            Socket1.socket.Get<RouteClasses.Route>(Config.amGetProcessedPayments).loading === 'init'
                            Socket1.socket.Send(Config.amGetProcessedPayments, {table: "processed_payments", page: Socket1.socket.Get<RouteClasses.Route>(Config.amGetProcessedPayments).page + 1, limit: 10})
                        } else {
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                paymentProcessed: fetchedData,
                                PaymentProcessedGet: false,
                                paymentProcessed_,
                                PaymentProcessedInsert2: false
                            })
                        }
                        
                    }
                }
            }
        
        }
    }


    // withdrawals
    // onlyWithdrawalRequestStatus
    if (Socket1.socket.Get<RouteClasses.Route>(Config.walletTransactionsGet) && Socket1.socket.Get<RouteClasses.Route>(Config.walletTransactionsGet).loading === 'loaded') {
        if (!Main.Instance.DatabaseDataState.playerTimelineTransactions && Socket1.socket.Get<RouteClasses.Route>(Config.walletTransactionsGet).transactions && Socket1.socket.Get<RouteClasses.Route>(Config.walletTransactionsGet).resolved) {

            const playerTimelineTransactions: any[] = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.walletTransactionsGet).transactions)
            let wrongId: boolean = false
            for (const item of playerTimelineTransactions) {
                item.entrySubType =
                    item.transactionType === TransactionType.DEPOSIT ? TimelineEntrySubType.Deposit :
                    item.transactionType === TransactionType.WITHDRAW ? TimelineEntrySubType.Withdraw :
                    item.transactionType === TransactionType.DEPOSIT_MANUAL ? TimelineEntrySubType.ManualDeposit :
                    item.transactionType === TransactionType.WITHDRAW_MANUAL ? TimelineEntrySubType.ManualWithdraw :
                    item.transactionType === TransactionType.DEPOSIT_CANCEL ? TimelineEntrySubType.CanceledDeposit :
                    item.transactionType === TransactionType.WITHDRAW_CANCEL ? TimelineEntrySubType.CanceledWithdraw :
                    0

                item.created = item.created ? isNaN(item.created as any) ? item.created.substring(0, 19).replace('T', ' ') : getDate(item.created ? +item.created : undefined) : ''
                item.completed = item.completed ? isNaN(item.completed as any) ? item.completed.substring(0, 19).replace('T', ' ') : getDate(item.completed ? +item.completed : undefined) : ''
                item.entryType = TimelineEntryType.Transaction
                // item.transactiontype = TransactionType[item.transactionType]
                item.transactionstatus = TransactionStatus[item.transactionStatus]
                item.transactiontype_ = (
                    item.transactionType === TransactionType.DEPOSIT || item.transactionType === TransactionType.DEPOSIT_MANUAL || item.transactionType === TransactionType.DEPOSIT_CANCEL ? 'd' : 
                    item.transactionType === TransactionType.WITHDRAW || item.transactionType === TransactionType.WITHDRAW_MANUAL || item.transactionType === TransactionType.WITHDRAW_CANCEL ? 'w' :
                    item.transactionType === TransactionType.WAGER || item.transactionType === TransactionType.WAGER_CANCEL ? 'a' :
                    item.transactionType === TransactionType.WIN || item.transactionType === TransactionType.WIN_CANCEL ? 'i' :
                    item.transactionType === TransactionType.BONUS_ADD || item.transactionType === TransactionType.BONUS_CANCEL || item.transactionType === TransactionType.BONUS_REDEEM ? 'b' :
                    'u')
                if (item.playerId && item.playerId !== Main.Instance.PlayerCardState.id) {
                    wrongId = true
                }
            }
            getLoadedResources('Socket1 - Get', Config.walletTransactionsGet)
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                playerTimeline: playerTimelineTransactions,
                playerTimelineTransactions,
                wrongId
                // playerTimelineTransactionsCount: Socket1.socket.Get<RouteClasses.Route>(Config.walletTransactionsGet).totalNumOfItems
            })
        }
    }

    // console.log (Main.Instance.DatabaseDataState.withdrawalRequest1Page)
    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet))
    if (Main.Instance.DatabaseDataState.paymentProcessed && Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet) && Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).transactions && Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).resolved) {
            if (Main.Instance.DatabaseDataState.WithdrawalRequest1) {
                const withdrawalRequest1Count: number = Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).totalNumOfItems
                const withdrawalRequest1: WithdrawalRequest[] = Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).transactions
                
                Socket1.socket.Send(Config.walletGameWithdrawGet, {
                    transactionStatus: Main.Instance.DatabaseDataState.onlyWithdrawalRequestStatus,
                    page: 1,
                    pageSize: isProduction() ? 50 : 10
                    // pageSize: isProduction() ? undefined : 100
                })
                Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).loading = 'init'

                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    WithdrawalRequest2Time: Math.floor((new Date()).getTime()/1000),
                    WithdrawalRequest1: false,
                    withdrawalRequest2: [],
                    WithdrawalRequest2: true,
                    withdrawalRequest1Page: 1,
                    withdrawalRequest1Count,// : Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).totalNumOfItems,
                    withdrawalRequest1// : Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).transactions
                })

                getLoadedResources('Socket1 - Get', Config.walletTransactionsGet, 'WithdrawalRequest1')
                getLoadedResources('Socket1 - Send', Config.walletGameWithdrawGet)
                // Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).loading = 'init'

            } else if (Main.Instance.DatabaseDataState.WithdrawalRequest2) {
                getLoadedResources('Socket1 - Get', Config.walletTransactionsGet, 'WithdrawalRequest2')
                const withdrawalRequest2: WithdrawalRequest[] = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).transactions)
                
                if (!thereIsNoneGeneratedPaymentFiles()) {
                    for (const item of withdrawalRequest2) {
                        // let found: boolean = false
                        // console.log ('paymentProcessed')
                        // console.log (Main.Instance.DatabaseDataState.paymentProcessed)
                        const Item: PaymentProcessed = Main.Instance.DatabaseDataState.paymentProcessed && Main.Instance.DatabaseDataState.paymentProcessed[Main.Instance.DatabaseDataState.paymentProcessed.length - 1]
                        // for (const Item of Main.Instance.DatabaseDataState.paymentProcessed) {
                        if (Item && Item.data && Item.data.status === PaymentProcessedStatus.Generated && Item.data.transactionIds) {
                        // console.log (Item)
                            for (const ITEM of Item.data.transactionIds) {
                                if (ITEM === item.transactionId) {
                                    // console.log ('found')
                                    // found = true
                                    item.markedForPayment = true
                                    break
                                }
                            }
                        }
                            // if (found) {break}
                        // }
                    }
                }

                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    WithdrawalRequest2: false,
                    withdrawalRequest2Count: Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).totalNumOfItems,
                    withdrawalRequest2
                })
            } else if (Main.Instance.DatabaseDataState.WithdrawalRequest1_) {
                const withdrawalRequest1 = Object.assign([], Main.Instance.DatabaseDataState.withdrawalRequest1)
                withdrawalRequest1.push(...Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).transactions)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    withdrawalRequest1,
                    WithdrawalRequest1_: false,
                    withdrawalRequest1Count: Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).totalNumOfItems
                })
                getLoadedResources('Socket1 - Get', Config.walletTransactionsGet, 'WithdrawalRequest1_')
            } else if (Main.Instance.DatabaseDataState.WithdrawalRequest2_) {
                // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).transactions)
                // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).totalNumOfItems)
                const withdrawalRequest2_ = Object.assign([], Main.Instance.DatabaseDataState.withdrawalRequest2)
                const withdrawalRequest2: WithdrawalRequest[] = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).transactions)
                if (!thereIsNoneGeneratedPaymentFiles()) {
                    for (const item of withdrawalRequest2) {
                        // let found: boolean = false
                        const Item: PaymentProcessed = Main.Instance.DatabaseDataState.paymentProcessed[Main.Instance.DatabaseDataState.paymentProcessed.length - 1]
                        // for (const Item of Main.Instance.DatabaseDataState.paymentProcessed) {
                        if (Item.data.status === PaymentProcessedStatus.Generated && Item.data.transactionIds) {
                            // console.log (Item)
                            for (const ITEM of Item.data.transactionIds) {
                                if (ITEM === item.transactionId) {
                                    // console.log ('found')
                                    // found = true
                                    item.markedForPayment = true
                                    break
                                }
                            }
                        }
                            // if (found) {break}
                        // }
                    }
                }
                // console.log (withdrawalRequest2)
                withdrawalRequest2_.push(...withdrawalRequest2)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    withdrawalRequest2: withdrawalRequest2_,
                    WithdrawalRequest2_: false,
                    withdrawalRequest2Count: Socket1.socket.Get<RouteClasses.Route>(Config.walletGameWithdrawGet).totalNumOfItems
                })
                getLoadedResources('Socket1 - Get', Config.walletTransactionsGet, 'WithdrawalRequest2_')
            }
        }
    }
    // game transactions
    if (Socket1.socket.Get<RouteClasses.Route>(Config.walletGameTransactionsGet) && Socket1.socket.Get<RouteClasses.Route>(Config.walletGameTransactionsGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.walletGameTransactionsGet).gameTransactions && Socket1.socket.Get<RouteClasses.Route>(Config.walletGameTransactionsGet).resolved) {
            if (!Main.Instance.PlayerCardState.gameSessionsTransactions || Main.Instance.PlayerCardState.GameSessionsTransactionsGet) {
                getLoadedResources('Socket1 - Get', Config.walletGameTransactionsGet)
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    GameSessionsTransactionsGet: false,
                    selectingGameSessionId: false,
                    gameSessionsTransactionsCount: Socket1.socket.Get<RouteClasses.Route>(Config.walletGameTransactionsGet).totalNumOfItems,
                    gameSessionsTransactions: Socket1.socket.Get<RouteClasses.Route>(Config.walletGameTransactionsGet).gameTransactions
                })
            }
        }
    }

    // game sessions
    if (Socket1.socket.Get<RouteClasses.Route>(Config.walletGameSessionsGet) && Socket1.socket.Get<RouteClasses.Route>(Config.walletGameSessionsGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.walletGameSessionsGet).gameSessions && Socket1.socket.Get<RouteClasses.Route>(Config.walletGameSessionsGet).resolved) {
            if (!Main.Instance.PlayerCardState.gameSessions || Main.Instance.PlayerCardState.GameSessionsGet) {
                getLoadedResources('Socket1 - Get', Config.walletGameSessionsGet)
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    gameSessionsCount: Socket1.socket.Get<RouteClasses.Route>(Config.walletGameSessionsGet).totalNumOfItems ? Socket1.socket.Get<RouteClasses.Route>(Config.walletGameSessionsGet).totalNumOfItems : 0,
                    GameSessionsGet: false,
                    gettingGameSessions: false,
                    GameSessions: true,
                    gameSessions: Socket1.socket.Get<RouteClasses.Route>(Config.walletGameSessionsGet).gameSessions
                })
            }
        }
    }
    

    if (Socket2 && Socket2.socket) {     
        if (IsBuildMyChance()) {

            if (Socket2.socket.Get<RouteClasses.Route>(Config.amMyChanceGames) && Socket2.socket.Get<RouteClasses.Route>(Config.amMyChanceGames).loading === 'loaded') {
                if (Socket2.socket.Get<RouteClasses.Route>(Config.amMyChanceGames).resolved && Socket2.socket.Get<RouteClasses.Route>(Config.amMyChanceGames).response && !Main.Instance.DatabaseDataState.Games) {
                    const GAMES: any[] = Socket2.socket.Get<RouteClasses.Route>(Config.amMyChanceGames).response
                    for (const item of GAMES) {
                        item.Name = item.Name.trim()
                        item.Provider = item.Provider && item.Provider.trim()
                        item.Category = item.Category.trim()
                    }

                    const GamesStreamAllSorted = GAMES.sort(byNAME)
                    const GamesStreamAllSelected: boolean[] = []
                    const providers: number[] = []
                    const _providers_: number[] = []
                    const gamesStreamProvider: any[] = []
                    const gamesStreamProvider_: any[] = []
                    const GamesStreamProvider: any[] = []
                    const categories: any[] = []
                    const _categories: any[] = []
                    const _categories_: number[] = []
                    const Categories: any[] = []
                    const gameCategories: number[] = []
                    for (const item of Socket2.socket.Get<RouteClasses.Route>(Config.amMyChanceGames).response) {
                        let found: boolean = false
                        let Found: boolean = false
                        for (const Item of gamesStreamProvider) {
                            if (item['Provider']/*.trim()*/ === Item['name']) {
                                found = true
                                break
                            }
                        }
                        for (const Item of categories) {
                            if (item['Category']/*.trim()*/ === Item['name']) {
                                Found = true
                                break
                            }
                        }
                        if (!found) {
                            gamesStreamProvider.push({ id: (GamesStreamProvider.length + 1).toString(), name: item['Provider']/*.trim()*/ })
                        }

                        if (!Found) {
                            categories.push({ id: (Categories.length + 1).toString(), name: item['Category']/*.trim()*/ })
                        }
                    }

                    gamesStreamProvider.sort(dynamicSort('name'))
                    GamesStreamProvider.push({ id: '0', name: Assets.AnyProvider })
                    _providers_.push(0)
                    for (const item of gamesStreamProvider) {
                        _providers_.push(0)
                        providers.push(GamesStreamProvider.length)
                        gamesStreamProvider_.push({ id: GamesStreamProvider.length.toString(), name: item['name'] })
                        GamesStreamProvider.push({ id: GamesStreamProvider.length.toString(), name: item['name'] })
                    }

                    categories.sort(dynamicSort('name'))
                    Categories.push({ id: '0', name: Assets.AnyProvider })
                    _categories_.push(0)
                    for (const item of categories) {
                        gameCategories.push(Categories.length)
                        _categories.push({ id: Categories.length.toString(), name: item['name'] })
                        Categories.push({ id: Categories.length.toString(), name: item['name'] })
                        _categories_.push(0)
                    }

                    for (const item of GAMES) {
                        GamesStreamAllSelected.push(false)
                        for (const Item of _categories) {
                            if (Item.name === item.Category/*.trim()*/) {
                                _categories_[+Item.id]++
                                break
                            }
                        }

                        for (const Item of gamesStreamProvider_) {
                            if (Item.name === item.Provider/*.trim()*/) {
                                _providers_[+Item.id]++
                                break
                            }
                        }
                    }
                    _categories_[0] = GamesStreamAllSelected.length
                    _providers_[0] = GamesStreamAllSelected.length

                    getLoadedResources('Socket2 - Get', Config.amMyChanceGames)
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        Games: GAMES,
                        GamesStreamProvider,
                        gamesStreamProvider: gamesStreamProvider_,
                        GamesStream: GamesStreamAllSorted,
                        GamesStreamAll: GamesStreamAllSorted,
                        GamesStreamAllSelected,
                        _categories,
                        _categories_,
                        _providers_,
                        Categories,
                    })
                    Logic.Type.New(Main.Instance.GamesState, {
                        providers,
                        gameCategories,
                        count: Socket2.socket.Get<RouteClasses.Route>(Config.amMyChanceGames).response.length,
                        countCalled: false
                    })
                }
            }
        }
    }
    // MYCHANCE

    if (Main.Instance.DatabaseDataState.isChangingPlayerLevel && Socket1.socket.Get<RouteClasses.Route>(Config.amChangePlayerLevel) && Socket1.socket.Get<RouteClasses.Route>(Config.amChangePlayerLevel).loading === 'loaded' && /* Socket1.socket.Get<RouteClasses.Route>(Config.amChangePlayerLevel).resolved && */Socket1.socket.Get<RouteClasses.Route>(Config.amChangePlayerLevel).message) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { isChangingPlayerLevel: false })
        alert(Socket1.socket.Get<RouteClasses.Route>(Config.amChangePlayerLevel).message)
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetUsersInfoFiltered) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetUsersInfoFiltered).loading === 'loaded') {
        if (!Main.Instance.DatabaseDataState.usersInfoFiltered || Main.Instance.DatabaseDataState.usersInfoFilteredGet) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetUsersInfoFiltered).resolved === false) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {usersInfoFilteredGet: false})
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    usersInfoFiltered: Socket1.socket.Get<RouteClasses.Route>(Config.amGetUsersInfoFiltered).message.playersInfo,
                    usersInfoFilteredGet: false,
                    usersInfoCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetUsersInfoFiltered).message.totalItems,
                })
                if (Main.Instance.UsersInfoState.filteredData && Main.Instance.UsersInfoState.filteredData.length > 0) {
                    Logic.Type.New(Main.Instance.UsersInfoState, {filteredData: undefined, pNum: 1})
                }
                getLoadedResources('Socket1 - Get', Config.amGetUsersInfoFiltered)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetUserInfo) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetUserInfo).loading === 'loaded') {
        if (!Main.Instance.DatabaseDataState.userInfo || Main.Instance.DatabaseDataState.userInfoGet) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetUserInfo).resolved === false) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    userInfoGet: false,
                    userIdSelected: false
                })
            } else {
                const userInfo: IUserInfo = Object.assign({}, Socket1.socket.Get<RouteClasses.Route>(Config.amGetUserInfo).message)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    userInfo,
                    userInfoGet: false,
                    userIdSelected: true
                })
                getLoadedResources('Socket1 - Get', Config.amGetUserInfo)
            }
            
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetStorePurchases) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetStorePurchases).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetStorePurchases).resolved) {
        if (!Main.Instance.DatabaseDataState.storePurchases || Main.Instance.DatabaseDataState.storePurchasesGet) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetStorePurchases).resolved === false) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {storePurchasesGet: false})
            } else {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                storePurchases: Socket1.socket.Get<RouteClasses.Route>(Config.amGetStorePurchases).message.rewards,
                storePurchasesGet: false,
                storePurchasesCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetStorePurchases).message.totalItems,
                storePurchasesSelectedPlayerUsername: Socket1.socket.Get<RouteClasses.Route>(Config.amGetStorePurchases).message.username
            })
            getLoadedResources('Socket1 - Get', Config.amGetStorePurchases)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentLeaderboard) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentLeaderboard).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentLeaderboard).resolved) {
        if (!Main.Instance.DatabaseDataState.tournamentResult || Main.Instance.DatabaseDataState.TournamentLeaderboardGet) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                tournamentResult: Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentLeaderboard).message ? Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentLeaderboard).message.leaderboard ? Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentLeaderboard).message.leaderboard : Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentLeaderboard).message : [],
                TournamentLeaderboardGet: false,
            })
            getLoadedResources('Socket1 - Get', Config.amGetTournamentLeaderboard)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amCashbackMondayOptionsGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amCashbackMondayOptionsGet).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amCashbackMondayOptionsGet).resolved) {
        if (Main.Instance.DatabaseDataState.CashbackMondayOptins === undefined) {
            const CashbackMondayOptins = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amCashbackMondayOptionsGet).message)
            Logic.Type.New(Main.Instance.DatabaseDataState, {CashbackMondayOptins})
            getLoadedResources('Socket1 - Get', Config.amCashbackMondayOptionsGet)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionLeaderboard) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionLeaderboard).loading === 'loaded') {
        if (!Main.Instance.DatabaseDataState.missionLeaderboard || Main.Instance.DatabaseDataState.missionLeaderboardGet) {
            // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionLeaderboard))
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionLeaderboard).resolved) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { missionLeaderboard: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionLeaderboard).message.leaderboard, missionLeaderboardCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionLeaderboard).message.leaderboard.length, missionLeaderboardGet: false, missionLeaderboardUpdate: true })
                getLoadedResources('Socket1 - Get', Config.amGetMissionLeaderboard)
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {missionLeaderboardGet: false })

            }
            
        }
    }

    // JACKPOTS
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetFirstDepositsList) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetFirstDepositsList).loading === 'loaded') {
        if ((!Main.Instance.DatabaseDataState.recentEventsFirstDeposits || Main.Instance.DatabaseDataState.RecentEventsGetFirstDeposits) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetFirstDepositsList)) {
            const recentEventsFirstDeposits = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amGetFirstDepositsList))
            getLoadedResources('Socket1 - Get', Config.amGetFirstDepositsList)
            if (!Main.Instance.DatabaseDataState.recentEventsActive) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetIssues: true, RecentEventsGetFirstDeposits: false, recentEventsFirstDepositsTimestamp: (new Date()).toISOString(), recentEventsFirstDeposits })
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false, RecentEventsGetIssues: true, RecentEventsGetFirstDeposits: false, recentEventsFirstDepositsTimestamp: (new Date()).toISOString(), recentEventsFirstDeposits })
                download(recentEventsFirstDeposits, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
            }
        }
    }
    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount))
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount).resolved) {
        
        // console.log('GET', Main.Instance.DatabaseDataState.IssuesCount)
        if (Main.Instance.DatabaseDataState.issuesCount === undefined || Main.Instance.DatabaseDataState.IssuesCount % 10 === 1) {
            
            let type: number = TimelineEntrySubType.Issues + Math.floor(Main.Instance.DatabaseDataState.IssuesCount / 10)
            Logic.Type.New(Main.Instance.DatabaseDataState, { type })
            const db: boolean = type === 39 ? true : false
            const Db: boolean = type === 40 ? true : false
            if (db || Db) {
                type = TimelineEntrySubType.ResponsibleGaming as number
            }
            if (Main.Instance.DatabaseDataState.issuesCount) {
                if (type === TimelineEntrySubType.RiskManagement as number) {
                    getPaginatedIssues(
                        {
                            resolved: FourIssues() ? Main.Instance.RiskManagementState.filterResolved : false,
                            minIssueType: Main.Instance.DatabaseDataState.issuesFilterIssueTypeRM === 999 ?
                                IssueTypes.RiskManagement :
                                Main.Instance.DatabaseDataState.issuesFilterIssueTypeRM as any,
                            maxIssueType: Main.Instance.DatabaseDataState.issuesFilterIssueTypeRM === 999 ?
                                IssueTypes.Other1 :
                                Main.Instance.DatabaseDataState.issuesFilterIssueTypeRM as any
                        },
                        Main.Instance.DatabaseDataState.issues1Page,
                        Main.Instance.DatabaseDataState.issues1Limit,
                        type,
                        Main.Instance.DatabaseDataState.issuesFilterIssueTypeRM
                    )
                } else if (type === TimelineEntrySubType.ResponsibleGaming as number) {
                    if (Db) {

                    } else {
                        getPaginatedIssues(
                            {
                                resolved: FourIssues() ? Main.Instance.RiskManagementState.filterResolved : false,
                                minIssueType: Main.Instance.DatabaseDataState.issuesFilterIssueTypeRG === 999 ?
                                    IssueTypes.ResponsibleGaming :
                                    Main.Instance.DatabaseDataState.issuesFilterIssueTypeRG as any,
                                maxIssueType: Main.Instance.DatabaseDataState.issuesFilterIssueTypeRG === 999 ?
                                    IssueTypes.Other2 :
                                    Main.Instance.DatabaseDataState.issuesFilterIssueTypeRG as any
                            },
                            Main.Instance.DatabaseDataState.issues2Page,
                            Main.Instance.DatabaseDataState.issues2Limit,
                            type,
                            db ? undefined : Main.Instance.DatabaseDataState.issuesFilterIssueTypeRG
                        )
                    }
                } else if (type === TimelineEntrySubType.KnowYourCustomer as number) {
                    getPaginatedIssues(
                        {
                            resolved: FourIssues() ? Main.Instance.RiskManagementState.filterResolved : false,
                            minIssueType: Main.Instance.DatabaseDataState.issuesFilterIssueTypeKYC === 999 ?
                                IssueTypes.KnowYourCustomer :
                                Main.Instance.DatabaseDataState.issuesFilterIssueTypeKYC as any,
                            maxIssueType: Main.Instance.DatabaseDataState.issuesFilterIssueTypeKYC === 999 ?
                                IssueTypes.Other3 :
                                Main.Instance.DatabaseDataState.issuesFilterIssueTypeKYC as any
                        },
                        Main.Instance.DatabaseDataState.issues3Page,
                        Main.Instance.DatabaseDataState.issues3Limit,
                        type,
                        Main.Instance.DatabaseDataState.issuesFilterIssueTypeKYC
                    )
                } else if (type === TimelineEntrySubType.Gamification as number) {
                    getPaginatedIssues(
                        {
                            resolved: FourIssues() ? Main.Instance.RiskManagementState.filterResolved : false,
                            minIssueType: Main.Instance.DatabaseDataState.issuesFilterIssueTypeGM === 999 ?
                                IssueTypes.Gamification :
                                Main.Instance.DatabaseDataState.issuesFilterIssueTypeGM as any,
                            maxIssueType: Main.Instance.DatabaseDataState.issuesFilterIssueTypeGM === 999 ?
                                IssueTypes.Other4 :
                                Main.Instance.DatabaseDataState.issuesFilterIssueTypeGM as any
                        },
                        Main.Instance.DatabaseDataState.issues4Page,
                        Main.Instance.DatabaseDataState.issues4Limit,
                        type,
                        Main.Instance.DatabaseDataState.issuesFilterIssueTypeGM
                    )
                }
            }

            let totalIssuesCount: number = 0
            for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount).message) {
                totalIssuesCount += item.totalIssues
            }

            Socket1.socket.Send(Config.amGetIssuesCount, { filters: { resolved: false } })
            getLoadedResources('Socket1 - Send', Config.amGetIssuesCount, 'unresolved')
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                issuesCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount).message,
                totalIssuesCount,
                IssuesCount: 2
            })
            
        } else if (Main.Instance.DatabaseDataState.IssuesCount === 2) {

            getLoadedResources('Socket1 - Get', Config.amGetIssuesCount, 'unresolved')
            Socket1.socket.Send(Config.amGetIssuesCount, {
                filters: { resolved: true }
            })
            
            getLoadedResources('Socket1 - Send', Config.amGetIssuesCount, 'resolved')
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                unresolvedIssuesCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount).message,
                IssuesCount: 3,
            })
            
        } else if (Main.Instance.DatabaseDataState.IssuesCount === 3) {
            
            const today: string = (new Date()).toISOString().substring(0, 10)
            const filters = Main.Instance.DatabaseDataState.type === 30 ?
                {
                    dateFrom: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, true) : Main.Instance.DatabaseDataState.allIssuesOptionsDatesFrom === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.allIssuesOptionsDates[Main.Instance.DatabaseDataState.allIssuesOptionsDatesFrom], true),
                    dateTo: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, false) : Main.Instance.DatabaseDataState.allIssuesOptionsDatesTo === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.allIssuesOptionsDates[Main.Instance.DatabaseDataState.allIssuesOptionsDatesTo], false)

                }
                :
                {
                    dateFrom: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, true) : Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesFrom === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.dashboardBackendOptionsDates[Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesFrom], true),
                    dateTo: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, false) : Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesTo === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.dashboardBackendOptionsDates[Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesTo], false)
                }
            Socket1.socket.Send(Config.amGetIssuesCount, { filters })
            getLoadedResources('Socket1 - Send', Config.amGetIssuesCount, 'all')
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                resolvedIssuesCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount).message,
                IssuesCount: 4,
            })
            
            getLoadedResources('Socket1 - Get', Config.amGetIssuesCount, 'resolved')
        } else if (Main.Instance.DatabaseDataState.IssuesCount === 4) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                issuesCountCustom: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount).message,
                IssuesCount: 5,
            })
            getLoadedResources('Socket1 - Get', Config.amGetIssuesCount, 'all')
            const today: string = (new Date()).toISOString().substring(0, 10)
            const filters =
                Main.Instance.DatabaseDataState.type === 30 ?
                    {
                        resolved: false,
                        dateFrom: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, true) : Main.Instance.DatabaseDataState.allIssuesOptionsDatesFrom === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.allIssuesOptionsDates[Main.Instance.DatabaseDataState.allIssuesOptionsDatesFrom], true),
                        dateTo: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, false) : Main.Instance.DatabaseDataState.allIssuesOptionsDatesTo === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.allIssuesOptionsDates[Main.Instance.DatabaseDataState.allIssuesOptionsDatesTo], false)

                    }
                    :
                    {
                        resolved: false,
                        dateFrom: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, true) : Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesFrom === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.dashboardBackendOptionsDates[Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesFrom], true),
                        dateTo: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, false) : Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesTo === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.dashboardBackendOptionsDates[Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesTo], false)
                    }
            // console.log(filters)
            Socket1.socket.Send(Config.amGetIssuesCount, { filters })
            getLoadedResources('Socket1 - Send', Config.amGetIssuesCount, 'unresolved')
        } else if (Main.Instance.DatabaseDataState.IssuesCount === 5) {
            // ************************************* unresolvedIssuesCountCustom ERROR
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                unresolvedIssuesCountCustom: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount).message,
                IssuesCount: 6,
            })
            getLoadedResources('Socket1 - Get', Config.amGetIssuesCount, 'unresolved')
            const today: string = (new Date()).toISOString().substring(0, 10)
            const filters =
                Main.Instance.DatabaseDataState.type === 30 ?
                    {
                        resolved: true,
                        dateFrom: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, true) : Main.Instance.DatabaseDataState.allIssuesOptionsDatesFrom === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.allIssuesOptionsDates[Main.Instance.DatabaseDataState.allIssuesOptionsDatesFrom], true),
                        dateTo: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, false) : Main.Instance.DatabaseDataState.allIssuesOptionsDatesTo === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.allIssuesOptionsDates[Main.Instance.DatabaseDataState.allIssuesOptionsDatesTo], false)

                    }
                    :
                    {
                        resolved: true,
                        dateFrom: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, true) : Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesFrom === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.dashboardBackendOptionsDates[Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesFrom], true),
                        dateTo: Main.Instance.DatabaseDataState.resolvedIssuesCountCustom === undefined ? convertToUnix(today, false) : Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesTo === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.dashboardBackendOptionsDates[Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesTo], false)
                    }

            Socket1.socket.Send(Config.amGetIssuesCount, { filters })
            getLoadedResources('Socket1 - Send', Config.amGetIssuesCount, 'resolved')
        } else if (Main.Instance.DatabaseDataState.IssuesCount === 6) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                resolvedIssuesCountCustom: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssuesCount).message,
                IssuesCount: 0,
            })
            getLoadedResources('Socket1 - Get', Config.amGetIssuesCount, 'resolved')
        }
    }

    if (Main.Instance.DatabaseDataState.ManualCheckBlacklistGet && Socket1.socket.Get<RouteClasses.Route>(Config.amManualCheckBlacklist) && Socket1.socket.Get<RouteClasses.Route>(Config.amManualCheckBlacklist).loading === 'loaded') {

        if (Socket1.socket.Get<RouteClasses.Route>(Config.amManualCheckBlacklist).resolved) {
            wsGetPlayerTimeline(Main.Instance.DatabaseDataState.playerCard.playerId)
            Logic.Type.New(Main.Instance.DatabaseDataState, { ManualCheckBlacklistGet: false })
        }
    }
    /*
        // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalHistoryGet))
        if ((Main.Instance.DatabaseDataState.Wallet || Main.Instance.DatabaseDataState.TransactionHistoryGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalHistoryGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalHistoryGet).loading === 'loaded') {
            // console.log (1)
            // console.log ('ispending ' + Main.Instance.DatabaseDataState.withdrawalHistoryIsPending)
            // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalHistoryGet))
            if (Main.Instance.DatabaseDataState.Wallet) {
                // console.log ('Wallet')
                if (Main.Instance.DatabaseDataState.WithdrawalHistory) {
                    // console.log ('WithdrawalHistory')
                    let approved: string
                    let rejected: string
                    let canceled: string
                    let executed: string
                    let completed: string
                    let deniedbybank: string
                    const S: WithdrawalHistory[] = Object.assign([], Main.Instance.DatabaseDataState.S)
                    for (let i: number = Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalHistoryGet).message.length - 1; i >= 0; i--) {
                        // console.log ('item ' + i)
                        const item: IWithdrawalEvent = Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalHistoryGet).message[i]
                        // console.log (item)
                        const Timestamp: string = new Date(item.created).toISOString()
                        const timestamp: string = Timestamp.substring(0, 10) + ' ' + Timestamp.substring(11, 19)
                        // console.log (timestamp)
                        if (item.status === TransactionStatus.APPROVED) {
                            approved = timestamp
                        } else if (item.status === TransactionStatus.REJECTED) {
                            rejected = timestamp
                        } else if (item.status === TransactionStatus.CANCELED) {
                            canceled = timestamp
                        } else if (item.status === TransactionStatus.EXECUTED) {
                            executed = timestamp
                        } else if (item.status === TransactionStatus.COMPLETED) {
                            completed = timestamp
                        } else if (item.status === TransactionStatus.DENIEDBYBANK) {
                            deniedbybank = timestamp
                        }
                    }
                    // console.log (JSON.stringify(S))
                    S[Main.Instance.DatabaseDataState.S.length - 1] = GetTimestamps(S[Main.Instance.DatabaseDataState.S.length - 1], approved, rejected, canceled, executed, completed, deniedbybank)
                    // const a: string = getTimestamps(approved, rejected, canceled, executed, completed, deniedbybank)
                    const s: string = Main.Instance.DatabaseDataState.s + getTimestamps(approved, rejected, canceled, executed, completed, deniedbybank) + '\n'
                    const ID: number = Main.Instance.DatabaseDataState.ID + 1
                    Logic.Type.New(Main.Instance.DatabaseDataState, { WithdrawalHistory: false, s, S, ID })
                    // console.log ('before ending history')
                    addWallet(s, S, ID, Main.Instance.DatabaseDataState.w)
                }
            } else {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalHistoryGet).resolved) {
                    // console.log ('transactionId ')
                    // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalHistoryGet).message)
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        TransactionHistoryGet: false,
                        withdrawalHistory: Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalHistoryGet).message
                    })
    
                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { withdrawalHistory: undefined, TransactionHistoryGet: false })
                }
            }
        }
    */

    /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusTriggeredInfoGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusTriggeredInfoGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusTriggeredInfoGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusTriggeredInfoGet).resolved) {
            if (!Main.Instance.DatabaseDataState.bonusCampaignReports || Main.Instance.DatabaseDataState.BonusCampaignReportsGet) {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusTriggeredInfoGet).message[0]) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        bonusCampaignReportsCount: Socket1.socket.Get<RouteClasses.Route>(Config.amBonusTriggeredInfoGet).message[0].totalItems,
                        BonusCampaignReportsGet: false,
                        bonusCampaignReports: Socket1.socket.Get<RouteClasses.Route>(Config.amBonusTriggeredInfoGet).message
                    })

                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        bonusCampaignReportsCount: 0,
                        BonusCampaignReportsGet: false,
                        bonusCampaignReports: Socket1.socket.Get<RouteClasses.Route>(Config.amBonusTriggeredInfoGet).message
                    })
                }
                getLoadedResources('Socket1 - Get', Config.amBonusTriggeredInfoGet)
            }
        }
    }
    */

    /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusGetAll) && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusGetAll).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusGetAll).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusGetAll).resolved) {
            if (!Main.Instance.PlayerCardState.bonusInfo || Main.Instance.PlayerCardState.BonusInfoGet) {
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    BonusInfoGet: false,
                    // BonusInfo: true,
                    bonusInfo: Socket1.socket.Get<RouteClasses.Route>(Config.amBonusGetAll).message
                })
                getLoadedResources('Socket1 - Get', Config.amBonusGetAll)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancel) && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancel).loading === 'loaded') {
        if (Main.Instance.PlayerCardState.BonusCancel) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancel).message &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancel).resolved &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancel).message === 'Bonus successfully canceled') {
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    BonusCancel: false,
                    BonusInfoGet: true,
                })
                getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancel).message)
            } else {
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    BonusCancel: false
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancel).error.message)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusActivate) && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusActivate).loading === 'loaded') {
        if (Main.Instance.PlayerCardState.BonusActivate) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusActivate).resolved &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amBonusActivate).message &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amBonusActivate).message === 'Bonus successfully activated') {
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    BonusActivate: false,
                    BonusInfoGet: true,
                })
                getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusActivate).message)
            } else {
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    BonusActivate: false,
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusActivate).error.message)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancelAll) && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancelAll).loading === 'loaded') {
        if (Main.Instance.PlayerCardState.BonusCancelAll) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancelAll).message &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancelAll).resolved &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancelAll).message === 'Bonuses successfully canceled') {
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    BonusCancelAll: false,
                    BonusInfoGet: true
                })
                getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancelAll).message)
            } else {
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    BonusCancelAll: false
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusCancelAll).error.message)
            }
        }
    }
    */

    /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManual) && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManual).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManual).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManual).resolved) {
            if (Main.Instance.PlayerCardState.BonusAddManual) {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManual).message === 'Bonus successfully added') {
                    Logic.Type.New(Main.Instance.PlayerCardState, {
                        BonusAddManual: false,
                        BonusAmount: 0,
                        BonusInfoGet: true,
                    })
                    getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                    alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManual).message)
                } else {
                    Logic.Type.New(Main.Instance.PlayerCardState, {
                        BonusAddManual: false,
                        BonusAmount: 0,
                    })
                    alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManual).error.message)
                }
            }
        }
    }
    */

    /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManualCode) && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManualCode).loading === 'loaded') {
        if (Main.Instance.PlayerCardState.BonusAddManualCode) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManualCode).message &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManualCode).message === 'Bonus successfully added'
                && Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManualCode).resolved) {

                Logic.Type.New(Main.Instance.PlayerCardState, {
                    BonusAddManualCode: false,
                    BonusCode: '',
                    BonusInfoGet: true,
                })
                getBonusInfo(Main.Instance.DatabaseDataState.playerCard.playerId)
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManualCode).message)
            } else {
                Logic.Type.New(Main.Instance.PlayerCardState, {
                    BonusAddManualCode: false,
                    BonusCode: '',
                })
                alert(Socket1.socket.Get<RouteClasses.Route>(Config.amBonusAddManualCode).error.message)
            }
        }
    }
    */
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetLabels) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetLabels).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetLabels).message && Socket1.socket.Get<RouteClasses.Route>(Config.gGetLabels).resolved) {
            if (!Main.Instance.DatabaseDataState.gameLabels || Main.Instance.DatabaseDataState.GameLabelsGet) {
                const gameLabels_: string[] = []
                const toggleLabels: boolean[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.gGetLabels).message) {
                    gameLabels_.push(JSON.stringify(item))
                    toggleLabels.push(false)
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, { GameLabelsGet: false, toggleLabels, gameLabels_, gameLabels: Socket1.socket.Get<RouteClasses.Route>(Config.gGetLabels).message })
                getLoadedResources('Socket1 - Get', Config.gGetLabels)
            }
        }
    }
*/
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameLabels) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameLabels).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameLabels).gameLabels && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameLabels).resolved) {
            if (!Main.Instance.DatabaseDataState.gamesListLabels || Main.Instance.DatabaseDataState.gamesListLabelsGet) {
                const gamesListLabels_: string[] = []
                const toggleGameLabels: boolean[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameLabels).gameLabels) {
                    gamesListLabels_.push(JSON.stringify(item))
                    toggleGameLabels.push(false)
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, { 
                    gamesListLabelsGet: false, 
                    toggleGameLabels, 
                    gamesListLabels_, 
                    gamesListLabels: Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameLabels).gameLabels })
                getLoadedResources('Socket1 - Get', Config.gGetGameLabels)
            }
        }
    }
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetCategories) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetCategories).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetCategories).message && Socket1.socket.Get<RouteClasses.Route>(Config.gGetCategories).resolved) {
            if (!Main.Instance.DatabaseDataState.categories || Main.Instance.DatabaseDataState.CategoriesGet) {
                const categories_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.gGetCategories).message) { categories_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { CategoriesGet: false, categories_, categories: Socket1.socket.Get<RouteClasses.Route>(Config.gGetCategories).message })
                getLoadedResources('Socket1 - Get', Config.gGetCategories)
            }
        }
    }
*/
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameCategories) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameCategories).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameCategories).gameCategories && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameCategories).resolved) {
            if (!Main.Instance.DatabaseDataState.gamesListCategories || Main.Instance.DatabaseDataState.gamesListCategoriesGet) {
                const gamesListCategories_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameCategories).gameCategories) { 
                    gamesListCategories_.push(JSON.stringify(item)) 
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, { gamesListCategoriesGet: false, gamesListCategories_, gamesListCategories: Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameCategories).gameCategories })
                getLoadedResources('Socket1 - Get', Config.gGetGameCategories)
            }
        }
    }
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictions) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictions).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictions).message && Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictions).resolved) {
            if (!Main.Instance.DatabaseDataState.jurisdictions || Main.Instance.DatabaseDataState.JurisdictionsGet) {
                const jurisdictions: Jurisdiction[] = Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictions).message ? Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictions).message).sort(cCode) : []
                Logic.Type.New(Main.Instance.DatabaseDataState, { JurisdictionsGet: false, jurisdictions})
                getLoadedResources('Socket1 - Get', Config.gGetJurisdictions)
            }
        }
    }
*/
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictionsList) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictionsList).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictionsList).jurisdictionsList && Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictionsList).resolved) {
            if (!Main.Instance.DatabaseDataState.jurisdictionsList || Main.Instance.DatabaseDataState.jurisdictionsListGet) {
                const jurisdictionsList: Jurisdiction[] = Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictionsList).jurisdictionsList ? Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.gGetJurisdictionsList).jurisdictionsList).sort(cCode) : []
                Logic.Type.New(Main.Instance.DatabaseDataState, { jurisdictionsListGet: false, jurisdictionsList})
                getLoadedResources('Socket1 - Get', Config.gGetJurisdictionsList)
            }
        }
    }
*/
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameSuppliers) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameSuppliers).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameSuppliers).message && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameSuppliers).resolved) {
            if (!Main.Instance.DatabaseDataState.rgsGameSupplierNew || Main.Instance.DatabaseDataState.RgsGameSupplierGetNew) {
                const rgsGameSupplier_New: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameSuppliers).message) { rgsGameSupplier_New.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { loadingGames3: false, RgsGameSupplierGetNew: false, rgsGameSupplier_New, rgsGameSupplierNew: Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameSuppliers).message })
                getLoadedResources('Socket1 - Get', Config.gGetGameSuppliers)
            }
        }
    }
*/

    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameProviders) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameProviders).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameProviders).gameProviderList && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameProviders).resolved) {
            if (!Main.Instance.DatabaseDataState.gameProviderNew || Main.Instance.DatabaseDataState.GameProviderGetNew) {
                const gameProvider_New: string[] = []
                
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameProviders).gameProviderList) { gameProvider_New.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { loadingGames2: false, GameProviderGetNew: false, gameProvider_New, gameProviderNew: Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameProviders).gameProviderList })
                getLoadedResources('Socket1 - Get', Config.gGetGameProviders)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetDevices) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetDevices).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetDevices).devices && Socket1.socket.Get<RouteClasses.Route>(Config.gGetDevices).resolved) {
            if (!Main.Instance.DatabaseDataState.devices || Main.Instance.DatabaseDataState.devicesGet) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { devicesGet: false, devices: Socket1.socket.Get<RouteClasses.Route>(Config.gGetDevices).devices })
                getLoadedResources('Socket1 - Get', Config.gGetDevices)
            }
        }
    }
/*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGames) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGames).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGames).message && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGames).resolved) {
            // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.gGetGames))
            if (!Main.Instance.DatabaseDataState.gamesCentralNew || Main.Instance.DatabaseDataState.GamesCentralGetNew) {
                const gamesCentralNew = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.gGetGames).message).sort(byname)
                const gamesCentral_New: string[] = []
                // const gamesIdAndName: any[] = []
                for (const item of gamesCentralNew) {
                    gamesCentral_New.push(JSON.stringify(item))
                    // gamesIdAndName.push({name: item.name, id: item.gameId})
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    loadingGames: false,
                    GamesCentralGetNew: false,
                    gamesCentral_New,
                    gamesCentralNew,
                    // gamesIdAndName: JSON.stringify(gamesIdAndName)
                })
                getLoadedResources('Socket1 - Get', Config.gGetGames)
            }
        }
    }
*/

    if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameList) && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameList).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameList).gameList && Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameList).resolved) {
            if (!Main.Instance.DatabaseDataState.gamesList || Main.Instance.DatabaseDataState.gamesListGet) {
                const gamesList: GamesList[] = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.gGetGameList).gameList).sort(byname)
                const gamesList_: string[] = []
                // const gamesIdAndName: any[] = []
                for (const item of gamesList) {
                    gamesList_.push(JSON.stringify(item))
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    loadingGames: false,
                    gamesListGet: false,
                    gamesList_,
                    gamesList,
                })
                getLoadedResources('Socket1 - Get', Config.gGetGameList)
                if (Main.Instance.DatabaseDataState.gameListNeedsUpdate) {
                    setCentralGames()
                    Logic.Type.New(Main.Instance.DatabaseDataState, {gameListNeedsUpdate: false})
                }
            }
        }
    }


    if (Socket1.socket.Get<RouteClasses.Route>(Config.amCrifCheck) && Socket1.socket.Get<RouteClasses.Route>(Config.amCrifCheck).loading === 'loaded' && Main.Instance.DatabaseDataState.manualCrifResponse) {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amCrifCheck).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amCrifCheck).message) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                manualCrifResponse: false,
                manualCrifResolved: true,
                manualCrifResponseAddress: Main.Instance.DatabaseDataState.manualAddress ? Socket1.socket.Get<RouteClasses.Route>(Config.amCrifCheck).message.addressCheckData : undefined,
                manualCrifResponsePEP: Main.Instance.DatabaseDataState.manualPEP ? Socket1.socket.Get<RouteClasses.Route>(Config.amCrifCheck).message.pepCheckData : undefined,
                isAddressVerified: Socket1.socket.Get<RouteClasses.Route>(Config.amCrifCheck).message.isAddressVerified,
                isPEP: Socket1.socket.Get<RouteClasses.Route>(Config.amCrifCheck).message.isPEP,
            })
        } else {
            Logic.Type.New(Main.Instance.DatabaseDataState, { manualCrifResponse: false, manualCrifResolved: false, manualCrifError: true })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amResendEmail) && Socket1.socket.Get<RouteClasses.Route>(Config.amResendEmail).loading === 'loaded' && Main.Instance.DatabaseDataState.manualResendVerification) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { manualResendVerification: false })
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amResendEmail).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amResendEmail).message) {
            alert(Socket1.socket.Get<RouteClasses.Route>(Config.amResendEmail).message)
        } else {
            alert(Assets.SomethingWentWrongWhileResendingEmail)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amLargeValueDeposits) {
            if (!Main.Instance.DatabaseDataState.largeValueDeposits || Main.Instance.DatabaseDataState.LargeValueDepositsGet) {
                const largeValueDeposits_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { largeValueDeposits_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueDepositsGet: false, largeValueDeposits_, largeValueDeposits: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amLargeValueDeposits)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amLargeValueWithdrawals) {
            if (!Main.Instance.DatabaseDataState.largeValueWithdrawal || Main.Instance.DatabaseDataState.LargeValueWithdrawalGet) {
                const largeValueWithdrawal_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { largeValueWithdrawal_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueWithdrawalGet: false, largeValueWithdrawal_, largeValueWithdrawal: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amLargeValueWithdrawals)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amTemporaryAccount) {
            if (!Main.Instance.DatabaseDataState.temporaryAccountStatus || Main.Instance.DatabaseDataState.TemporaryAccountStatusGet) {
                const temporaryAccountStatus_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { temporaryAccountStatus_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryAccountStatusGet: false, temporaryAccountStatus_, temporaryAccountStatus: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amTemporaryAccount)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amPlayerActivity) {
            if (!Main.Instance.DatabaseDataState.noPlayerActivityStatus || Main.Instance.DatabaseDataState.NoPlayerActivityStatusGet) {
                const noPlayerActivityStatus_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { noPlayerActivityStatus_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { NoPlayerActivityStatusGet: false, noPlayerActivityStatus_, noPlayerActivityStatus: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amPlayerActivity)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amBlacklist) {
            if (!Main.Instance.DatabaseDataState.blacklist || Main.Instance.DatabaseDataState.BlacklistGet) {
                const blacklist_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { blacklist_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { BlacklistGet: false, blacklist_, blacklist: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amBlacklist)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amMaximumBalance) {
            if (!Main.Instance.DatabaseDataState.maximumBalance || Main.Instance.DatabaseDataState.MaximumBalanceGet) {
                const maximumBalance_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { maximumBalance_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { MaximumBalanceGet: false, maximumBalance_, maximumBalance: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amMaximumBalance)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amRetail) {
            if (!Main.Instance.DatabaseDataState.retail || Main.Instance.DatabaseDataState.RetailGet) {
                let first_time: boolean = false
                if (!Main.Instance.DatabaseDataState.retail) {
                    first_time = true
                }
                const retail_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { retail_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { RetailGet: false, retail_, retail: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amRetail)
                if (first_time) { 
                    Socket1.socket.Send(Config.amBasicGet, { table: Config.amRetailActions }) 
                    getLoadedResources('Socket1 - Send', Config.amBasicGet, Config.amRetailActions)
                }
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amRetailActions) {
            if (!Main.Instance.DatabaseDataState.retailActions || Main.Instance.DatabaseDataState.RetailActionsGet) {
                const retailActions_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { retailActions_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { RetailActionsGet: false, retailActions_, retailActions: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amRetailActions)
            }
        }
    }


    if (Socket1.socket.Get<RouteClasses.Route>(Config.walletGameReportsReal) && Socket1.socket.Get<RouteClasses.Route>(Config.walletGameReportsReal).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.gameReportsRealGet) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {gameReportsReal: Socket1.socket.Get<RouteClasses.Route>(Config.walletGameReportsReal).gameReports, gameReportsRealGet: false})
            getLoadedResources('Socket1 - Get', Config.walletGameReportsReal)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.walletGameReportsTest) && Socket1.socket.Get<RouteClasses.Route>(Config.walletGameReportsTest).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.gameReportsTestGet) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {gameReportsTest: Socket1.socket.Get<RouteClasses.Route>(Config.walletGameReportsTest).gameReports, gameReportsTestGet: false})
            getLoadedResources('Socket1 - Get', Config.walletGameReportsTest)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.walletPlayerReports) && Socket1.socket.Get<RouteClasses.Route>(Config.walletPlayerReports).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.playerReportsGet) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {playerReports: Socket1.socket.Get<RouteClasses.Route>(Config.walletPlayerReports).playerReports, playerReportsGet: false})
            getLoadedResources('Socket1 - Get', Config.walletPlayerReports)
        }
    }
    
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetReports) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetReports).loading === 'loaded') {
        if (!Main.Instance.DatabaseDataState.ggrReports || Main.Instance.DatabaseDataState.ggrReportsGet) {
            // NOT FOR PRODUCTION
            let ggrReports: IReports[]
            let ggrReportsTotal: IReports
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetReports).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amGetReports).message) {
                ggrReports = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amGetReports).message.sort(byDateUnix))

                ggrReportsTotal = {
                    WANJackpotIncrements: 0,
                    bonusAwarded: 0,
                    bonusEndingBalance: 0,
                    bonusStartingBalance: 0,
                    canceledBonus: 0,
                    convertedBonus: 0,
                    depositsPSP: 0,
                    difference: 0,
                    jackpotHitsRng: 0,
                    manualAdjustments: 0,
                    manualDeposits: 0,
                    realEndingBalance: 0,
                    realMovement: 0,
                    realStartingBalance: 0,
                    totalBetBonus: 0,
                    totalBetRealLive: 0,
                    totalBetRealRNG: 0,
                    totalGGR: 0,
                    totalGGR2: 0,
                    totalWinBonus: 0,
                    totalWinRealLive: 0,
                    totalWinRealRNG: 0,
                    withdrawsPending: 0,
                    withdrawsProcessed: 0,
                }

                for (const item of ggrReports) {
                    // POSSIBLE BUG (FIX)
                    item.date += 3600 * 10
                    item.realMovement = -item.realMovement
                    ggrReportsTotal.WANJackpotIncrements += item.WANJackpotIncrements
                    ggrReportsTotal.bonusAwarded += item.bonusAwarded
                    if (item.canceledBonus) { ggrReportsTotal.canceledBonus += item.canceledBonus }
                    ggrReportsTotal.bonusEndingBalance += item.bonusEndingBalance
                    ggrReportsTotal.bonusStartingBalance += item.bonusStartingBalance
                    ggrReportsTotal.convertedBonus += item.convertedBonus
                    ggrReportsTotal.depositsPSP += item.depositsPSP
                    ggrReportsTotal.difference += item.difference
                    ggrReportsTotal.jackpotHitsRng += item.jackpotHitsRng
                    ggrReportsTotal.manualAdjustments += item.manualAdjustments
                    ggrReportsTotal.manualDeposits += item.manualDeposits
                    ggrReportsTotal.realEndingBalance += item.realEndingBalance
                    ggrReportsTotal.realMovement += item.realMovement
                    ggrReportsTotal.realStartingBalance += item.realStartingBalance
                    ggrReportsTotal.totalBetBonus += item.totalBetBonus
                    ggrReportsTotal.totalBetRealLive += item.totalBetRealLive
                    ggrReportsTotal.totalBetRealRNG += item.totalBetRealRNG
                    ggrReportsTotal.totalGGR += item.totalGGR
                    ggrReportsTotal.totalGGR2 += item.totalGGR2
                    ggrReportsTotal.totalWinBonus += item.totalWinBonus
                    ggrReportsTotal.totalWinRealLive += item.totalWinRealLive
                    ggrReportsTotal.totalWinRealRNG += item.totalWinRealRNG
                    ggrReportsTotal.withdrawsPending += item.withdrawsPending
                    ggrReportsTotal.withdrawsProcessed += item.withdrawsProcessed
                }
            } else {
                const a: string = '[{"date":1561075200,"totalBetRealRNG":0,"totalWinRealRNG":0,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":0,"totalWinBonus":0,"convertedBonus":0,"totalGGR":0,"depositsPSP":500,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":0,"realEndingBalance":500,"realMovement":-500,"totalGGR2":0,"difference":0,"bonusAwarded":0,"bonusStartingBalance":0,"bonusEndingBalance":0,"canceledBonus":0},{"date":1561161600,"totalBetRealRNG":2607.35,"totalWinRealRNG":2110.17,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":0,"totalWinBonus":356.32,"convertedBonus":354.32,"totalGGR":142.86,"depositsPSP":3250,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":500,"realEndingBalance":3607.14,"realMovement":-3107.14,"totalGGR2":142.86,"difference":0,"bonusAwarded":445,"bonusStartingBalance":0,"bonusEndingBalance":447,"canceledBonus":0},{"date":1561248000,"totalBetRealRNG":6039.03,"totalWinRealRNG":5298.23,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":40.85,"totalWinBonus":655.93,"convertedBonus":878.43,"totalGGR":-137.63,"depositsPSP":6600,"manualDeposits":0,"withdrawsProcessed":-3344.77,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":3607.14,"realEndingBalance":7000,"realMovement":-3392.86,"totalGGR2":-137.63,"difference":0,"bonusAwarded":100,"bonusStartingBalance":447,"bonusEndingBalance":0,"canceledBonus":283.65},{"date":1561334400,"totalBetRealRNG":2326.9,"totalWinRealRNG":1574.5,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":0,"totalWinBonus":282,"convertedBonus":580,"totalGGR":172.4,"depositsPSP":2710,"manualDeposits":0,"withdrawsProcessed":-610,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":7000,"realEndingBalance":8927.6,"realMovement":-1927.6,"totalGGR2":172.4,"difference":0,"bonusAwarded":600,"bonusStartingBalance":0,"bonusEndingBalance":202,"canceledBonus":100},{"date":1561420800,"totalBetRealRNG":17113.01,"totalWinRealRNG":16505.16,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":23.19,"totalWinBonus":349.5,"convertedBonus":553.31,"totalGGR":54.54,"depositsPSP":2500,"manualDeposits":0,"withdrawsProcessed":-615,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":8927.6,"realEndingBalance":10758.06,"realMovement":-1830.46,"totalGGR2":54.54,"difference":0,"bonusAwarded":50,"bonusStartingBalance":202,"bonusEndingBalance":25,"canceledBonus":0},{"date":1561507200,"totalBetRealRNG":6570.97,"totalWinRealRNG":5188.17,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":27.35,"totalWinBonus":75.41,"convertedBonus":0.25,"totalGGR":1382.55,"depositsPSP":3020.69,"manualDeposits":0,"withdrawsProcessed":-619.04,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":10758.06,"realEndingBalance":11777.16,"realMovement":-1019.1,"totalGGR2":1382.55,"difference":0,"bonusAwarded":100,"bonusStartingBalance":25,"bonusEndingBalance":172.81,"canceledBonus":0},{"date":1561593600,"totalBetRealRNG":12089.42,"totalWinRealRNG":9809.33,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":99,"totalWinBonus":498.61,"convertedBonus":116.85,"totalGGR":2163.24,"depositsPSP":3715,"manualDeposits":1800,"withdrawsProcessed":-1250.95,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":11777.16,"realEndingBalance":13877.97,"realMovement":-2100.81,"totalGGR2":2163.24,"difference":0,"bonusAwarded":0,"bonusStartingBalance":172.81,"bonusEndingBalance":455.39,"canceledBonus":0.18},{"date":1561680000,"totalBetRealRNG":96.48,"totalWinRealRNG":9,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":0,"totalWinBonus":0,"convertedBonus":0,"totalGGR":87.48,"depositsPSP":3200,"manualDeposits":0,"withdrawsProcessed":-50,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":13877.97,"realEndingBalance":16940.49,"realMovement":-3062.52,"totalGGR2":87.48,"difference":0,"bonusAwarded":0,"bonusStartingBalance":455.39,"bonusEndingBalance":455.39,"canceledBonus":0},{"date":1561766400,"totalBetRealRNG":1374.3,"totalWinRealRNG":262.94,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":0,"totalWinBonus":0,"convertedBonus":0,"totalGGR":1111.36,"depositsPSP":0,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":16940.49,"realEndingBalance":15829.13,"realMovement":1111.36,"totalGGR2":1111.36,"difference":0,"bonusAwarded":0,"bonusStartingBalance":455.39,"bonusEndingBalance":455.39,"canceledBonus":0},{"date":1561852800,"totalBetRealRNG":2842.4,"totalWinRealRNG":1713.81,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":0,"totalWinBonus":0,"convertedBonus":0,"totalGGR":1128.59,"depositsPSP":5399,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":15829.13,"realEndingBalance":20099.54,"realMovement":-4270.41,"totalGGR2":1128.59,"difference":0,"bonusAwarded":0,"bonusStartingBalance":455.39,"bonusEndingBalance":455.39,"canceledBonus":0},{"date":1561939200,"totalBetRealRNG":80.6,"totalWinRealRNG":123.28,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":0,"totalWinBonus":0,"convertedBonus":0,"totalGGR":-42.68,"depositsPSP":500,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":20099.54,"realEndingBalance":20642.22,"realMovement":-542.68,"totalGGR2":-42.68,"difference":0,"bonusAwarded":0,"bonusStartingBalance":455.39,"bonusEndingBalance":455.39,"canceledBonus":0},{"date":1562025600,"totalBetRealRNG":13976.55,"totalWinRealRNG":11727.66,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":0,"totalWinBonus":1120.8,"convertedBonus":580,"totalGGR":1668.89,"depositsPSP":20855.23,"manualDeposits":0,"withdrawsProcessed":-0.5,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":20642.22,"realEndingBalance":39828.06,"realMovement":-19185.84,"totalGGR2":1668.89,"difference":0,"bonusAwarded":75,"bonusStartingBalance":455.39,"bonusEndingBalance":1071.19,"canceledBonus":0},{"date":1562112000,"totalBetRealRNG":7324.15,"totalWinRealRNG":5538.2,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":20,"totalWinBonus":545.65,"convertedBonus":520,"totalGGR":1265.95,"depositsPSP":14005,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":39828.06,"realEndingBalance":52567.11,"realMovement":-12739.05,"totalGGR2":1265.95,"difference":0,"bonusAwarded":225,"bonusStartingBalance":1071.19,"bonusEndingBalance":1301.84,"canceledBonus":0},{"date":1562198400,"totalBetRealRNG":16.06,"totalWinRealRNG":7.74,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":0,"totalWinBonus":2.58,"convertedBonus":0,"totalGGR":8.32,"depositsPSP":0,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":52567.11,"realEndingBalance":52558.79,"realMovement":8.32,"totalGGR2":8.32,"difference":0,"bonusAwarded":0,"bonusStartingBalance":1301.84,"bonusEndingBalance":1304.42,"canceledBonus":0},{"date":1562284800,"totalBetRealRNG":37326.33,"totalWinRealRNG":33113.89,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":31.7,"totalWinBonus":20.53,"convertedBonus":617.46,"totalGGR":3594.98,"depositsPSP":8282,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":52558.79,"realEndingBalance":57245.81,"realMovement":-4687.02,"totalGGR2":3594.98,"difference":0,"bonusAwarded":245,"bonusStartingBalance":1304.42,"bonusEndingBalance":920.79,"canceledBonus":0},{"date":1562371200,"totalBetRealRNG":75983.59,"totalWinRealRNG":74654.11,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":452.11,"totalWinBonus":331.86,"convertedBonus":0,"totalGGR":1329.48,"depositsPSP":10431,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":57245.81,"realEndingBalance":66347.33,"realMovement":-9101.52,"totalGGR2":1329.48,"difference":0,"bonusAwarded":150,"bonusStartingBalance":920.79,"bonusEndingBalance":950.54,"canceledBonus":0},{"date":1562457600,"totalBetRealRNG":102367.55,"totalWinRealRNG":95104.12,"totalBetRealLive":0,"totalWinRealLive":0,"WANJackpotIncrements":0,"jackpotHitsRng":0,"totalBetBonus":780.63,"totalWinBonus":922.27,"convertedBonus":181.64,"totalGGR":7081.79,"depositsPSP":9114,"manualDeposits":0,"withdrawsProcessed":0,"withdrawsPending":0,"manualAdjustments":0,"realStartingBalance":66347.33,"realEndingBalance":68379.54,"realMovement":-2032.21,"totalGGR2":7081.79,"difference":0,"bonusAwarded":80,"bonusStartingBalance":950.54,"bonusEndingBalance":990.54,"canceledBonus":0}]'
                const t: string = '{"WANJackpotIncrements":0,"bonusAwarded":475,"canceledBonus":0,"bonusEndingBalance":2861.87,"bonusStartingBalance":3175.75,"convertedBonus":799.1,"depositsPSP":27827,"difference":0,"jackpotHitsRng":0,"manualAdjustments":0,"manualDeposits":0,"realEndingBalance":191972.68,"realMovement":15820.75,"realStartingBalance":176151.93,"totalBetBonus":1264.44,"totalBetRealLive":0,"totalBetRealRNG":215677.47,"totalGGR":12006.25,"totalGGR2":12006.25,"totalWinBonus":1274.6599999999999,"totalWinRealLive":0,"totalWinRealRNG":202872.12,"withdrawsPending":0,"withdrawsProcessed":0}'
                ggrReports = JSON.parse(a)
                ggrReportsTotal = JSON.parse(t)
            }

            if (!Main.Instance.DatabaseDataState.ggrReports) {
                const ggrReportsDates: string[] = []
                for (const item of ggrReports) {
                    ggrReportsDates.push((new Date(item.date * 1000)).toISOString().substring(0, 10))
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, { ggrReportsGet: false, ggrReports, ggrReportsDates, ggrReportsTotal })
                getLoadedResources('Socket1 - Get', Config.amGetReports)
            } else { 
                Logic.Type.New(Main.Instance.DatabaseDataState, { ggrReportsGet: false, ggrReports, ggrReportsTotal }) 
                getLoadedResources('Socket1 - Get', Config.amGetReports)
            }
        }
    }
 
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message) {

            if (!Main.Instance.DatabaseDataState.IssuesGet && Main.Instance.DatabaseDataState.PlayerTimelineIssues) {
                // here we need to "construct real playerTimeline"
                const playerTimeline = Object.assign([], Main.Instance.DatabaseDataState.playerTimelineTransactions)
                const playerTimelineIssues = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message)
                for (const item of playerTimelineIssues) {
                    item.entryType = TimelineEntryType.Issue
                }
                playerTimeline.push(...playerTimelineIssues)
                playerTimeline.sort(byCreated)
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    playerTimeline,
                    PlayerTimelineIssues: false,
                    playerTimelineIssues: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message
                })
                getLoadedResources('Socket1 - Get', Config.amGetIssues, 'player-timeline')
            } else if ((/*!Main.Instance.DatabaseDataState.issues1 || */Main.Instance.DatabaseDataState.IssuesGet) && Main.Instance.DatabaseDataState.playerCards) {
                // TO BE DONE
                if (Main.Instance.DatabaseDataState.issueGetStatusProvisionalOrActive && Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message[0]) {
                    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message)
                    const statusProvisionalOrActive: IProvisionalOrActive = {}
                    statusProvisionalOrActive.playerId = Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message[0].playerId
                    statusProvisionalOrActive.wasActive = Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message[0].data.wasActive
                    statusProvisionalOrActive.wasProvisional = Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message[0].data.wasProvisional
                    Logic.Type.New(Main.Instance.DatabaseDataState, {issueGetStatusProvisionalOrActive: false, statusProvisionalOrActive, IssuesGet: false})
                }
                if (Main.Instance.DatabaseDataState.whichIssuesToGet === TimelineEntrySubType.RiskManagement) {
                    // if (Main.Instance.DatabaseDataState.isGettingIssues) {
                    //     Logic.Type.New(Main.Instance.DatabaseDataState, {
                    //         whichIssuesToGet: TimelineEntrySubType.ResponsibleGaming,
                    //         issues1: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                    //     })
                        
                    //     Socket1.socket.Send(Config.amGetIssues, {
                    //         filters: {
                    //             resolved: false,
                    //             minIssueType: IssueTypes.ResponsibleGaming,
                    //             maxIssueType: IssueTypes.Other2
                    //         },
                    //         page: Main.Instance.DatabaseDataState.issues2Page,
                    //         limit: Main.Instance.DatabaseDataState.issues2Limit
                    //     })
                    // } else {
                    getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[31])
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        IssuesGet: false,
                        whichIssuesToGet: TimelineEntrySubType.None,
                        issues1: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                    })
                       
                    // }

                } else if (Main.Instance.DatabaseDataState.whichIssuesToGet === TimelineEntrySubType.ResponsibleGaming) {
                    // if (Main.Instance.DatabaseDataState.isGettingIssues) {
                    //     Logic.Type.New(Main.Instance.DatabaseDataState, {
                    //         whichIssuesToGet: TimelineEntrySubType.KnowYourCustomer,
                    //         issues2: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                    //     })
                        
                    //     Socket1.socket.Send(Config.amGetIssues, {
                    //         filters: {
                    //             resolved: false,
                    //             minIssueType: IssueTypes.KnowYourCustomer,
                    //             maxIssueType: IssueTypes.Other3
                    //         },
                    //         page: Main.Instance.DatabaseDataState.issues3Page,
                    //         limit: Main.Instance.DatabaseDataState.issues3Limit
                    //     })
                    // } else {
                    if (Main.Instance.DatabaseDataState.issueType) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            IssuesGet: false,
                            whichIssuesToGet: TimelineEntrySubType.None,
                            issues2: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                        })
                        getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[44])
                    } else {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            whichIssuesToGet: TimelineEntrySubType.DashboardBackend,
                            issues2: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                        })
                        const issueType = getIssueTypes(IssueTypes.DashboardBackend, IssueTypes.Other2 - 1)
                        Socket1.socket.Send(Config.amGetIssues, {
                            filters: {
                                resolved: false,
                                //minIssueType: IssueTypes.DashboardBackend,
                                // maxIssueType: IssueTypes.Other2 - 1
                                issueType
                            },
                            page: Main.Instance.DatabaseDataState.issues0Page,
                            limit: Main.Instance.DatabaseDataState.issues0Limit
                        });
                        
                    }
                    // }

                } else if (Main.Instance.DatabaseDataState.whichIssuesToGet === TimelineEntrySubType.KnowYourCustomer) {
                    // if (Main.Instance.DatabaseDataState.isGettingIssues) {
                    //     Logic.Type.New(Main.Instance.DatabaseDataState, {
                    //         whichIssuesToGet: TimelineEntrySubType.Gamification,
                    //         issues3: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                    //     })
                        
                    //     Socket1.socket.Send(Config.amGetIssues, {
                    //         filters: {
                    //             resolved: false,
                    //             minIssueType: IssueTypes.Gamification,
                    //             maxIssueType: IssueTypes.Other4
                    //         },
                    //         page: Main.Instance.DatabaseDataState.issues4Page,
                    //         limit: Main.Instance.DatabaseDataState.issues4Limit
                    //     })
                    // } else {
                    getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[33])
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        IssuesGet: false,
                        whichIssuesToGet: TimelineEntrySubType.None,
                        issues3: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                    })
                    // }
                } else if (Main.Instance.DatabaseDataState.whichIssuesToGet === TimelineEntrySubType.Gamification) {

                    // if (Main.Instance.DatabaseDataState.isGettingIssues) {
                    //     Logic.Type.New(Main.Instance.DatabaseDataState, {
                    //         whichIssuesToGet: TimelineEntrySubType.DashboardBackend,
                    //         issues4: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                    //     })
                        
                    //     const today: string = (new Date()).toISOString().substring(0, 10)
                    //     Socket1.socket.Send(Config.amGetIssues, {
                    //         filters: {
                    //             resolved: false,
                    //             minIssueType: IssueTypes.DashboardBackend,
                    //             maxIssueType: IssueTypes.Other2 - 1,
                    //             dateFrom: Main.Instance.DatabaseDataState.issuesDashboardBackend ? Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesFrom === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.dashboardBackendOptionsDates[Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesFrom], true) : convertToUnix(today, true),
                    //             dateTo: Main.Instance.DatabaseDataState.issuesDashboardBackend ? Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesTo === - 1 ? undefined : convertToUnix(Main.Instance.DatabaseDataState.dashboardBackendOptionsDates[Main.Instance.DatabaseDataState.dashboardBackendOptionsDatesTo], false) : convertToUnix(today, false),
                    //         },
                    //         page: Main.Instance.DatabaseDataState.issues0Page,
                    //         limit: Main.Instance.DatabaseDataState.issues0Limit
                    //     })
                    // } else {
                    getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[34])
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        IssuesGet: false,
                        whichIssuesToGet: TimelineEntrySubType.None,
                        issues4: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                    })
                        
                    // }
                } else if (Main.Instance.DatabaseDataState.whichIssuesToGet === TimelineEntrySubType.DashboardBackend) {
                    // console.log(Main.Instance.DatabaseDataState.isGettingIssues)
                    // if (Main.Instance.DatabaseDataState.isGettingIssues) {
                    //     console.log('dates')
                    //     const dashboardBackendOptionsDates: string[] = []
                    //     const startDate: Date = new Date(Assets_.startDateYear, Assets_.startDateMonth, Assets_.startDateDay, 12, 0, 0, 0)
                    //     const now: Date = new Date()
                    //     now.setHours(12)
                    //     now.setMinutes(0)
                    //     now.setSeconds(0)
                    //     now.setMilliseconds(0)
                    //     const Now: number = now.getTime()
                    //     for (let i: number = startDate.getTime(); i <= Now; i += 24 * 60 * 60 * 1000) {
                    //         const date: Date = new Date(i)
                    //         dashboardBackendOptionsDates.push(date.toISOString().substring(0, 10))
                    //     }
                    //     Logic.Type.New(Main.Instance.DatabaseDataState, {
                    //         dashboardBackendOptionsDates,// : dashboardBackendOptionsDates.reverse(),
                    //         dashboardBackendOptionsDatesFrom: dashboardBackendOptionsDates.length - 1,
                    //         dashboardBackendOptionsDatesTo: dashboardBackendOptionsDates.length - 1,
                    //         DashboardBackend: false,
                    //         whichIssuesToGet: TimelineEntrySubType.FraudAlerts,
                    //         issuesDashboardBackend: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                    //     })

                    //     Socket1.socket.Send(Config.amGetIssues, {
                    //         filters: {
                    //             resolved: false,
                    //             minIssueType: IssueTypes.FraudAlerts,
                    //             maxIssueType: IssueTypes.Other1 - 1
                    //         }
                    //     })
                    // } else {
                        if (!Main.Instance.DatabaseDataState.dashboardBackendOptionsDates) {
                            const dashboardBackendOptionsDates: string[] = []
                            const startDate: Date = new Date(Assets_.startDateYear, Assets_.startDateMonth, Assets_.startDateDay, 12, 0, 0, 0)
                            const now: Date = new Date()
                            now.setHours(12)
                            now.setMinutes(0)
                            now.setSeconds(0)
                            now.setMilliseconds(0)
                            const Now: number = now.getTime()
                            for (let i: number = startDate.getTime(); i <= Now; i += 24 * 60 * 60 * 1000) {
                                const date: Date = new Date(i)
                                dashboardBackendOptionsDates.push(date.toISOString().substring(0, 10))
                            }
                            getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[44])
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                dashboardBackendOptionsDates,
                                dashboardBackendOptionsDatesFrom: dashboardBackendOptionsDates.length - 1,
                                dashboardBackendOptionsDatesTo: dashboardBackendOptionsDates.length - 1,
                                DashboardBackend: false,
                                IssuesGet: false,
                                whichIssuesToGet: TimelineEntrySubType.None,
                                issuesDashboardBackend: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                            })
                        } else {
                            
                            getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[44])
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                DashboardBackend: false,
                                IssuesGet: false,
                                whichIssuesToGet: TimelineEntrySubType.None,
                                issuesDashboardBackend: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message// .reverse()
                            })
                        }
                        
                        
                    // }
                } else if (Main.Instance.DatabaseDataState.whichIssuesToGet === TimelineEntrySubType.FraudAlerts) {
                    // if (Main.Instance.DatabaseDataState.isGettingIssues) {
                    //     Logic.Type.New(Main.Instance.DatabaseDataState, {
                    //         whichIssuesToGet: TimelineEntrySubType.Veto,
                    //         issuesFraudAlerts: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message.reverse()
                    //     })
                        
                    //     Socket1.socket.Send(Config.amGetIssues, {
                    //         filters: {
                    //             resolved: false,
                    //             minIssueType: IssueTypes.BlacklistVeto,
                    //             maxIssueType: IssueTypes.BlacklistManual
                    //         }
                    //     })
                    // } else {
                    getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[46])
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        IssuesGet: false,
                        whichIssuesToGet: TimelineEntrySubType.Veto,
                        issuesFraudAlerts: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message.reverse()
                    })
                    // }
                } else if (Main.Instance.DatabaseDataState.whichIssuesToGet === TimelineEntrySubType.Veto) {

                    const issuesBlacklistRegistration: Latest[] = []
                    const issuesBlacklistExclusion: Latest[] = []
                    const issuesBlacklistLogin: Latest[] = []
                    const issuesBlacklistCronJob: Latest[] = []
                    const issuesBlacklistManual: Latest[] = []
                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message) {
                        if (item.issueType === IssueTypes.BlacklistRegistration) {
                            issuesBlacklistRegistration.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.BlacklistLogin) {
                            issuesBlacklistLogin.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.BlacklistCronJob) {
                            issuesBlacklistCronJob.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.BlacklistManual) {
                            issuesBlacklistManual.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        }
                    }

                    // if (Main.Instance.DatabaseDataState.isGettingIssues) {
                    //     Logic.Type.New(Main.Instance.DatabaseDataState, {
                    //         issuesBlacklistRegistration,
                    //         issuesBlacklistExclusion,
                    //         issuesBlacklistLogin,
                    //         issuesBlacklistCronJob,
                    //         issuesBlacklistManual,
                    //         whichIssuesToGet: TimelineEntrySubType.Crif,
                    //         // issuesVeto: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message.reverse()
                    //     })
                        
                    //     Socket1.socket.Send(Config.amGetIssues, {
                    //         filters: {
                    //             resolved: false,
                    //             minIssueType: IssueTypes.CRIFCheckMismatch,
                    //             maxIssueType: IssueTypes.CRIFAddressChangedOperator
                    //         }
                    //     })

                    // } else {
                    getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[47])
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        IssuesGet: false,
                        issuesBlacklistRegistration,
                        issuesBlacklistExclusion,
                        issuesBlacklistLogin,
                        issuesBlacklistCronJob,
                        issuesBlacklistManual,
                        whichIssuesToGet: TimelineEntrySubType.Crif,
                        // issuesVeto: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message.reverse()
                    })

                    // }
                } else if (Main.Instance.DatabaseDataState.whichIssuesToGet === TimelineEntrySubType.Crif) {

                    const issuesCRIFCheckMismatch: Latest[] = []
                    const issuesCRIFCheckLogin: Latest[] = []
                    const issuesCRIFCheckRegistration: Latest[] = []
                    const issuesCRIFChangedOperator: Latest[] = []

                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message) {
                        if (item.issueType === IssueTypes.CRIFCheckMismatch) {
                            issuesCRIFCheckMismatch.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.CRIFCheckLogin) {
                            issuesCRIFCheckLogin.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.CRIFCheckRegistration) {
                            issuesCRIFCheckRegistration.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.CRIFAddressChangedPlayer) {
                            issuesCRIFChangedOperator.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        }
                    }

                    // if (Main.Instance.DatabaseDataState.isGettingIssues) {
                    //     Logic.Type.New(Main.Instance.DatabaseDataState, {
                    //         issuesCRIFCheckMismatch,
                    //         issuesCRIFCheckLogin,
                    //         issuesCRIFCheckRegistration,
                    //         issuesCRIFChangedOperator,
                    //         whichIssuesToGet: TimelineEntrySubType.Pep,
                    //         // issuesCrif: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message.reverse()
                    //     })
                        
                    //     Socket1.socket.Send(Config.amGetIssues, {
                    //         filters: {
                    //             resolved: false,
                    //             minIssueType: IssueTypes.PEPCheckLogin,
                    //             maxIssueType: IssueTypes.PEPChangedByOperator
                    //         }
                    //     })
                    // } else {
                    getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[48])
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        IssuesGet: false,
                        issuesCRIFCheckMismatch,
                        issuesCRIFCheckLogin,
                        issuesCRIFCheckRegistration,
                        issuesCRIFChangedOperator,
                        whichIssuesToGet: TimelineEntrySubType.Pep,
                        // issuesCrif: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message.reverse()
                    })
                    // }
                } else if (Main.Instance.DatabaseDataState.whichIssuesToGet === TimelineEntrySubType.Pep) {

                    const issuesPEPCheckLogin: Latest[] = []
                    const issuesPEPCheckRegistration: Latest[] = []
                    const issuesPEPCheckNameChanged: Latest[] = []
                    const issuesPEPCheckBeneficiaryName: Latest[] = []
                    const issuesPEPCheckByOperator: Latest[] = []

                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message) {
                        if (item.issueType === IssueTypes.PEPCheckLogin) {
                            issuesPEPCheckLogin.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.PEPCheckRegistration) {
                            issuesPEPCheckRegistration.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.PEPCheckNameChanged) {
                            issuesPEPCheckNameChanged.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.PEPCheckBeneficiaryName) {
                            issuesPEPCheckBeneficiaryName.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        } else if (item.issueType === IssueTypes.PEPChangedByOperator) {
                            issuesPEPCheckByOperator.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                        }
                    }
                    getLoadedResources('Socket1 - Get', Config.amGetIssues, TimelineEntrySubType[49])
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        issuesPEPCheckLogin,
                        issuesPEPCheckRegistration,
                        issuesPEPCheckNameChanged,
                        issuesPEPCheckBeneficiaryName,
                        issuesPEPCheckByOperator,
                        whichIssuesToGet: TimelineEntrySubType.None,
                        // isGettingIssues: false,
                        IssuesGet: false,
                        // issuesPep: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message.reverse()
                    })
                    
                }

                // OLD CODE START
                /*
                                const issuesFraudAlerts: IIssue[] = []
                                const issuesBlacklistRegistration: Latest[] = []
                                const issuesBlacklistExclusion: Latest[] = []
                                const issuesBlacklistLogin: Latest[] = []
                                const issuesBlacklistCronJob: Latest[] = []
                                const issuesBlacklistManual: Latest[] = []
                                const issuesPEPCheckLogin: Latest[] = []
                                const issuesPEPCheckRegistration: Latest[] = []
                                const issuesPEPCheckNameChanged: Latest[] = []
                                const issuesPEPCheckBeneficiaryName: Latest[] = []
                                const issuesPEPCheckByOperator: Latest[] = []
                
                                const issuesCRIFCheckMismatch: Latest[] = []
                                const issuesCRIFCheckLogin: Latest[] = []
                                const issuesCRIFCheckRegistration: Latest[] = []
                                const issuesCRIFChangedOperator: Latest[] = []
                
                                // const issues_: string[] = []
                                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message) {
                                    if (item.issueType === IssueTypes.BlacklistExclusion) {
                                        issuesBlacklistExclusion.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.BlacklistRegistration) {
                                        issuesBlacklistRegistration.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.BlacklistLogin) {
                                        issuesBlacklistLogin.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.BlacklistCronJob) {
                                        issuesBlacklistCronJob.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.BlacklistManual) {
                                        issuesBlacklistManual.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.PEPCheckLogin) {
                                        issuesPEPCheckLogin.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.PEPCheckRegistration) {
                                        issuesPEPCheckRegistration.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.PEPCheckNameChanged) {
                                        issuesPEPCheckNameChanged.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.PEPCheckBeneficiaryName) {
                                        issuesPEPCheckBeneficiaryName.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.PEPChangedByOperator) {
                                        issuesPEPCheckByOperator.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.CRIFCheckMismatch) {
                                        issuesCRIFCheckMismatch.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.CRIFCheckLogin) {
                                        issuesCRIFCheckLogin.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.CRIFCheckRegistration) {
                                        issuesCRIFCheckRegistration.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType === IssueTypes.CRIFAddressChangedPlayer) {
                                        issuesCRIFChangedOperator.push({ entryType: item.entryType, entrySubType: item.entrySubType, issueType: item.issueType, playerId: item.playerId, created: item.created, assignTo: item.assignTo, comment: item.comment, history: item.history, id: item.id, resolved: item.resolved, riskLevel: item.riskLevel, riskManagerId: item.riskManagerId, username: getUsername(item.playerId) })
                                    } else if (item.issueType >= IssueTypes.FraudAlerts && item.issueType <= IssueTypes.FraudAlerts + 25) {
                                        issuesFraudAlerts.push(item)
                                    }
                                    // issues_.push (JSON.stringify(item))
                                }
                
                                Logic.Type.New(Main.Instance.DatabaseDataState, {
                                    issuesFraudAlerts,
                                    issuesBlacklistRegistration,
                                    issuesBlacklistLogin,
                                    issuesBlacklistCronJob,
                                    issuesBlacklistManual,
                                    issuesBlacklistExclusion,
                                    issuesPEPCheckLogin,
                                    issuesPEPCheckRegistration,
                                    issuesPEPCheckNameChanged,
                                    issuesPEPCheckBeneficiaryName,
                                    issuesPEPCheckByOperator,
                                    issuesCRIFCheckMismatch,
                                    issuesCRIFCheckLogin,
                                    issuesCRIFCheckRegistration,
                                    issuesCRIFChangedOperator,
                                    IssuesGet: false,
                                    // issues_: issues_.reverse(),
                                    issues: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message.reverse()
                                })
                */
            } else if (Main.Instance.DatabaseDataState.AllIssuesFilter) {
                if (Main.Instance.DatabaseDataState.allIssuesOptionsDates === undefined) {
                    const allIssuesOptionsDates: string[] = []
                    const startDate: Date = new Date(Assets_.startDateYear, Assets_.startDateMonth, Assets_.startDateDay, 12, 0, 0, 0)
                    const now: Date = new Date()
                    now.setHours(12)
                    now.setMinutes(0)
                    now.setSeconds(0)
                    now.setMilliseconds(0)
                    const Now: number = now.getTime()

                    for (let i: number = startDate.getTime(); i <= Now; i += 24 * 60 * 60 * 1000) {

                        const date: Date = new Date(i)

                        allIssuesOptionsDates.push(date.toISOString().substring(0, 10))
                    }

                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        allIssuesOptionsDates,
                        allIssuesOptionsDatesFrom: -1,
                        allIssuesOptionsDatesTo: -1,
                        AllIssuesFilter: false,

                        issuesAllIssuesFilter: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message
                    })
                    getLoadedResources('Socket1 - Get', Config.amGetIssues, 'all filter')
                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        AllIssuesFilter: false,
                        issuesAllIssuesFilter: Socket1.socket.Get<RouteClasses.Route>(Config.amGetIssues).message
                    })
                    getLoadedResources('Socket1 - Get', Config.amGetIssues, 'all')
                }

            }
        }
    }

    // amInsertIssue
    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue))
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue) && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.IssuesInsert) {
            // we need to find this issue in the issues and update with the new values !!!! now message : {issue, playerCard}
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).resolved &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.issue /* &&
                /Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.issue.id */) {
                if (JSON.stringify(Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.playerCard) === '{}') {
                    wsGetPlayerCard(Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.issue.playerId, true)
                } else if (Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.playerCard && JSON.stringify(Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.playerCard) !== '{}') {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { playerCard: Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.playerCard, playerCard_: JSON.stringify(Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.playerCard) })
                    wsGetPlayerTimeline(Socket1.socket.Get<RouteClasses.Route>(Config.amInsertIssue).message.playerCard.playerId, Main.Instance.DatabaseDataState.timelineLimit, Main.Instance.DatabaseDataState.timelinePage)
                }
            }
            Logic.Type.New(Main.Instance.DatabaseDataState, { IssuesInsert: false })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateIssue) && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateIssue).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.IssuesUpdate) {
            // we need to find this issue in the issues and update with the new values !!!! now message : {issue, playerCard}
            if (// Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateIssue).resolved &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateIssue).message &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateIssue).message.message &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateIssue).message.message.issue &&
                Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateIssue).message.message.issue.id) {
                const issue: IIssue = Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateIssue).message.message.issue
                const playerCard = Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateIssue).message.message.playerCard
                if (playerCard && JSON.stringify(playerCard) === '{}') {
                    wsGetPlayerCard(issue.playerId, true)
                } else if (playerCard && JSON.stringify(playerCard) !== '{}') {
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        playerCard,
                        playerCard_: JSON.stringify(playerCard)
                    })
                    if (Main.Instance.PlayerCardState.nav === 0 || Main.Instance.PlayerCardState.nav === 3 || Main.Instance.PlayerCardState.nav === 4 || Main.Instance.PlayerCardState.nav === 5) {
                        GetPlayerTimeline(Main.Instance.PlayerCardState.nav)
                    } else {
                        wsGetPlayerTimeline(playerCard.playerId/*, Main.Instance.DatabaseDataState.timelineLimit, Main.Instance.DatabaseDataState.timelinePage*/)
                    }
                }
                // basically first we need to establish, what type is the issue.
                // need to find category
                const issueId: number = issue.id
                const issueType: IssueTypes = issue.issueType
                let category: TimelineEntrySubType = TimelineEntrySubType.None
                if (issueType >= IssueTypes.FraudAlerts && issueType < IssueTypes.Other1) {
                    category = TimelineEntrySubType.FraudAlerts
                } else if (issueType >= IssueTypes.DashboardBackend && issueType < IssueTypes.Other2) {
                    category = TimelineEntrySubType.DashboardBackend
                } else if (issueType >= IssueTypes.BlacklistVeto && issueType <= IssueTypes.BlacklistManual) {
                    category = TimelineEntrySubType.Veto
                } else if (issueType >= IssueTypes.CRIFCheckMismatch && issueType <= IssueTypes.CRIFAddressChangedOperator) {
                    category = TimelineEntrySubType.Crif
                } else if (issueType >= IssueTypes.PEPCheckLogin && issueType <= IssueTypes.PEPChangedByOperator) {
                    category = TimelineEntrySubType.Pep
                } else if (issueType >= IssueTypes.RiskManagement && issueType <= IssueTypes.Other1) {
                    category = TimelineEntrySubType.RiskManagement
                } else if (issueType >= IssueTypes.ResponsibleGaming && issueType <= IssueTypes.Other2) {
                    category = TimelineEntrySubType.ResponsibleGaming
                } else if (issueType >= IssueTypes.KnowYourCustomer && issueType <= IssueTypes.Other3) {
                    category = TimelineEntrySubType.KnowYourCustomer
                } else if (issueType >= IssueTypes.Gamification && issueType <= IssueTypes.Other4) {
                    category = TimelineEntrySubType.Gamification
                }
                // console.log(category)
                let index: number = -1
                let index0: number = -1
                // let index1: number = -1
                // finally
                if (category === TimelineEntrySubType.ResponsibleGaming || category === TimelineEntrySubType.DashboardBackend || category === TimelineEntrySubType.Veto) {
                    const issues2: IIssue[] = Object.assign([], Main.Instance.DatabaseDataState.issues2)
                    for (let i: number = 0; i < issues2.length; i++) {
                        if (issues2[i].id === issueId) {
                            issues2[i] = issue
                            index = i
                            break
                        }
                    }

                    const issuesDashboardBackend: IIssue[] = Object.assign([], Main.Instance.DatabaseDataState.issuesDashboardBackend)
                    const issuesBlacklistRegistration: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesBlacklistRegistration)
                    const issuesBlacklistLogin: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesBlacklistLogin)
                    const issuesBlacklistCronJob: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesBlacklistCronJob)
                    const issuesBlacklistManual: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesBlacklistManual)
                    const issuesBlacklistExclusion: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesBlacklistExclusion)

                    if (category === TimelineEntrySubType.DashboardBackend) {
                        for (let i: number = 0; i < issuesDashboardBackend.length; i++) {
                            if (issuesDashboardBackend[i].id === issueId) {
                                issuesDashboardBackend[i] = issue
                                index0 = i
                                break
                            }
                        }
                    } else if (category === TimelineEntrySubType.Veto) {
                        if (issueType === IssueTypes.BlacklistRegistration) {
                            for (let i: number = 0; i < issuesBlacklistRegistration.length; i++) {
                                if (issuesBlacklistRegistration[i].id === issueId) {
                                    index0 = i
                                    issuesBlacklistRegistration[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.BlacklistLogin) {
                            for (let i: number = 0; i < issuesBlacklistLogin.length; i++) {
                                if (issuesBlacklistLogin[i].id === issueId) {
                                    index0 = i
                                    issuesBlacklistLogin[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.BlacklistCronJob) {
                            for (let i: number = 0; i < issuesBlacklistCronJob.length; i++) {
                                if (issuesBlacklistCronJob[i].id === issueId) {
                                    index0 = i
                                    issuesBlacklistCronJob[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.BlacklistManual) {
                            for (let i: number = 0; i < issuesBlacklistManual.length; i++) {
                                if (issuesBlacklistManual[i].id === issueId) {
                                    index0 = i
                                    issuesBlacklistManual[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.BlacklistExclusion) {
                            for (let i: number = 0; i < issuesBlacklistExclusion.length; i++) {
                                if (issuesBlacklistExclusion[i].id === issueId) {
                                    index0 = i
                                    issuesBlacklistExclusion[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        }
                    }
                    if (index !== -1 || index0 !== -1) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            issues2,
                            issuesDashboardBackend,
                            IssuesUpdate: false,
                            issuesBlacklistRegistration,
                            issuesBlacklistLogin,
                            issuesBlacklistCronJob,
                            issuesBlacklistManual,
                            issuesBlacklistExclusion,
                            IssuesCount: index0 !== -1 ? 91 : 21
                        })
                        Socket1.socket.Send(Config.amGetIssuesCount, { filters: {} })
                        getLoadedResources('Socket1 - Send', Config.amGetIssuesCount, TimelineEntrySubType[category])
                    }
                } else if (category === TimelineEntrySubType.RiskManagement || category === TimelineEntrySubType.FraudAlerts) {
                    const issues1: IIssue[] = Object.assign([], Main.Instance.DatabaseDataState.issues1)
                    for (let i: number = 0; i < issues1.length; i++) {
                        if (issues1[i].id === issueId) {
                            issues1[i] = issue
                            index = i
                            break
                        }
                    }

                    const issuesFraudAlerts: IIssue[] = Object.assign([], Main.Instance.DatabaseDataState.issuesFraudAlerts)
                    if (category === TimelineEntrySubType.FraudAlerts) {
                        for (let i: number = 0; i < issuesFraudAlerts.length; i++) {
                            if (issuesFraudAlerts[i].id === issueId) {
                                index0 = i
                                issuesFraudAlerts[i] = issue
                                break
                            }
                        }
                    }

                    if (index !== -1 || index0 !== -1) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            issues1,
                            IssuesUpdate: false,
                            issuesFraudAlerts,
                            IssuesCount: 11
                        })
                        Socket1.socket.Send(Config.amGetIssuesCount, { filters: {} })
                        getLoadedResources('Socket1 - Send', Config.amGetIssuesCount, TimelineEntrySubType[category])
                    }
                } else if (category === TimelineEntrySubType.KnowYourCustomer || category === TimelineEntrySubType.Crif || category === TimelineEntrySubType.Pep) {
                    const issues3: IIssue[] = Object.assign([], Main.Instance.DatabaseDataState.issues3)
                    for (let i: number = 0; i < issues3.length; i++) {
                        if (issues3[i].id === issueId) {
                            issues3[i] = issue
                            index = i
                            break
                        }
                    }

                    const issuesPEPCheckLogin: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesPEPCheckLogin)
                    const issuesPEPCheckRegistration: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesPEPCheckRegistration)
                    const issuesPEPCheckNameChanged: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesPEPCheckNameChanged)
                    const issuesPEPCheckBeneficiaryName: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesPEPCheckBeneficiaryName)
                    const issuesPEPCheckByOperator: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesPEPCheckByOperator)

                    const issuesCRIFCheckMismatch: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesCRIFCheckMismatch)
                    const issuesCRIFCheckLogin: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesCRIFCheckLogin)
                    const issuesCRIFCheckRegistration: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesCRIFCheckRegistration)
                    const issuesCRIFChangedOperator: Latest[] = Object.assign([], Main.Instance.DatabaseDataState.issuesCRIFChangedOperator)

                    if (category === TimelineEntrySubType.Crif) {
                        if (issueType === IssueTypes.CRIFCheckMismatch) {
                            for (let i: number = 0; i < issuesCRIFCheckMismatch.length; i++) {
                                if (issuesCRIFCheckMismatch[i].id === issueId) {
                                    index0 = i
                                    issuesCRIFCheckMismatch[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.CRIFCheckLogin) {
                            for (let i: number = 0; i < issuesCRIFCheckLogin.length; i++) {
                                if (issuesCRIFCheckLogin[i].id === issueId) {
                                    index0 = i
                                    issuesCRIFCheckLogin[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.CRIFCheckRegistration) {
                            for (let i: number = 0; i < issuesCRIFCheckRegistration.length; i++) {
                                if (issuesCRIFCheckRegistration[i].id === issueId) {
                                    index0 = i
                                    issuesCRIFCheckRegistration[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.CRIFAddressChangedOperator) {
                            for (let i: number = 0; i < issuesCRIFChangedOperator.length; i++) {
                                if (issuesCRIFChangedOperator[i].id === issueId) {
                                    index0 = i
                                    issuesCRIFChangedOperator[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        }

                    } else if (category === TimelineEntrySubType.Pep) {
                        if (issueType === IssueTypes.PEPCheckLogin) {
                            for (let i: number = 0; i < issuesPEPCheckLogin.length; i++) {
                                if (issuesPEPCheckLogin[i].id === issueId) {
                                    index0 = i
                                    issuesPEPCheckLogin[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.PEPCheckRegistration) {
                            for (let i: number = 0; i < issuesPEPCheckRegistration.length; i++) {
                                if (issuesPEPCheckRegistration[i].id === issueId) {
                                    index0 = i
                                    issuesPEPCheckRegistration[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.PEPCheckNameChanged) {
                            for (let i: number = 0; i < issuesPEPCheckNameChanged.length; i++) {
                                if (issuesPEPCheckNameChanged[i].id === issueId) {
                                    index0 = i
                                    issuesPEPCheckNameChanged[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.PEPCheckBeneficiaryName) {
                            for (let i: number = 0; i < issuesPEPCheckBeneficiaryName.length; i++) {
                                if (issuesPEPCheckBeneficiaryName[i].id === issueId) {
                                    index0 = i
                                    issuesPEPCheckBeneficiaryName[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        } else if (issueType === IssueTypes.PEPChangedByOperator) {
                            for (let i: number = 0; i < issuesPEPCheckByOperator.length; i++) {
                                if (issuesPEPCheckByOperator[i].id === issueId) {
                                    index0 = i
                                    issuesPEPCheckByOperator[i] = { entryType: issue.entryType, entrySubType: issue.entrySubType, issueType: issue.issueType, playerId: issue.playerId, created: issue.created, assignTo: issue.assignTo, comment: issue.comment, history: issue.history, id: issue.id, resolved: issue.resolved, riskLevel: issue.riskLevel, riskManagerId: issue.riskManagerId, username: getUsername(issue.playerId) }
                                    break
                                }
                            }
                        }
                    }

                    if (index !== -1 || index0 !== -1) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            issues3,
                            IssuesUpdate: false,
                            issuesPEPCheckLogin,
                            issuesPEPCheckRegistration,
                            issuesPEPCheckNameChanged,
                            issuesPEPCheckBeneficiaryName,
                            issuesPEPCheckByOperator,
                            issuesCRIFCheckMismatch,
                            issuesCRIFCheckLogin,
                            issuesCRIFCheckRegistration,
                            issuesCRIFChangedOperator,
                            IssuesCount: 31
                        })
                        Socket1.socket.Send(Config.amGetIssuesCount, { filters: {} })
                        getLoadedResources('Socket1 - Send', Config.amGetIssuesCount, TimelineEntrySubType[category])
                    }
                } else if (category === TimelineEntrySubType.Gamification) {
                    const issues4: IIssue[] = Object.assign([], Main.Instance.DatabaseDataState.issues4)
                    for (let i: number = 0; i < issues4.length; i++) {
                        if (issues4[i].id === issueId) {
                            issues4[i] = issue
                            index = i
                            break
                        }
                    }

                    if (index !== -1) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            issues4,
                            IssuesUpdate: false,
                            IssuesCount: 41
                        })
                        Socket1.socket.Send(Config.amGetIssuesCount, { filters: {} })
                        getLoadedResources('Socket1 - Send', Config.amGetIssuesCount, TimelineEntrySubType[category])
                    }
                }

                if (index === -1 && index0 === -1) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { IssuesUpdate: false/*, IssuesCount: 1*/ })
                    // Socket1.socket.Send (Config.amGetIssuesCount, {filters:{}})
                }
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, { IssuesUpdate: false/*, IssuesCount: 1*/ })
                // Socket1.socket.Send (Config.amGetIssuesCount, {filters:{}})
            }
            // wsGetIssues()
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetLoggedInPlayers) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetLoggedInPlayers).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetLoggedInPlayers).resolved && Socket1.socket.Get<RouteClasses.Route>(Config.amGetLoggedInPlayers).data  && (!Main.Instance.DatabaseDataState.loggedPlayers || Main.Instance.DatabaseDataState.LoggedPlayersGet)) {
            const data = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amGetLoggedInPlayers).data)
            if (data.list) {
                for (const item of data.list) {
                    const date = new Date(item.created * 1000).toISOString() 
                    item.created = date.substring(0, 10) + ' ' + date.substring(11, 19)
                }
            }
            Logic.Type.New(Main.Instance.DatabaseDataState, { LoggedPlayersGet: false, loggedPlayersTimestamp: (new Date()).toISOString(), loggedPlayers: data})
            getLoadedResources('Socket1 - Get', Config.amGetLoggedInPlayers)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPepPlayers) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPepPlayers).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPepPlayers).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPepPlayers).resolved && (!Main.Instance.DatabaseDataState.pepPlayers || Main.Instance.DatabaseDataState.PepPlayersGet)) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { PepPlayersGet: false, pepPlayersTimestamp: (new Date()).toISOString(), pepPlayers: Socket1.socket.Get<RouteClasses.Route>(Config.amGetPepPlayers).message })
            getLoadedResources('Socket1 - Get', Config.amGetPepPlayers)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCards) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCards).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCards).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCards).resolved && (!Main.Instance.DatabaseDataState.playerCards || Main.Instance.DatabaseDataState.PlayerCardsGet)) {
            const playerCards_: string[] = []
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCards).message) {
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCards).message) {
                    playerCards_.push(JSON.stringify(item))
                }
            }
            getLoadedResources('Socket1 - Get', Config.amGetPlayerCards)
            Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerCardsGet: false, playerCards_, playerCards: Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCards).message })
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayersInfo) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayersInfo).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.countries && Main.Instance.DatabaseDataState.nationalities && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayersInfo).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayersInfo).resolved && (!Main.Instance.DatabaseDataState.playersInfo/* || Main.Instance.DatabaseDataState.PlayerInfoGet*/)) {
            const crmCountriesStream: Array<{ country: string, name: string }> = []
            let crmRegionsStream: Array<{ country: string, region: string, name: string }> = []
            const crmNationalitiesStream: Array<{ nationality: string, name: string }> = []
            // const crmPlayerDataStream: Array<{id: string, data: IPlayersInfo[]}> = []
            for (let i: number = 0; i < Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayersInfo).message.length; i++) {
                const item = Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayersInfo).message[i]
                // crmPlayerDataStream.push ({id: i.toString(), data: []})
                let foundCountry: boolean = false
                for (const Item of crmCountriesStream) {
                    if (Item.country === item.country) {
                        foundCountry = true
                        break
                    }
                }
                if (!foundCountry) {
                    crmCountriesStream.push({ country: item.country, name: getCountry(item.country) })
                }

                let foundRegion: boolean = false
                for (const Item of crmRegionsStream) {
                    if (Item.country === item.country && Item.region === item.canton) {
                        foundRegion = true
                        break
                    }
                }
                if (!foundRegion) {
                    if (item.canton !== 'NaN') {
                        crmRegionsStream.push({
                            region: item.canton,
                            country: item.country,
                            name: getRegion(item.country, item.canton)
                        })
                    }
                }

                let foundNationality: boolean = false
                for (const Item of crmNationalitiesStream) {
                    if (Item.nationality === item.nationality) {
                        foundNationality = true
                        break
                    }
                }
                if (!foundNationality) {
                    crmNationalitiesStream.push({ nationality: item.nationality, name: getNationality(item.nationality) })
                }

            }

            crmRegionsStream = crmRegionsStream.sort(byName)
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                crmCurrenciesStream: [{ currency: 'CHF' }, { currency: 'EUR' }, { currency: 'USD' }, { currency: 'RUB' }, { currency: 'GBP' }],
                crmCountriesStream,
                crmRegionsStream,
                crmNationalitiesStream,
                // crmPlayerDataStream,
                // PlayerInfoGet: false,
                playersInfo: Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayersInfo).message
            })
            getLoadedResources('Socket1 - Get', Config.amGetPlayersInfo)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.PlayerCardGet && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).resolved) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).message === Assets_.FailedToFetchPlayerCard) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    openingPlayerCard: false,
                    PlayerCardGet: false
                })
            } else /*if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).message.playerId === Main.Instance.PlayerCardState.id)*/ {
                // document.cookie = 'playerId=' + Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).message.playerId
                // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).message)
                Cookies.remove('playerId', { path: '/' })
                Cookies.set('playerId', Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).message.playerId, { path: '/' })
                getLoadedResources('Cookie - Set', 'playerId=')
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    openingPlayerCard: false,
                    PlayerCardGet: false,
                    playerCard_: JSON.stringify(Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).message),
                    playerCard: Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).message
                })
                getLoadedResources('Socket1 - Get', Config.amGetPlayerCard)
                if (Main.Instance.PlayerCardState.nav === PlayerCardButtons.GameSessions) {
                    getGameSessions(Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerCard).message.playerId)
                }
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerTimeline) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerTimeline).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.PlayerTimelineGet && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerTimeline).message) {
            // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerTimeline).message)
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerTimeline).resolved === false || Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerTimeline).message === Assets_.ParameterPlayerIdMustBeSpecified) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerTimelineGet: false/*, playerTimeline: []*/ })
            } else {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    PlayerTimelineGet: false,
                    playerTimeline: Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerTimeline).message
                })
                getLoadedResources('Socket1 - Get', Config.amGetPlayerTimeline)
            }
        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).loading === 'loaded') {
            if ((!Main.Instance.DatabaseDataState.recentEventsDeposits || Main.Instance.DatabaseDataState.RecentEventsGetDeposits) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).eventType === RecentEventsTypes.Deposit && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).resolved) {
                // console.log (27)
                Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetWithdrawals: true, RecentEventsGetDeposits: false, recentEventsDepositsTimestamp: (new Date()).toISOString(), recentEventsDeposits: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message })
                if (!Main.Instance.DatabaseDataState.recentEventsActive) {
                    Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.Withdraw, limit: dashboardSmallTableRows })
                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                    download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
                }
            }
        }
    */
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).loading === 'loaded') {
            if ((!Main.Instance.DatabaseDataState.recentEventsWithdrawals || Main.Instance.DatabaseDataState.RecentEventsGetWithdrawals) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).eventType === RecentEventsTypes.Withdraw && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).resolved) {
                // console.log (28)
                Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetLogins: true, RecentEventsGetWithdrawals: false, recentEventsWithdrawalsTimestamp: (new Date()).toISOString(), recentEventsWithdrawals: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message })
                if (!Main.Instance.DatabaseDataState.recentEventsActive) {
                    Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.Login, limit: dashboardSmallTableRows })
                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                    download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
                }
            }
        }
    */
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).loading === 'loaded') {
        if ((!Main.Instance.DatabaseDataState.recentEventsLogins || Main.Instance.DatabaseDataState.RecentEventsGetLogins) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).eventType === RecentEventsTypes.Login && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).resolved) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetRegistrations: true, RecentEventsGetLogins: false, recentEventsLoginsTimestamp: (new Date()).toISOString(), recentEventsLogins: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message })
            if (!Main.Instance.DatabaseDataState.recentEventsActive) {
                Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.Registration, limit: dashboardSmallTableRows })
                getLoadedResources('Socket1 - Send', Config.amGetRecentEvents)
            } else {
                getLoadedResources('Socket1 - Get', Config.amGetRecentEvents, 'logins')
                Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).loading === 'loaded') {
        if ((!Main.Instance.DatabaseDataState.recentEventsRegistrations || Main.Instance.DatabaseDataState.RecentEventsGetRegistrations) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).eventType === RecentEventsTypes.Registration && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).resolved) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetFirstDeposits: true, RecentEventsGetRegistrations: false, recentEventsRegistrationsTimestamp: (new Date()).toISOString(), recentEventsRegistrations: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message })
            if (!Main.Instance.DatabaseDataState.recentEventsActive) {
                Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.AllIssues, limit: dashboardSmallTableRows })
                getLoadedResources('Socket1 - Send', Config.amGetRecentEvents)
            } else {
                getLoadedResources('Socket1 - Get', Config.amGetRecentEvents, 'registrations')
                Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
            }
        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).loading === 'loaded') {
            if ((!Main.Instance.DatabaseDataState.recentEventsFirstDeposits || Main.Instance.DatabaseDataState.RecentEventsGetFirstDeposits) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).eventType === RecentEventsTypes.FirstDeposits && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).resolved) {
                // console.log (31)
                Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetIssues: true, RecentEventsGetFirstDeposits: false, recentEventsFirstDepositsTimestamp: (new Date()).toISOString(), recentEventsFirstDeposits: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message })
                if (!Main.Instance.DatabaseDataState.recentEventsActive) {
                    Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.AllIssues, limit: dashboardSmallTableRows })
                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                    download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
                }
            }
        }
    */

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).loading === 'loaded') {
        if ((!Main.Instance.DatabaseDataState.recentEventsIssues || Main.Instance.DatabaseDataState.RecentEventsGetIssues) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).eventType === RecentEventsTypes.AllIssues && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).resolved) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                RecentEventsGetLogouts: true,
                RecentEventsGetIssues: false,
                recentEventsIssuesTimestamp: (new Date()).toISOString(),
                recentEventsIssues: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message
            }
            )
            if (!Main.Instance.DatabaseDataState.recentEventsActive) {
                Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.Logout, limit: dashboardSmallTableRows }/*, Callback*/)
                getLoadedResources('Socket1 - Send', Config.amGetRecentEvents)
            } else {
                getLoadedResources('Socket1 - Get', Config.amGetRecentEvents, 'issues')
                Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).loading === 'loaded') {
        if ((!Main.Instance.DatabaseDataState.recentEventsLogouts || Main.Instance.DatabaseDataState.RecentEventsGetLogouts) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).eventType === RecentEventsTypes.Logout && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).resolved) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetIssuesResolved: true, RecentEventsGetLogouts: false, recentEventsLogoutsTimestamp: (new Date()).toISOString(), recentEventsLogouts: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message })
            if (!Main.Instance.DatabaseDataState.recentEventsActive) {
                Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.ResolvedIssues, limit: dashboardSmallTableRows })
                getLoadedResources('Socket1 - Send', Config.amGetRecentEvents)
            } else {
                getLoadedResources('Socket1 - Get', Config.amGetRecentEvents, 'logouts')
                Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).loading === 'loaded') {
        if ((!Main.Instance.DatabaseDataState.recentEventsIssuesResolved || Main.Instance.DatabaseDataState.RecentEventsGetIssuesResolved) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).eventType === RecentEventsTypes.ResolvedIssues && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).resolved) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetIssuesUnresolved: true, RecentEventsGetIssuesResolved: false, recentEventsIssuesResolvedTimestamp: (new Date()).toISOString(), recentEventsIssuesResolved: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message })
            if (!Main.Instance.DatabaseDataState.recentEventsActive) {
                Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.UnresolvedIssues, limit: dashboardSmallTableRows })
                getLoadedResources('Socket1 - Send', Config.amGetRecentEvents)
            } else {
                getLoadedResources('Socket1 - Get', Config.amGetRecentEvents, 'issues resolved')
                Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).loading === 'loaded') {
        if ((!Main.Instance.DatabaseDataState.recentEventsIssuesUnresolved || Main.Instance.DatabaseDataState.RecentEventsGetIssuesUnresolved) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).eventType === RecentEventsTypes.UnresolvedIssues && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).resolved) {
            if (Main.Instance.DatabaseDataState.showJustAssignedToIssues) {
                const RecentEventsIssuesUnresolved: Latest[] = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message)
                const recentEventsIssuesUnresolved: Latest[] = []

                for (const item of RecentEventsIssuesUnresolved) {
                    let found: boolean = false
                    if (item.assignTo) {
                        for (const Item of item.assignTo) {
                            if (Item === Main.Instance.LoginState.id) {
                                found = true
                                break
                            }
                        }
                    }

                    if (found) { recentEventsIssuesUnresolved.push(item) }
                }

                Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetIssuesUnresolved: false, recentEventsIssuesUnresolvedTimestamp: (new Date()).toISOString(), recentEventsIssuesUnresolved })

                if (!Main.Instance.DatabaseDataState.recentEventsActive) {

                } else {
                    getLoadedResources('Socket1 - Get', Config.amGetRecentEvents, 'issues unresolved')
                    Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                    if (Main.Instance.DatabaseDataState.RecentEventsActive > 0) {
                        download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
                    }
                }

            } else {

                Logic.Type.New(Main.Instance.DatabaseDataState, { RecentEventsGetIssuesUnresolved: false, recentEventsIssuesUnresolvedTimestamp: (new Date()).toISOString(), recentEventsIssuesUnresolved: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message })

                if (!Main.Instance.DatabaseDataState.recentEventsActive) {

                } else {
                    getLoadedResources('Socket1 - Get', Config.amGetRecentEvents, 'issues unresolved')
                    Logic.Type.New(Main.Instance.DatabaseDataState, { recentEventsActive: false })
                    if (Main.Instance.DatabaseDataState.RecentEventsActive > 0) {
                        download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRecentEvents).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
                    }
                }
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiredAccounts) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiredAccounts).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiredAccounts).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiredAccounts).resolved && (!Main.Instance.DatabaseDataState.expiredAccounts || Main.Instance.DatabaseDataState.ExpiredAccountsGet)) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                ExpiredAccountsGet: false,
                expiredAccountsTimestamp: (new Date()).toISOString(),
                expiredAccounts: Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiredAccounts).message !== 'No data returned from the query.' ?
                    Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiredAccounts).message : []
            })
            getLoadedResources('Socket1 - Get', Config.amGetExpiredAccounts)
            download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiredAccounts).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
        }
    }
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts).resolved && (!Main.Instance.DatabaseDataState.unverifiedAccountsAll || Main.Instance.DatabaseDataState.UnverifiedAccountsAllGet)) {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                UnverifiedAccountsAllGet: false,
                unverifiedAccountsAllTimestamp: (new Date()).toISOString(),
                unverifiedAccountsAll: Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts).message !== 'No data returned from the query.' ?
                    Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts).message : []
            })
            // download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
            getLoadedResources('Socket1 - Get', Config.amGetExpiringAccounts)
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetAccountsInfo) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetAccountsInfo).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetAccountsInfo).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetAccountsInfo).resolved) {
            // tu se mora zadeva zagnat rekurzivno in dodajat v allAccountsData
            if (Main.Instance.DatabaseDataState.allAccountsStarted) {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetAccountsInfo).message.length) {
                    const allAccountsData: IAccountInfo[] = Object.assign([], Main.Instance.DatabaseDataState.allAccountsData)
                    allAccountsData.push(...Socket1.socket.Get<RouteClasses.Route>(Config.amGetAccountsInfo).message)
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        allAccountsData,
                        allAccountsPage: Main.Instance.DatabaseDataState.allAccountsPage + 1,
                    })
                    getLoadedResources('Socket1 - Get', Config.amGetAccountsInfo)
                    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetAccountsInfo).message.length === Main.Instance.DatabaseDataState.allAccountsLimit) {
                        Socket1.socket.Send(Config.amGetAccountsInfo, {
                            page: Main.Instance.DatabaseDataState.allAccountsPage,
                            limit: Main.Instance.DatabaseDataState.allAccountsLimit
                        })
                        getLoadedResources('Socket1 - Send', Config.amGetAccountsInfo)
                    } else {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            allAccountsStarted: false
                        })

                        download(
                            [],
                            100,
                            Assets.AllAcounts
                        )
                    }

                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        allAccountsStarted: false
                    })
                    download(
                        [],
                        100,
                        Assets.AllAcounts
                    )
                }
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsInfo) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsInfo).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsInfo).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsInfo).resolved) {
            // tu se mora zadeva zagnat rekurzivno in dodajat v expiringAccountsData
            if (Main.Instance.DatabaseDataState.expiringAccountsStarted) {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsInfo).message.length) {
                    const expiringAccountsData: IAccountInfo[] = Object.assign([], Main.Instance.DatabaseDataState.expiringAccountsData)
                    expiringAccountsData.push(...Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsInfo).message)
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        expiringAccountsData,
                        expiringAccountsPage: Main.Instance.DatabaseDataState.expiringAccountsPage + 1,
                    })
                    getLoadedResources('Socket1 - Get', Config.amGetExpiringAccountsInfo)
                    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsInfo).message.length === Main.Instance.DatabaseDataState.expiringAccountsLimit) {
                        Socket1.socket.Send(Config.amGetExpiringAccountsInfo, {
                            page: Main.Instance.DatabaseDataState.expiringAccountsPage,
                            limit: Main.Instance.DatabaseDataState.expiringAccountsLimit
                        })
                        getLoadedResources('Socket1 - Send', Config.amGetExpiringAccountsInfo)
                    } else {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            expiringAccountsStarted: false
                        })

                        download(
                            Main.Instance.DatabaseDataState.unverifiedAccountsAll,
                            Main.Instance.DatabaseDataState.RecentEventsActive,
                            Main.Instance.DatabaseDataState.RecentEventsActiveTitle
                        )
                    }

                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        expiringAccountsStarted: false
                    })

                    download(
                        Main.Instance.DatabaseDataState.unverifiedAccountsAll,
                        Main.Instance.DatabaseDataState.RecentEventsActive,
                        Main.Instance.DatabaseDataState.RecentEventsActiveTitle
                    )
                }
                /*
                            Logic.Type.New (Main.Instance.DatabaseDataState, {
                                UnverifiedAccountsAllGet: false,
                                unverifiedAccountsAllTimestamp: (new Date()).toISOString(),
                                unverifiedAccountsAll:  Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts).message !== 'No data returned from the query.' ?
                                                        Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts).message : []
                            })
                */
                // download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccounts).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsByDays) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsByDays).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsByDays).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsByDays).resolved && (!Main.Instance.DatabaseDataState.unverifiedAccounts || Main.Instance.DatabaseDataState.UnverifiedAccountsGet)) {

            Logic.Type.New(Main.Instance.DatabaseDataState, {
                UnverifiedAccountsGet: false,
                unverifiedAccountsTimestamp: (new Date()).toISOString(),
                unverifiedAccounts: Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsByDays).message !== 'No data returned from the query.' ?
                    Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsByDays).message : []
            })
            getLoadedResources('Socket1 - Get', Config.amGetExpiringAccountsByDays)
            download(Socket1.socket.Get<RouteClasses.Route>(Config.amGetExpiringAccountsByDays).message, Main.Instance.DatabaseDataState.RecentEventsActive, Main.Instance.DatabaseDataState.RecentEventsActiveTitle)

        }
    }
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetSessionTransactions) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetSessionTransactions).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetSessionTransactions).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetSessionTransactions).resolved && Main.Instance.DatabaseDataState.SessionTransactionsGet) {
                // console.log (39)
                Logic.Type.New (Main.Instance.DatabaseDataState, {
                    SessionTransactionsGet: false,
                    sessionTransactions: Socket1.socket.Get<RouteClasses.Route>(Config.amGetSessionTransactions).message,
                    sessionTransactionsFiltered: Socket1.socket.Get<RouteClasses.Route>(Config.amGetSessionTransactions).message
                })
                Logic.Type.New(Main.Instance.PlayerCardState, {nav: PlayerCardButtons.PlayingHistory})
            }
        }
    */
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetQuestionnaireInfo) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetQuestionnaireInfo).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetQuestionnaireInfo).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetQuestionnaireInfo).resolved && Main.Instance.DatabaseDataState.QuestionnaireGet) {
            // console.log (40)
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                QuestionnaireGet: false,
                questionnaire: Socket1.socket.Get<RouteClasses.Route>(Config.amGetQuestionnaireInfo).resolved === false ? undefined : Socket1.socket.Get<RouteClasses.Route>(Config.amGetQuestionnaireInfo).message,
            })
            getLoadedResources('Socket1 - Get', Config.amGetQuestionnaireInfo)
        }
    }

    // SECTION SETTINGS
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amSettings) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.custom || Main.Instance.DatabaseDataState.CustomGet)) {
                let proceed: boolean = false
                if (!Main.Instance.DatabaseDataState.custom) { proceed = true }
                const custom_: string = JSON.stringify(Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message[0].data)
                Logic.Type.New(Main.Instance.DatabaseDataState, { CustomGet: false, custom_, custom: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message[0].data })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amSettings)
                /*
                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) { Logic.Type.New(Main.Instance.DatabaseDataState, { GamesGet: true }) }
                    wsBasicGet(Config.amGames)
                }
                */
                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) { Logic.Type.New(Main.Instance.DatabaseDataState, { CountriesGet: true }) }
                    wsBasicGet(Config.amCountries)
                }

            }
        }
    }

    // SECTION GAMES, CONNECTED WITH SETTINGS
    /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amGames) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.games || Main.Instance.DatabaseDataState.GamesGet)) {
                let proceed: boolean = false
                // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet))
                if (!Main.Instance.DatabaseDataState.games) { proceed = true }
                const games_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { games_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { GamesGet: false, games_, games: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message, /*loadingGames4: false })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amGames)
                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) { Logic.Type.New(Main.Instance.DatabaseDataState, { CountriesGet: true }) }
                    wsBasicGet(Config.amCountries)
                }
            }
        }
    }
    */
    // SECTION GEOGRAPHY
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amCountries) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.countries || Main.Instance.DatabaseDataState.CountriesGet)) {
                let proceed: boolean = false
                if (!Main.Instance.DatabaseDataState.countries) { proceed = true }
                // const countries_: string[] = []
                // for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) countries_.push (JSON.stringify(item))
                Logic.Type.New(Main.Instance.DatabaseDataState, {/*NationalitiesGet: true,*/ CountriesGet: false/*, countries_*/, countries: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amCountries)
                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, { NationalitiesGet: true })
                    }
                    wsBasicGet(Config.amNationalities)
                }
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amNationalities) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.nationalities || Main.Instance.DatabaseDataState.NationalitiesGet)) {
                let proceed: boolean = false
                if (!Main.Instance.DatabaseDataState.nationalities) { proceed = true }
                // const nationalities_: string[] = []
                // for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) nationalities_.push (JSON.stringify(item))
                Logic.Type.New(Main.Instance.DatabaseDataState, {/*SaQuestionsGet: true,*/ NationalitiesGet: false/*, nationalities_*/, nationalities: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amNationalities)
                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerGroupsGet: true })
                    }
                    wsBasicGet(Config.amPlayerGroups)
                }
            }
        }
    }

    // SECTION PLAYER GROUPS
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amPlayerGroups) {
            if (!Main.Instance.DatabaseDataState.playerGroups || Main.Instance.DatabaseDataState.PlayerGroupsGet) {
                const playerGroups_: string[] = []
                const crmPlayerDataStream: IPlayers[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) {
                    crmPlayerDataStream.push({ id: item.id, data: [] })
                    playerGroups_.push(JSON.stringify(item))
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, { crmPlayerDataStream, /*RefreshButtonEnabled: true,*/ PlayerGroupsGet: false, playerGroups_, playerGroups: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amPlayerGroups)
                populateRealData(0)
                /*
                                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                                        Logic.Type.New (Main.Instance.DatabaseDataState, {PaymentProcessedGet: true})
                                    }
                                    wsBasicGet(Config.amProcessedPayments)
                                }
                */
            }
        }
    }

    // if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
    //     if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amProcessedPayments) {
    //         if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.paymentProcessed || Main.Instance.DatabaseDataState.PaymentProcessedGet || Main.Instance.DatabaseDataState.PaymentProcessedInsert2)) {
    //             let selectedPaymentFile: number
    //             let selectedPaymentFileIndex: number
    //             const paymentProcessed_: string[] = []
    //             for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) {
    //                 paymentProcessed_.push(JSON.stringify(item))
    //             }
    //             if (Main.Instance.DatabaseDataState.PaymentProcessedInsert2) {
    //                 selectedPaymentFile = Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message[Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message.length - 1].id
    //                 selectedPaymentFileIndex = Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message.length - 1
    //                 Logic.Type.New(Main.Instance.DatabaseDataState, { selectedPaymentFile, selectedPaymentFileIndex,/*BonusCampaignGet: true,*/RefreshButtonEnabled: true, PaymentProcessedGet: false, PaymentProcessedInsert2: false, paymentProcessed_, paymentProcessed: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })

    //             } else {
    //                 Logic.Type.New(Main.Instance.DatabaseDataState, {/*BonusCampaignGet: true,*/RefreshButtonEnabled: true, PaymentProcessedGet: false, paymentProcessed_, paymentProcessed: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
    //             }
    //             /*
    //                             if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
    //                                 wsBasicGet(Config.amBonusCampaigns)
    //                             }
    //             */
    //         }
    //     }
    // }

    // SECTION RAFFLE
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amRaffle) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.raffle || Main.Instance.DatabaseDataState.RaffleGet)) {
                let proceed: boolean = false
                if (!Main.Instance.DatabaseDataState.raffle) { proceed = true }
                const raffle_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { raffle_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.RaffleState, { count: raffle_.length })
                Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleGet: false, raffle_, raffle: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amRaffle)
                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) { Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleParticipantsGet: true }) }
                    wsBasicGet(Config.amRaffleParticipants)
                }
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amRaffleParticipants) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.raffleParticipants || Main.Instance.DatabaseDataState.RaffleParticipantsGet)) {
                const raffleParticipants_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { raffleParticipants_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, {/*CountriesGet: true,*/ RaffleParticipantsGet: false, raffleParticipants_, raffleParticipants: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amRaffleParticipants)
            }
        }
    }

    // SECTION BONUS
    /*
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amBonus) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.bonus || Main.Instance.DatabaseDataState.BonusGet)) {
                let proceed: boolean = false
                if (!Main.Instance.DatabaseDataState.bonus) { proceed = true }
                const bonus_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { bonus_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.BonusState, { count: bonus_.length })
                Logic.Type.New(Main.Instance.DatabaseDataState, { BonusGet: false, bonus_, bonus: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amBonus)
                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, { BonusCampaignGet: true })
                    }
                    wsBasicGet(Config.amBonusCampaigns)
                }
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amBonusCampaigns) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.bonusCampaign || Main.Instance.DatabaseDataState.BonusCampaignGet)) {
                let proceed: boolean = false
                if (!Main.Instance.DatabaseDataState.bonusCampaign) { proceed = true }
                const bonusCampaign_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { bonusCampaign_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.BonusCampaignState, { count: bonusCampaign_.length })
                Logic.Type.New(Main.Instance.DatabaseDataState, { RefreshButtonEnabled: true, BonusCampaignGet: false, bonusCampaign_, bonusCampaign: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amBonusCampaigns)
                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, { BonusWageringRequirementGet: true })
                    }
                    wsBasicGet(Config.amBonusWageringRequirement)
                }
            }
        }
    }
    */

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amBonusWageringRequirement) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.bonusWageringRequirement || Main.Instance.DatabaseDataState.BonusWageringRequirementGet)) {

                let proceed: boolean = false
                if (!Main.Instance.DatabaseDataState.bonusWageringRequirement) { proceed = true }
                Logic.Type.New(Main.Instance.DatabaseDataState, { RefreshButtonEnabled: true, BonusWageringRequirementGet: false, bonusWageringRequirement: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amBonusWageringRequirement)
                if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                    if (!Main.Instance.DatabaseDataState.RefreshButtonEnabled) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, { CurrenciesGet: true })
                    }
                    wsBasicGet(Config.amCurrencies)
                }
            }
        }
    }


    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amCurrencies) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.currencies || Main.Instance.DatabaseDataState.CurrenciesGet)) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {/*CounselingCentresGet: true,/*CategoriesGet: true,*/ CurrenciesGet: false, currencies: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amCurrencies)
            }
        }
    }

    // SECTION WITHDRAWALS
    /*
        // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet))
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).resolved) {
                // console.log (1)
                if (Main.Instance.DatabaseDataState.wallet) {
                    // console.log (2)
                    if (!Main.Instance.DatabaseDataState.allWithdrawalHistory || Main.Instance.DatabaseDataState.walletStatus === TransactionStatus.APPROVED) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            wallet: false,
                            Wallet: true,
                            ID: 0,
                            w: Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message,
                            s: '',
                            S: []
                        })
                    } else {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            wallet: false,
                            Wallet: true,
                            ID: 0,
                            w: Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message,
                        })
                    }
                    // console.log ('new status ' + TransactionStatus[Main.Instance.DatabaseDataState.walletStatus] + ' [' + Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message.length + ']')
                    // console.log (Main.Instance.DatabaseDataState.s)
                    addWallet(Main.Instance.DatabaseDataState.s, Main.Instance.DatabaseDataState.S, 0, Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message)
                } else {
                    // console.log (3)
    
                    if (Main.Instance.DatabaseDataState.WithdrawalRequest1) {
                        // console.log ('w1')
                        // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message)
    
                        if (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message.length === Main.Instance.DatabaseDataState.withdrawalsLimit) {
                            const withdrawalRequestTemp: any[] = Object.assign([], Main.Instance.DatabaseDataState.withdrawalRequestTemp)
                            withdrawalRequestTemp.push(...Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message)
    
                            Socket1.socket.Send(Config.amWithdrawalsGet, {
                                status: TransactionStatus.PENDING,
                                page: Main.Instance.DatabaseDataState.withdrawalsPage + 1,
                                limit: Main.Instance.DatabaseDataState.withdrawalsLimit
                            })
    
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                withdrawalRequestTemp,
                                withdrawalsPage: Main.Instance.DatabaseDataState.withdrawalsPage + 1
                            })
    
                        } else {
                            const withdrawalRequestTemp = Object.assign([], Main.Instance.DatabaseDataState.withdrawalRequestTemp)
                            withdrawalRequestTemp.push(...Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message)
    
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                withdrawalsPage: 1,
                                RefreshButtonEnabled: true,
                                WithdrawalRequest1: false,
                                WithdrawalRequest2: true,
                                withdrawalRequest1: withdrawalRequestTemp,
                                withdrawalRequestTemp: [],
                            })
                            // GET WITHDRAWALS
    
                            Socket1.socket.Send(Config.amWithdrawalsGet, {
                                status: Main.Instance.DatabaseDataState.onlyWithdrawalRequestStatus,
                                page: 1,
                                limit: Main.Instance.DatabaseDataState.withdrawalsLimit
                            })
    
                            // getNonPendingWithdrawals()
                        }
                    } else if (Main.Instance.DatabaseDataState.WithdrawalRequest2) {
                        // console.log ('w2')
                        // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message)
    
                        if (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message.length === Main.Instance.DatabaseDataState.withdrawalsLimit) {
                            const withdrawalRequestTemp: any[] = Object.assign([], Main.Instance.DatabaseDataState.withdrawalRequestTemp)
                            withdrawalRequestTemp.push(...Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message)
        
                            Socket1.socket.Send(Config.amWithdrawalsGet, {
                                status: Main.Instance.DatabaseDataState.onlyWithdrawalRequestStatus,
                                page: Main.Instance.DatabaseDataState.withdrawalsPage + 1,
                                limit: Main.Instance.DatabaseDataState.withdrawalsLimit
                            })
    
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                withdrawalRequestTemp,
                                withdrawalsPage: Main.Instance.DatabaseDataState.withdrawalsPage + 1
                            })
                            // console.log ('IN')
                        } else {
                            const withdrawalRequestTemp: any[] = Object.assign([], Main.Instance.DatabaseDataState.withdrawalRequestTemp)
                            withdrawalRequestTemp.push(...Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsGet).message)
                            // console.log ('IN2')
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                RefreshButtonEnabled: true,
                                WithdrawalRequest2: false,
                                withdrawalRequest2: withdrawalRequestTemp,
                                withdrawalsPage: 1
                            })
                        }
                    }
    
                }

                // logic here needs to be done, that the first request that is made is saved into the pending database
                // then another request is made, which gets whatever the current status is
    
            }
        }
    */
    // console.log ('*')
    // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsStatusChange))
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsStatusChange) && Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsStatusChange).loading === 'loaded') {
        if (Main.Instance.DatabaseDataState.WithdrawalStatusChange) {
        
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsStatusChange).message && Socket1.socket.Get<RouteClasses.Route>(Config.amWithdrawalsStatusChange).resolved) {
            // console.log ('IN')
            // resolved, message
            // let the flow through, only if there are no mistakes here
            // update the content of the payment file only when there was a success with change withdrawal status
            if (Main.Instance.DatabaseDataState.WithdrawalStatusChangeExecuted) {
                const paymentProcessed: PaymentProcessed[] = Object.assign([], Main.Instance.DatabaseDataState.paymentProcessed)
                const index = Main.Instance.DatabaseDataState.paymentProcessedIndex
                // console.log(paymentProcessed[index].id)
                // console.log(paymentProcessed[index].data)
                wsBasicUpdate(Config.amProcessedPayments, paymentProcessed[index].id, paymentProcessed[index].data)
            }
            Logic.Type.New(Main.Instance.DatabaseDataState, { WithdrawalStatusChange: false, WithdrawalStatusChangeExecuted: false })
            } else {
            Logic.Type.New(Main.Instance.DatabaseDataState, { WithdrawalStatusChange: false, WithdrawalStatusChangeExecuted: false })
            alert(Assets.Withdrawal + ' ' + Assets.Status.toLowerCase() + ' ' + Assets.Change.toLowerCase() + ' ' + Assets.Error.toLowerCase())
            }
        }
    }

    // SECTION QUESTIONNAIRE (NOT CONNECTED)
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amSelfAssessmentGifts) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.saGifts || Main.Instance.DatabaseDataState.SaGiftsGet)) {
                const saGifts_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { saGifts_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { SaGiftsGet: false, saGifts_, saGifts: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amSelfAssessmentCriteria) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.saCriteria || Main.Instance.DatabaseDataState.SaCriteriaGet)) {
                const saCriteria_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { saCriteria_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { SaCriteriaGet: false, saCriteria_, saCriteria: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amSelfAssessmentQuestions) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.saQuestions || Main.Instance.DatabaseDataState.SaQuestionsGet)) {
                const saQuestions_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { saQuestions_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, {/*BonusGet: true, */SaQuestionsGet: false, saQuestions_, saQuestions: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }

    // SECTION OTHER
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amLanguages) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.Languages || Main.Instance.DatabaseDataState.LanguagesGet)) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { LanguagesGet: false, Languages: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amLanguages)
            }
        }
    }

    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amNotify) {
                if (!Main.Instance.DatabaseDataState.notify || Main.Instance.DatabaseDataState.NotifyGet) {
                    // console.log (57)
                    // console.log ('01')
                    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet))
                    let proceed: boolean = false
                    if (!Main.Instance.DatabaseDataState.notify) { proceed = true }
                    const notify_: string[] = []
                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { notify_.push (JSON.stringify(item)) }
                    Logic.Type.New (Main.Instance.DatabaseDataState, {RaffleGet: true, NotifyGet: false, notify_, notify: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message})
                    // if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) { wsBasicGet(Config.amRaffle) }
                }
            }
        }
    */

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amCounselingCentres) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.counselingCentres || Main.Instance.DatabaseDataState.CounselingCentresGet)) {
                const counselingCentres_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { counselingCentres_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, {/*GamesGet: true,*/CounselingCentresGet: false, counselingCentres_, counselingCentres: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amPostalCodes) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.postalCodes || Main.Instance.DatabaseDataState.PostalCodesGet)) {
                const postalCodes_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { postalCodes_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, {/*ShopGet: true,RefreshButtonEnabled: true,*/PostalCodesGet: false, postalCodes_, postalCodes: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }
    /*
        // NOT ACTIVE ATM
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amShop) {
                if (!Main.Instance.DatabaseDataState.shop || Main.Instance.DatabaseDataState.ShopGet) {
                    // 17.
                    // console.log ('17')
                    // console.log ('shop')
                    // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message)
                    // let proceed: boolean = false
                    // if (!Main.Instance.DatabaseDataState.shop) {proceed = true}
                    const shop_: string[] = []
                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { shop_.push (JSON.stringify(item)) }
                    Logic.Type.New (Main.Instance.ShopState, {count: shop_.length})
                    Logic.Type.New (Main.Instance.DatabaseDataState, {ShopGet: false, shop_, shop: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message})
                    // if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) {wsBasicGet(Config.amWithdrawalRequests)}
                }
            }
        }
    */
    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amJurisdictions) {
                if (!Main.Instance.DatabaseDataState.jurisdictions || Main.Instance.DatabaseDataState.JurisdictionsGet) {
                    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet))
                    // 6.
                    // console.log ('6')
                    let proceed: boolean = false
                    if (!Main.Instance.DatabaseDataState.jurisdictions) proceed = true
                    const jurisdictions: Jurisdiction[] = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message ? Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message.sort(cName) : [])
                    // const nationalities_: string[] = []
                    // for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) nationalities_.push (JSON.stringify(item))
                    Logic.Type.New (Main.Instance.DatabaseDataState, {SaQuestionsGet: true, JurisdictionsGet: false, jurisdictions})
                    if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) wsBasicGet(Config.amSelfAssessmentQuestions)
                }
            }
        }
    */

    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amCategories) {
                if (!Main.Instance.DatabaseDataState.categories || Main.Instance.DatabaseDataState.CategoriesGet) {
                    // 11.
                    // console.log ('11')
                    // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message)
                    let proceed: boolean = false
                    if (!Main.Instance.DatabaseDataState.categories) proceed = true
                    const categories_: string[] = []
                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) categories_.push (JSON.stringify(item))
                    Logic.Type.New (Main.Instance.DatabaseDataState, {CounselingCentresGet: true, CategoriesGet: false, categories_, categories: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message})
                    if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) wsBasicGet(Config.amCounselingCentres)
                }
            }
        }
    */

    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amGamesCentral) {
                if (!Main.Instance.DatabaseDataState.gamesCentral || Main.Instance.DatabaseDataState.GamesCentralGet) {
                    // 13.
                    // console.log ('gamesCentral')
                    // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message)
                    let proceed: boolean = false
                    if (!Main.Instance.DatabaseDataState.gamesCentral) proceed = true
                    const gamesCentral_: string[] = []
                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) gamesCentral_.push (JSON.stringify(item))
                    Logic.Type.New (Main.Instance.DatabaseDataState, {GamesGet: true, GamesCentralGet: false, gamesCentral_, gamesCentral: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message})
                    if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) wsBasicGet(Config.amGames)
                }
            }
        }
    */

    /*
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amGameProviders) {
                if (!Main.Instance.DatabaseDataState.gameProvider || Main.Instance.DatabaseDataState.GameProviderGet) {
                    // 14.
                    // console.log ('game providers')
                    // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message)
                    let proceed: boolean = false
                    if (!Main.Instance.DatabaseDataState.gameProvider) proceed = true
                    const gameProvider_: string[] = []
                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) gameProvider_.push (JSON.stringify(item))
                    Logic.Type.New (Main.Instance.GameProviderState, {count: gameProvider_.length})
                    Logic.Type.New (Main.Instance.DatabaseDataState, {PostalCodesGet: true, GameProviderGet: false, gameProvider_, gameProvider: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message})
                    if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) wsBasicGet(Config.amPostalCodes)
                }
            }
        }

        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amRgsGameSupplier) {
                if (!Main.Instance.DatabaseDataState.rgsGameSupplier || Main.Instance.DatabaseDataState.RgsGameSupplierGet) {
                    // 15.
                    // console.log ('game providers')
                    // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message)
                    let proceed: boolean = false
                    if (!Main.Instance.DatabaseDataState.rgsGameSupplier) proceed = true
                    const rgsGameSupplier_: string[] = []
                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) rgsGameSupplier_.push (JSON.stringify(item))
                    Logic.Type.New (Main.Instance.RgsGameSupplierState, {count: rgsGameSupplier_.length})
                    Logic.Type.New (Main.Instance.DatabaseDataState, {PostalCodesGet: true, RgsGameSupplierGet: false, rgsGameSupplier_, rgsGameSupplier: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message})
                    if (proceed || !Main.Instance.DatabaseDataState.RefreshButtonEnabled) wsBasicGet(Config.amPostalCodes)
                }
            }
        }
    */

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amNetLimitLossIncreased) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.netLimitLossIncreased || Main.Instance.DatabaseDataState.NetLimitLossIncreasedGet)) {
                const netLimitLossIncreased_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { netLimitLossIncreased_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossIncreasedGet: false, netLimitLossIncreased_, netLimitLossIncreased: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amNetLimitLossRegistration) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.netLimitLossRegistration || Main.Instance.DatabaseDataState.NetLimitLossRegistrationGet)) {
                const netLimitLossRegistration_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { netLimitLossRegistration_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossRegistrationGet: false, netLimitLossRegistration_, netLimitLossRegistration: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amTemporaryExclude) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.temporaryExclude || Main.Instance.DatabaseDataState.TemporaryExcludeGet)) {
                const temporaryExclude_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { temporaryExclude_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeGet: false, temporaryExclude_, temporaryExclude: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amTemporaryExcludeOptions) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.temporaryExcludeOptions || Main.Instance.DatabaseDataState.TemporaryExcludeOptionsGet)) {
                const temporaryExcludeOptions_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { temporaryExcludeOptions_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeOptionsGet: false, temporaryExcludeOptions_, temporaryExcludeOptions: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amDashboardBackend) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.dashboardBackend || Main.Instance.DatabaseDataState.DashboardBackendGet)) {
                const dashboardBackend_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { dashboardBackend_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { DashboardBackendGet: false, dashboardBackend_, dashboardBackend: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
                getLoadedResources('Socket1 - Get', Config.amBasicGet, Config.amDashboardBackend)
            }
        }
    }

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).table === Config.amSelfExclusion) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).resolved && (!Main.Instance.DatabaseDataState.selfExclusion || Main.Instance.DatabaseDataState.SelfExclusionGet)) {
                const selfExclusion_: string[] = []
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message) { selfExclusion_.push(JSON.stringify(item)) }
                Logic.Type.New(Main.Instance.DatabaseDataState, { SelfExclusionGet: false, selfExclusion_, selfExclusion: Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).message })
            }
        }
    }


}

export function wsBasicUpdate(table: string, id: number, data: any) {
    let proceed: boolean = false

    const Data = Object.assign({}, JSON.parse(JSON.stringify(data)))
    Data.id = id

    if (table === Config.amPlayerGroups && !Main.Instance.DatabaseDataState.PlayerGroupsUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerGroupsUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Data Store -> Player Groups', Data)
    } else if (table === Config.amProcessedPayments && !Main.Instance.DatabaseDataState.PaymentProcessedUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { PaymentProcessedUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Account Store -> Payments Processed', Data)
    } else if (table === Config.amSettings && !Main.Instance.DatabaseDataState.CustomUpdate) {
        proceed = true
        // Logic.Type.New (Main.Instance.DatabaseDataState, {CustomUpdate: true, gameLabel_: JSON.stringify(Main.Instance.DatabaseDataState.tags)})
        insertAdminLog(Config.asAdminLogSaveEdit, 'Custom Settings', Data)
    /* } else if (table === Config.amBonusCampaigns && !Main.Instance.DatabaseDataState.BonusCampaignUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { BonusCampaignUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Bonus Campaign', Data)
    */
    } else if (table === Config.amBonusWageringRequirement && !Main.Instance.DatabaseDataState.BonusWageringRequirementUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { BonusWageringRequirementUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Bonus Wagering Requirement', Data)
    /* } else if (table === Config.amBonus && !Main.Instance.DatabaseDataState.BonusUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { BonusUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Bonus', Data)
    */
    } else if (table === Config.amRaffle && !Main.Instance.DatabaseDataState.RaffleUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Raffle', Data)
    } else if (table === Config.amRaffleParticipants && !Main.Instance.DatabaseDataState.RaffleParticipantsUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleParticipantsUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Raffle Participants', Data)
    } else if (table === Config.amLargeValueDeposits && !Main.Instance.DatabaseDataState.LargeValueDepositsUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueDepositsUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Risk Management', Data)
    } else if (table === Config.amLargeValueWithdrawals && !Main.Instance.DatabaseDataState.LargeValueWithdrawalUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueWithdrawalUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Risk Management', Data)
    } else if (table === Config.amTemporaryAccount && !Main.Instance.DatabaseDataState.TemporaryAccountStatusUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryAccountStatusUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Risk Management', Data)
    } else if (table === Config.amPlayerActivity && !Main.Instance.DatabaseDataState.NoPlayerActivityStatusUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { NoPlayerActivityStatusUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Risk Management', Data)
    } else if (table === Config.amBlacklist && !Main.Instance.DatabaseDataState.BlacklistUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { BlacklistUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Risk Management', Data)
    } else if (table === Config.amMaximumBalance && !Main.Instance.DatabaseDataState.MaximumBalanceUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { MaximumBalanceUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Risk Management', Data)
    } else if (table === Config.amRetail && !Main.Instance.DatabaseDataState.RetailUpdate) {
        let allowUpdate: boolean = false
        for (const item of Main.Instance.DatabaseDataState.retailActions) {
            if (item.data.riskLevel === data['riskLevel']) {
                allowUpdate = true
                break
            }
        }
        if (allowUpdate) {
            proceed = true
            Logic.Type.New(Main.Instance.DatabaseDataState, { RetailUpdate: true })
            insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Risk Management', Data)
        } else { alert(Assets.u1) }
    } else if (table === Config.amRetailActions && !Main.Instance.DatabaseDataState.RetailActionsUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { RetailActionsUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Risk Management', Data)
        /*
            } else if (table === Config.amNotify && !Main.Instance.DatabaseDataState.NotifyUpdate) {
                proceed = true
                Logic.Type.New (Main.Instance.DatabaseDataState, {NotifyUpdate: true})
                insertAdminLog (Config.asAdminLogSaveEdit, 'Settings -> Generic Settings', data)
        */
    } else if (table === Config.amSelfAssessmentGifts && !Main.Instance.DatabaseDataState.SaGiftsUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { SaGiftsUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    } else if (table === Config.amSelfAssessmentCriteria && !Main.Instance.DatabaseDataState.SaCriteriaUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { SaCriteriaUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    } else if (table === Config.amSelfAssessmentQuestions && !Main.Instance.DatabaseDataState.SaQuestionsUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { SaQuestionsUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    } else if (table === Config.amNetLimitLossIncreased && !Main.Instance.DatabaseDataState.NetLimitLossIncreasedUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossIncreasedUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    } else if (table === Config.amNetLimitLossRegistration && !Main.Instance.DatabaseDataState.NetLimitLossRegistrationUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossRegistrationUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    } else if (table === Config.amTemporaryExclude && !Main.Instance.DatabaseDataState.TemporaryExcludeUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    } else if (table === Config.amTemporaryExcludeOptions && !Main.Instance.DatabaseDataState.TemporaryExcludeOptionsUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeOptionsUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    } else if (table === Config.amDashboardBackend && !Main.Instance.DatabaseDataState.DashboardBackendUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { DashboardBackendUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    } else if (table === Config.amSelfExclusion && !Main.Instance.DatabaseDataState.SelfExclusionUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { SelfExclusionUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    } else if (table === Config.amCounselingCentres && !Main.Instance.DatabaseDataState.CounselingCentresUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { CounselingCentresUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Risk/Compliance Store -> Responsible Gaming', Data)
    /*} else if (table === Config.amGames && !Main.Instance.DatabaseDataState.GamesUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { GamesUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Game Store -> Games', data)
*/
    } else if (table === Config.amPostalCodes && !Main.Instance.DatabaseDataState.PostalCodesUpdate) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { PostalCodesUpdate: true })
        insertAdminLog(Config.asAdminLogSaveEdit, 'Player Settings -> Postal Codes', Data)

    }
    if (proceed) {
        Socket1.socket.Send(Config.amBasicUpdate, { table, id, data })
    }
}

export function wsBasicInsert(table: string, data: any) {
    let proceed: boolean = false
    if (table === Config.amPlayerGroups && !Main.Instance.DatabaseDataState.PlayerGroupsInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerGroupsInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Data Store -> Player Groups', data)
    } else if (table === Config.amProcessedPayments && !Main.Instance.DatabaseDataState.PaymentProcessedInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { PaymentProcessedInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Account Store -> Payments Processed', data)
    } else if (table === Config.amCountries && !Main.Instance.DatabaseDataState.CountriesInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { CountriesInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Player Managament -> Country', data)
    } else if (table === Config.amNationalities && !Main.Instance.DatabaseDataState.NationalitiesInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { NationalitiesInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Player Managament -> Nationality', data)
/*
    } else if (table === Config.amBonusCampaigns && !Main.Instance.DatabaseDataState.BonusCampaignInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { BonusCampaignInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Bonus Campaign', data)
*/
    } else if (table === Config.amBonusWageringRequirement && !Main.Instance.DatabaseDataState.BonusWageringRequirementInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { BonusWageringRequirementInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Bonus Wagering Requirement', data)
/*
    } else if (table === Config.amBonus && !Main.Instance.DatabaseDataState.BonusInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { BonusInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Bonus', data)
*/
    } else if (table === Config.amRaffle && !Main.Instance.DatabaseDataState.RaffleInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Raffle', data)
    } else if (table === Config.amRaffleParticipants && !Main.Instance.DatabaseDataState.RaffleParticipantsInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { RaffleParticipantsInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Raffle Participants', data)
    } else if (table === Config.amLargeValueDeposits && !Main.Instance.DatabaseDataState.LargeValueDepositsInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueDepositsInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Risk Management', data)
    } else if (table === Config.amLargeValueWithdrawals && !Main.Instance.DatabaseDataState.LargeValueWithdrawalInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { LargeValueWithdrawalInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Risk Management', data)
    } else if (table === Config.amTemporaryAccount && !Main.Instance.DatabaseDataState.TemporaryAccountStatusInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryAccountStatusInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Risk Management', data)
    } else if (table === Config.amPlayerActivity && !Main.Instance.DatabaseDataState.NoPlayerActivityStatusInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { NoPlayerActivityStatusInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Risk Management', data)
    } else if (table === Config.amBlacklist && !Main.Instance.DatabaseDataState.BlacklistInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { BlacklistInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Risk Management', data)
    } else if (table === Config.amMaximumBalance && !Main.Instance.DatabaseDataState.MaximumBalanceInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { MaximumBalanceInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Risk Management', data)
    } else if (table === Config.amRetail && !Main.Instance.DatabaseDataState.RetailInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { RetailInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Risk Management', data)
    } else if (table === Config.amRetailActions && !Main.Instance.DatabaseDataState.RetailActionsInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { RetailActionsInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Risk Management', data)
        /*
            } else if (table === Config.amNotify && !Main.Instance.DatabaseDataState.NotifyInsert) {
                proceed = true
                Logic.Type.New (Main.Instance.DatabaseDataState, {NotifyInsert: true})
                insertAdminLog (Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Generic Settings', data)
        */
    } else if (table === Config.amSelfAssessmentGifts && !Main.Instance.DatabaseDataState.SaGiftsInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { SaGiftsInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Responsible Gaming', data)
    } else if (table === Config.amSelfAssessmentCriteria && !Main.Instance.DatabaseDataState.SaCriteriaInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { SaCriteriaInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Responsible Gaming', data)
    } else if (table === Config.amSelfAssessmentQuestions && !Main.Instance.DatabaseDataState.SaQuestionsInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { SaQuestionsInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Responsible Gaming', data)
    } else if (table === Config.amNetLimitLossIncreased && !Main.Instance.DatabaseDataState.NetLimitLossIncreasedInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossIncreasedInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Responsible Gaming', data)
    } else if (table === Config.amNetLimitLossRegistration && !Main.Instance.DatabaseDataState.NetLimitLossRegistrationInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { NetLimitLossRegistrationInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Responsible Gaming', data)
    } else if (table === Config.amTemporaryExclude && !Main.Instance.DatabaseDataState.TemporaryExcludeInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Responsible Gaming', data)
    } else if (table === Config.amTemporaryExcludeOptions && !Main.Instance.DatabaseDataState.TemporaryExcludeOptionsInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { TemporaryExcludeOptionsInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Responsible Gaming', data)
    } else if (table === Config.amDashboardBackend && !Main.Instance.DatabaseDataState.DashboardBackendInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { DashboardBackendInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Responsible Gaming', data)
    } else if (table === Config.amSelfExclusion && !Main.Instance.DatabaseDataState.SelfExclusionInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { SelfExclusionInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Risk/Compliance Store -> Responsible Gaming', data)
/*
    } else if (table === Config.amGames && !Main.Instance.DatabaseDataState.GamesInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { GamesInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Game Store -> Games', data)
*/
    } else if (table === Config.amPostalCodes && !Main.Instance.DatabaseDataState.PostalCodesInsert) {
        proceed = true
        Logic.Type.New(Main.Instance.DatabaseDataState, { PostalCodesInsert: true })
        insertAdminLog(Config.asAdminLogSaveInsert, 'Player Settings -> Postal Codes', data)
    }

    if (proceed) {
        Socket1.socket.Send(Config.amBasicInsert, { table, data })
    }
}

export function wsBasicDelete(table: string, id: number) {
    let proceed: boolean = false
    if (table === Config.amPlayerGroups && !Main.Instance.DatabaseDataState.PlayerGroupsDelete) {
        proceed = true
        const playerGroups: IPlayerGroup[] = Object.assign([], Main.Instance.DatabaseDataState.playerGroups)

        const playerGroups_: string[] = Object.assign([], Main.Instance.DatabaseDataState.playerGroups_)
        for (let i: number = 0; i < playerGroups.length; i++) {
            if (playerGroups[i].id === id) {
                playerGroups.splice(i, 1)
                playerGroups_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { playerGroups, playerGroups_, PlayerGroupsDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Data Store -> Player Group', { id })
/*
    } else if (table === Config.amBonus && !Main.Instance.DatabaseDataState.BonusDelete) {
        proceed = true
        const bonus: Bonus[] = Object.assign([], Main.Instance.DatabaseDataState.bonus)
        const bonus_: string[] = Object.assign([], Main.Instance.DatabaseDataState.bonus_)
        for (let i: number = 0; i < bonus.length; i++) {
            if (bonus[i].id === id) {
                bonus.splice(i, 1)
                bonus_.splice(i, 1)
                break
            }
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { bonus, bonus_, BonusDelete: true, selectedPaymentFileIndex: undefined, selectedPaymentFile: undefined })
        insertAdminLog(Config.asAdminLogDelete, 'Game Store -> Bonus', { id })

    } else if (table === Config.amBonusCampaigns && !Main.Instance.DatabaseDataState.BonusCampaignDelete) {
        proceed = true
        const bonusCampaign: BonusCampaign[] = Object.assign([], Main.Instance.DatabaseDataState.bonusCampaign)
        const bonusCampaign_: string[] = Object.assign([], Main.Instance.DatabaseDataState.bonusCampaign_)
        for (let i: number = 0; i < bonusCampaign.length; i++) {
            if (bonusCampaign[i].id === id) {
                bonusCampaign.splice(i, 1)
                bonusCampaign_.splice(i, 1)
                break
            }
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { bonusCampaign, bonusCampaign_, BonusCampaignDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Game Store -> Bonus Campaign', { id })
*/
    } else if (table === Config.amBonusWageringRequirement && !Main.Instance.DatabaseDataState.BonusWageringRequirementDelete) {
        proceed = true
        const bonusWageringRequirement: IBonusWageringRequirement[] = Object.assign([], Main.Instance.DatabaseDataState.bonusWageringRequirement)

        for (let i: number = 0; i < bonusWageringRequirement.length; i++) {
            if (bonusWageringRequirement[i].id === id) {
                bonusWageringRequirement.splice(i, 1)
                break
            }
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { bonusWageringRequirement, BonusWageringRequirementDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Game Store -> Bonus Wagering Requirement', { id })

    } else if (table === Config.amProcessedPayments && !Main.Instance.DatabaseDataState.PaymentProcessedDelete) {
        proceed = true
        const paymentProcessed: PaymentProcessed[] = Object.assign([], Main.Instance.DatabaseDataState.paymentProcessed)
        const paymentProcessed_: string[] = Object.assign([], Main.Instance.DatabaseDataState.paymentProcessed_)
        for (let i: number = 0; i < paymentProcessed.length; i++) {
            if (paymentProcessed[i].id === id) {
                paymentProcessed.splice(i, 1)
                paymentProcessed_.splice(i, 1)
                break
            }
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { paymentProcessed, paymentProcessed_, PaymentProcessedDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Account Store -> Payments Processed', { id })

    } else if (table === Config.amPostalCodes && !Main.Instance.DatabaseDataState.PostalCodesDelete) {
        proceed = true
        const postalCodes: PostalCodes[] = Object.assign([], Main.Instance.DatabaseDataState.postalCodes)
        const postalCodes_: string[] = Object.assign([], Main.Instance.DatabaseDataState.postalCodes_)
        for (let i: number = 0; i < postalCodes.length; i++) {
            if (postalCodes[i].id === id) {
                postalCodes.splice(i, 1)
                postalCodes_.splice(i, 1)
                break
            }
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { postalCodes, postalCodes_, PostalCodesDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Player Settings -> Postal codes', { id })

    } else if (table === Config.amRaffle && !Main.Instance.DatabaseDataState.RaffleDelete) {
        proceed = true
        const raffle: Raffle[] = Object.assign([], Main.Instance.DatabaseDataState.raffle)
        const raffle_: string[] = Object.assign([], Main.Instance.DatabaseDataState.raffle_)
        for (let i: number = 0; i < raffle.length; i++) {
            if (raffle[i].id === id) {
                raffle.splice(i, 1)
                raffle_.splice(i, 1)
                break
            }
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { raffle, raffle_, RaffleDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Raffle', { id })
    } else if (table === Config.amRaffleParticipants && !Main.Instance.DatabaseDataState.RaffleParticipantsDelete) {
        proceed = true
        const raffleParticipants: RaffleParticipants[] = Object.assign([], Main.Instance.DatabaseDataState.raffleParticipants)
        const raffleParticipants_: string[] = Object.assign([], Main.Instance.DatabaseDataState.raffleParticipants_)
        for (let i: number = 0; i < raffleParticipants.length; i++) {
            if (raffleParticipants[i].id === id) {
                raffleParticipants.splice(i, 1)
                raffleParticipants_.splice(i, 1)
                break
            }
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { raffleParticipants, raffleParticipants_, RaffleParticipantsDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Raffle Participants', { id })
    } else if (table === Config.amLargeValueDeposits && !Main.Instance.DatabaseDataState.LargeValueDepositsDelete) {
        proceed = true
        const largeValueDeposits: LargeValueDepositsWithdrawal[] = Object.assign([], Main.Instance.DatabaseDataState.largeValueDeposits)
        const largeValueDeposits_: string[] = Object.assign([], Main.Instance.DatabaseDataState.largeValueDeposits_)
        for (let i: number = 0; i < largeValueDeposits.length; i++) {
            if (largeValueDeposits[i].id === id) {
                largeValueDeposits.splice(i, 1)
                largeValueDeposits_.splice(i, 1)
                break
            }
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { largeValueDeposits, largeValueDeposits_, LargeValueDepositsDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Risk Management', { id })
    } else if (table === Config.amLargeValueWithdrawals && !Main.Instance.DatabaseDataState.LargeValueWithdrawalDelete) {
        proceed = true
        const largeValueWithdrawal: LargeValueDepositsWithdrawal[] = Object.assign([], Main.Instance.DatabaseDataState.largeValueWithdrawal)
        const largeValueWithdrawal_: string[] = Object.assign([], Main.Instance.DatabaseDataState.largeValueWithdrawal_)
        for (let i: number = 0; i < largeValueWithdrawal.length; i++) {
            if (largeValueWithdrawal[i].id === id) {
                largeValueWithdrawal.splice(i, 1)
                largeValueWithdrawal_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { largeValueWithdrawal, largeValueWithdrawal_, LargeValueDepositsDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Risk Management', { id })
    } else if (table === Config.amTemporaryAccount && !Main.Instance.DatabaseDataState.TemporaryAccountStatusDelete) {
        proceed = true
        const temporaryAccountStatus: TemporaryAccountStatus[] = Object.assign([], Main.Instance.DatabaseDataState.temporaryAccountStatus)
        const temporaryAccountStatus_: string[] = Object.assign([], Main.Instance.DatabaseDataState.temporaryAccountStatus_)
        for (let i: number = 0; i < temporaryAccountStatus.length; i++) {
            if (temporaryAccountStatus[i].id === id) {
                temporaryAccountStatus.splice(i, 1)
                temporaryAccountStatus_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { temporaryAccountStatus, temporaryAccountStatus_, TemporaryAccountStatusDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Risk Management', { id })
    } else if (table === Config.amPlayerActivity && !Main.Instance.DatabaseDataState.NoPlayerActivityStatusDelete) {
        proceed = true
        const noPlayerActivityStatus: NoPlayerActivityStatus[] = Object.assign([], Main.Instance.DatabaseDataState.noPlayerActivityStatus)
        const noPlayerActivityStatus_: string[] = Object.assign([], Main.Instance.DatabaseDataState.noPlayerActivityStatus_)
        for (let i: number = 0; i < noPlayerActivityStatus.length; i++) {
            if (noPlayerActivityStatus[i].id === id) {
                noPlayerActivityStatus.splice(i, 1)
                noPlayerActivityStatus_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { noPlayerActivityStatus, noPlayerActivityStatus_, TemporaryAccountStatusDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Risk Management', { id })
    } else if (table === Config.amBlacklist && !Main.Instance.DatabaseDataState.BlacklistDelete) {
        proceed = true
        const blacklist: Blacklist[] = Object.assign([], Main.Instance.DatabaseDataState.blacklist)
        const blacklist_: string[] = Object.assign([], Main.Instance.DatabaseDataState.blacklist_)
        for (let i: number = 0; i < blacklist.length; i++) {
            if (blacklist[i].id === id) {
                blacklist.splice(i, 1)
                blacklist_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { blacklist, blacklist_, BlacklistDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Risk Management', { id })
    } else if (table === Config.amMaximumBalance && !Main.Instance.DatabaseDataState.MaximumBalanceDelete) {
        proceed = true
        const maximumBalance: MaximumBalance[] = Object.assign([], Main.Instance.DatabaseDataState.maximumBalance)
        const maximumBalance_: string[] = Object.assign([], Main.Instance.DatabaseDataState.maximumBalance_)
        for (let i: number = 0; i < maximumBalance.length; i++) {
            if (maximumBalance[i].id === id) {
                maximumBalance.splice(i, 1)
                maximumBalance_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { maximumBalance, maximumBalance_, MaximumBalanceDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Risk Management', { id })
    } else if (table === Config.amRetail && !Main.Instance.DatabaseDataState.RetailDelete) {
        proceed = true
        const retail: Retail[] = Object.assign([], Main.Instance.DatabaseDataState.retail)
        const retail_: string[] = Object.assign([], Main.Instance.DatabaseDataState.retail_)
        for (let i: number = 0; i < retail.length; i++) {
            if (retail[i].id === id) {
                retail.splice(i, 1)
                retail_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { retail, retail_, RetailDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Risk Management', { id })
    } else if (table === Config.amRetailActions && !Main.Instance.DatabaseDataState.RetailActionsDelete) {
        proceed = true
        const retailActions: RetailAction[] = Object.assign([], Main.Instance.DatabaseDataState.retailActions)
        const retailActions_: string[] = Object.assign([], Main.Instance.DatabaseDataState.retailActions_)
        for (let i: number = 0; i < retailActions.length; i++) {
            if (retailActions[i].id === id) {
                retailActions.splice(i, 1)
                retailActions_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { retailActions, retailActions_, RetailActionsDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Risk Management', { id })
        /*
            } else if (table === Config.amNotify && !Main.Instance.DatabaseDataState.NotifyDelete) {
                proceed = true
                const notify: Notify[] = Object.assign ([], Main.Instance.DatabaseDataState.notify)
                const notify_: string[] = Object.assign ([], Main.Instance.DatabaseDataState.notify_)
                for (let i: number = 0; i < notify.length; i++) {
                    if (notify[i].id === id) {
                        notify.splice (i, 1)
                        notify_.splice (i, 1)
                        break
                    }
                }

                Logic.Type.New (Main.Instance.DatabaseDataState, {notify, notify_, NotifyDelete: true})
                insertAdminLog (Config.asAdminLogDelete, 'Risk/Compliance Store -> Generic Settings', {id})
        */
    } else if (table === Config.amSelfAssessmentGifts && !Main.Instance.DatabaseDataState.SaGiftsDelete) {
        proceed = true
        const saGifts: SAGifts[] = Object.assign([], Main.Instance.DatabaseDataState.saGifts)
        const saGifts_: string[] = Object.assign([], Main.Instance.DatabaseDataState.saGifts_)
        for (let i: number = 0; i < saGifts.length; i++) {
            if (saGifts[i].id === id) {
                saGifts.splice(i, 1)
                saGifts_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { saGifts, saGifts_, SaGiftsDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Responsible Gaming', { id })
    } else if (table === Config.amSelfAssessmentCriteria && !Main.Instance.DatabaseDataState.SaCriteriaDelete) {
        proceed = true
        const saCriteria: SACriteria[] = Object.assign([], Main.Instance.DatabaseDataState.saCriteria)
        const saCriteria_: string[] = Object.assign([], Main.Instance.DatabaseDataState.saCriteria_)
        for (let i: number = 0; i < saCriteria.length; i++) {
            if (saCriteria[i].id === id) {
                saCriteria.splice(i, 1)
                saCriteria_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { saCriteria, saCriteria_, SaCriteriaDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Responsible Gaming', { id })
    } else if (table === Config.amSelfAssessmentQuestions && !Main.Instance.DatabaseDataState.SaQuestionsDelete) {
        proceed = true
        const saQuestions: SAQuestions[] = Object.assign([], Main.Instance.DatabaseDataState.saQuestions)
        const saQuestions_: string[] = Object.assign([], Main.Instance.DatabaseDataState.saQuestions_)
        for (let i: number = 0; i < saQuestions.length; i++) {
            if (saQuestions[i].id === id) {
                saQuestions.splice(i, 1)
                saQuestions_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { saQuestions, saQuestions_, SaQuestionsDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Responsible Gaming', { id })
    } else if (table === Config.amNetLimitLossIncreased && !Main.Instance.DatabaseDataState.NetLimitLossIncreasedDelete) {
        proceed = true
        const netLimitLossIncreased: NetLimitLossIncreased[] = Object.assign([], Main.Instance.DatabaseDataState.netLimitLossIncreased)
        const netLimitLossIncreased_: string[] = Object.assign([], Main.Instance.DatabaseDataState.netLimitLossIncreased_)
        for (let i: number = 0; i < netLimitLossIncreased.length; i++) {
            if (netLimitLossIncreased[i].id === id) {
                netLimitLossIncreased.splice(i, 1)
                netLimitLossIncreased_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { netLimitLossIncreased, netLimitLossIncreased_, NetLimitLossIncreasedDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Responsible Gaming', { id })
    } else if (table === Config.amNetLimitLossRegistration && !Main.Instance.DatabaseDataState.NetLimitLossRegistrationDelete) {
        proceed = true
        const netLimitLossRegistration: NetLimitLossRegistration[] = Object.assign([], Main.Instance.DatabaseDataState.netLimitLossRegistration)
        const netLimitLossRegistration_: string[] = Object.assign([], Main.Instance.DatabaseDataState.netLimitLossRegistration_)
        for (let i: number = 0; i < netLimitLossRegistration.length; i++) {
            if (netLimitLossRegistration[i].id === id) {
                netLimitLossRegistration.splice(i, 1)
                netLimitLossRegistration_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { netLimitLossRegistration, netLimitLossRegistration_, NetLimitLossRegistrationDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Responsible Gaming', { id })
    } else if (table === Config.amTemporaryExclude && !Main.Instance.DatabaseDataState.TemporaryExcludeDelete) {
        proceed = true
        const temporaryExclude: TemporaryExclude[] = Object.assign([], Main.Instance.DatabaseDataState.temporaryExclude)
        const temporaryExclude_: string[] = Object.assign([], Main.Instance.DatabaseDataState.temporaryExclude_)
        for (let i: number = 0; i < temporaryExclude.length; i++) {
            if (temporaryExclude[i].id === id) {
                temporaryExclude.splice(i, 1)
                temporaryExclude_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { temporaryExclude, temporaryExclude_, TemporaryExcludeDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Responsible Gaming', { id })
    } else if (table === Config.amTemporaryExcludeOptions && !Main.Instance.DatabaseDataState.TemporaryExcludeOptionsDelete) {
        proceed = true
        const temporaryExcludeOptions: TemporaryExcludeOptions[] = Object.assign([], Main.Instance.DatabaseDataState.temporaryExcludeOptions)
        const temporaryExcludeOptions_: string[] = Object.assign([], Main.Instance.DatabaseDataState.temporaryExcludeOptions_)
        for (let i: number = 0; i < temporaryExcludeOptions.length; i++) {
            if (temporaryExcludeOptions[i].id === id) {
                temporaryExcludeOptions.splice(i, 1)
                temporaryExcludeOptions_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { temporaryExcludeOptions, temporaryExcludeOptions_, TemporaryExcludeOptionsDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Responsible Gaming', { id })
    } else if (table === Config.amDashboardBackend && !Main.Instance.DatabaseDataState.DashboardBackendDelete) {
        proceed = true
        const dashboardBackend: DashboardBackend[] = Object.assign([], Main.Instance.DatabaseDataState.dashboardBackend)
        const dashboardBackend_: string[] = Object.assign([], Main.Instance.DatabaseDataState.dashboardBackend_)
        for (let i: number = 0; i < dashboardBackend.length; i++) {
            if (dashboardBackend[i].id === id) {
                dashboardBackend.splice(i, 1)
                dashboardBackend_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { dashboardBackend, dashboardBackend_, DashboardBackendDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Responsible Gaming', { id })
    } else if (table === Config.amSelfExclusion && !Main.Instance.DatabaseDataState.SelfExclusionDelete) {
        proceed = true
        const selfExclusion: SelfExclusion[] = Object.assign([], Main.Instance.DatabaseDataState.selfExclusion)
        const selfExclusion_: string[] = Object.assign([], Main.Instance.DatabaseDataState.selfExclusion_)
        for (let i: number = 0; i < selfExclusion.length; i++) {
            if (selfExclusion[i].id === id) {
                selfExclusion.splice(i, 1)
                selfExclusion_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { selfExclusion, selfExclusion_, SelfExclusionDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Risk/Compliance Store -> Responsible Gaming', { id })

/*    } else if (table === Config.amGames && !Main.Instance.DatabaseDataState.GamesDelete) {
        proceed = true
        const games: Games[] = Object.assign([], Main.Instance.DatabaseDataState.games)
        const games_: string[] = Object.assign([], Main.Instance.DatabaseDataState.games_)
        for (let i: number = 0; i < games.length; i++) {
            if (games[i].id === id) {
                games.splice(i, 1)
                games_.splice(i, 1)
                break
            }
        }

        Logic.Type.New(Main.Instance.DatabaseDataState, { games, games_, SelfExclusionDelete: true })
        insertAdminLog(Config.asAdminLogDelete, 'Games Store -> Approved Games Store', { id })
*/
    } else {

    }

    if (proceed) {
        Socket1.socket.Send(Config.amBasicDelete, { table, id })
    }
}
/*
export function wsGetGGRReport() {
    Logic.Type.New (Main.Instance.DatabaseDataState, {ggrReportsGet: true})
    const Arguments:{dateFrom?: string, dateTo?: string} = {}

    if (Main.Instance.GGRRevenueState.dateFrom > -1) {
        Arguments.dateFrom = Main.Instance.DatabaseDataState.ggrReportsDates[Main.Instance.GGRRevenueState.dateFrom]
    }

    if (Main.Instance.GGRRevenueState.dateTo > -1) {
        Arguments.dateTo = Main.Instance.DatabaseDataState.ggrReportsDates[Main.Instance.GGRRevenueState.dateTo]
    }
    // console.log (Arguments)
    Socket1.socket.Send (Config.amGetReports, Arguments)
}
*/
export function wsGetPlayerCards() {
    Logic.Type.New(Main.Instance.DatabaseDataState, { PlayerCardsGet: true })
    Socket1.socket.Send(Config.amGetPlayerCards, {})
    getLoadedResources('Socket1 - Send', Config.amGetPlayerCards)
}
/*
export function wsGetIssues() {
    console.log ('wsGetIssues')
    Logic.Type.New (Main.Instance.DatabaseDataState, {IssuesGet: true})
    Socket1.socket.Send (Config.amGetIssues, {
        filters: {resolved: false},
        page: Main.Instance.DatabaseDataState.issues1Page,
        limit: Main.Instance.DatabaseDataState.issues1Limit
    })
}
*/
/*export function wsGetUnresolvedIssues() {
    // Logic.Type.New (Main.Instance.DatabaseDataState, {UnresolvedIssuesGet: true})
    Socket1.socket.Send (Config.amGetIssues, {filters: {resolved: false}, page: Main.Instance.DatabaseDataState.issuesPage, limit: Main.Instance.DatabaseDataState.issuesLimit})
}
*/

export function wsInsertManualWithdrawal(issue: IIssueInsertAdmin) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { ManualWithdrawalInsert: true })
    Socket1.socket.Send(Config.amManualWithdrawal, { playerId: issue.playerId, amount: issue.data.withdrawBalance, currency: 'CHF', riskManagerId: issue.riskManagerId })
}

export function wsInsertManualDeposit(issue: IIssueInsertAdmin) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { ManualDepositInsert: true })
    Socket1.socket.Send(Config.amManualDeposit, { playerId: issue.playerId, amount: issue.data.withdrawBalance, currency: 'CHF', riskManagerId: issue.riskManagerId, comment: issue.comment })
}

export function wsInsertMassManualDeposit() {
    const deposit = Object.assign({}, Main.Instance.DatabaseDataState.uploadedMassManualDeposits[Main.Instance.DatabaseDataState.countMassManualDeposits])
    if (deposit && deposit.playerId && deposit.amount) {
        Socket1.socket.Send(Config.amManualDeposit, { playerId: Main.Instance.DatabaseDataState.uploadedMassManualDeposits[Main.Instance.DatabaseDataState.countMassManualDeposits].playerId, amount: Main.Instance.DatabaseDataState.uploadedMassManualDeposits[Main.Instance.DatabaseDataState.countMassManualDeposits].amount, currency: 'CHF', riskManagerId: Main.Instance.LoginState.id, comment: Main.Instance.DatabaseDataState.uploadedMassManualDeposits[Main.Instance.DatabaseDataState.countMassManualDeposits].comment})
        Logic.Type.New(Main.Instance.DatabaseDataState, { ManualDepositInsert: true })
    } else {
        Logic.Type.New(Main.Instance.DatabaseDataState, { ManualDepositInsert: false, countMassManualDeposits: 0, uploadedMassManualDeposits: [], isInsertingMassManualUploads: false})
    }
}

export function updateCommunications(playerId: string, communications: ICommunicationUpdate) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { CommunicationsUpdate: true })
    Socket1.socket.Send(Config.amCommunicationsUpdate, { playerId, communications })
}

export function wsInsertIssue(issue: IIssueInsertAdmin) {
    // console.log(issue)
    Logic.Type.New(Main.Instance.DatabaseDataState, { IssuesInsert: true, IssuesInsertType: issue.issueType })
    Socket1.socket.Send(Config.amInsertIssue, issue)
}

export function wsUpdateIssue(issue: IIssue) {
    // console.log(issue)
    Logic.Type.New(Main.Instance.DatabaseDataState, { IssuesUpdate: true })
    Socket1.socket.Send(Config.amUpdateIssue, { issue })
}

export function wsGetPlayerCard(playerId: string, getTimeline?: boolean) {
    if (getTimeline) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { playerTimeline: [], loadedPlayerCard: true, sessionId: undefined, /*gameSessions: undefined, gameSessionSelectedId: undefined, */openingPlayerCard: true, openedPlayerCard: true, PlayerCardGet: true, PlayerTimelineGet: true })
    } else {
        Logic.Type.New(Main.Instance.DatabaseDataState, { loadedPlayerCard: true, sessionId: undefined, /*gameSessions: undefined, gameSessionSelectedId: undefined, */openingPlayerCard: true, openedPlayerCard: true, PlayerCardGet: true })
    }
    Socket1.socket.Send(Config.amGetPlayerCard, { playerId })
    getLoadedResources('Socket1 - Send', Config.amGetPlayerCard)
    if (getTimeline) {
        Logic.Type.New(Main.Instance.PlayerCardState, {
            gameSessions: undefined,
            gameSessionsTransactions: undefined,
        })
        getPlayerTimeline(playerId)
    }
}

function getPlayerTimeline(playerId: string, pageSize?: number, page?: number) {
    
    // const r = Config.pipeServer + Config.pipeTransactionsAll + '?playerId=' + playerId + '&token=' + Config.keyGet
    // Logic.Type.New (Main.Instance.DatabaseDataState, {})
    // getStream(Config.pipeServer + Config.pipeTransactionsAll + '?playerId=' + playerId + '&token=' + Config.keyGet, onProgress3, onEnd3, onError3)


    Socket1.socket.Send(Config.walletTransactionsGet, {
        playerId,
        page: page ? page : 1,
        pageSize: pageSize ? pageSize : 10000
    })
    getLoadedResources('Socket1 - Send', Config.walletTransactionsGet)
    Socket1.socket.Get<RouteClasses.Route>(Config.walletTransactionsGet).loading = 'init'
    Logic.Type.New(Main.Instance.DatabaseDataState, { playerTimelineTransactions: undefined })
}


export function wsGetPlayerTimeline(playerId: string, limit?: number, page?: number) {
    if (Main.Instance.DatabaseDataState.playerTimeline) {
        Logic.Type.New(Main.Instance.DatabaseDataState, {
            PlayerTimelineGet: true,
            playerTimeline: []
        })
    }
    if (limit && page) {
        // CHANGE Socket1.socket.Send(Config.amGetPlayerTimeline, { playerId, limit, page })
        // pipe
        getPlayerTimeline(playerId, limit, page)
    } else {
        // CHANGE Socket1.socket.Send(Config.amGetPlayerTimeline, { playerId })
        // pipe
        // const r = Config.pipeServer + Config.pipeTransactionsAll + '?playerId=' + playerId + '&token=' + Config.keyGet
        // getStream(r, onProgress3, onEnd3, onError3)
        getPlayerTimeline(playerId)
    }
    Logic.Type.New(Main.Instance.PlayerCardState, {selectingGameSessionId: false})
}
/*
export function wsGetSessionTransactions(sessionId: string) {
    Logic.Type.New (Main.Instance.DatabaseDataState, {SessionTransactionsGet: true})
    // console.log (Config.amGetSessionTransactions, sessionId)
    Socket1.socket.Send (Config.amGetSessionTransactions, {sessionId})
}
*/
export function wsGetLoggedInPlayers(page: number, size: number) {
    // console.log(page, size)
    Logic.Type.New(Main.Instance.DatabaseDataState, { LoggedPlayersGet: true })
    Socket1.socket.Send(Config.amGetLoggedInPlayers, {paginationParams: {page, size}})
    getLoadedResources('Socket1 - Send', Config.amGetLoggedInPlayers)
}

export function wsGetQuestionnaire(playerId: string, date: string) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { QuestionnaireGet: true })
    Socket1.socket.Send(Config.amGetQuestionnaireInfo, { playerId, date })
    getLoadedResources('Socket1 - Send', Config.amGetQuestionnaireInfo)
}

export function wsBasicGet(table: string) {
    Socket1.socket.Get<RouteClasses.Route>(Config.amBasicGet).loading = 'loading'
    Socket1.socket.Send(Config.amBasicGet, { table })
    getLoadedResources('Socket1 - Send', Config.amBasicGet, table)
}
/*
const countries:{name: string, alpha2: string, 'country-code': string}[]=[{"name":"Afghanistan","alpha-2":"AF","country-code":"004"},{"name":"Åland Islands","alpha-2":"AX","country-code":"248"},{"name":"Albania","alpha-2":"AL","country-code":"008"},{"name":"Algeria","alpha-2":"DZ","country-code":"012"},{"name":"American Samoa","alpha-2":"AS","country-code":"016"},{"name":"Andorra","alpha-2":"AD","country-code":"020"},{"name":"Angola","alpha-2":"AO","country-code":"024"},{"name":"Anguilla","alpha-2":"AI","country-code":"660"},{"name":"Antarctica","alpha-2":"AQ","country-code":"010"},{"name":"Antigua and Barbuda","alpha-2":"AG","country-code":"028"},{"name":"Argentina","alpha-2":"AR","country-code":"032"},{"name":"Armenia","alpha-2":"AM","country-code":"051"},{"name":"Aruba","alpha-2":"AW","country-code":"533"},{"name":"Australia","alpha-2":"AU","country-code":"036"},{"name":"Austria","alpha-2":"AT","country-code":"040"},{"name":"Azerbaijan","alpha-2":"AZ","country-code":"031"},{"name":"Bahamas","alpha-2":"BS","country-code":"044"},{"name":"Bahrain","alpha-2":"BH","country-code":"048"},{"name":"Bangladesh","alpha-2":"BD","country-code":"050"},{"name":"Barbados","alpha-2":"BB","country-code":"052"},{"name":"Belarus","alpha-2":"BY","country-code":"112"},{"name":"Belgium","alpha-2":"BE","country-code":"056"},{"name":"Belize","alpha-2":"BZ","country-code":"084"},{"name":"Benin","alpha-2":"BJ","country-code":"204"},{"name":"Bermuda","alpha-2":"BM","country-code":"060"},{"name":"Bhutan","alpha-2":"BT","country-code":"064"},{"name":"Bolivia (Plurinational State of)","alpha-2":"BO","country-code":"068"},{"name":"Bonaire, Sint Eustatius and Saba","alpha-2":"BQ","country-code":"535"},{"name":"Bosnia and Herzegovina","alpha-2":"BA","country-code":"070"},{"name":"Botswana","alpha-2":"BW","country-code":"072"},{"name":"Bouvet Island","alpha-2":"BV","country-code":"074"},{"name":"Brazil","alpha-2":"BR","country-code":"076"},{"name":"British Indian Ocean Territory","alpha-2":"IO","country-code":"086"},{"name":"Brunei Darussalam","alpha-2":"BN","country-code":"096"},{"name":"Bulgaria","alpha-2":"BG","country-code":"100"},{"name":"Burkina Faso","alpha-2":"BF","country-code":"854"},{"name":"Burundi","alpha-2":"BI","country-code":"108"},{"name":"Cabo Verde","alpha-2":"CV","country-code":"132"},{"name":"Cambodia","alpha-2":"KH","country-code":"116"},{"name":"Cameroon","alpha-2":"CM","country-code":"120"},{"name":"Canada","alpha-2":"CA","country-code":"124"},{"name":"Cayman Islands","alpha-2":"KY","country-code":"136"},{"name":"Central African Republic","alpha-2":"CF","country-code":"140"},{"name":"Chad","alpha-2":"TD","country-code":"148"},{"name":"Chile","alpha-2":"CL","country-code":"152"},{"name":"China","alpha-2":"CN","country-code":"156"},{"name":"Christmas Island","alpha-2":"CX","country-code":"162"},{"name":"Cocos (Keeling) Islands","alpha-2":"CC","country-code":"166"},{"name":"Colombia","alpha-2":"CO","country-code":"170"},{"name":"Comoros","alpha-2":"KM","country-code":"174"},{"name":"Congo","alpha-2":"CG","country-code":"178"},{"name":"Congo (Democratic Republic of the)","alpha-2":"CD","country-code":"180"},{"name":"Cook Islands","alpha-2":"CK","country-code":"184"},{"name":"Costa Rica","alpha-2":"CR","country-code":"188"},{"name":"Côte d'Ivoire","alpha-2":"CI","country-code":"384"},{"name":"Croatia","alpha-2":"HR","country-code":"191"},{"name":"Cuba","alpha-2":"CU","country-code":"192"},{"name":"Curaçao","alpha-2":"CW","country-code":"531"},{"name":"Cyprus","alpha-2":"CY","country-code":"196"},{"name":"Czechia","alpha-2":"CZ","country-code":"203"},{"name":"Denmark","alpha-2":"DK","country-code":"208"},{"name":"Djibouti","alpha-2":"DJ","country-code":"262"},{"name":"Dominica","alpha-2":"DM","country-code":"212"},{"name":"Dominican Republic","alpha-2":"DO","country-code":"214"},{"name":"Ecuador","alpha-2":"EC","country-code":"218"},{"name":"Egypt","alpha-2":"EG","country-code":"818"},{"name":"El Salvador","alpha-2":"SV","country-code":"222"},{"name":"Equatorial Guinea","alpha-2":"GQ","country-code":"226"},{"name":"Eritrea","alpha-2":"ER","country-code":"232"},{"name":"Estonia","alpha-2":"EE","country-code":"233"},{"name":"Eswatini","alpha-2":"SZ","country-code":"748"},{"name":"Ethiopia","alpha-2":"ET","country-code":"231"},{"name":"Falkland Islands (Malvinas)","alpha-2":"FK","country-code":"238"},{"name":"Faroe Islands","alpha-2":"FO","country-code":"234"},{"name":"Fiji","alpha-2":"FJ","country-code":"242"},{"name":"Finland","alpha-2":"FI","country-code":"246"},{"name":"France","alpha-2":"FR","country-code":"250"},{"name":"French Guiana","alpha-2":"GF","country-code":"254"},{"name":"French Polynesia","alpha-2":"PF","country-code":"258"},{"name":"French Southern Territories","alpha-2":"TF","country-code":"260"},{"name":"Gabon","alpha-2":"GA","country-code":"266"},{"name":"Gambia","alpha-2":"GM","country-code":"270"},{"name":"Georgia","alpha-2":"GE","country-code":"268"},{"name":"Germany","alpha-2":"DE","country-code":"276"},{"name":"Ghana","alpha-2":"GH","country-code":"288"},{"name":"Gibraltar","alpha-2":"GI","country-code":"292"},{"name":"Greece","alpha-2":"GR","country-code":"300"},{"name":"Greenland","alpha-2":"GL","country-code":"304"},{"name":"Grenada","alpha-2":"GD","country-code":"308"},{"name":"Guadeloupe","alpha-2":"GP","country-code":"312"},{"name":"Guam","alpha-2":"GU","country-code":"316"},{"name":"Guatemala","alpha-2":"GT","country-code":"320"},{"name":"Guernsey","alpha-2":"GG","country-code":"831"},{"name":"Guinea","alpha-2":"GN","country-code":"324"},{"name":"Guinea-Bissau","alpha-2":"GW","country-code":"624"},{"name":"Guyana","alpha-2":"GY","country-code":"328"},{"name":"Haiti","alpha-2":"HT","country-code":"332"},{"name":"Heard Island and McDonald Islands","alpha-2":"HM","country-code":"334"},{"name":"Holy See","alpha-2":"VA","country-code":"336"},{"name":"Honduras","alpha-2":"HN","country-code":"340"},{"name":"Hong Kong","alpha-2":"HK","country-code":"344"},{"name":"Hungary","alpha-2":"HU","country-code":"348"},{"name":"Iceland","alpha-2":"IS","country-code":"352"},{"name":"India","alpha-2":"IN","country-code":"356"},{"name":"Indonesia","alpha-2":"ID","country-code":"360"},{"name":"Iran (Islamic Republic of)","alpha-2":"IR","country-code":"364"},{"name":"Iraq","alpha-2":"IQ","country-code":"368"},{"name":"Ireland","alpha-2":"IE","country-code":"372"},{"name":"Isle of Man","alpha-2":"IM","country-code":"833"},{"name":"Israel","alpha-2":"IL","country-code":"376"},{"name":"Italy","alpha-2":"IT","country-code":"380"},{"name":"Jamaica","alpha-2":"JM","country-code":"388"},{"name":"Japan","alpha-2":"JP","country-code":"392"},{"name":"Jersey","alpha-2":"JE","country-code":"832"},{"name":"Jordan","alpha-2":"JO","country-code":"400"},{"name":"Kazakhstan","alpha-2":"KZ","country-code":"398"},{"name":"Kenya","alpha-2":"KE","country-code":"404"},{"name":"Kiribati","alpha-2":"KI","country-code":"296"},{"name":"Korea (Democratic People's Republic of)","alpha-2":"KP","country-code":"408"},{"name":"Korea (Republic of)","alpha-2":"KR","country-code":"410"},{"name":"Kuwait","alpha-2":"KW","country-code":"414"},{"name":"Kyrgyzstan","alpha-2":"KG","country-code":"417"},{"name":"Lao People's Democratic Republic","alpha-2":"LA","country-code":"418"},{"name":"Latvia","alpha-2":"LV","country-code":"428"},{"name":"Lebanon","alpha-2":"LB","country-code":"422"},{"name":"Lesotho","alpha-2":"LS","country-code":"426"},{"name":"Liberia","alpha-2":"LR","country-code":"430"},{"name":"Libya","alpha-2":"LY","country-code":"434"},{"name":"Liechtenstein","alpha-2":"LI","country-code":"438"},{"name":"Lithuania","alpha-2":"LT","country-code":"440"},{"name":"Luxembourg","alpha-2":"LU","country-code":"442"},{"name":"Macao","alpha-2":"MO","country-code":"446"},{"name":"Macedonia (the former Yugoslav Republic of)","alpha-2":"MK","country-code":"807"},{"name":"Madagascar","alpha-2":"MG","country-code":"450"},{"name":"Malawi","alpha-2":"MW","country-code":"454"},{"name":"Malaysia","alpha-2":"MY","country-code":"458"},{"name":"Maldives","alpha-2":"MV","country-code":"462"},{"name":"Mali","alpha-2":"ML","country-code":"466"},{"name":"Malta","alpha-2":"MT","country-code":"470"},{"name":"Marshall Islands","alpha-2":"MH","country-code":"584"},{"name":"Martinique","alpha-2":"MQ","country-code":"474"},{"name":"Mauritania","alpha-2":"MR","country-code":"478"},{"name":"Mauritius","alpha-2":"MU","country-code":"480"},{"name":"Mayotte","alpha-2":"YT","country-code":"175"},{"name":"Mexico","alpha-2":"MX","country-code":"484"},{"name":"Micronesia (Federated States of)","alpha-2":"FM","country-code":"583"},{"name":"Moldova (Republic of)","alpha-2":"MD","country-code":"498"},{"name":"Monaco","alpha-2":"MC","country-code":"492"},{"name":"Mongolia","alpha-2":"MN","country-code":"496"},{"name":"Montenegro","alpha-2":"ME","country-code":"499"},{"name":"Montserrat","alpha-2":"MS","country-code":"500"},{"name":"Morocco","alpha-2":"MA","country-code":"504"},{"name":"Mozambique","alpha-2":"MZ","country-code":"508"},{"name":"Myanmar","alpha-2":"MM","country-code":"104"},{"name":"Namibia","alpha-2":"NA","country-code":"516"},{"name":"Nauru","alpha-2":"NR","country-code":"520"},{"name":"Nepal","alpha-2":"NP","country-code":"524"},{"name":"Netherlands","alpha-2":"NL","country-code":"528"},{"name":"New Caledonia","alpha-2":"NC","country-code":"540"},{"name":"New Zealand","alpha-2":"NZ","country-code":"554"},{"name":"Nicaragua","alpha-2":"NI","country-code":"558"},{"name":"Niger","alpha-2":"NE","country-code":"562"},{"name":"Nigeria","alpha-2":"NG","country-code":"566"},{"name":"Niue","alpha-2":"NU","country-code":"570"},{"name":"Norfolk Island","alpha-2":"NF","country-code":"574"},{"name":"Northern Mariana Islands","alpha-2":"MP","country-code":"580"},{"name":"Norway","alpha-2":"NO","country-code":"578"},{"name":"Oman","alpha-2":"OM","country-code":"512"},{"name":"Pakistan","alpha-2":"PK","country-code":"586"},{"name":"Palau","alpha-2":"PW","country-code":"585"},{"name":"Palestine, State of","alpha-2":"PS","country-code":"275"},{"name":"Panama","alpha-2":"PA","country-code":"591"},{"name":"Papua New Guinea","alpha-2":"PG","country-code":"598"},{"name":"Paraguay","alpha-2":"PY","country-code":"600"},{"name":"Peru","alpha-2":"PE","country-code":"604"},{"name":"Philippines","alpha-2":"PH","country-code":"608"},{"name":"Pitcairn","alpha-2":"PN","country-code":"612"},{"name":"Poland","alpha-2":"PL","country-code":"616"},{"name":"Portugal","alpha-2":"PT","country-code":"620"},{"name":"Puerto Rico","alpha-2":"PR","country-code":"630"},{"name":"Qatar","alpha-2":"QA","country-code":"634"},{"name":"Réunion","alpha-2":"RE","country-code":"638"},{"name":"Romania","alpha-2":"RO","country-code":"642"},{"name":"Russian Federation","alpha-2":"RU","country-code":"643"},{"name":"Rwanda","alpha-2":"RW","country-code":"646"},{"name":"Saint Barthélemy","alpha-2":"BL","country-code":"652"},{"name":"Saint Helena, Ascension and Tristan da Cunha","alpha-2":"SH","country-code":"654"},{"name":"Saint Kitts and Nevis","alpha-2":"KN","country-code":"659"},{"name":"Saint Lucia","alpha-2":"LC","country-code":"662"},{"name":"Saint Martin (French part)","alpha-2":"MF","country-code":"663"},{"name":"Saint Pierre and Miquelon","alpha-2":"PM","country-code":"666"},{"name":"Saint Vincent and the Grenadines","alpha-2":"VC","country-code":"670"},{"name":"Samoa","alpha-2":"WS","country-code":"882"},{"name":"San Marino","alpha-2":"SM","country-code":"674"},{"name":"Sao Tome and Principe","alpha-2":"ST","country-code":"678"},{"name":"Saudi Arabia","alpha-2":"SA","country-code":"682"},{"name":"Senegal","alpha-2":"SN","country-code":"686"},{"name":"Serbia","alpha-2":"RS","country-code":"688"},{"name":"Seychelles","alpha-2":"SC","country-code":"690"},{"name":"Sierra Leone","alpha-2":"SL","country-code":"694"},{"name":"Singapore","alpha-2":"SG","country-code":"702"},{"name":"Sint Maarten (Dutch part)","alpha-2":"SX","country-code":"534"},{"name":"Slovakia","alpha-2":"SK","country-code":"703"},{"name":"Slovenia","alpha-2":"SI","country-code":"705"},{"name":"Solomon Islands","alpha-2":"SB","country-code":"090"},{"name":"Somalia","alpha-2":"SO","country-code":"706"},{"name":"South Africa","alpha-2":"ZA","country-code":"710"},{"name":"South Georgia and the South Sandwich Islands","alpha-2":"GS","country-code":"239"},{"name":"South Sudan","alpha-2":"SS","country-code":"728"},{"name":"Spain","alpha-2":"ES","country-code":"724"},{"name":"Sri Lanka","alpha-2":"LK","country-code":"144"},{"name":"Sudan","alpha-2":"SD","country-code":"729"},{"name":"Suriname","alpha-2":"SR","country-code":"740"},{"name":"Svalbard and Jan Mayen","alpha-2":"SJ","country-code":"744"},{"name":"Sweden","alpha-2":"SE","country-code":"752"},{"name":"Switzerland","alpha-2":"CH","country-code":"756"},{"name":"Syrian Arab Republic","alpha-2":"SY","country-code":"760"},{"name":"Taiwan, Province of China","alpha-2":"TW","country-code":"158"},{"name":"Tajikistan","alpha-2":"TJ","country-code":"762"},{"name":"Tanzania, United Republic of","alpha-2":"TZ","country-code":"834"},{"name":"Thailand","alpha-2":"TH","country-code":"764"},{"name":"Timor-Leste","alpha-2":"TL","country-code":"626"},{"name":"Togo","alpha-2":"TG","country-code":"768"},{"name":"Tokelau","alpha-2":"TK","country-code":"772"},{"name":"Tonga","alpha-2":"TO","country-code":"776"},{"name":"Trinidad and Tobago","alpha-2":"TT","country-code":"780"},{"name":"Tunisia","alpha-2":"TN","country-code":"788"},{"name":"Turkey","alpha-2":"TR","country-code":"792"},{"name":"Turkmenistan","alpha-2":"TM","country-code":"795"},{"name":"Turks and Caicos Islands","alpha-2":"TC","country-code":"796"},{"name":"Tuvalu","alpha-2":"TV","country-code":"798"},{"name":"Uganda","alpha-2":"UG","country-code":"800"},{"name":"Ukraine","alpha-2":"UA","country-code":"804"},{"name":"United Arab Emirates","alpha-2":"AE","country-code":"784"},{"name":"United Kingdom of Great Britain and Northern Ireland","alpha-2":"GB","country-code":"826"},{"name":"United States of America","alpha-2":"US","country-code":"840"},{"name":"United States Minor Outlying Islands","alpha-2":"UM","country-code":"581"},{"name":"Uruguay","alpha-2":"UY","country-code":"858"},{"name":"Uzbekistan","alpha-2":"UZ","country-code":"860"},{"name":"Vanuatu","alpha-2":"VU","country-code":"548"},{"name":"Venezuela (Bolivarian Republic of)","alpha-2":"VE","country-code":"862"},{"name":"Viet Nam","alpha-2":"VN","country-code":"704"},{"name":"Virgin Islands (British)","alpha-2":"VG","country-code":"092"},{"name":"Virgin Islands (U.S.)","alpha-2":"VI","country-code":"850"},{"name":"Wallis and Futuna","alpha-2":"WF","country-code":"876"},{"name":"Western Sahara","alpha-2":"EH","country-code":"732"},{"name":"Yemen","alpha-2":"YE","country-code":"887"},{"name":"Zambia","alpha-2":"ZM","country-code":"894"},{"name":"Zimbabwe","alpha-2":"ZW","country-code":"716"}]
*/
// const countries = {'AF':{'name':'Afghanistan','dial_code':'+93','code':'AF'},'AX':{'name':'Åland Islands','dial_code':'+358','code':'AX'},'AL':{'name':'Albania','dial_code':'+355','code':'AL'},'DZ':{'name':'Algeria','dial_code':'+213','code':'DZ'},'AS':{'name':'American Samoa','dial_code':'+1684','code':'AS'},'AD':{'name':'Andorra','dial_code':'+376','code':'AD'},'AO':{'name':'Angola','dial_code':'+244','code':'AO'},'AI':{'name':'Anguilla','dial_code':'+1264','code':'AI'},'AQ':{'name':'Antarctica','dial_code':'+672','code':'AQ'},'AG':{'name':'Antigua and Barbuda','dial_code':'+1268','code':'AG'},'AR':{'name':'Argentina','dial_code':'+54','code':'AR'},'AM':{'name':'Armenia','dial_code':'+374','code':'AM'},'AW':{'name':'Aruba','dial_code':'+297','code':'AW'},'AU':{'name':'Australia','dial_code':'+61','code':'AU'},'AT':{'name':'Austria','dial_code':'+43','code':'AT'},'AZ':{'name':'Azerbaijan','dial_code':'+994','code':'AZ'},'BS':{'name':'Bahamas','dial_code':'+1242','code':'BS'},'BH':{'name':'Bahrain','dial_code':'+973','code':'BH'},'BD':{'name':'Bangladesh','dial_code':'+880','code':'BD'},'BB':{'name':'Barbados','dial_code':'+1246','code':'BB'},'BY':{'name':'Belarus','dial_code':'+375','code':'BY'},'BE':{'name':'Belgium','dial_code':'+32','code':'BE'},'BZ':{'name':'Belize','dial_code':'+501','code':'BZ'},'BJ':{'name':'Benin','dial_code':'+229','code':'BJ'},'BM':{'name':'Bermuda','dial_code':'+1441','code':'BM'},'BT':{'name':'Bhutan','dial_code':'+975','code':'BT'},'BO':{'name':'Bolivia, Plurinational State of bolivia','dial_code':'+591','code':'BO'},'BA':{'name':'Bosnia and Herzegovina','dial_code':'+387','code':'BA'},'BW':{'name':'Botswana','dial_code':'+267','code':'BW'},'BV':{'name':'Bouvet Island','dial_code':'+47','code':'BV'},'BR':{'name':'Brazil','dial_code':'+55','code':'BR'},'IO':{'name':'British Indian Ocean Territory','dial_code':'+246','code':'IO'},'BN':{'name':'Brunei Darussalam','dial_code':'+673','code':'BN'},'BG':{'name':'Bulgaria','dial_code':'+359','code':'BG'},'BF':{'name':'Burkina Faso','dial_code':'+226','code':'BF'},'BI':{'name':'Burundi','dial_code':'+257','code':'BI'},'KH':{'name':'Cambodia','dial_code':'+855','code':'KH'},'CM':{'name':'Cameroon','dial_code':'+237','code':'CM'},'CA':{'name':'Canada','dial_code':'+1','code':'CA'},'CV':{'name':'Cape Verde','dial_code':'+238','code':'CV'},'KY':{'name':'Cayman Islands','dial_code':'+ 345','code':'KY'},'CF':{'name':'Central African Republic','dial_code':'+236','code':'CF'},'TD':{'name':'Chad','dial_code':'+235','code':'TD'},'CL':{'name':'Chile','dial_code':'+56','code':'CL'},'CN':{'name':'China','dial_code':'+86','code':'CN'},'CX':{'name':'Christmas Island','dial_code':'+61','code':'CX'},'CC':{'name':'Cocos (Keeling) Islands','dial_code':'+61','code':'CC'},'CO':{'name':'Colombia','dial_code':'+57','code':'CO'},'KM':{'name':'Comoros','dial_code':'+269','code':'KM'},'CG':{'name':'Congo','dial_code':'+242','code':'CG'},'CD':{'name':'Congo, The Democratic Republic of the Congo','dial_code':'+243','code':'CD'},'CK':{'name':'Cook Islands','dial_code':'+682','code':'CK'},'CR':{'name':'Costa Rica','dial_code':'+506','code':'CR'},'CI':{'name':'Cote d\'Ivoire','dial_code':'+225','code':'CI'},'HR':{'name':'Croatia','dial_code':'+385','code':'HR'},'CU':{'name':'Cuba','dial_code':'+53','code':'CU'},'CY':{'name':'Cyprus','dial_code':'+357','code':'CY'},'CZ':{'name':'Czech Republic','dial_code':'+420','code':'CZ'},'DK':{'name':'Denmark','dial_code':'+45','code':'DK'},'DJ':{'name':'Djibouti','dial_code':'+253','code':'DJ'},'DM':{'name':'Dominica','dial_code':'+1767','code':'DM'},'DO':{'name':'Dominican Republic','dial_code':'+1849','code':'DO'},'EC':{'name':'Ecuador','dial_code':'+593','code':'EC'},'EG':{'name':'Egypt','dial_code':'+20','code':'EG'},'SV':{'name':'El Salvador','dial_code':'+503','code':'SV'},'GQ':{'name':'Equatorial Guinea','dial_code':'+240','code':'GQ'},'ER':{'name':'Eritrea','dial_code':'+291','code':'ER'},'EE':{'name':'Estonia','dial_code':'+372','code':'EE'},'ET':{'name':'Ethiopia','dial_code':'+251','code':'ET'},'FK':{'name':'Falkland Islands (Malvinas)','dial_code':'+500','code':'FK'},'FO':{'name':'Faroe Islands','dial_code':'+298','code':'FO'},'FJ':{'name':'Fiji','dial_code':'+679','code':'FJ'},'FI':{'name':'Finland','dial_code':'+358','code':'FI'},'FR':{'name':'France','dial_code':'+33','code':'FR'},'GF':{'name':'French Guiana','dial_code':'+594','code':'GF'},'PF':{'name':'French Polynesia','dial_code':'+689','code':'PF'},'TF':{'name':'French Southern Territories','dial_code':'+262','code':'TF'},'GA':{'name':'Gabon','dial_code':'+241','code':'GA'},'GM':{'name':'Gambia','dial_code':'+220','code':'GM'},'GE':{'name':'Georgia','dial_code':'+995','code':'GE'},'DE':{'name':'Germany','dial_code':'+49','code':'DE'},'GH':{'name':'Ghana','dial_code':'+233','code':'GH'},'GI':{'name':'Gibraltar','dial_code':'+350','code':'GI'},'GR':{'name':'Greece','dial_code':'+30','code':'GR'},'GL':{'name':'Greenland','dial_code':'+299','code':'GL'},'GD':{'name':'Grenada','dial_code':'+1473','code':'GD'},'GP':{'name':'Guadeloupe','dial_code':'+590','code':'GP'},'GU':{'name':'Guam','dial_code':'+1671','code':'GU'},'GT':{'name':'Guatemala','dial_code':'+502','code':'GT'},'GG':{'name':'Guernsey','dial_code':'+44','code':'GG'},'GN':{'name':'Guinea','dial_code':'+224','code':'GN'},'GW':{'name':'Guinea-Bissau','dial_code':'+245','code':'GW'},'GY':{'name':'Guyana','dial_code':'+592','code':'GY'},'HT':{'name':'Haiti','dial_code':'+509','code':'HT'},'HM':{'name':'Heard Island and Mcdonald Islands','dial_code':'+0','code':'HM'},'VA':{'name':'Holy See (Vatican City State)','dial_code':'+379','code':'VA'},'HN':{'name':'Honduras','dial_code':'+504','code':'HN'},'HK':{'name':'Hong Kong','dial_code':'+852','code':'HK'},'HU':{'name':'Hungary','dial_code':'+36','code':'HU'},'IS':{'name':'Iceland','dial_code':'+354','code':'IS'},'IN':{'name':'India','dial_code':'+91','code':'IN'},Assets.ID:{'name':'Indonesia','dial_code':'+62','code':Assets.ID},'IR':{'name':'Iran, Islamic Republic of Persian Gulf','dial_code':'+98','code':'IR'},'IQ':{'name':'Iraq','dial_code':'+964','code':'IQ'},'IE':{'name':'Ireland','dial_code':'+353','code':'IE'},'IM':{'name':'Isle of Man','dial_code':'+44','code':'IM'},'IL':{'name':'Israel','dial_code':'+972','code':'IL'},'IT':{'name':'Italy','dial_code':'+39','code':'IT'},'JM':{'name':'Jamaica','dial_code':'+1876','code':'JM'},'JP':{'name':'Japan','dial_code':'+81','code':'JP'},'JE':{'name':'Jersey','dial_code':'+44','code':'JE'},'JO':{'name':'Jordan','dial_code':'+962','code':'JO'},'KZ':{'name':'Kazakhstan','dial_code':'+7','code':'KZ'},'KE':{'name':'Kenya','dial_code':'+254','code':'KE'},'KI':{'name':'Kiribati','dial_code':'+686','code':'KI'},'KP':{'name':'Korea, Democratic People\'s Republic of Korea','dial_code':'+850','code':'KP'},'KR':{'name':'Korea, Republic of South Korea','dial_code':'+82','code':'KR'},'XK':{'name':'Kosovo','dial_code':'+383','code':'XK'},'KW':{'name':'Kuwait','dial_code':'+965','code':'KW'},'KG':{'name':'Kyrgyzstan','dial_code':'+996','code':'KG'},'LA':{'name':'Laos','dial_code':'+856','code':'LA'},'LV':{'name':'Latvia','dial_code':'+371','code':'LV'},'LB':{'name':'Lebanon','dial_code':'+961','code':'LB'},'LS':{'name':'Lesotho','dial_code':'+266','code':'LS'},'LR':{'name':'Liberia','dial_code':'+231','code':'LR'},'LY':{'name':'Libyan Arab Jamahiriya','dial_code':'+218','code':'LY'},'LI':{'name':'Liechtenstein','dial_code':'+423','code':'LI'},'LT':{'name':'Lithuania','dial_code':'+370','code':'LT'},'LU':{'name':'Luxembourg','dial_code':'+352','code':'LU'},'MO':{'name':'Macao','dial_code':'+853','code':'MO'},'MK':{'name':'Macedonia','dial_code':'+389','code':'MK'},'MG':{'name':'Madagascar','dial_code':'+261','code':'MG'},'MW':{'name':'Malawi','dial_code':'+265','code':'MW'},'MY':{'name':'Malaysia','dial_code':'+60','code':'MY'},'MV':{'name':'Maldives','dial_code':'+960','code':'MV'},'ML':{'name':'Mali','dial_code':'+223','code':'ML'},'MT':{'name':'Malta','dial_code':'+356','code':'MT'},'MH':{'name':'Marshall Islands','dial_code':'+692','code':'MH'},'MQ':{'name':'Martinique','dial_code':'+596','code':'MQ'},'MR':{'name':'Mauritania','dial_code':'+222','code':'MR'},'MU':{'name':'Mauritius','dial_code':'+230','code':'MU'},'YT':{'name':'Mayotte','dial_code':'+262','code':'YT'},'MX':{'name':'Mexico','dial_code':'+52','code':'MX'},'FM':{'name':'Micronesia, Federated States of Micronesia','dial_code':'+691','code':'FM'},'MD':{'name':'Moldova','dial_code':'+373','code':'MD'},'MC':{'name':'Monaco','dial_code':'+377','code':'MC'},'MN':{'name':'Mongolia','dial_code':'+976','code':'MN'},'ME':{'name':'Montenegro','dial_code':'+382','code':'ME'},'MS':{'name':'Montserrat','dial_code':'+1664','code':'MS'},'MA':{'name':'Morocco','dial_code':'+212','code':'MA'},'MZ':{'name':'Mozambique','dial_code':'+258','code':'MZ'},'MM':{'name':'Myanmar','dial_code':'+95','code':'MM'},'NA':{'name':'Namibia','dial_code':'+264','code':'NA'},'NR':{'name':'Nauru','dial_code':'+674','code':'NR'},'NP':{'name':'Nepal','dial_code':'+977','code':'NP'},'NL':{'name':'Netherlands','dial_code':'+31','code':'NL'},'AN':{'name':'Netherlands Antilles','dial_code':'+599','code':'AN'},'NC':{'name':'New Caledonia','dial_code':'+687','code':'NC'},'NZ':{'name':'New Zealand','dial_code':'+64','code':'NZ'},'NI':{'name':'Nicaragua','dial_code':'+505','code':'NI'},'NE':{'name':'Niger','dial_code':'+227','code':'NE'},'NG':{'name':'Nigeria','dial_code':'+234','code':'NG'},'NU':{'name':'Niue','dial_code':'+683','code':'NU'},'NF':{'name':'Norfolk Island','dial_code':'+672','code':'NF'},'MP':{'name':'Northern Mariana Islands','dial_code':'+1670','code':'MP'},'NO':{'name':'Norway','dial_code':'+47','code':'NO'},'OM':{'name':'Oman','dial_code':'+968','code':'OM'},'PK':{'name':'Pakistan','dial_code':'+92','code':'PK'},'PW':{'name':'Palau','dial_code':'+680','code':'PW'},'PS':{'name':'Palestinian Territory, Occupied','dial_code':'+970','code':'PS'},'PA':{'name':'Panama','dial_code':'+507','code':'PA'},'PG':{'name':'Papua New Guinea','dial_code':'+675','code':'PG'},'PY':{'name':'Paraguay','dial_code':'+595','code':'PY'},'PE':{'name':'Peru','dial_code':'+51','code':'PE'},'PH':{'name':'Philippines','dial_code':'+63','code':'PH'},'PN':{'name':'Pitcairn','dial_code':'+64','code':'PN'},'PL':{'name':'Poland','dial_code':'+48','code':'PL'},'PT':{'name':'Portugal','dial_code':'+351','code':'PT'},'PR':{'name':'Puerto Rico','dial_code':'+1939','code':'PR'},'QA':{'name':'Qatar','dial_code':'+974','code':'QA'},'RO':{'name':'Romania','dial_code':'+40','code':'RO'},'RU':{'name':'Russia','dial_code':'+7','code':'RU'},'RW':{'name':'Rwanda','dial_code':'+250','code':'RW'},'RE':{'name':'Reunion','dial_code':'+262','code':'RE'},'BL':{'name':'Saint Barthelemy','dial_code':'+590','code':'BL'},'SH':{'name':'Saint Helena, Ascension and Tristan Da Cunha','dial_code':'+290','code':'SH'},'KN':{'name':'Saint Kitts and Nevis','dial_code':'+1869','code':'KN'},'LC':{'name':'Saint Lucia','dial_code':'+1758','code':'LC'},'MF':{'name':'Saint Martin','dial_code':'+590','code':'MF'},'PM':{'name':'Saint Pierre and Miquelon','dial_code':'+508','code':'PM'},'VC':{'name':'Saint Vincent and the Grenadines','dial_code':'+1784','code':'VC'},'WS':{'name':'Samoa','dial_code':'+685','code':'WS'},'SM':{'name':'San Marino','dial_code':'+378','code':'SM'},'ST':{'name':'Sao Tome and Principe','dial_code':'+239','code':'ST'},'SA':{'name':'Saudi Arabia','dial_code':'+966','code':'SA'},'SN':{'name':'Senegal','dial_code':'+221','code':'SN'},'RS':{'name':'Serbia','dial_code':'+381','code':'RS'},'SC':{'name':'Seychelles','dial_code':'+248','code':'SC'},'SL':{'name':'Sierra Leone','dial_code':'+232','code':'SL'},'SG':{'name':'Singapore','dial_code':'+65','code':'SG'},'SK':{'name':'Slovakia','dial_code':'+421','code':'SK'},'SI':{'name':'Slovenia','dial_code':'+386','code':'SI'},'SB':{'name':'Solomon Islands','dial_code':'+677','code':'SB'},'SO':{'name':'Somalia','dial_code':'+252','code':'SO'},'ZA':{'name':'South Africa','dial_code':'+27','code':'ZA'},'SS':{'name':'South Sudan','dial_code':'+211','code':'SS'},'GS':{'name':'South Georgia and the South Sandwich Islands','dial_code':'+500','code':'GS'},'ES':{'name':'Spain','dial_code':'+34','code':'ES'},'LK':{'name':'Sri Lanka','dial_code':'+94','code':'LK'},'SD':{'name':'Sudan','dial_code':'+249','code':'SD'},'SR':{'name':'Suriname','dial_code':'+597','code':'SR'},'SJ':{'name':'Svalbard and Jan Mayen','dial_code':'+47','code':'SJ'},'SZ':{'name':'Swaziland','dial_code':'+268','code':'SZ'},'SE':{'name':'Sweden','dial_code':'+46','code':'SE'},'CH':{'name':'Switzerland','dial_code':'+41','code':'CH'},'SY':{'name':'Syrian Arab Republic','dial_code':'+963','code':'SY'},'TW':{'name':'Taiwan','dial_code':'+886','code':'TW'},'TJ':{'name':'Tajikistan','dial_code':'+992','code':'TJ'},'TZ':{'name':'Tanzania, United Republic of Tanzania','dial_code':'+255','code':'TZ'},'TH':{'name':'Thailand','dial_code':'+66','code':'TH'},'TL':{'name':'Timor-Leste','dial_code':'+670','code':'TL'},'TG':{'name':'Togo','dial_code':'+228','code':'TG'},'TK':{'name':'Tokelau','dial_code':'+690','code':'TK'},'TO':{'name':'Tonga','dial_code':'+676','code':'TO'},'TT':{'name':'Trinidad and Tobago','dial_code':'+1868','code':'TT'},'TN':{'name':'Tunisia','dial_code':'+216','code':'TN'},'TR':{'name':'Turkey','dial_code':'+90','code':'TR'},'TM':{'name':'Turkmenistan','dial_code':'+993','code':'TM'},'TC':{'name':'Turks and Caicos Islands','dial_code':'+1649','code':'TC'},'TV':{'name':'Tuvalu','dial_code':'+688','code':'TV'},'UG':{'name':'Uganda','dial_code':'+256','code':'UG'},'UA':{'name':'Ukraine','dial_code':'+380','code':'UA'},'AE':{'name':'United Arab Emirates','dial_code':'+971','code':'AE'},'GB':{'name':'United Kingdom','dial_code':'+44','code':'GB'},'US':{'name':'United States','dial_code':'+1','code':'US'},'UY':{'name':'Uruguay','dial_code':'+598','code':'UY'},'UZ':{'name':'Uzbekistan','dial_code':'+998','code':'UZ'},'VU':{'name':'Vanuatu','dial_code':'+678','code':'VU'},'VE':{'name':'Venezuela, Bolivarian Republic of Venezuela','dial_code':'+58','code':'VE'},'VN':{'name':'Vietnam','dial_code':'+84','code':'VN'},'VG':{'name':'Virgin Islands, British','dial_code':'+1284','code':'VG'},'VI':{'name':'Virgin Islands, U.S.','dial_code':'+1340','code':'VI'},'WF':{'name':'Wallis and Futuna','dial_code':'+681','code':'WF'},'YE':{'name':'Yemen','dial_code':'+967','code':'YE'},'ZM':{'name':'Zambia','dial_code':'+260','code':'ZM'},'ZW':{'name':'Zimbabwe','dial_code':'+263','code':'ZW'}}

/*
function fillPostcodes(id: number) {
    if (id === 1) {
        Socket1.socket.Send(Config.amBasicInsert, {table: Config.amPostalCodes, data: swissPostal[id]}, fillPostcodes(++id))
    } else if (id < swissPostal.length) {
        // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert))
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amPostalCodes) {
            // console.log(id)
            Socket1.socket.Send(Config.amBasicInsert, {table: Config.amPostalCodes, data: swissPostal[id]}, fillPostcodes(++id))
        }
    } else console.log ('Finished')

}
*/
/*
export function wsInsertSpecial() {

    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amNationalities) {
            Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading = 'init'
            Logic.Type.New (Main.Instance.DatabaseDataState, {id: Main.Instance.DatabaseDataState.id + 1})
            if (Main.Instance.DatabaseDataState.id < nationalities.length)
            Socket1.socket.Send(Config.amBasicInsert, {table: Config.amNationalities, data: nationalities[Main.Instance.DatabaseDataState.id]})
        }
    }

}

/*
export function wsInsertSpecial() {
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert) && Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).table === Config.amLanguages) {
            Socket1.socket.Get<RouteClasses.Route>(Config.amBasicInsert).loading = 'init'
            Logic.Type.New (Main.Instance.DatabaseDataState, {id: Main.Instance.DatabaseDataState.id + 1})
            if (Main.Instance.DatabaseDataState.id < Main.Instance.DatabaseDataState.currencies.length)
            Socket1.socket.Send(Config.amBasicInsert, {table: Config.amLanguages, data: Main.Instance.DatabaseDataState.currencies[Main.Instance.DatabaseDataState.id]})
        }
    }
}
*/

export function getGameProviders() {
    Logic.Type.New(Main.Instance.DatabaseDataState, { GameProviderGetNew: true })
    Socket1.socket.Send(Config.gGetGameProviders, {})
    getLoadedResources('Socket1 - Send', Config.gGetGameProviders)
}

/*
export async function exportAllGamesCMS() {
    // get provider from gameId
    try {
        const request = await axios.get(Config.strapiCasinoGames + '?_limit=1000000')
        const games: any[] = request.data
        const newGames: Casinogame[] = []
        if (Main.Instance.DatabaseDataState.gameProviderNew && Main.Instance.DatabaseDataState.gamesCentralFiltered) { // gamesCentralNew
            for (const adminGame of Main.Instance.DatabaseDataState.gamesCentralFiltered) {
                let provider: string = ''
                for (const item of Main.Instance.DatabaseDataState.gameProviderNew) {
                    if (item.providerId === parseInt(adminGame.providerId)) {
                        provider = item.name
                        break
                    }
                }
                const cmsGame = games.find((g) => g.gameId === adminGame.gameId)
                if (cmsGame && (cmsGame.name !== adminGame.name || cmsGame.provider !== provider)) {
                    const updatedGame: Casinogame = {
                        name: adminGame.name,
                        gameId: cmsGame.gameId,
                        provider
                    }
                    await axios.put(`${Config.strapiCasinoGames}/${cmsGame.id}`, updatedGame)
                }
                if (!cmsGame) {
                    const newGame: Casinogame = {
                        name: adminGame.name,
                        gameId: adminGame.gameId,
                        provider
                    }
                    await axios.post(Config.strapiCasinoGames, newGame)
                    newGames.push({gameId: adminGame.gameId, name: adminGame.name, provider})
                }
            }
        }
        // here we need to update the games statuses
        const casinoGames: Casinogame[] = Object.assign([], Main.Instance.DatabaseDataState.casinoGames)
        casinoGames.push(...newGames)
        InitializeGamesCentralFiltered(Main.Instance.DatabaseDataState.gamesCentralNew, casinoGames)
        alert(Assets.GamesWereSuccessfullyExportedToCMS)
    } catch (e) { alert(Assets.GamesFailedToExportToCMS) }
}
*/

export async function exportAllGamesListCMS() {
    // get provider from gameId
    try {
        const request = await axios.get(Config.strapiCasinoGames + '?_limit=1000000')
        const games: any[] = request.data
        const newGames: Casinogame[] = []
        if (Main.Instance.DatabaseDataState.gameProviderNew && Main.Instance.DatabaseDataState.gamesListExport) { // gamesCentralNew
            for (const adminGame of Main.Instance.DatabaseDataState.gamesListExport) {
                let provider: string = ''
                for (const item of Main.Instance.DatabaseDataState.gameProviderNew) {
                    if (item.providerId === adminGame.providerId) {
                        provider = item.name
                        break
                    }
                }
                const cmsGame = games.find((g) => g.gameId === adminGame.gameId)
                if (cmsGame && (cmsGame.name !== adminGame.gameName || cmsGame.provider !== provider)) {
                    const updatedGame: Casinogame = {
                        name: adminGame.gameName,
                        gameId: cmsGame.gameId,
                        provider
                    }
                    await axios.put(`${Config.strapiCasinoGames}/${cmsGame.id}`, updatedGame)
                }
                if (!cmsGame) {
                    const newGame: Casinogame = {
                        name: adminGame.gameName,
                        gameId: adminGame.gameId,
                        provider
                    }
                    await axios.post(Config.strapiCasinoGames, newGame)
                    newGames.push({gameId: adminGame.gameId, name: adminGame.gameName, provider})
                }
            }
        }
        // here we need to update the games statuses
        const casinoGames: Casinogame[] = Object.assign([], Main.Instance.DatabaseDataState.casinoGames)
        casinoGames.push(...newGames)
        setGames(Main.Instance.DatabaseDataState.gamesList, casinoGames)
        alert(Assets.GamesWereSuccessfullyExportedToCMS)
    } catch (e) { alert(Assets.GamesFailedToExportToCMS) }
}

/*
export async function exportGameCMS(game: GamesCentralNew) {
    try {
        if (game) {
            const casinoGames: Casinogame[] = Object.assign([], Main.Instance.DatabaseDataState.casinoGames)
            const adminGame = { name: game.name, gameId: game.gameId, provider: '' }
            const request = await axios.get(Config.strapiCasinoGames + '?_limit=1000000')
            const games: any[] = request.data
            const cmsGame = games.find((g) => g.gameId === adminGame.gameId)

            let provider: string = ''
            for (const item of Main.Instance.DatabaseDataState.gameProviderNew) {
                if (item.providerId === parseInt(game.providerId)) {
                    provider = item.name
                    break
                }
            }
            if (cmsGame && cmsGame.name !== adminGame.name) {
                const updatedGame: Casinogame = {
                    name: adminGame.name,
                    gameId: cmsGame.gameId,
                    provider
                }
                await axios.put(`${Config.strapiCasinoGames}/${cmsGame.id}`, updatedGame)
            }
            if (!cmsGame) {
                const newGame: Casinogame = {
                    name: adminGame.name,
                    gameId: adminGame.gameId,
                    provider
                }
                // console.log (newGame)
                await axios.post(Config.strapiCasinoGames, newGame)
                casinoGames.push({gameId: adminGame.gameId, name: adminGame.name, provider})
            }
            InitializeGamesCentralFiltered(Main.Instance.DatabaseDataState.gamesCentralNew, casinoGames)
            alert(Assets.GameWasSuccessfullyExportedToCMS)
        }
        // here we need to update the games statuses


    } catch (e) {
        // console.log (e)
        alert(Assets.GameFailedToExportToCMS)
    }
}
*/

export async function exportGameListCMS(game: GamesList) {
    try {
        if (game) {
            const casinoGames: Casinogame[] = Object.assign([], Main.Instance.DatabaseDataState.casinoGames)
            const adminGame = { name: game.gameName, gameId: game.gameId, provider: '' }
            const request = await axios.get(Config.strapiCasinoGames + '?_limit=1000000')
            const games: any[] = request.data
            const cmsGame = games.find((g) => g.gameId === adminGame.gameId)

            let provider: string = ''
            for (const item of Main.Instance.DatabaseDataState.gameProviderNew) {
                if (item.providerId === game.providerId) {
                    provider = item.name
                    break
                }
            }
            if (cmsGame && cmsGame.name !== adminGame.name) {
                const updatedGame: Casinogame = {
                    name: adminGame.name,
                    gameId: cmsGame.gameId,
                    provider
                }
                await axios.put(`${Config.strapiCasinoGames}/${cmsGame.id}`, updatedGame)
            }
            if (!cmsGame) {
                const newGame: Casinogame = {
                    name: adminGame.name,
                    gameId: adminGame.gameId,
                    provider
                }
                // console.log (newGame)
                await axios.post(Config.strapiCasinoGames, newGame)
                casinoGames.push({gameId: adminGame.gameId, name: adminGame.name, provider})
            }
            setGames(Main.Instance.DatabaseDataState.gamesList, casinoGames)
            alert(Assets.GameWasSuccessfullyExportedToCMS)
        }
        // here we need to update the games statuses


    } catch (e) {
        // console.log (e)
        alert(Assets.GameFailedToExportToCMS)
    }
}

export async function updateGameTags(newTags: string[]) {
    const tagsRequest = await axios.get(Config.strapiGameTags + '?_limit=1000000');
    const currentTags: Array<{ id: number, name: string }> = tagsRequest.data; // Tag

    for (const tag of currentTags) {
        const tagFound = newTags.find((t) => t === tag.name);
        if (!tagFound) {
            await axios.delete(`${Config.strapiGameTags}/${+tag.id}`);
        }
    }

    for (const tag of newTags) {
        const tagFound = currentTags.find((t) => t.name === tag);
        if (!tagFound) {
            await axios.post(Config.strapiGameTags, {
                name: tag,
            });
        }
    }
}

export async function updateGameCategories(newCategories: string[]) {
    const categoriesRequest = await axios.get(Config.strapiGameCategories + '?_limit=1000000');
    const currentCategories: Array<{ id: number, name: string }> = categoriesRequest.data;

    for (const category of currentCategories) {
        const tagFound = newCategories.find((t) => t === category.name);
        if (!tagFound) {
            await axios.delete(`${Config.strapiGameCategories}/${+category.id}`);
        }
    }

    for (const category of newCategories) {
        const categoryFound = currentCategories.find((t) => t.name === category);
        if (!categoryFound) {
            await axios.post(Config.strapiGameCategories, {
                name: category,
            });
        }
    }
}

export async function wsJackpotsReinitializeGames(force?: boolean) {
    if (Socket1 === undefined || Socket1.socket === undefined) {
        setTimeout(() => wsJackpotsReinitializeGames(force), 100)
    } else {
        WsJackpotsReinitializeGames(force)
    }
}

export async function wsReinitializeGames(force?: boolean) {
    // console.log('init')
    if (Socket1 === undefined || Socket1.socket === undefined) {
        // console.log ('socket is not initialized')
        setTimeout(() => wsReinitializeGames(force), 100)
    } else {
        WsReinitializeGames(force)
    }
}

export async function WsReinitializeGames(force?: boolean) {

    Logic.Type.New(Main.Instance.DatabaseDataState, { GameProviderGetNew: true, /*GamesGet: true, GamesCentralGetNew: true,*/gamesListGet: true, /*RgsGameSupplierGetNew: true,*/ loadingGames: true, loadingGames2: true /*, loadingGames3: true, loadingGames4: true*/, devicesGet: true })
    // Socket1.socket.Send(Config.gGetGames, {})
    Socket1.socket.Send(Config.gGetGameProviders, {})
    // Socket1.socket.Send(Config.gGetGameSuppliers, {})
    // Socket1.socket.Send(Config.gGetLabels, {})
    // Socket1.socket.Send(Config.gGetCategories, {})
    // Socket1.socket.Send(Config.gGetJurisdictions, {})

    // getLoadedResources('Socket1 - Send', Config.gGetGames)
    getLoadedResources('Socket1 - Send', Config.gGetGameProviders)
    // getLoadedResources('Socket1 - Send', Config.gGetGameSuppliers)

    Socket1.socket.Send(Config.gGetGameList, {})
    Socket1.socket.Send(Config.gGetGameLabels, {})
    Socket1.socket.Send(Config.gGetGameCategories, {})
    // Socket1.socket.Send(Config.gGetJurisdictionsList, {})
    Socket1.socket.Send(Config.gGetDevices, {})
    getLoadedResources('Socket1 - Send', Config.gGetGameList)
    getLoadedResources('Socket1 - Send', Config.gGetGameLabels)
    getLoadedResources('Socket1 - Send', Config.gGetGameCategories)
    // getLoadedResources('Socket1 - Send', Config.gGetJurisdictionsList)
    getLoadedResources('Socket1 - Send', Config.gGetDevices)

    // wsBasicGet(Config.amGames)
}

export async function WsJackpotsReinitializeGames(force?: boolean) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { GameProviderGetNew: true, GamesGet: true, /*GamesCentralGetNew: true,*/gamesListGet: true,  /*RgsGameSupplierGetNew: true,*/ loadingGames: true, loadingGames2: true, /*loadingGames3: true, loadingGames4: true,*/ strapiConnected: false })
/*
    const gamesRequest = await axios.get(Config.strapiCasinoGames + '?_limit=1000000')
    // console.log (gamesRequest)
    const casinoGames: Casinogame[] = gamesRequest.data// .slice (0, gamesRequest.data.length - 1)
    const tagsRequest = await axios.get(Config.strapiGameTags + '?_limit=1000000')
    const tags: Tag[] = tagsRequest.data
    const toggleTags: boolean[] = []
    for (const { } of tagsRequest.data) { toggleTags.push(false) }
    const categoriesRequest = await axios.get(Config.strapiGameCategories + '?_limit=1000000')
    const scategories: SCategory[] = categoriesRequest.data.sort(categoryIdSort)
    Logic.Type.New(Main.Instance.DatabaseDataState, { casinoGames, tags, scategories, toggleTags })
*/
    // Socket1.socket.Send(Config.gGetGames, {})
    Socket1.socket.Send(Config.gGetGameProviders, {})
    // Socket1.socket.Send(Config.gGetGameSuppliers, {})
    // Socket1.socket.Send(Config.gGetLabels, {})
    // Socket1.socket.Send(Config.gGetCategories, {})
    // Socket1.socket.Send(Config.gGetJurisdictions, {})

    // getLoadedResources('Socket1 - Send', Config.gGetGames)
    getLoadedResources('Socket1 - Send', Config.gGetGameProviders)
    // getLoadedResources('Socket1 - Send', Config.gGetGameSuppliers)
    // wsBasicGet(Config.amGames)


    // NEW
    Socket1.socket.Send(Config.gGetGameList, {})
    getLoadedResources('Socket1 - Send', Config.gGetGameList)
    Socket1.socket.Send(Config.gGetGameLabels, {})
    getLoadedResources('Socket1 - Send', Config.gGetGameLabels)
    Socket1.socket.Send(Config.gGetGameCategories, {})
    getLoadedResources('Socket1 - Send', Config.gGetGameCategories)
    // Socket1.socket.Send(Config.gGetJurisdictionsList, {})
    // getLoadedResources('Socket1 - Send', Config.gGetJurisdictionsList)
    Socket1.socket.Send(Config.gGetDevices, {})
    getLoadedResources('Socket1 - Send', Config.gGetDevices)

    // console.log (Config.strapiCasinoGames)
    let strapiConnected: boolean = false
    const gamesRequest = await axios.get(Config.strapiCasinoGames + '?_limit=1000000')
    // console.log (gamesRequest)
    const tagsRequest = await axios.get(Config.strapiGameTags + '?_limit=1000000')
    // console.log (tagsRequest)
    const categoriesRequest = await axios.get(Config.strapiGameCategories + '?_limit=1000000')
    // console.log (categoriesRequest)

    if (gamesRequest && tagsRequest && categoriesRequest) {
        strapiConnected = true
    } 
    const toggleTags: boolean[] = []
    for (const { } of tagsRequest.data) { toggleTags.push(false) }
    

    Logic.Type.New(Main.Instance.DatabaseDataState, {
        casinoGames: gamesRequest.data,
        tags: tagsRequest.data,
        scategories: categoriesRequest.data.sort(categoryIdSort),
        toggleTags, 
        strapiConnected
    })

/*
    if (Config.environment === Config.Environment.PRODUCTION) {
        console.log (2)
*/
}

export async function wsReinitialize(force?: boolean) {

    if (
        (IsBuildJackpotsCH()) && (!Socket1 || !Socket1.socket /* || !Socket2 || !Socket2.socket */)
        || IsBuildPasino() && (!Socket1 || !Socket1.socket /* || !Socket2 || !Socket2.socket */)
        || IsBuildDefault() && (!Socket1 || !Socket1.socket)
        || IsBuildMyChance() && (!Socket1 || !Socket1.socket || !Socket2 || !Socket2.socket || !Main.Instance.FrontendStoreState.strapiPass)
        || IsBuildOdds()
    ) {

        setTimeout(() => wsReinitialize(force), 100)
        
    } else {
        WsReinitialize(force)
    }
}

export async function WsReinitialize(force?: boolean) {
    const minLengthToSearch =  Cookies.get('minLengthToSearch')
    const searchOnlyAtTheStartOfPhrase = Cookies.get('searchOnlyAtTheStartOfPhrase')
    const playerCardUsername = Cookies.get('playerCardUsername')
    const playerCardFirst = Cookies.get('playerCardFirst')
    const playerCardLast = Cookies.get('playerCardLast')
    const playerCardPlayerId = Cookies.get('playerCardPlayerId')
    const playerCardEmail = Cookies.get('playerCardEmail')
    const selectedEnvironment = Cookies.get('selectedEnvironment')
    const gameStoreGameId = Cookies.get('gameStoreGameId')
    const gameStoreGameName = Cookies.get('gameStoreGameName')

    if (minLengthToSearch || searchOnlyAtTheStartOfPhrase || playerCardUsername || playerCardFirst || playerCardLast || playerCardPlayerId || playerCardEmail || gameStoreGameId || gameStoreGameName) {
        if (minLengthToSearch && +minLengthToSearch !== Main.Instance.SearchState.minLengthToSearch
            || searchOnlyAtTheStartOfPhrase && searchOnlyAtTheStartOfPhrase === 'true' !== Main.Instance.SearchState.searchOnlyAtTheStartOfPhrase
            || playerCardUsername && playerCardUsername === 'true' !== Main.Instance.SearchState.playerCardUsername
            || playerCardFirst && playerCardFirst === 'true' !== Main.Instance.SearchState.playerCardFirst
            || playerCardLast && playerCardLast === 'true' !== Main.Instance.SearchState.playerCardLast
            || playerCardPlayerId && playerCardPlayerId === 'true' !== Main.Instance.SearchState.playerCardPlayerId
            || playerCardEmail && playerCardEmail === 'true' !== Main.Instance.SearchState.playerCardEmail
            || gameStoreGameId && gameStoreGameId === 'true' !== Main.Instance.SearchState.gameStoreGameId
            || gameStoreGameName && gameStoreGameName === 'true' !== Main.Instance.SearchState.gameStoreGameName
        ) {
            Logic.Type.New(Main.Instance.SearchState, {
                minLengthToSearch: minLengthToSearch ? +minLengthToSearch : Main.Instance.SearchState.minLengthToSearch,
                searchOnlyAtTheStartOfPhrase: searchOnlyAtTheStartOfPhrase ? searchOnlyAtTheStartOfPhrase === 'true' : Main.Instance.SearchState.searchOnlyAtTheStartOfPhrase,
                playerCardUsername: playerCardUsername ? playerCardUsername === 'true' : Main.Instance.SearchState.playerCardUsername,
                playerCardFirst: playerCardFirst ? playerCardFirst === 'true' : Main.Instance.SearchState.playerCardFirst,
                playerCardLast: playerCardLast ? playerCardLast === 'true' : Main.Instance.SearchState.playerCardLast,
                playerCardPlayerId: playerCardPlayerId ? playerCardPlayerId === 'true' : Main.Instance.SearchState.playerCardPlayerId,
                playerCardEmail: playerCardEmail ? playerCardEmail === 'true' : Main.Instance.SearchState.playerCardEmail,
                gameStoreGameId: gameStoreGameId ? gameStoreGameId === 'true' : Main.Instance.SearchState.gameStoreGameId,
                gameStoreGameName: gameStoreGameName ? gameStoreGameName === 'true' : Main.Instance.SearchState.gameStoreGameName
            })
        }
    }
    if (force && Main.Instance.PlayerCardState.id !== '0' && Main.Instance.DatabaseDataState.playerCard && Main.Instance.DatabaseDataState.playerCard.playerId) {
        wsGetPlayerCard(Main.Instance.PlayerCardState.id, true)
    } else if (Main.Instance.Location === '/account-store/player-card' && Main.Instance.DatabaseDataState.loadedPlayerCard === false && Socket1 && JSON.stringify(Socket1) !== '{}' && parseInt(selectedEnvironment) === Config.environment as number) {

        const PlayerId = Cookies.get('playerId')
        getLoadedResources('Cookie - Get', 'playerId')
        if (PlayerId !== null) {
            Logic.Type.New(Main.Instance.PlayerCardState, { id: PlayerId })
            wsGetPlayerCard(PlayerId, true)
        }
    } else if (Main.Instance.Location !== '/account-store/player-card' && Main.Instance.DatabaseDataState.loadedPlayerCard === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { loadedPlayerCard: true })
    }

    if (force || Main.Instance.LogState.distinctUserId === undefined) {
        Logic.Type.New(Main.Instance.LogState, { distinctUserId: [], distinctUserIdSorted: [] })
        getAdminLog(true)
        if (IsBuildJackpotsCH() || IsBuildPasino()) {
            if (force) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    RefreshButtonEnabled: false,
                    CustomGet: true,
                    PlayerCardsGet: true,
                    LoggedPlayersGet: true,
                    UnverifiedAccountsAllGet: true,
                    ExpiredAccountsGet: true,
                })
            }
            // absolutely need to have
            Socket1.socket.Send(Config.amGetExpiredAccounts, {page: 1, limit: dashboardSmallTableRows})
            Socket1.socket.Send(Config.amGetLoggedInPlayers, {paginationParams: {page: 1, size: 7}})
            Socket1.socket.Send(Config.amGetExpiringAccounts, {page: 1, limit: dashboardSmallTableRows})
            wsBasicGet(Config.amSettings)
            /* TEMPORARY */
            Socket1.socket.Send(Config.amGetIssuesCount, { filters: {} })
            
            // plan to remove
            Socket1.socket.Send(Config.amGetPlayerCards, {})

            getLoadedResources('Socket1 - Send', Config.amGetExpiredAccounts)
            getLoadedResources('Socket1 - Send', Config.amGetLoggedInPlayers)
            getLoadedResources('Socket1 - Send', Config.amGetExpiringAccounts)
            getLoadedResources('Socket1 - Send', Config.amGetIssuesCount)
            getLoadedResources('Socket1 - Send', Config.amGetPlayerCards)

            const showCommentsRM: boolean[] = []
            const showCommentsRG: boolean[] = []
            for (const { } of Assets_.ResponsibleGamingGroups) { showCommentsRG.push(false) }
            for (const { } of Assets_.RiskManagementGroups) { showCommentsRM.push(false) }
            Logic.Type.New(Main.Instance.RiskManagementState, { showCommentsRG, showCommentsRM })

            
        } else if (IsBuildDefault()) {
            wsBasicGet(Config.amSettings)
            // Socket1.socket.Send(Config.gGetGames, {})
            Socket1.socket.Send(Config.gGetGameProviders, {})
            // Socket1.socket.Send(Config.gGetGameSuppliers, {})
            // Socket1.socket.Send(Config.gGetLabels, {})
            // Socket1.socket.Send(Config.gGetCategories, {})
            // Socket1.socket.Send(Config.gGetJurisdictions, {})

            // getLoadedResources('Socket1 - Send', Config.gGetGames)
            getLoadedResources('Socket1 - Send', Config.gGetGameProviders)
            // getLoadedResources('Socket1 - Send', Config.gGetGameSuppliers)
            // getLoadedResources('Socket1 - Send', Config.gGetLabels)
            // getLoadedResources('Socket1 - Send', Config.gGetCategories)
            // getLoadedResources('Socket1 - Send', Config.gGetJurisdictions)

            Socket1.socket.Send(Config.gGetGameList, {})
            getLoadedResources('Socket1 - Send', Config.gGetGameList)
            Socket1.socket.Send(Config.gGetGameLabels, {})
            getLoadedResources('Socket1 - Send', Config.gGetGameLabels)
            Socket1.socket.Send(Config.gGetGameCategories, {})
            getLoadedResources('Socket1 - Send', Config.gGetGameCategories)
            // Socket1.socket.Send(Config.gGetJurisdictionsList, {})
            // getLoadedResources('Socket1 - Send', Config.gGetJurisdictionsList)

        } else if (IsBuildMyChance()) {
            // const isStrapiDataSet: boolean = await setStrapiData()
            Logic.Type.New(Main.Instance.DatabaseDataState, {strapiConnected: false})
            if (Main.Instance.DatabaseDataState.strapiAuth === undefined && Main.Instance.FrontendStoreState.strapiPass) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { strapiAuth: ''})
                axios.post(Config.strapiMyChanceAuth, { identifier: 'frontend', password: Main.Instance.FrontendStoreState.strapiPass})
                .then((response) => {
                    // console.log(response)
                    axios.get(Config.strapiMyChanceShopItems + '?_limit=10000&_sort=id:ASC&status_in=active&status_in=preview', {
                        headers: {
                            Authorization: 'Bearer ' + response.data.jwt
                        }
                    })
                        .then((response2) => {
                            // console.log(response2)
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                strapiAuth: response.data.jwt,
                                rewardsCMS: response2.data,
                                strapiConnected: true
                            })
                            Socket1.socket.Send(Config.amGetRewardsAll, {})
                            getLoadedResources('Socket1 - Send', Config.amGetRewardsAll)
                        })
                        .catch((e) => {Socket1.socket.Send(Config.amGetRewardsAll, {})})
                })
                .catch((e) => {Socket1.socket.Send(Config.amGetRewardsAll, {})})
            } else if (Main.Instance.DatabaseDataState.strapiAuth !== '' && Main.Instance.FrontendStoreState.strapiPass) {
                axios.get(Config.strapiMyChanceShopItems + '?_limit=10000&_sort=id:ASC&status_in=active&status_in=preview', {
                    headers: {
                        Authorization: 'Bearer ' + Main.Instance.DatabaseDataState.strapiAuth
                    }
                })
                .then((response2) => {
                    
                    Logic.Type.New(Main.Instance.DatabaseDataState, {
                        rewardsCMS: response2.data,
                        strapiConnected: true
                    })
                    Socket1.socket.Send(Config.amGetRewardsAll, {})
                    getLoadedResources('Socket1 - Send', Config.amGetRewardsAll)
                })
                .catch((e) => {Socket1.socket.Send(Config.amGetRewardsAll, {})})
            }
            Socket1.socket.Send(Config.amGetUsersInfoFiltered, {filters: {}})
            Socket1.socket.Send(Config.amGetTournamentsAll, {})
            Socket1.socket.Send(Config.amGetStoresAll, {})
            Socket1.socket.Send(Config.amGetRewards, {
                intent: -1,
                limit: 1000,
                offset: 0,
                type: 0
            })
            Socket1.socket.Send(Config.amGetLevelsAll, {})
            Socket1.socket.Send(Config.amGetMissionsAll, {})
            Socket1.socket.Send(Config.amGetTournaments, {})
            Socket2.socket.Send(Config.amMyChanceGames, {})
            // Socket1.socket.Send(Config.amGetMissionLeaderboard, {})
            // const dateFrom: Date = new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1 < 10 ? '0' : '') + (new Date().getMonth() + 1) + '-' + '01T00:00:00Z')
            // const dateTo: Date = new Date()
            // getChancesLeaderboard(dateFrom, dateTo)
            Socket1.socket.Send(Config.amCashbackMondayOptionsGet, {})

            getLoadedResources('Socket2 - Send', Config.amMyChanceGames)
            getLoadedResources('Socket1 - Send', Config.amGetTournamentsAll)
            getLoadedResources('Socket1 - Send', Config.amGetStoresAll)
            getLoadedResources('Socket1 - Send', Config.amGetRewards)
            getLoadedResources('Socket1 - Send', Config.amGetLevelsAll)
            getLoadedResources('Socket1 - Send', Config.amGetMissionsAll)
            getLoadedResources('Socket1 - Send', Config.amGetTournaments)
            // getLoadedResources('Socket1 - Send', Config.amGetMissionLeaderboard)
            getLoadedResources('Socket1 - Send', Config.amCashbackMondayOptionsGet)
            getLoadedResources('Socket1 - Send', Config.amGetUsersInfoFiltered)
            getLoadedResources('Socket1 - Send', Config.amGetRewardsAll)
            
            
        }
    }
}

// function setStrapiData() {
//     if (Main.Instance.DatabaseDataState.strapiAuth === undefined && Main.Instance.FrontendStoreState.strapiPass) {
//         Logic.Type.New(Main.Instance.DatabaseDataState, { strapiAuth: '', strapiConnected: false})
//         axios.post(Config.strapiMyChanceAuth, { identifier: 'frontend', password: Main.Instance.FrontendStoreState.strapiPass})
//             .then((response) => {
//                 // console.log(response)
//                 axios.get(Config.strapiMyChanceShopItems + '?_limit=10000&_sort=id:ASC&status_in=active&status_in=preview', {
//                     headers: {
//                         Authorization: 'Bearer ' + response.data.jwt
//                     }
//                 })
//                     .then((response2) => {
//                         // console.log(response2)
//                         Logic.Type.New(Main.Instance.DatabaseDataState, {
//                             strapiAuth: response.data.jwt,
//                             rewardsCMS: response2.data,
//                             strapiConnected: true
//                         })
//                         Socket1.socket.Send(Config.amGetRewardsAll, {})
//                         getLoadedResources('Socket1 - Send', Config.amGetRewardsAll)
//                         return true
//                     })
//             })
//     } else if (Main.Instance.DatabaseDataState.strapiAuth !== '' && Main.Instance.FrontendStoreState.strapiPass) {
//         axios.get(Config.strapiMyChanceShopItems + '?_limit=10000&_sort=id:ASC&status_in=active&status_in=preview', {
//             headers: {
//                 Authorization: 'Bearer ' + Main.Instance.DatabaseDataState.strapiAuth
//             }
//         })
//         .then((response2) => {
            
//             Logic.Type.New(Main.Instance.DatabaseDataState, {
//                 rewardsCMS: response2.data,
//                 // strapiConnected: true
//             })
//             Socket1.socket.Send(Config.amGetRewardsAll, {})
//             getLoadedResources('Socket1 - Send', Config.amGetRewardsAll)
//             return true
//         })
//     }
//     return false
// }
/*
export function strapiMyChanceCasinoGames(response3: any[], response2: any[], jwt?: string) {
    const GamesStreamAllSorted = response3.sort(byNAME)
    const GamesStreamAllSelected: boolean[] = []
    // const gamesStreamProvider: any[] = []

    const providers: number[] = []
    const _providers_: number[] = []
    const gamesStreamProvider: any[] = []
    const gamesStreamProvider_: any[] = []
    const GamesStreamProvider: any[] = []
    const categories: any[] = []
    const _categories: any[] = []
    const _categories_: number[] = []
    const Categories: any[] = []
    const gameCategories: number[] = []
    for (const item of response3) {
        let found: boolean = false
        let Found: boolean = false
        for (const Item of gamesStreamProvider) {
            if (item['Provider'].trim() === Item['name']) {
                found = true
                break
            }
        }
        for (const Item of categories) {
            if (item['Category'].trim() === Item['name']) {
                Found = true
                break
            }
        }
        if (!found) {
            gamesStreamProvider.push({ id: (GamesStreamProvider.length + 1).toString(), name: item['Provider'].trim()})
        }

        if (!Found) {
            categories.push({ id: (Categories.length + 1).toString(), name: item['Category'].trim() })
        }
    }

    gamesStreamProvider.sort(dynamicSort('name'))
    GamesStreamProvider.push({ id: '0', name: Assets.AnyProvider })
    _providers_.push(0)
    for (const item of gamesStreamProvider) {
        _providers_.push(0)
        providers.push(GamesStreamProvider.length)
        gamesStreamProvider_.push({ id: GamesStreamProvider.length.toString(), name: item['name'] })
        GamesStreamProvider.push({ id: GamesStreamProvider.length.toString(), name: item['name'] })
    }

    categories.sort(dynamicSort('name'))
    Categories.push({ id: '0', name: Assets.AnyProvider })
    _categories_.push(0)
    for (const item of categories) {
        gameCategories.push(Categories.length)
        _categories.push({ id: Categories.length.toString(), name: item['name'] })
        Categories.push({ id: Categories.length.toString(), name: item['name'] })
        _categories_.push(0)
    }
    for (const item of response3) {
        GamesStreamAllSelected.push(false)
        // let found: boolean = false
        for (const Item of _categories) {
            if (Item.name === item.Category.trim()) {
                _categories_[+Item.id]++
                // found = true
                break
            }
        }
        // if (!found) {console.log (item)}
        for (const Item of gamesStreamProvider_) {
            if (Item.name === item.Provider.trim()) {
                _providers_[+Item.id]++
                break
            }
        }
    }
    _categories_[0] = GamesStreamAllSelected.length
    _providers_[0] = GamesStreamAllSelected.length

    Logic.Type.New(Main.Instance.DatabaseDataState, {
        Games: response3,
        GamesStreamProvider,
        gamesStreamProvider: gamesStreamProvider_,
        GamesStream: GamesStreamAllSorted,
        GamesStreamAll: GamesStreamAllSorted,
        GamesStreamAllSelected,
        _categories,
        _categories_,
        _providers_,
        Categories,
        rewardsCMS: response2,
        strapiAuth: jwt ? jwt : Main.Instance.DatabaseDataState.strapiAuth,
    })
    
    Logic.Type.New(Main.Instance.GamesState, {
        providers,
        gameCategories,
        count: response3.length,
        countCalled: false
    })
}
*/
function categoryIdSort(a, b) {
    if (+a.categoryId < +b.categoryId) {
        return -1;
    }
    if (+a.categoryId > +b.categoryId) {
        return 1;
    }
    return 0;
}

export function getRecentEvents(which: number, fetch: boolean) {

    if (which === 1) {
        Socket1.socket.Send(Config.amGetExpiredAccounts, {})
        getLoadedResources('Socket1 - Send', Config.amGetExpiredAccounts)
    } else if (which === 2) {
        Socket1.socket.Send(Config.amGetExpiringAccounts, {})
        getLoadedResources('Socket1 - Send', Config.amGetExpiringAccounts)
        if (fetch) {
            getExpiringAccounts()
        }
    } else if (which === 3) {
        Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.Deposit })
        getLoadedResources('Socket1 - Send', Config.amGetRecentEvents, RecentEventsTypes[21])
    } else if (which === 4) {
        // Socket1.socket.Send (Config.amGetRecentEvents, {eventType: RecentEventsTypes.FirstDeposits})
        Socket1.socket.Send(Config.amGetFirstDepositsList, {})
        getLoadedResources('Socket1 - Send', Config.amGetFirstDepositsList)
    } else if (which === 5) {
        Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.Withdraw })
        getLoadedResources('Socket1 - Send', Config.amGetRecentEvents, RecentEventsTypes[22])
    } else if (which === 6) {
        Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.Registration })
        getLoadedResources('Socket1 - Send', Config.amGetRecentEvents, RecentEventsTypes[1])
    } else if (which === 7) {
        Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.Login })
        getLoadedResources('Socket1 - Send', Config.amGetRecentEvents, RecentEventsTypes[12])
    } else if (which === 8) {
        Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.Logout })
        getLoadedResources('Socket1 - Send', Config.amGetRecentEvents, RecentEventsTypes[13])
    } else if (which === 9) {
        Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.AllIssues })
        getLoadedResources('Socket1 - Send', Config.amGetRecentEvents, RecentEventsTypes[31])
    } else if (which === 10) {
        Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.UnresolvedIssues })
        getLoadedResources('Socket1 - Send', Config.amGetRecentEvents, RecentEventsTypes[33])
    } else if (which === 11) {
        Socket1.socket.Send(Config.amGetRecentEvents, { eventType: RecentEventsTypes.ResolvedIssues })
        getLoadedResources('Socket1 - Send', Config.amGetRecentEvents, RecentEventsTypes[32])
    } else if (which === 12) {
        Socket1.socket.Send(Config.amGetExpiringAccountsByDays, {})
        getLoadedResources('Socket1 - Send', Config.amGetExpiringAccountsByDays)
        // if (fetch) {
        //     getExpiringAccountsByDays()
        // }
    }
}

// function getExpiringAccountsByDays() {
//     Logic.Type.New (Main.Instance.DatabaseDataState, {
//         expiringAccountsByDaysStarted: true,

//     })

// }

function getExpiringAccounts() {
    Logic.Type.New(Main.Instance.DatabaseDataState, {
        expiringAccountsStarted: true,
        expiringAccountsPage: 1,
        expiringAccountsData: []
    })
    Socket1.socket.Send(Config.amGetExpiringAccountsInfo, {
        page: 1,
        limit: Main.Instance.DatabaseDataState.expiringAccountsLimit,
    })
    getLoadedResources('Socket1 - Send', Config.amGetExpiringAccountsInfo)
}

export function getAllAccounts() {
    Logic.Type.New(Main.Instance.DatabaseDataState, {
        allAccountsStarted: true,
        allAccountsPage: 1,
        allAccountsData: []
    })
    Socket1.socket.Send(Config.amGetAccountsInfo, {
        page: 1,
        limit: Main.Instance.DatabaseDataState.allAccountsLimit,
    })
    getLoadedResources('Socket1 - Send', Config.amGetAccountsInfo)

}

export function getCoreTransactionsRefresh() {
    axios.get(
        Config.asCoreTransactionsAggregated, {
        params: {
            year: Main.Instance.DatabaseDataState.coreTransactionsYear !== undefined ?
                Main.Instance.DatabaseDataState.coreTransactionsDistinctYears[Main.Instance.DatabaseDataState.coreTransactionsYear].year : undefined,
            month: Main.Instance.DatabaseDataState.coreTransactionsMonth !== undefined ?
                Main.Instance.DatabaseDataState.coreTransactionsDistinctMonths[Main.Instance.DatabaseDataState.coreTransactionsMonth].month : undefined,
            date: Main.Instance.DatabaseDataState.coreTransactionsDate !== undefined ?
                Main.Instance.DatabaseDataState.coreTransactionsDistinctDates[Main.Instance.DatabaseDataState.coreTransactionsDate].date : undefined,
            games: Main.Instance.DatabaseDataState.coreTransactionsDistinctGames,
            game: Main.Instance.DatabaseDataState.coreTransactionsGame,
            siteid: Main.Instance.FrontendStoreState.site_id
        },
        headers: {
            'x-api-key': Main.Instance.LoginState.token,
            'x-api-user': Main.Instance.LoginState.entityId
        }
    }
    )
        .then((responseAggregatedStream) => {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                coreTransactionsAggregatedStream: responseAggregatedStream.data,
            })
        })
}

export function getCoreTransactions() {

    if (Main.Instance.DatabaseDataState.coreTransactionsCalled === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { coreTransactionsCalled: true })
        // axios.get (Config.asCoreTransactionsCount, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}})
        // .then ((responseCount) => {
        axios.get(Config.asCoreTransactionsDistinctYears, { params: { siteid: Main.Instance.FrontendStoreState.site_id }, headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((responseDistinctYears) => {
                axios.get(Config.asCoreTransactionsDistinctMonths, { params: { siteid: Main.Instance.FrontendStoreState.site_id }, headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                    .then((responseDistinctMonths) => {
                        axios.get(Config.asCoreTransactionsDistinctDates, { params: { siteid: Main.Instance.FrontendStoreState.site_id }, headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                            .then((responseDistinctDates) => {
                                axios.get(Config.asCoreTransactionsDistinctGames, { params: { siteid: Main.Instance.FrontendStoreState.site_id }, headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                                    .then((responseDistinctGames) => {
                                        axios.get(Config.asCoreTransactionsAggregated, {
                                            headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }, params: {
                                                year: responseDistinctYears && responseDistinctYears.data &&
                                                    Main.Instance.DatabaseDataState.coreTransactionsYear !== undefined &&
                                                    responseDistinctYears.data[Main.Instance.DatabaseDataState.coreTransactionsYear] ?
                                                    responseDistinctYears.data[Main.Instance.DatabaseDataState.coreTransactionsYear].year : undefined,
                                                month: responseDistinctMonths && Main.Instance.DatabaseDataState.coreTransactionsMonth !== undefined ?
                                                    responseDistinctMonths.data[Main.Instance.DatabaseDataState.coreTransactionsMonth].month : undefined,
                                                date: responseDistinctDates && Main.Instance.DatabaseDataState.coreTransactionsDate !== undefined ?
                                                    responseDistinctDates.data[Main.Instance.DatabaseDataState.coreTransactionsDate].date : undefined,
                                                siteid: Main.Instance.FrontendStoreState.site_id,
                                            }
                                        })
                                            .then((responseAggregatedStream) => {
                                                const coreTransactionsGame: number[] = []
                                                for (let i: number = 0; i < responseDistinctGames.data.length; i++) {
                                                    coreTransactionsGame.push(i)
                                                }
                                                Logic.Type.New(Main.Instance.DatabaseDataState, {
                                                    coreTransactionsAggregatedStream: responseAggregatedStream.data,
                                                    // coreTransactionsStreamCount: +responseCount.data,
                                                    coreTransactionsDistinctYears: responseDistinctYears.data,
                                                    coreTransactionsDistinctMonths: responseDistinctMonths.data,
                                                    coreTransactionsDistinctDates: responseDistinctDates.data,
                                                    coreTransactionsDistinctGames: responseDistinctGames.data,
                                                    coreTransactionsGame,
                                                    coreTransactionsStream: [],
                                                    coreTransactionsCalled: false,
                                                })
                                            })
                                    })
                            })
                    })
            })
        // })
    }
}

export function getCoreTransactionsDetailedData() {
    // tslint:disable-next-line:max-line-length
    axios.get(Config.asCoreTransactionsInit, { params: { siteid: Main.Instance.FrontendStoreState.site_id, game: Main.Instance.DatabaseDataState.coreTransactionsDetailedData, date: Main.Instance.DatabaseDataState.coreTransactionsDistinctDates[Main.Instance.DatabaseDataState.coreTransactionsDate].date }, headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((responseInit) => {
            // Logic.Type.New (Main.Instance.DatabaseDataState, {coreTransactionsStream: [], coreTransactionsStreamInit:responseInit.data})
            // tslint:disable-next-line:max-line-length
            axios.get(Config.asCoreTransactions, {
                params: {
                    siteid: Main.Instance.FrontendStoreState.site_id,
                    game: Main.Instance.DatabaseDataState.coreTransactionsDetailedData,
                    date: Main.Instance.DatabaseDataState.coreTransactionsDistinctDates[Main.Instance.DatabaseDataState.coreTransactionsDate].date,
                    limit: Main.Instance.DatabaseDataState.coreTransactionsLimit,
                    offset: Main.Instance.DatabaseDataState.coreTransactionsOffset
                },
                headers: {
                    'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId,
                }
            })
                .then((response) => {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { coreTransactionsStream: response.data, coreTransactionsStreamInit: responseInit.data })
                })
        })
}

/*
DbRoutes.InsertPlayerGroup (Main.Instance.PlayerGroups, InsertLastPage)
axios.post(Config.csRules, Main.Instance.PlayerGroups)
.then((response) => {
    DbRoutes.getCRMRules()
    clearFields()
})
*/



export function WsGetGeneral() {
    Socket1.socket.Send(Config.amGetGeneral, {})
    getLoadedResources('Socket1 - Send', Config.amGetGeneral)
}

export function WsUpdateGeneral(data: IGeneral) {
    insertAdminLog(Config.asAdminLogSaveEdit, 'General Settings -> General', data)
    Socket1.socket.Send(Config.amUpdateGeneral, { data })

}

export function wsGetGeneral() {
    if (Main.Instance.GeneralState.general === undefined /*Main.Instance.GeneralState.general.currencies === undefined*/
        && Socket1.socket.Get<RouteClasses.Route>(Config.amGetGeneral) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetGeneral).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetGeneral).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetGeneral).message.data && Socket1.socket.Get<RouteClasses.Route>(Config.amGetGeneral).resolved) {
        Logic.Type.New(Main.Instance.GeneralState, { general: Socket1.socket.Get<RouteClasses.Route>(Config.amGetGeneral).message.data, general_: JSON.stringify(Socket1.socket.Get<RouteClasses.Route>(Config.amGetGeneral).message.data) })
    }
}

export function getSettlement() {
    Logic.Type.New(Main.Instance.DatabaseDataState, { settlement: true })
    axios.get(Config.psSettlementReportsScandibet).then((response) => {
        Logic.Type.New(Main.Instance.DatabaseDataState, { settlement: false, settlementStream: response.data.return })
    })
}

export function SetNewPassword(username: string, password: string, oldpassword: string) {
    // console.log('SET NEW PASSWORD')
    // console.log(username, password, oldpassword)
    // console.log(Main.Instance.LoginState.token, Main.Instance.LoginState.entityId)
    axios.post(Config.asNewPassword, { username, password, oldpassword } /*, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } } */)
    .then((response) => {
        Logic.Type.New(Main.Instance.LoginState, { Verified: false, Username: username, Password: '' })
        Logic.Type.New(Main.Instance, { Location: RouterObjects['login'].path })
    })
}

export function authorizeHash(hash: string) {
    // console.log('AUTHORIZE HASH')
    // console.log(Main.Instance.LoginState.token, Main.Instance.LoginState.entityId)
    axios.get(Config.asAuthorizeHash + hash /*, {headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }} */)
    .then((response) => {
        if (response.status === 200) {
            Logic.Type.New(Main.Instance.LoginState, { Verified: true })
        } else {
            alert(Assets.t1)
        }
    })
}

export function AuthorizeSecurityQuestion(emailphone: string) {
    const route: string = Main.Instance.LoginState.loginMethod === 5 ? Config.asAuthorizeSecurityQuestionEmail : Config.asAuthorizeSecurityQuestionPhone
    axios.get(route + '?user=' + emailphone + '&build=' + Config.Build + '&environment=' + Config.environment, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
    .then((response) => {
        if (response.status === 201) {
            Logic.Type.New(Main.Instance.LoginState, { securityQuestion: 0 })
        } else if (response.status === 200) {
            Logic.Type.New(Main.Instance.LoginState, { securityQuestion: parseInt(response.data) })
        }
    })
}

export function AuthorizeSecurityAnswer(emailphone: string, answer: string) {
    const route: string = Main.Instance.LoginState.loginMethod === 5 ? Config.asAuthorizeSecurityAnswerEmail : Config.asAuthorizeSecurityAnswerPhone
    axios.get(route + '?user=' + emailphone + '&answer=' + answer + '&build=' + Config.Build + '&environment=' + Config.environment, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
    .then((response) => {
        if (response.status === 200 && response.data.resolved === true) {
            // console.log (response.data.username)
            Logic.Type.New(Main.Instance.LoginState, { securityAnswerCorrect: true, securityQuestion: 0, securityAnswer: '' })
            if (confirm(Assets.DoYouWantToResetPasswordForUsername + ' "' + response.data.username + '"?')) {
                ForgotPassword(response.data.username)
            }
        }
    })
}

export function ForgotPassword(username: string) {
    const url = window.location.href && window.location.href.split('-')
    let env: string
    if (url.length === 3) {
        env = url[1] + '-'
    } else if (url.length === 2) {
        env = ''
    }
    // const sql: string = Config.asForgotPassword + '?username=' + username + '&admin=' + (IsBuildJackpotsCH() || IsBuildPasino() ? Config.ENVIRONMENT_PRE[Config.environment] : '') + Config.builds[Config.Build]
    const sql: string = Config.asForgotPassword + '?username=' + username + '&admin=' + (IsBuildJackpotsCH() || IsBuildPasino() ? (env ? env : Config.ENVIRONMENT_PRE[Config.environment]) : '') + Config.builds[Config.Build]
    axios.get(sql /* , {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}} */)
    .then((response) => {
        if (response.status === 200) {
            alert(Assets.y1)
        } else if (response.status === 201) {
            alert(Assets.y2)
        }
    })
}

export function getLoadedResources(whatSocket: string, whatRoute?: string,  input?: string) {

    const timestamp: string = (new Date()).toISOString()
    const env: string = getEnvironmentString()
    const resources = Object.assign([], Main.Instance.LoadingResourcesState.loadedResources)
    const build = Config.builds[Config.Build]
    const location = Main.Instance.Location
    resources.push({timestamp, environment: env, build, socket: whatSocket, route: whatRoute ? whatRoute : '', location, input: input ? input : ''})
    Logic.Type.New(Main.Instance.LoadingResourcesState, {loadedResources: resources})
}

function getEnvironmentString(): string {
    return  Config.ENVIRONMENT[Config.environment].toString()
}

function getEnvironment(): number { // DEV AND DEVEDGE GET INSERTED AS THE SAME ENVIRONMENT
    return Config.environment === Config.Environment.STAGE ? 2 : Config.environment === Config.Environment.PRODUCTION ? 3 : 1
}

export function insertAdminLog(type: string, subType: string, data: any, entity_id?: number, user_id?: number) {
    const timestamp: string = (new Date()).toISOString()
    const stage: number = getEnvironment()

    let subtype: string = subType ? subType : undefined
    if (subtype) {
        subtype = capitalizeFirstLetter(subtype)
        const position = subtype.indexOf(' -> ')
        if (position !== -1) {
            subtype = subtype.substring(0, position + 4) + capitalizeFirstLetter(subtype.substring(position + 4, subtype.length))
        }
    }
    axios.post(
        Config.asAdminLog,
        {
            entityId: entity_id !== undefined ? entity_id : +Main.Instance.LoginState.entityId,
            userId: user_id !== undefined ? user_id : +Main.Instance.LoginState.id,
            stage,
            type,
            subType: subtype,
            timestamp,
            data: data ? JSON.stringify(data) : undefined,
        },
        {
            headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId },
        }
    )
    /*
        .then((response) => console.log (response))
        .catch((e) => console.log (e))
    */
    const lastActionTime: number = new Date().getTime()
    if (lastActionTime - Main.Instance.DatabaseDataState.lastActionTime > 1000) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { lastActionTime }, true)
    }
}

export function getAdminLog(light?: boolean, all?: boolean) {
    const entity: string = '?entityId=' + (Main.Instance.LoginState.entityId ? Main.Instance.LoginState.entityId : '0')
    // const stage: string = '&stage=' + (Config.Stage === true ? 2 : Config.Stage === undefined ? 3 : 1)
    const stage: string = '&stage=' + getEnvironment()// (Config.environment === 3 ? 2 : Config.environment === 4 ? 3 : 1)
    const type: string = '&type=' + Main.Instance.LogState.distinctTypeValue
    // let arg: string = '?entityId=' + (Main.Instance.LoginState.entityId ? Main.Instance.LoginState.entityId : '0')
    let arg = entity + '&userId=' + Main.Instance.LogState.distinctUserIdValue
    // arg += '&roleId=' + Main.Instance.LogState.distinctUserRoleValue
    arg += stage + type
    arg += '&subType=' + Main.Instance.LogState.distinctSubtypeValue
    arg += '&dateStart=' + Main.Instance.LogState.distinctDateValueStart
    arg += '&dateEnd=' + Main.Instance.LogState.distinctDateValueEnd
    // arg += '&gameId=' + Main.Instance.LogState.distinctGameId
    // arg += '&gameName=' + Main.Instance.LogState.distinctGameName

    const str: string = Config.asAdminLog + arg + (all ? '&limit=10000000&offset=0' : '&limit=' + Main.Instance.LogState.pSize.toString() + '&offset=' + Main.Instance.LogState.offset)
    const Str = Config.asAdminLogCount + arg
    axios.get(Config.asAdminLogDistinctUserId + entity + stage, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((responseAdminLogDistinctUserId) => {
            if (all) {
                // axios.get(Str, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                // .then((Response) => {
                    axios.get(str, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((response) => {
                            Logic.Type.New(Main.Instance.DatabaseDataState, { log: response.data })
                            setLog(response.data)
/*
                            Logic.Type.New(Main.Instance.LogState, {
                                count: +Response.data.count
                            })
*/
                    })
                // })
            }
            if (light) {
                const distinctUserIdSorted: any[] = Object.assign([], responseAdminLogDistinctUserId.data)
                distinctUserIdSorted.sort(sortUserId)
                Logic.Type.New(Main.Instance.LogState, {
                    distinctUserId: responseAdminLogDistinctUserId.data,
                    distinctUserIdSorted
                })
            } else {
                axios.get(Config.asAdminLogDistinctType + entity + stage, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                .then((responseAdminLogDistinctType) => {
                    axios.get(Config.asAdminLogDistinctSubtype + entity + stage + type, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((responseAdminLogDistinctSubtype) => {
                            axios.get(Config.asAdminLogDistinctDate + entity + stage, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                                .then((responseAdminLogDistinctDate) => {
                                    axios.get(Str, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                                        .then((Response) => {
                                            axios.get(str, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                                                .then((response) => {
                                                    Logic.Type.New(Main.Instance.DatabaseDataState, { log: response.data })
                                                    const distinctUserIdSorted: any[] = Object.assign([], responseAdminLogDistinctUserId.data)
                                                    distinctUserIdSorted.sort(sortUserId)
                                                    Logic.Type.New(Main.Instance.LogState, {
                                                        count: +Response.data.count,
                                                        distinctUserIdSorted,
                                                        distinctUserId: responseAdminLogDistinctUserId.data,
                                                        distinctType: responseAdminLogDistinctType.data,
                                                        distinctSubtype: responseAdminLogDistinctSubtype.data,
                                                        distinctDate: responseAdminLogDistinctDate.data,
                                                    })
                                                })
                                        })
                                })
                        })
                })
            }
        })
}

function sortUserId(a, b) {
    return a.user_id - b.user_id
}

// '?build=' + Config.Build post umjesto get
export function Login(usr: string, pass: string) {
    
    Logic.Type.New(Main.Instance.LoginState, { Password: '', Password1: '', Password2: '' })
    const route: string = Main.Instance.LoginState.loginMethod === 0 ? Config.asAuthorize : Main.Instance.LoginState.loginMethod === 1 ? Config.asAuthorizeEmail : Config.asAuthorizePhone
    // const Route: string = Main.Instance.LoginState.loginMethod === 0 ? Config.asAuthorizedUser : Main.Instance.LoginState.loginMethod === 1 ? Config.asAuthorizedUserEmail : Config.asAuthorizedUserPhone
    const ROUTE: string = route + '?build=' + Config.Build + '&environment=' + Config.environment
    axios.get(ROUTE, {headers: {'x-api-pass': pass, 'x-api-name': usr}}) // dont send keys here
    // axios.get(ROUTE, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId, 'x-api-pass': pass, 'x-api-name': usr } })
        .then((response) => {
            // 201 = wrong password, 202 = wrong environment
            if (response && !response.data.resolved && response.data.error === 'Not Authorized!') {
                Logic.Type.New(Main.Instance.LoginState, { wrongApiKey: true })
            } else if (response && response.status && response.status === 202) {
                Logic.Type.New(Main.Instance.LoginState, { wrongEnvironment: true })
            } else if (response && response.status && response.status !== 201) {
                Logic.Type.New(Main.Instance.LoginState, {
                    // logout: false,
                    id: response.data.id,
                    role: response.data.role,
                    token: response.data.token,
                    // roles: response.data.roles,
                    entity: response.data.entity ? response.data.entity : 'Gamanza',
                    entityId: response.data.entity_id,
                    // custom: response.data.custom,
                    gamanzaAdmin: response.data.custom.securityRights.unused1,
                    gamanzaMagicHand: response.data.custom.securityRights.unused7,
                    gdpr: response.data.custom.securityRights.gdpr,
                    support: response.data.custom.securityRights.support,
                    operator: response.data.custom.securityRights.operator,
                    marketing: response.data.custom.securityRights.marketing,
                    rfSpecialist: response.data.custom.securityRights.rfSpecialist,
                    rgSpecialist: response.data.custom.securityRights.rgSpecialist,
                    administrator: response.data.custom.securityRights.administrator,
                    accounting: response.data.custom.securityRights.accounting,
                    unused3: response.data.custom.securityRights.unused3, // Download reports
                    unused1: response.data.custom.securityRights.unused1, // Gamanza Admin
                    unused2: response.data.custom.securityRights.unused2, // Gamanza games admin
                    unused7: response.data.custom.securityRights.unused7, // Gamanza magic hand
                    environmentsAllowed: response.data.custom.environmentsAllowed,
                    Verified: true,
                    
                })
                
                Cookies.remove('loginData', { path: '/' })
                Cookies.remove('selectedEnvironment', { path: '/' })
                // document.cookie = 'selectedEnvironment=' + Config.environment
                Cookies.set('selectedEnvironment', Config.environment, { path: '/' })
                Cookies.set('loginData', base64.encode(JSON.stringify(Main.Instance.LoginState)), { path: '/' })

                
                // axios.get(Route + '?user=' + usr, { headers: { 'x-api-key': response0.data.token, 'x-api-user': response0.data.entity_id } })
                // .then((response) => {
/*
                    const usersNew: UsersNew[] = []
                    axios.get(Config.asNewUser + (response.data.entity_id === 0 ? '' : '?entityId=' + response.data.entity_id), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                    .then((response1) => {
                        for (const item of response1.data) {
                            usersNew.push(item)
                        }
                        Logic.Type.New(Main.Instance.DatabaseDataState, {usersNew})
                        
                    })
*/              // console.log(response.data.token)
                Socket1.reConnect(response.data.token)
                if (IsBuildMyChance()) {
                    Socket2.reConnect(response.data.token)
                }
                

                insertAdminLog(Config.asAdminLogLogin, undefined, {}, response.data.entity_id, response.data.id)
                getLoadedResources('Cookie - Set', 'selectedEnvironment=')
                getLoadedResources('Cookie - Set', 'loginData=')
                if (IsBuildJackpotsCH() || IsBuildPasino()) {
                    if (RouterObjects['main_Dashboard']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['main_Dashboard'].path })
                    }
                } else if (IsBuildMyChance()) {
                    if (RouterObjects['gamification']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['gamification'].path })
                    } else if (RouterObjects['general_Settings']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['general_Settings'].path })
                    }
                } else if (IsBuildOddyzzey()) {
                    if (RouterObjects['gamification']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['gamification'].path })
                    } else if (RouterObjects['general_Settings']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['general_Settings'].path })
                    }
                } else if (IsBuildTrekronor()) {
                    if (RouterObjects['front___End_Store']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['front___End_Store'].path })
                    }
                } else if (IsBuildBettoday()) {
                    if (RouterObjects['front___End_Store']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['front___End_Store'].path })
                    }
                } else if (IsBuildOdds()) {
                    if (RouterObjects['oddsportal']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['oddsportal'].path })
                    }
                } else {
/*
                    if (RouterObjects['game_Store']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['game_Store'].path })
                    }
*/
                    if (RouterObjects['deployed_projects']) {
                        Logic.Type.New(Main.Instance, { Location: RouterObjects['deployed_projects'].path })
                    }
                }
                // })
                // .catch((e) => console.log(e))
        } else {
        /*if (!dev)*/ Logic.Type.New(Main.Instance.LoginState, { wrongPassword: true })
            }
        })
}

export function changeIndexRewardShop(id: number, index: number) {
    axios.put(Config.psChangeIndexRewardShop, { id, index })
}

export function reloadDefaultTrekronorSports() {
    const custom = Object.assign({}, Main.Instance.FrontendStoreState.custom)
    custom['general']['userEntry']['data']['sports'] = Object.assign([], custom['general']['database']['sports'])
    Logic.Type.New(Main.Instance.FrontendStoreState, { custom })
}

export function reloadDefaultTrekronorCategory(sportName: string) {
    const custom = Object.assign({}, Main.Instance.FrontendStoreState.custom)
    custom['general']['userEntry']['data']['categories'][sportName.toLowerCase()] = Object.assign([], custom['general']['database']['categories'][sportName.toLowerCase()])
    Logic.Type.New(Main.Instance.FrontendStoreState, { custom })
}

export function reloadDefaultTrekronorTournament(categoryName: string, sportName: string) {
    const custom = Object.assign({}, Main.Instance.FrontendStoreState.custom)
    if (custom['general']['userEntry']['data']['tournaments'] === undefined) { custom['general']['userEntry']['data']['tournaments'] = {} }
    if (custom['general']['userEntry']['data']['tournaments'][sportName] === undefined) {
        custom['general']['userEntry']['data']['tournaments'][sportName] = {}
    }
    custom['general']['userEntry']['data']['tournaments'][sportName][categoryName.toLowerCase()] =
        Object.assign([], custom['general']['database']['tournaments'][sportName][categoryName.toLowerCase()])
    Logic.Type.New(Main.Instance.FrontendStoreState, { custom })
}

export function reloadDefaultTrekronorMatch(categoryName: string, sportName: string, tournamentName: string) {
    const custom = Object.assign({}, Main.Instance.FrontendStoreState.custom)
    if (custom['general']['userEntry']['data']['matches'] === undefined) { custom['general']['userEntry']['data']['matches'] = {} }
    if (custom['general']['userEntry']['data']['matches'][sportName] === undefined) {
        custom['general']['userEntry']['data']['matches'][sportName] = {}
    }
    if (custom['general']['userEntry']['data']['matches'][sportName][categoryName] === undefined) {
        custom['general']['userEntry']['data']['matches'][sportName][categoryName] = {}
    }
    custom['general']['userEntry']['data']['matches'][sportName][categoryName][tournamentName.toLowerCase()] =
        Object.assign([], custom['general']['database']['matches'][sportName][categoryName][tournamentName.toLowerCase()])
    Logic.Type.New(Main.Instance.FrontendStoreState, { custom })
}

export function getAllSports() {
    axios.get(Config.tdSports).then((response) => {
        const custom = Object.assign({}, Main.Instance.FrontendStoreState.custom)
        if (custom['general'] === undefined) { custom['general'] = {} }
        if (custom['general']['database'] === undefined) { custom['general']['database'] = {} }
        custom['general']['database']['sports'] = response.data.return
        Logic.Type.New(Main.Instance.FrontendStoreState, { custom })
    })
}

export function getAllCategories(sportId: number, sportName: string) {
    axios.get(Config.tdCategories + '?sportId=' + sportId).then((response) => {
        const custom = Object.assign({}, Main.Instance.FrontendStoreState.custom)
        if (custom['general'] === undefined) { custom['general'] = {} }
        if (custom['general']['database'] === undefined) { custom['general']['database'] = {} }
        if (custom['general']['database']['categories'] === undefined) { custom['general']['database']['categories'] = {} }
        custom['general']['database']['categories'][sportName.toLowerCase()] = response.data.return
        Logic.Type.New(Main.Instance.FrontendStoreState, { custom })
        alert(Assets.Found + ' ' + response.data.return.length + ' ' + Assets.Categories.toLowerCase() + Assets._for_ + sportName)
        reloadDefaultTrekronorCategory(sportName)
    })
}

export function getAllTournaments(categoryId: number, categoryName: string, sportName: string) {
    axios.get(Config.tdTournaments + '?categoryId=' + categoryId).then((response) => {
        const custom = Object.assign({}, Main.Instance.FrontendStoreState.custom)
        if (custom['general'] === undefined) { custom['general'] = {} }
        if (custom['general']['database'] === undefined) { custom['general']['database'] = {} }
        if (custom['general']['database']['tournaments'] === undefined) { custom['general']['database']['tournaments'] = {} }
        if (custom['general']['database']['tournaments'][sportName] === undefined) {
            custom['general']['database']['tournaments'][sportName] = {}
        }
        custom['general']['database']['tournaments'][sportName][categoryName.toLowerCase()] = response.data.return
        Logic.Type.New(Main.Instance.FrontendStoreState, { custom })
        alert(Assets.Found + ' ' + response.data.return.length + ' ' + Assets.Tournaments.toLowerCase() + Assets._for_ + sportName + '/' + categoryName)
        reloadDefaultTrekronorTournament(categoryName, sportName)
    })
}

export function getAllMatches(tournamentId: number, tournamentName: string, sportName: string, categoryName: string) {
    axios.get(Config.tdMatches + '?tournamentId=' + tournamentId).then((response) => {
        const custom = Object.assign({}, Main.Instance.FrontendStoreState.custom)
        if (custom['general'] === undefined) { custom['general'] = {} }
        if (custom['general']['database'] === undefined) { custom['general']['database'] = {} }
        if (custom['general']['database']['matches'] === undefined) { custom['general']['database']['matches'] = {} }
        if (custom['general']['database']['matches'][sportName] === undefined) {
            custom['general']['database']['matches'][sportName] = {}
        }
        if (custom['general']['database']['matches'][sportName][categoryName] === undefined) {
            custom['general']['database']['matches'][sportName][categoryName] = {}
        }
        custom['general']['database']['matches'][sportName][categoryName][tournamentName.toLowerCase()] = response.data.return
        Logic.Type.New(Main.Instance.FrontendStoreState, { custom })
        alert(Assets.Found + ' ' + response.data.return.length + ' ' + Assets.Matches.toLowerCase() + Assets._for_ + sportName + '/' + categoryName + '/' + tournamentName)
        reloadDefaultTrekronorMatch(categoryName, sportName, tournamentName)
    })
}

/*
function getSports() {
    axios.get (tkSports).then ((response) => {
        // console.log(response.data)
    })
}
*/
/* SECTION Oddyzzey */
export function WsGetChallenges() {
    Socket1.socket.Send(Config.amGetChallenges, {/*limit: Main.Instance.ChallengeState.pSize, offset: +Main.Instance.ChallengeState.offset, type: +Main.Instance.ChallengeState.filter_challenge_type*/ })
    Socket1.socket.Send(Config.amGetChallengesAll, {})
    getLoadedResources('Socket1 - Send', Config.amGetChallenges)
    getLoadedResources('Socket1 - Send', Config.amGetChallengesAll)
}

export function WsGetStore() {
    Socket1.socket.Send(Config.amGetStores, {/*limit: Main.Instance.StoreState.pSize, offset: +Main.Instance.StoreState.offset*/ })
    Socket1.socket.Send(Config.amGetStoresAll, {})
    getLoadedResources('Socket1 - Send', Config.amGetStores)
    getLoadedResources('Socket1 - Send', Config.amGetStoresAll)
}

export function WsGetPlayerIds() {
    Socket1.socket.Send(Config.amGetPlayerIds, {})
    getLoadedResources('Socket1 - Send', Config.amGetPlayerIds)
}

function compare(a, b) {
    if (+a.player < +b.player) {
        return -1;
    }
    if (+a.player > +b.player) {
        return 1;
    }
    return 0;
}
/*
function cTier(a,b) {
    if (+a.tier < +b.tier)
      return -1;
    if (+a.tier > +b.tier)
      return 1;
    return 0;
}
*/
/*
function cName(a,b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
}
*/
/*
function cCode(a, b) {
    if (a.code < b.code) {
        return -1;
    }
    if (a.code > b.code) {
        return 1;
    }
    return 0;
}
*/

export function wsGetPlayerIds() {
    if (Main.Instance.DatabaseDataState.playersStream === undefined
        && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerIds) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerIds).loading === 'loaded' &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerIds).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerIds).message.playerIds) {
        const playersStream: any[] = []
        for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetPlayerIds).message.playerIds) {
            playersStream.push({ player: item.toString() })
        }
        playersStream.sort(compare)
        Logic.Type.New(Main.Instance.DatabaseDataState, { playersStream })
        getLoadedResources('Socket1 - Get', Config.amGetPlayerIds)
    }
}

export function wsGetChallenges() {
    if (Main.Instance.DatabaseDataState.challengesStream === undefined || Main.Instance.DatabaseDataState.challengesNewGet) {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallenges) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallenges).loading === 'loaded') {
            if (Main.Instance.FrontendStoreState.Category5 === undefined) {
                const Category5: Option[] = []
                Category5.push({ id: '0', name: 'Any Challenge Type' })
                for (const item of Assets.challengeTypes) { Category5.push({ id: Category5.length.toString(), name: item }) }
                Logic.Type.New(Main.Instance.FrontendStoreState, { Category5 })
            }
            const challengesStream: any[] = []
            for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallenges).message) {
                challengesStream.push({ id: item.id, name: item.name, date: item.date, 'Challenge Type': Assets.challengeTypes[item.type - 1], challenge: item.conditions })
            }
            Logic.Type.New(Main.Instance.DatabaseDataState, { challengesStream, challengesNewGet: false })
            getLoadedResources('Socket1 - Get', Config.amGetChallenges)

            if (+Main.Instance.ChallengeState.filter_challenge_type === 0) {
                if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallengesAll).message !== undefined) {
                    Logic.Type.New(Main.Instance.ChallengeState, { count: Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallengesAll).message.length })
                }
            } else {
                let count: number = 0
                for (const item of Main.Instance.DatabaseDataState.challengesAllStream) {
                    if (item['type'] !== +Main.Instance.ChallengeState.filter_challenge_type) { continue }
                    count++
                }
                Logic.Type.New(Main.Instance.ChallengeState, { count })
            }
        }
    }
}

export function wsGetStore() {
    if (Main.Instance.DatabaseDataState.storeStream === undefined || Main.Instance.DatabaseDataState.storesNewGet) {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetStores) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetStores).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetStores).message) {
            const storeStream: any[] = []
            for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetStores).message) {

                storeStream.push({
                    id: item.id,
                    name: item.name,
                    rewards: item.rewards,
                    boosters: JSON.stringify(item.filters),
                    '# rewards': item.rewards ? item.rewards.length === 1 ? '1 reward' : item.rewards.length + ' rewards' : '0 rewards',
                    'MinLevel': item.filters && item.filters.minLevel && item.filters.minLevel.level && Main.Instance.DatabaseDataState.levelsAllStream && Main.Instance.DatabaseDataState.levelsAllStream[item.filters.minLevel.level - 1] ?
                        Main.Instance.DatabaseDataState.levelsAllStream[item.filters.minLevel.level - 1]['name'] : 'Not defined',
                    'MinSublevel': item.filters && item.filters.minLevel ? item.filters.minLevel.sublevel ?
                        item.filters.minLevel.sublevel : item.filters.minLevel.level ? 1 : 'Not defined' : 'Not defined',
                    'MaxLevel': item.filters && item.filters.maxLevel && item.filters.maxLevel.level && Main.Instance.DatabaseDataState.levelsAllStream && Main.Instance.DatabaseDataState.levelsAllStream[item.filters.maxLevel.level - 1] ?
                        Main.Instance.DatabaseDataState.levelsAllStream[item.filters.maxLevel.level - 1]['name'] : 'Not defined',
                    'MaxSublevel': item.filters && item.filters.maxLevel ? item.filters.maxLevel.sublevel ?
                        item.filters.maxLevel.sublevel : item.filters.maxLevel.level && Main.Instance.DatabaseDataState.levelsAllStream && Main.Instance.DatabaseDataState.levelsAllStream[item.filters.maxLevel.level - 1] ?
                            Main.Instance.DatabaseDataState.levelsAllStream[item.filters.maxLevel.level - 1]['sublevels'] : 'Not defined' : 'Not defined',
                })
            }
            Logic.Type.New(Main.Instance.DatabaseDataState, { storeStream, storesNewGet: false })
            getLoadedResources('Socket1 - Get', Config.amGetStores)
        }
    }
}

export function wsDeleteChallenge() {
    if (Main.Instance.DatabaseDataState.challengesNewDelete === false &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteChallenge) && Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteChallenge).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { challengesNewDelete: true, challengesNewGet: true, challengesNewGetAll: true })
        WsGetChallenges()
    }
}

export function wsDeleteStore() {
    if (Main.Instance.DatabaseDataState.storesNewDelete === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteStore) && Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteStore).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { storesNewDelete: false, storesNewGet: true, storesNewGetAll: true })
        WsGetStore()
    }
}

export function wsInsertChallenge() {
    if (Main.Instance.DatabaseDataState.challengesNewInsert === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amInsertChallenge) && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertChallenge).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { challengesNewInsert: false, challengesNewGet: true, challengesNewGetAll: true })
        WsGetChallenges()
        Challenges.InsertLastPage()
    }
}

export function wsUpdateChallenge() {
    if (Main.Instance.DatabaseDataState.challengesNewUpdate === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateChallenge) && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateChallenge).loading === 'loaded') {
        if (!Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateChallenge).resolved) {
            alert(Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateChallenge).message)
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { challengesNewUpdate: false, challengesNewGet: true, challengesNewGetAll: true })
        WsGetChallenges()
        Challenges.Update()
    }
}

export function wsInsertStore() {
    if (Main.Instance.DatabaseDataState.storesNewInsert === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amInsertStore) && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertStore).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { storesNewInsert: false, storesNewGet: true, storesNewGetAll: true })
        WsGetStore()
        Store.InsertLastPage()
    }
}

export function wsUpdateStore() {
    if (Main.Instance.DatabaseDataState.storesNewUpdate === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateStore) && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateStore).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { storesNewUpdate: false, storesNewGet: true, storesNewGetAll: true })
        WsGetStore()
        Store.Update()
    }
}

export function WSupdateChallenge(items) {
    if (Main.Instance.DatabaseDataState.challengesNewUpdate === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { challengesNewUpdate: true })
        Socket1.socket.Send(Config.amUpdateChallenge, items)
    }
}

export function WSinsertChallenge(items) {
    if (Main.Instance.DatabaseDataState.challengesNewInsert === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { challengesNewInsert: true })
        Socket1.socket.Send(Config.amInsertChallenge, items)
    }
}

function WSdeleteChallenge(id: number) {
    if (!Main.Instance.DatabaseDataState.challengesNewDelete) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { challengesNewDelete: true })
        Socket1.socket.Send(Config.amDeleteChallenge, { id })
    }
}

export function WSupdateStore(items) {
    if (Main.Instance.DatabaseDataState.storesNewUpdate === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { storesNewUpdate: true })
        Socket1.socket.Send(Config.amUpdateStore, items)
        if (IsBuildMyChance()) {
            insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Shop', items)
        } else {
            insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Store', items)
        }

    }
}

export function WSinsertStore(items) {
    if (Main.Instance.DatabaseDataState.storesNewInsert === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { storesNewInsert: true })
        Socket1.socket.Send(Config.amInsertStore, items)
        if (IsBuildMyChance()) {
            insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Shop', items)
        } else {
            insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Store', items)
        }

    }
}

function WSdeleteStore(id: number) {
    if (!Main.Instance.DatabaseDataState.storesNewDelete) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { storesNewDelete: true })
        Socket1.socket.Send(Config.amDeleteStore, { storeId: id })
        if (IsBuildMyChance()) {
            insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Shop', { id })
        } else {
            insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Store', { id })
        }
    }
}

/* LEVELS */

export function WsGetLevels() {
    if (IsBuildOddyzzey()) {
        Socket1.socket.Send(Config.amGetLevels, {/*limit: Main.Instance.CRMLevelsState.pSize, offset: +Main.Instance.CRMLevelsState.offset*/ })
        Socket1.socket.Send(Config.amGetLevelsAll, {})
        getLoadedResources('Socket1 - Send', Config.amGetLevels)
        getLoadedResources('Socket1 - Send', Config.amGetLevelsAll)
    } else if (IsBuildMyChance()) {
        Socket1.socket.Send(Config.amGetLevels, {})
        Socket1.socket.Send(Config.amGetLevelsAll, {})
        getLoadedResources('Socket1 - Send', Config.amGetLevels)
        getLoadedResources('Socket1 - Send', Config.amGetLevelsAll)
    }
}
/*
export function wsGetLevels() {
    // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels))
    if (Main.Instance.DatabaseDataState.levelsStream === undefined || Main.Instance.DatabaseDataState.levelsNewGet === true) {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).loading === 'loaded') {

            // let count: number = Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).message.length
            // Logic.Type.New (Main.Instance.CRMLevelsState, {countCalled: false, count})
            // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).message)
            // if (count) {
                // console.log (Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).message)
                // let levelsStream: any[] = [] for (const item of 
            if (IsBuildOddyzzey() || IsBuildMyChance()) {
                const levelsStream = Object.assign ([], Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).message)
                for (const item of levelsStream) { delete(item.custom) }
            
                Logic.Type.New (Main.Instance.DatabaseDataState, {levelsStream, levelsNewGet: false})
            }
        } 
    }
}
*/
export function wsGetLevels() {
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).loading === 'loaded') {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).message && Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).resolved && (!Main.Instance.DatabaseDataState.levelsStream || Main.Instance.DatabaseDataState.levelsStream.length === 0 || Main.Instance.DatabaseDataState.levelsNewGet)) {
            getLoadedResources('Socket1 - Get', Config.amGetLevels)
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                levelsStream: Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).message,
                levelsNewCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).message.length,
                levelsAllStream: Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevels).message
            })
            Logic.Type.New(Main.Instance.DatabaseDataState, { levelsNewGet: false })
        }
    }
}



export function wsDeleteLevel() {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        if (Main.Instance.DatabaseDataState.levelsNewDelete === true &&
            Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteLevel) && Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteLevel).loading === 'loaded') {
            Logic.Type.New(Main.Instance.DatabaseDataState, { levelsNewDelete: false, levelsNewGet: true, levelsNewGetAll: true })
            WsGetLevels()
        }
    }
}

export function wsInsertLevel() {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        if (Main.Instance.DatabaseDataState.levelsNewInsert === true && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertLevel) && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertLevel).loading === 'loaded') {
            Logic.Type.New(Main.Instance.DatabaseDataState, { levelsNewInsert: false, levelsNewGet: true, levelsNewGetAll: true })
            WsGetLevels()
            Levels.InsertLastPage()
        }
    }
}

export function wsUpdateLevel() {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        if (Main.Instance.DatabaseDataState.levelsNewUpdate === true && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateLevel) && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateLevel).loading === 'loaded') {
            Logic.Type.New(Main.Instance.DatabaseDataState, { levelsNewUpdate: false, levelsNewGet: true, levelsNewGetAll: true })
            WsGetLevels()
            Levels.Update()
        }
    }
}

function WSupdateLevel(items: ILevelDefinition) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { levelsNewUpdate: true })
        Socket1.socket.Send(Config.amUpdateLevel, items)
        insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Levels', items)
    }
}

function WSinsertLevel(items: ILevelDefinition) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { levelsNewInsert: true })
        Socket1.socket.Send(Config.amInsertLevel, items)
        insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Levels', items)
    }
}

function WSdeleteLevel(id: number) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { levelsNewDelete: true })
        Socket1.socket.Send(Config.amDeleteLevel, { id })
        insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Levels', { id })
    }
}

export function wsGetRewards() {
    if ((Main.Instance.DatabaseDataState.rewardsNewGet || Main.Instance.DatabaseDataState.rewardShopStream === undefined) /* && Main.Instance.DatabaseDataState.rewardsCMS */
        && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewards) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewards).loading === 'loaded') {
        const rewardShopStream: any[] = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewards).message)
        const RewardShopStream: any[] = []
        for (const item of rewardShopStream) {
            let categories: string = ''
            let rewardIntent: string = ''
            let rewards: string = ''
            let value_spin: {} = {}
            let numOfFreeSpins: string = ''
            if (item['reward']) {
                if (IsBuildMyChance()) {
                    if (Main.Instance.DatabaseDataState.rewardsCMS) {
                        for (const Item of Main.Instance.DatabaseDataState.rewardsCMS) {
                            if (item.id === Item.rewardId) {
                                value_spin = Item.value_spin
                                if (Item.numOfFreeSpins) {
                                    numOfFreeSpins = Item.numOfFreeSpins.toString() + (item.rewardType === 1 ? 'FS' : item.rewardType === 9 ? 'MS' : '')
                                } else {
                                    numOfFreeSpins = ''
                                }
                            }
                        }
                    }

                    RewardShopStream.push({
                        id: item['id'],
                        Reward: item['name'],
                        // ['Reward intent']: rewardIntent,
                        ['Reward type']: /* rewardType, */ item['rewardType'],
                        // categories,
                        type: injectSpaces(RewardTypes[item['rewardType']]),
                        category: 1,
                        reward: { category1: item['reward'].category1, description: item['reward'].description },
                        valueSpin: value_spin,
                        numOfFreeSpins
                        // rewards,
                    })
                } else {
                    if (item['reward'].category1) { categories += '1 ' }
                    if (item['reward'].category2) { categories += '2 ' }
                    if (item['reward'].category3) { categories += '3 ' }

                    if (item['rewardIntent']) {
                        for (const Item of item['rewardIntent']) {
                            if (rewardIntent.length > 0) {
                                rewardIntent += ', '
                            }
                            if (rewards.length > 0) {
                                rewards += ','
                            }
                            rewardIntent += Assets_.RewardIntent[Item]
                            rewards += Item
                        }
                    }

                    let rewardType = 'Unknown'
                    const rewardTypes = Object.keys(RewardTypes)
                    if (item['rewardType']) {
                        for (let i: number = 0; i < rewardTypes.length / 2; i++) {
                            if (i === parseInt(item['rewardType']) - 1) {
                                rewardType = rewardTypes[rewardTypes.length / 2 + i + 1]
                            }
                        }
                    }

                    RewardShopStream.push({
                        id: item['id'],
                        Reward: item['name'],
                        ['Reward intent']: rewardIntent,
                        ['Reward type']: rewardType,
                        categories,
                        category: 0,
                        reward: item['reward'],
                        rewards,
                    })
                }
            } else {
                RewardShopStream.push(item)
            }
        }

        if (+Main.Instance.RewardShopState.filter_category === 0 && +Main.Instance.RewardShopState.filter_type === 0) {
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewardsAll).message !== undefined) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { rewardShopStream: RewardShopStream, rewardsNewGet: false, rewardShopCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewardsAll).message.length })
                getLoadedResources('Socket1 - Get', Config.amGetRewardsAll)
            }
        } else {
            let count: number = 0
            for (const item of Main.Instance.DatabaseDataState.rewardShopStreamAll) {
                if (+Main.Instance.RewardShopState.filter_type > 0 && item['rewardType'] !== +Main.Instance.RewardShopState.filter_type) { continue }
                if (+Main.Instance.RewardShopState.filter_category > 0) {
                    let found: boolean = false
                    for (const Item of item['rewardIntent']) {
                        if (Item === +Main.Instance.RewardShopState.filter_category - 1) {
                            found = true
                            break
                        }
                    }
                    if (!found) { continue }
                }
                count++
            }
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                rewardShopStream: RewardShopStream,
                rewardsNewGet: false,
                rewardShopCount: count
            })
            getLoadedResources('Socket1 - Get', Config.amGetRewards)
        }
    }
}

export function WsGetRewards() {
    Socket1.socket.Send(Config.amGetRewards, {
        intent: +Main.Instance.RewardShopState.filter_category - 1,
        type: +Main.Instance.RewardShopState.filter_type,
        limit: +Main.Instance.RewardShopState.pSize,
        offset: +Main.Instance.RewardShopState.offset,
    })
    getLoadedResources('Socket1 - Send', Config.amGetRewards)
}

export function WSinsertReward(item: any) {
    if (Main.Instance.DatabaseDataState.rewardsNewInsert === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { rewardsNewInsert: true })
        Socket1.socket.Send(Config.amInsertReward, item)
        insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Rewards', item)
    }
}

export function WSupdateReward(item: any) {
    if (Main.Instance.DatabaseDataState.rewardsNewUpdate === false) {
        let ITEM
        let categories: string = ''
        let rewardIntent: string = ''
        let rewards: string = ''
        let value_spin: {} = {}
        let numOfFreeSpins: string = ''
        if (IsBuildMyChance()) {
            for (const Item of Main.Instance.DatabaseDataState.rewardsCMS) {
                if (item.id === Item.rewardId) {
                    value_spin = Item.value_spin
                    if (Item.numOfFreeSpins) {
                        numOfFreeSpins = Item.numOfFreeSpins.toString() + (item.rewardType === 1 ? 'FS' : item.rewardType === 9 ? 'MS' : '')
                    } else {
                        numOfFreeSpins = ''
                    }

                }
            }

            ITEM = {
                id: item['id'],
                Reward: item['name'],
                // ['Reward intent']: rewardIntent,
                ['Reward type']: /* rewardType, */ item['rewardType'],
                type: injectSpaces(RewardTypes[item['rewardType']]),
                // categories,
                category: 1,
                reward: { category1: item['reward'].category1, description: item['reward'].description },
                valueSpin: value_spin,
                numOfFreeSpins
                // rewards,
            }
        } else {
            if (item['reward'].category1) { categories += '1 ' }
            if (item['reward'].category2) { categories += '2 ' }
            if (item['reward'].category3) { categories += '3 ' }

            if (item['rewardIntent']) {
                for (const Item of item['rewardIntent']) {
                    if (rewardIntent.length > 0) {
                        rewardIntent += ', '
                    }
                    if (rewards.length > 0) {
                        rewards += ','
                    }
                    rewardIntent += Assets_.RewardIntent[Item]
                    rewards += Item
                }
            }

            let rewardType = 'Unknown'
            const rewardTypes = Object.keys(RewardTypes)
            if (item['rewardType']) {
                for (let i: number = 0; i < rewardTypes.length / 2; i++) {
                    if (i === parseInt(item['rewardType']) - 1) {
                        rewardType = rewardTypes[rewardTypes.length / 2 + i + 1]
                    }
                }
            }

            ITEM = {
                id: item['id'],
                Reward: item['name'],
                ['Reward intent']: rewardIntent,
                ['Reward type']: rewardType,
                categories,
                category: 0,
                reward: item['reward'],
                rewards,
            }
        }

        let index = -1
        for (let i: number = 0; i < Main.Instance.DatabaseDataState.rewardShopStream.length; i++) {
            if (Main.Instance.DatabaseDataState.rewardShopStream[i].id === item.id) {
                index = i
                break
            }
        }
        if (index > - 1) {
            const rewardShopStream = Object.assign([], Main.Instance.DatabaseDataState.rewardShopStream)
            rewardShopStream[index] = ITEM
            Logic.Type.New(Main.Instance.DatabaseDataState, { rewardsNewUpdate: true, rewardShopStream })
        } else {
            Logic.Type.New(Main.Instance.DatabaseDataState, { rewardsNewUpdate: true })
        }
        Socket1.socket.Send(Config.amUpdateReward, item)
        insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Rewards', item)
    }
}

function WSdeleteReward(id: number) {
    if (Main.Instance.DatabaseDataState.rewardsNewDelete === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { rewardsNewDelete: true })
        Socket1.socket.Send(Config.amDeleteReward, { id })
        insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Rewards', { id })
    }
}

export function wsInsertReward() {
    if (Main.Instance.DatabaseDataState.rewardsNewInsert === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amInsertReward) && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertReward).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { rewardsNewInsert: false, rewardsNewGet: true/*, rewardsNewGetAll: true*/ })
        WsGetRewards()
        Rewards.InsertLastPage()
    }
}

export function wsUpdateReward() {
    if (Main.Instance.DatabaseDataState.rewardsNewUpdate === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateReward) && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateReward).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { rewardsNewUpdate: false/*, rewardsNewGet: true/*, rewardsNewGetAll: true*/ })
        Rewards.Update()
    }
}

export function wsDeleteReward() {
    if (Main.Instance.DatabaseDataState.rewardsNewDelete === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteReward) && Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteReward).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { rewardsNewDelete: false, rewardsNewGet: true/*, rewardsNewGetAll: true*/ })
        WsGetRewards()
    }
}

export function wsDeleteMission() {
    if (Main.Instance.DatabaseDataState.missionsNewDelete &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteMission) && Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteMission).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { missionsNewDelete: false, missionsNewGet: true, missionsNewGetAll: true })
        WsGetMissions()
    }
}

function WSdeleteMission(id: number) {
    if (!Main.Instance.DatabaseDataState.missionsNewDelete) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { missionsNewDelete: true })
        Socket1.socket.Send(Config.amDeleteMission, { id })
        if (IsBuildMyChance()) {
            insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Chances', { id })
        } else {
            insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Missions', { id })
        }
    }
}

export function WsGetMissions() {
    Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).loading = 'init'
    // Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionsAll).loading = 'init'
    Socket1.socket.Send(Config.amGetMissions, {/*limit: Main.Instance.MissionState.pSize, offset: +Main.Instance.MissionState.offset*/ })
    Socket1.socket.Send(Config.amGetMissionsAll, {})
    getLoadedResources('Socket1 - Send', Config.amGetMissions)
    getLoadedResources('Socket1 - Send', Config.amGetMissionsAll)
}

export function wsGetMissions() {
    
    if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).resolved) {
        if (!Main.Instance.DatabaseDataState.missionsNew || Main.Instance.DatabaseDataState.missionsNewGet) {
            
            if (Main.Instance.DatabaseDataState.missionIdDuplicate === -1) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    missionsNew: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).message,
                    missionsNew_: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).message,
                    missionsNewGet: false,
                    missionsNewCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).message.length,
                    missionStreamAll: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).message,
                })
            } else {     
                if (Main.Instance.DatabaseDataState.missionIdDuplicate !== -1) {

                    let mission: IMissionDefinition2
                    let newMission: IMissionDefinition2
                    for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).message) {

                        if (item.id === Main.Instance.DatabaseDataState.missionIdDuplicate) {
                            mission = Object.assign({}, item)
                        }
                        let found: boolean = false
                        for (const Item of Main.Instance.DatabaseDataState.missionsNew_) {
                            

                            if (item.id === Item.id) {

                                found = true
                            }
                        }
                        if (found === false) {
                            newMission = Object.assign({}, item)
                            
                        }                       
                    }

                    if (newMission) {

                        newMission.tasks = [...mission.tasks]
                        WSupdateMission(newMission)
                    }
                    
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    missionsNew: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).message,
                    missionsNewGet: false,
                    missionsNewCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).message.length,
                    missionStreamAll: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).message,
                    missionIdDuplicate: -1
                })
            }
            
            getLoadedResources('Socket1 - Get', Config.amGetMissions)
        }
    }
}

/*
export function wsGetMissions() {
    // console.log ('wsGetMissions')
    if (Main.Instance.DatabaseDataState.missionStream === undefined || Main.Instance.DatabaseDataState.missionsNewGet) {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).loading === 'loaded') {

            // console.log ('wsGetMissions2')

            // if (count) {
            const missionStream: any[] = Object.assign([], Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissions).message)
            // console.log (missionStream)
            const MissionStream: any[] = []
            // console.log (Main.Instance.DatabaseDataState.missionStreamAll)
            // '1 '
            for (const item of missionStream) {
                let tasks: string = ''
                if (item['tasks']) { for (let i: number = 0; i < item['tasks'].length; i++) { tasks += (i + 1).toString() + ' ' } }
                // let nm: string = '' for (let Item of Main.Instance.DatabaseDataState.missionStreamAll) if (item['nextmission'] === Item['id']) { nm = Item['name']; break}
                // console.log (item)
                // console.log (item['hiddenRewards'])

                // let validFrom = item['validFrom'].toString()
                // let from = validFrom.substring(0,10) + ' ' + validFrom.substring(11,19)
                // let validTo = item['validTo'].toString()
                // let to = validTo.substring(0,10) + ' ' + validTo.substring(11,19)

                // console.log ('tasks')
                // console.log (item['tasks'])
                MissionStream.push({
                    id: item['id'],
                    order: item['missionOrder'],
                    name: item['name'],
                    description: item['description'],
                    // 'Valid from (' + Assets_.UTC + ')': from,
                    // 'Valid to (' + Assets_.UTC + ')': to,
                    tasks,
                    task_id: 0,
                    task: item['tasks'] ? item['tasks'] : [],
                    hr: item['hiddenRewards'] ? item['hiddenRewards'] : [],
                    mt: +item['maxTimes'],
                })
            }
            // console.log ('wsGetMissions3')
            Logic.Type.New(Main.Instance.DatabaseDataState, { missionStream: MissionStream, missionsNewGet: false })
            // }
        }
    }
}
*/
export function wsInsertMission() {
    if (Main.Instance.DatabaseDataState.missionsNewInsert &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amInsertMission) && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertMission).loading === 'loaded') {

        Logic.Type.New(Main.Instance.DatabaseDataState, { missionsNewInsert: false, missionsNewGet: true, missionsNewGetAll: true })
        WsGetMissions()
        Missions.InsertLastPage()
    }
}

export function wsUpdateMission() {
    if (Main.Instance.DatabaseDataState.missionsNewUpdate &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateMission) && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateMission).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { missionsNewUpdate: false, missionsNewGet: true, missionsNewGetAll: true })
        WsGetMissions()
        Missions.Update()
    }
}

export function WSinsertMission(item: IMissionDefinition2) {
    if (!Main.Instance.DatabaseDataState.missionsNewInsert) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { missionsNewInsert: true })
        Socket1.socket.Send(Config.amInsertMission, item)
        if (IsBuildMyChance()) {
            insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Chances', item)
        } else {
            insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Missions', item)
        }
    }
}

export function WSupdateMission(item: IMissionDefinition2) {
    if (!Main.Instance.DatabaseDataState.missionsNewUpdate) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { missionsNewUpdate: true })
        Socket1.socket.Send(Config.amUpdateMission, item)
        if (IsBuildMyChance()) {
            insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Chances', item)
        } else {
            insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Missions', item)
        }
    }
}

export function WSinsertMissionOld(item) {
    if (!Main.Instance.DatabaseDataState.missionsNewInsert) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { missionsNewInsert: true })
        Socket1.socket.Send(Config.amInsertMission, item)
    }
}

export function WSupdateMissionOld(item) {
    if (!Main.Instance.DatabaseDataState.missionsNewUpdate) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { missionsNewUpdate: true })
        Socket1.socket.Send(Config.amUpdateMission, item)
    }
}

export function WsGetTournaments() {
    Socket1.socket.Send(Config.amGetTournaments, {/*limit: Main.Instance.TournamentState.pSize, offset: +Main.Instance.TournamentState.offset*/ })
    Socket1.socket.Send(Config.amGetTournamentsAll, {})
    getLoadedResources('Socket1 - Send', Config.amGetTournaments)
    getLoadedResources('Socket1 - Send', Config.amGetTournamentsAll)
}

export function wsInsertTournament() {
    if (Main.Instance.DatabaseDataState.tournamentsNewInsert === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amInsertTournament) && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertTournament).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentsNewInsert: false, tournamentsNewGet: true, tournamentsNewGetAll: true })

        if (Socket1.socket.Get<RouteClasses.Route>(Config.amInsertTournament).resolved === false && Socket1.socket.Get<RouteClasses.Route>(Config.amInsertTournament).message) {
            alert(Socket1.socket.Get<RouteClasses.Route>(Config.amInsertTournament).message)

        }
        WsGetTournaments()
        TournamentsOddyzzey.InsertLastPage()
    }
}

export function wsUpdateTournament() {
    if (Main.Instance.DatabaseDataState.tournamentsNewUpdate === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateTournament) && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateTournament).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentsNewUpdate: false, tournamentsNewGet: true, tournamentsNewGetAll: true })
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateTournament).resolved === false && Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateTournament).message) {
            alert(Socket1.socket.Get<RouteClasses.Route>(Config.amUpdateTournament).message)
        }
        WsGetTournaments()
        TournamentsOddyzzey.Update()
    }
}

function WSInsertTournament(tournament: any) {
    if (Main.Instance.DatabaseDataState.tournamentsNewInsert === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentsNewInsert: true })
        Socket1.socket.Send(Config.amInsertTournament, tournament)
        if (TournamentsOddyzzey.isLocationRaces()) {
            insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Races', tournament)
        } else {
            insertAdminLog(Config.asAdminLogSaveInsert, 'Gamification -> Tournaments', tournament)
        }
    }
}

function WSUpdateTournament(tournament: any) {
    if (Main.Instance.DatabaseDataState.tournamentsNewUpdate === false) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentsNewUpdate: true })
        // console.log ('before update')
        // console.log (JSON.stringify(tournament))
        // console.log(tournament)
        Socket1.socket.Send(Config.amUpdateTournament, tournament)
        if (TournamentsOddyzzey.isLocationRaces()) {
            insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Races', tournament)
        } else {
            insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Tournaments', tournament)
        }
    }
}

function WSdeleteTournament(id: number) {
    if (!Main.Instance.DatabaseDataState.tournamentsNewDelete) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentsNewDelete: true })
        Socket1.socket.Send(Config.amDeleteTournament, { id })
        if (TournamentsOddyzzey.isLocationRaces()) {
            insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Races', { id })
        } else {
            insertAdminLog(Config.asAdminLogDelete, 'Gamification -> Tournaments', { id })
        }
    }
}

export function wsDeleteTournament() {
    if (Main.Instance.DatabaseDataState.tournamentsNewDelete === true &&
        Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteTournament) && Socket1.socket.Get<RouteClasses.Route>(Config.amDeleteTournament).loading === 'loaded') {
        Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentsNewDelete: false, tournamentsNewGet: true, tournamentsNewGetAll: true })
        WsGetTournaments()
    }
}

export function wsGetTournaments() {
    if (Main.Instance.DatabaseDataState.tournamentStream === undefined || Main.Instance.DatabaseDataState.tournamentsNewGet || Main.Instance.DatabaseDataState.tournamentStream.length === 0) {
        if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournaments) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournaments).loading === 'loaded') {
            const TournamentStream: Tournament[] = []
            if (Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournaments).message) {
                for (const item of Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournaments).message) {
                    const maxRounds = +item.maxRounds > 0 ? item.maxRounds : '∞'
                    let tt = ''
                    if (+item.tournamentType === 1) { tt = 'Daily' }
                    if (+item.tournamentType === 2) { tt = 'Special' }
                    if (+item.tournamentType === 3) { tt = 'Races' }
                    const now: string = new Date().toISOString()
                    let tournament_current
                    if (item && item.validFrom && now.substring(0, 10) <= item.validFrom.substring(0, 10)) { tournament_current = 2 } else if (item && item.validTo && now.substring(0, 10) <= item.validTo.substring(0, 10)) { tournament_current = 0 } else { tournament_current = 1 }
                    TournamentStream.push({
                        id: item.id,
                        name: item.name,
                        description: item.description,
                        tournament_current,
                        validFrom: item.validFrom ? item.validFrom.substring(0, 10) + ' ' + item.validFrom.substring(11, 19) : '',
                        validTo: item.validTo ? item.validTo.substring(0, 10) + ' ' + item.validTo.substring(11, 19) : '',
                        leaderboardType: item.leaderboardType,
                        tournamentType: tt, // 'T. Type'
                        rounds: item.minRounds + ' - ' + maxRounds,
                        minRounds: item.minRounds,
                        maxRounds: item.maxRounds,
                        points: item.points,
                        optIn: item.optIn,
                        minMaxBets: item.minMaxBets,
                        validGames: item.validGames,
                        prizes: item.prizes,
                        invalidGames: item.invalidGames,
                        active: item.active,
                        raceDetails: item.raceDetails
                    })
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentStream: TournamentStream, tournamentsNewGet: false, tournamentStream_: Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournaments).message })
                getLoadedResources('Socket1 - Get', Config.amGetTournaments)
            }
        }

    }
}

export function getTournamentResults(tournamentId: number) {
    Logic.Type.New(Main.Instance.TournamentState, { modeLeaderboard: true })
    Socket1.socket.Send('tournament-results', { id: tournamentId })
    getLoadedResources('Socket1 - Send', 'tournament-results')
}

export function wsGetTournamentResults() {
    if (Main.Instance.TournamentState.modeLeaderboard.toString() === 'true' && Socket1.socket.Get<RouteClasses.Route>('tournament-results') &&
        Socket1.socket.Get<RouteClasses.Route>('tournament-results').loading === 'loaded') {
        Logic.Type.New(Main.Instance.TournamentState, { modeLeaderboard: false })
        Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentLeaderboard: Socket1.socket.Get<RouteClasses.Route>('tournament-results').message })
        getLoadedResources('Socket1 - Get', 'tournament-results')
    }
}

export function getDailyTournamentResults(tournamentId: number, date: string) {
    // console.log ('getDailyTournamentResults')
    Logic.Type.New(Main.Instance.TournamentState, { modeLeaderboard: true })
    Socket1.socket.Send('daily-tournament-results', { id: tournamentId, date })
    getLoadedResources('Socket1 - Send', 'daily-tournament-results')
}

export function wsGetDailyTournamentResults() {
    if (Main.Instance.TournamentState.modeLeaderboard.toString() === 'true' && Socket1.socket.Get<RouteClasses.Route>('daily-tournament-results') &&
        Socket1.socket.Get<RouteClasses.Route>('daily-tournament-results').loading === 'loaded') {
        Logic.Type.New(Main.Instance.TournamentState, { modeLeaderboard: false })
        Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentLeaderboard: Socket1.socket.Get<RouteClasses.Route>('daily-tournament-results').message })
        getLoadedResources('Socket1 - Get', 'daily-tournament-results')
    }
}

export function wsInitialize() {

    // store all
    if ((Main.Instance.DatabaseDataState.storeStreamAll === undefined || Main.Instance.DatabaseDataState.storesNewGetAll)
        && Socket1.socket.Get<RouteClasses.Route>(Config.amGetStoresAll) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetStoresAll).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetStoresAll).message) {
        Logic.Type.New(Main.Instance.StoreState, {
            count: Socket1.socket.Get<RouteClasses.Route>(Config.amGetStoresAll).message.length
        })

        Logic.Type.New(Main.Instance.DatabaseDataState, {
            storesNewGetAll: false,
            storeStreamAll: Socket1.socket.Get<RouteClasses.Route>(Config.amGetStoresAll).message
        })
        getLoadedResources('Socket1 - Get', Config.amGetStoresAll)
    }

    // challenges all
    if ((Main.Instance.DatabaseDataState.challengesAllStream === undefined || Main.Instance.DatabaseDataState.challengesNewGetAll)
        && Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallengesAll) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallengesAll).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallengesAll).message) {

        Logic.Type.New(Main.Instance.ChallengeState, {
            count: Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallengesAll).message.length
        })

        Logic.Type.New(Main.Instance.DatabaseDataState, {
            challengesAllStream: Socket1.socket.Get<RouteClasses.Route>(Config.amGetChallengesAll).message,
            challengesNewGetAll: false
        })
        getLoadedResources('Socket1 - Get', Config.amGetChallengesAll)
    }

    // tournaments all

    if ((Main.Instance.DatabaseDataState.tournamentStreamAll === undefined || Main.Instance.DatabaseDataState.tournamentsNewGetAll || Main.Instance.DatabaseDataState.tournamentStreamAll.length === 0)
        && Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentsAll) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentsAll).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentsAll).message) {

        Logic.Type.New(Main.Instance.TournamentState, {
            count: Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentsAll).message.length
        })

        Logic.Type.New(Main.Instance.DatabaseDataState, {
            tournamentsNewGetAll: false,
            tournamentStreamAll: Socket1.socket.Get<RouteClasses.Route>(Config.amGetTournamentsAll).message
        })
        getLoadedResources('Socket1 - Get', Config.amGetTournamentsAll)
    }

    // levels all

    if ((Main.Instance.DatabaseDataState.levelsAllStream === undefined || Main.Instance.DatabaseDataState.levelsNewGetAll)
        && Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevelsAll) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevelsAll).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevelsAll).message) {

        Logic.Type.New(Main.Instance.CRMLevelsState, {
            count: Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevelsAll).message.length
        })

        Logic.Type.New(Main.Instance.DatabaseDataState, {
            levelsAllStream: Socket1.socket.Get<RouteClasses.Route>(Config.amGetLevelsAll).message,
            levelsNewGetAll: false
        })
        getLoadedResources('Socket1 - Get', Config.amGetLevelsAll)
    }

    // missions all
    if ((Main.Instance.DatabaseDataState.missionStreamAll === undefined || Main.Instance.DatabaseDataState.missionsNewGetAll)
        && Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionsAll) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionsAll).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionsAll).message) {

        Logic.Type.New(Main.Instance.MissionState, {count: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionsAll).message.length})
        Logic.Type.New(Main.Instance.DatabaseDataState, {
            missionsNewGetAll: false,
            missionStreamAll: Socket1.socket.Get<RouteClasses.Route>(Config.amGetMissionsAll).message
        })

    
        getLoadedResources('Socket1 - Get', Config.amGetMissionsAll)
    }

    // rewards all
    // console.log(Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewardsAll))
    if ((Main.Instance.DatabaseDataState.rewardShopStreamAll === undefined || Main.Instance.DatabaseDataState.rewardsNewGetAll)
        && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewardsAll) && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewardsAll).loading === 'loaded' && Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewardsAll).message) {

        Logic.Type.New(Main.Instance.DatabaseDataState, {
            rewardShopCount: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewardsAll).message.length,
            rewardsNewGetAll: false,
            rewardShopStreamAll: Socket1.socket.Get<RouteClasses.Route>(Config.amGetRewardsAll).message
        })
        getLoadedResources('Socket1 - Get', Config.amGetRewardsAll)
        if (Main.Instance.FrontendStoreState.Category2 === undefined) {
            const category: string[] = []
            const Category: Option[] = []
            const Category2: Option[] = []
            const Category3: Option[] = []
            const Category4: Option[] = []

            Category.push({ id: '0', name: Assets.SelectReward })
            Category3.push({ id: '0', name: 'Any Intent' })
            if (!IsBuildMyChance()) {
                Category4.push({ id: '0', name: 'Any Reward Type' })
            }


            for (let i: number = 0; i < 4; i++) {
                Category2.push({ id: i.toString(), name: i === 0 ? Assets.Description : i.toString() })
            }

            for (let i: number = 0; i < Object.keys(Assets_.RewardIntent).length / 2; i++) {
                Category3.push({ id: (i + 1).toString(), name: Assets_.RewardIntent[i] })
            }
            if (IsBuildMyChance()) {
                for (let i: number = 0; i < Object.keys(RewardTypes).length / 2; i++) {
                    if (i === 1 || i === 2 || i === 3 || i === 9 || i === 10) {
                        Category4.push({ id: i.toString(), name: RewardTypes[i] })
                        Category.push({ id: i.toString(), name: injectSpaces(RewardTypes[i]) })
                    }

                }
            } else {
                const rewardTypes = Object.keys(RewardTypes)
                for (let i: number = 0; i < rewardTypes.length / 2; i++) {
                    category.push(rewardTypes[rewardTypes.length / 2 + i])
                    Category4.push({ id: Category4.length.toString(), name: rewardTypes[rewardTypes.length / 2 + i] })
                }
                for (const item of category) {
                    Category.push({ id: Category.length.toString(), name: item })
                }
            }

            category.sort(byName)
            Logic.Type.New(Main.Instance.FrontendStoreState, { Category4, Category3, Category2, Category })
        }
    }
}

export function UploadGame() { }

export function PromostoreGetPlayers() {
    promostoreGetPlayers(0)
}
// Logic
function promostoreGetPlayers(which: number, playerData?: any[]) {

    axios.get(Config.psLevelsAllDetailsBySite + '?site_id=' + Main.Instance.FrontendStoreState.site_id)
        .then((response0) => {

            if (response0.data) {
                const data: any[] = []
                const sublevels: number[] = []
                for (const level of response0.data) {
                    if (level.sublevels) { sublevels.push(parseInt(level.sublevels)) }
                    data.push({
                        id: level.hierarchy,
                        level: level.hierarchy,
                        name: level.name,
                        prte: level.prte,
                        sublevels: level.sublevels,
                        level_value: level.level_value,
                        stagnation: level.stagnation,
                        reward_every: level.reward_every,
                        final_level: level.final_level,
                    })
                    if (level.final_level !== undefined && level.final_level.toString() === 'true') { break }
                }

                const Which: string = '&which=' + which.toString()
                const Which_: string = '?which=' + which.toString()

                let Level: string = ''

                if (parseInt(Main.Instance.ReportPState.filter_level) > 0) {
                    Level = '&level=' + Main.Instance.ReportPState.filter_level

                }

                let slMin: string = ''
                if (parseInt(Main.Instance.ReportPState.filter_level) > 0 && Main.Instance.ReportPState.sublevel_min > 0) {
                    slMin = '&slmin=' + Main.Instance.ReportPState.sublevel_min.toString()
                }

                let slMax: string = ''
                if (parseInt(Main.Instance.ReportPState.filter_level) > 0 && Main.Instance.ReportPState.sublevel_max > 0) {
                    slMax = '&slmax=' + Main.Instance.ReportPState.sublevel_max.toString()
                }

                let Search: string = ''

                const search: string | undefined = Main.Instance.SearchState.search_string &&
                    Main.Instance.SearchState.search_string.length > 0 ?
                    Main.Instance.SearchState.search_string.toLowerCase() : undefined

                if (search) {
                    Search = '&search=' + search
                }

                let Sort: string = ''
                if (which === 0) {
                    if (Main.Instance.ReportPState.sort.length > 0 &&
                        Main.Instance.ReportPState.Sort.length === Main.Instance.ReportPState.sort.length) {
                        Sort = '&sort='
                        for (let i: number = 0; i < Main.Instance.ReportPState.sort.length; i++) {
                            Sort += Main.Instance.ReportPState.Sort[i] + '|'
                            Sort += Main.Instance.ReportPState.sort[i] % 100 + '|'
                        }
                    }
                }

                let str: string = Config.psPlayer
                if (which === 2) {
                    str += Which_ + Level + slMin + slMax + Search
                } else if (which === 1) {
                    str += Which_ + Level + slMin + slMax + Search
                } else if (which === 0) {
                    str += '?limit=9999999999' // + Main.Instance.ReportPState.pSize.toString()
                        + '&offset=' + Main.Instance.ReportPState.offset
                        + Sort + Which + Level + slMin + slMax + Search
                }

                if (which === 0) {

                    axios.get(str).then((response) => {
                        if (response.data.return.length === 0) {
                            Logic.Type.New(Main.Instance.ReportPState, {
                                countCalled: false,
                                count: 0,
                                sublevels,
                                Data: [],
                            })
                        } else {
                            const str2: string = Config.psPlayerStats + Which_ + Level + slMin + slMax + Search
                            axios.get(str2).then((response2) => {
                                let level: number
                                for (const player of response.data.return) {
                                    if (!player) { continue }
                                    level = parseInt(player.level_)
                                    // current = parseInt(player.level_current)

                                    player.level_ = data[level - 1] ? data[level - 1].sublevels > 0 ?
                                        data[level - 1] && data[level - 1].name + ' ' + (+player.sublevel_ < 10 ? '0' + player.sublevel_ : player.sublevel_) :
                                        data[level - 1].name : 'Unknown'
                                    player.sublevel_ = level < data.length ? data[level - 1] < 10 ?
                                        data[level - 1].final_level === true ? 0 : 1 : 0 : 0
                                }

                                const footer: string[] = []
                                if (parseInt(response2.data.return.count) > 0) {
                                    for (let i: number = 1; i <= Assets_.PLAYER_STATS_FIELDS; i++) {
                                        if (i === 1) {
                                            footer.push(Assets.s1)
                                        } else if (i === 6 || i === 7) {
                                            footer.push(Assets_.NA)
                                        } else if (i === 10) {
                                            const level0: number = Math.floor(response2.data.return['s10'] / 100) - 1
                                            if (data[level0] && data[level0].final_level === true) {
                                                footer.push(data[level0].name.toUpperCase())
                                            } else if (data[level0] && data[level0].name) {
                                                footer.push(data[level0].name.toLowerCase() + ' ' + response2.data.return['s10'] % 100)
                                            }
                                        } else if (i === 11) {
                                            const level0: number = Math.floor(response2.data.return['s11'] / 100) - 1
                                            if (data[level0] && data[level0].final_level === true) {
                                                footer.push(data[level0].name.toUpperCase())
                                            } else if (data[level0] && data[level0].name) {
                                                footer.push(data[level0].name.toLowerCase() + ' ' + response2.data.return['s11'] % 100)
                                            }
                                        } else if (i === 12) {
                                            footer.push(DateAddZeros(response2.data.return['s12'] ? response2.data.return['s12'].toString() : 'unknown'))
                                        } else if (i === 13) {
                                            footer.push(DateAddZeros(response2.data.return['s13'] ? response2.data.return['s13'].toString() : 'unknown'))
                                        } else { footer.push(response2.data.return['s' + i.toString()]) }
                                    }

                                    for (let i: number = 1; i <= Assets_.PLAYER_STATS_FIELDS; i++) {
                                        if (i === 1) {
                                            footer.push(Assets.a1)
                                        } else if (i === 10) {
                                            const level0: number = Math.floor(response2.data.return['a10'] / 100) - 1
                                            if (data[level0] && data[level0].final_level === true) {
                                                footer.push(data[level0].name.toUpperCase())
                                            } else if (data[level0] && data[level0].name) {
                                                footer.push(data[level0].name.toLowerCase() + ' ' + response2.data.return['a10'] % 100)
                                            }
                                        } else if (i === 11) {
                                            const level0: number = Math.floor(response2.data.return['a11'] / 100) - 1
                                            if (data[level0] && data[level0].final_level === true && data[level0].name) {
                                                footer.push(data[level0].name.toUpperCase())
                                            } else if (data[level0] && data[level0].name) {
                                                footer.push(data[level0].name.toLowerCase() + ' ' + response2.data.return['a11'] % 100)
                                            }
                                        } else if (i === 12) {
                                            footer.push(DateAddZeros(response2.data.return['a12'] ? response2.data.return['a12'].toString() : 'unknown'))
                                            footer.push(DateAddZeros(response2.data.return['a12'] ? response2.data.return['a13'].toString() : 'unknown'))
                                        } else { footer.push(response2.data.return['a' + i.toString()]) }
                                    }
                                }
                                if (which === 0) {
                                    // sublevel_current
                                    Logic.Type.New(Main.Instance.ReportPState, {
                                        countCalled: false,
                                        count: parseInt(response2.data.return.count),
                                        sublevels,
                                        Data: isPureScandibet() ? response.data.return : response.data.return.slice(0, 2),
                                        // footer: footer !!! THINK ABOUT WHAT TO DO WITH THIS
                                    })
                                }
                            })
                                .catch((err) => alert(err))
                        }
                    })
                        .catch((err) => alert(err))
                } else {

                    if (playerData && playerData.length > 0) {
                        let level: number
                        // let current: number
                        const tempData: any[] = []
                        for (const temp of playerData) {
                            tempData.push({
                                playerid: temp.player,
                                tp: temp.xpl,
                                ap: temp.xp,
                                wagered: temp.amountWagered,
                                wagers: temp.counterWagers,
                                apbs: temp.apbs,
                                // median: temp.median,
                                won: temp.amountWon,
                                wins: temp.counterWins,
                                level_: temp.level,
                                sublevel_: temp.sublevel,
                                event_first: temp.event_first,
                                event_last: temp.event_last,
                                localcurrency: temp.localcurrency,
                            })
                        }
                        playerData = Object.assign([], tempData)
                        let sortedData: any[] = []

                        const s: number[] = []
                        for (let ss: number = 0; ss < Assets_.PLAYER_STATS_FIELDS - 1; ss++) { s.push(0) }
                        for (const player of playerData) {
                            if (!player) { continue }
                            level = parseInt(player.level_)
                            player.level_ = data[level - 1] ? data[level - 1].sublevels > 0 ?
                                data[level - 1].name + ' ' + player.sublevel_ :
                                data[level - 1].name : 'Unknown'

                            player.sublevel_ = level < data.length ? data[level - 1] ?
                                data[level - 1].final_level === true ? 0 : 1 : 0 : 0

                            s[2] += player.wagered
                            s[3] += player.wagers
                            s[4] += player.apbs
                            // s[5] += player.median
                            s[6] += player.won
                            s[7] += player.wins
                            sortedData.push(player)
                        }

                        if (which === 1) {
                            if (Main.Instance.ReportPState1.Sort.length > 0) {
                                for (let i: number = Main.Instance.ReportPState1.Sort.length - 1; i >= 0; i--) {
                                    const item: string = Main.Instance.ReportPState1.Sort[i]
                                    const sortType = item === 'playerid' ? 0 : 1
                                    const sortBy: string = item
                                    sortedData = SortData(sortedData, Main.Instance.ReportPState1.sort[i] % 100, sortType, sortBy)
                                }
                            }
                        } else if (which === 2) {
                            if (Main.Instance.ReportPState2.Sort.length > 0) {
                                for (let i: number = Main.Instance.ReportPState2.Sort.length - 1; i >= 0; i--) {
                                    const item: string = Main.Instance.ReportPState2.Sort[i]
                                    const sortType = item === 'playerid' ? 0 : 1
                                    const sortBy: string = item
                                    sortedData = SortData(sortedData, Main.Instance.ReportPState2.sort[i] % 100, sortType, sortBy)
                                }
                            }
                        }

                        // prepare footer object
                        const footer: string[] = []

                        const a: number[] = []
                        for (const ss of s) {
                            a.push(ss / playerData.length)
                        }

                        if (playerData && playerData.length > 0) {
                            for (let i: number = 1; i <= Assets_.PLAYER_STATS_FIELDS; i++) {
                                if (i === 1) {
                                    footer.push(Assets.s1)
                                } else if (i === 6 || i === 7) {
                                    footer.push(Assets_.NA)
                                } else if (s[i - 2] !== undefined) { footer.push(s[i - 2].toFixed(2)) }
                            }

                            for (let i: number = 1; i <= Assets_.PLAYER_STATS_FIELDS; i++) {
                                if (i === 1) {
                                    footer.push(Assets.a1)
                                } else if (a[i - 2] !== undefined) { footer.push(a[i - 2].toFixed(2)) }
                            }
                        }

                        if (which === 1) {
                            Logic.Type.New(Main.Instance.ReportPState, {
                                countCalled: false,
                                count1: playerData.length,
                                sublevels,
                                offset1: '0',
                                pNum1: 0,
                                Data1: sortedData.slice(0, Main.Instance.ReportPState.pSize1),
                                data1: sortedData,
                                data1Copy: playerData,
                                footer1: footer,
                            })
                        } else if (which === 2) {
                            Logic.Type.New(Main.Instance.ReportPState, {
                                countCalled: false,
                                count2: playerData.length,
                                sublevels,
                                offset2: '0',
                                pNum2: 0,
                                Data2: sortedData.slice(0, Main.Instance.ReportPState.pSize2),
                                data2: sortedData,
                                data2Copy: playerData,
                                footer2: footer,
                            })
                        }
                    }
                }
            }
        }).catch((err) => alert(err))
}
/*
export function getEventDistinctDates() {
  axios.get(Config.promostoreserver + '/event-distinct-dates/')
  .then((response) => PromostoreGetPlayers())
  .catch(err => alert(err))
}
*/
function SortData(data: any[], direction: number, sortType: number, sort: string): any[] {
    if (sortType === 0) {
        data.sort((a, b) => {
            if (a[sort] < b[sort]) { return -1 } else if (a[sort] > b[sort]) { return 1 } else { return 0 }
        })
    } else {
        data.sort((a, b) => {
            return a[sort] - b[sort]
        })
    }

    if (sortType === 0) {
        if (direction === 1) { return data } else { return data.reverse() }
    } else {
        if (direction === 1) { return data.reverse() } else { return data }
    }
}

export function getEventPlayer(player: string, playerLastEventDate: string, playerCurrency: string, playerPoints: number) {

    const query: string = '?player=' + player
    let arg: string = ''

    if (parseInt(Main.Instance.ReportPState.filter_type) > 0) {
        arg += '&type=' + Main.Instance.ReportPState.filter_type
    }

    if (parseInt(Main.Instance.ReportPState.filter_processed) > 0) {
        arg += '&processed=' + Main.Instance.ReportPState.filter_processed
        arg += '&lasteventdate=' + playerLastEventDate
    }

    if (Main.Instance.ReportPState.fromDate && Main.Instance.ReportPState.fromDate.length > 0) {
        arg += '&date1=' + Main.Instance.ReportPState.fromDate
    }

    if (Main.Instance.ReportPState.toDate && Main.Instance.ReportPState.toDate.length > 0) {
        arg += '&date2=' + Main.Instance.ReportPState.toDate
    }

    if (Main.Instance.ReportPState.fromTime && Main.Instance.ReportPState.fromTime.length > 0) {
        arg += '&time1=' + Main.Instance.ReportPState.fromTime
    }

    if (Main.Instance.ReportPState.toTime && Main.Instance.ReportPState.toTime.length > 0) {
        arg += '&time2=' + Main.Instance.ReportPState.toTime
    }

    const str: string = Config.psEventsPlayer + query + arg

    axios.get(str).then((response) => {
        const data: any[] = []

        for (const item of response.data.msg.message.events) {
            if (item.activity === 'Bethard' && item.gamerefid === 'Sportsbook' && !item.odds) {
                continue
            }
            if (item.odds) { item.custom = item.odds } else { item.custom = Assets_.NA }

            if (data.length > 0 && data[data.length - 1].merged === false
                && data[data.length - 1].aggregate_time === item.time
                && data[data.length - 1].timestamp === item.date
                && item.eventtype === 'win'
                && (data[data.length - 1].eventtype === 'wager' || data[data.length - 1].eventtype === 'buy-in')) {
                data[data.length - 1].eventtype2 = item.eventtype
                data[data.length - 1].sourcevalue2 = item.amountWon
                data[data.length - 1].net = parseFloat(item.amountWon) + data[data.length - 1].net
                data[data.length - 1].points_total += item.points
                data[data.length - 1].merged = true
            } else if (data.length > 0 && data[data.length - 1].merged === false
                && data[data.length - 1].aggregate_time === item.time
                && data[data.length - 1].timestamp === item.date
                && (item.eventtype === 'wager' || item.eventtype === 'buy-in')
                && (data[data.length - 1].eventtype2 === 'win')) {
                data[data.length - 1].eventtype = item.eventtype
                data[data.length - 1].sourcevalue = item.amountWagered
                data[data.length - 1].net = -parseFloat(item.amountWagered) + data[data.length - 1].net
                data[data.length - 1].points_total += item.points
                data[data.length - 1].merged = true
            } else {
                if (item.eventtype === 'wager' ||
                    item.eventtype === 'buy-in') {
                    data.push({
                        timestamp: item.date,
                        aggregate_time: item.time,
                        sourcevalue: item.amountWagered,
                        eventtype: item.eventtype,
                        custom: item.custom,
                        sourcevalue2: 0,
                        eventtype2: '',
                        net: -parseFloat(item.amountWagered),
                        points_total: item.points,
                        activityrefid: item.activity,
                        gamerefid: item.game,
                        merged: false,
                        withdrawal: 0,
                        deposit: 0,
                    })
                } else if (item.eventtype === 'payment-withdraw') {
                    data.push({
                        timestamp: item.date,
                        aggregate_time: item.time,
                        sourcevalue: 0,
                        eventtype: item.eventtype,
                        custom: item.custom,
                        sourcevalue2: 0,
                        eventtype2: '',
                        net: 0,
                        points_total: item.points,
                        activityrefid: item.activity,
                        gamerefid: item.game,
                        merged: false,
                        withdrawal: item.withdrawal,
                        deposit: 0,
                    })
                } else if (item.eventtype === 'payment-deposit') {
                    data.push({
                        timestamp: item.date,
                        aggregate_time: item.time,
                        sourcevalue: 0,
                        eventtype: item.eventtype,
                        custom: item.custom,
                        sourcevalue2: 0,
                        eventtype2: '',
                        net: 0,
                        points_total: item.points,
                        activityrefid: item.activity,
                        gamerefid: item.game,
                        merged: false,
                        withdrawal: 0,
                        deposit: item.deposit,
                    })
                } else if (item.eventtype === 'win') {
                    data.push({
                        timestamp: item.date,
                        aggregate_time: item.time,
                        sourcevalue: 0,
                        eventtype: '',
                        custom: item.custom,
                        sourcevalue2: item.amountWon,
                        eventtype2: item.eventtype,
                        net: +parseFloat(item.amountWon),
                        points_total: item.points,
                        activityrefid: item.activity,
                        gamerefid: item.game,
                        merged: false,
                        withdrawal: 0,
                        deposit: 0,
                    })
                }
            }
        }

        let sortedData: any[] = data
        if (Main.Instance.ReportPState3.Sort.length > 0) {
            for (let i: number = Main.Instance.ReportPState3.Sort.length - 1; i >= 0; i--) {
                const item: string = Main.Instance.ReportPState3.Sort[i]
                const sortType = item === 'timestamp' || item === 'aggregate_time' || item === 'activity' || item === 'game' ? 0 : 1
                let sortBy: string = item
                if (item === 'eventtype') { sortBy = 'sourcevalue' } else if (item === 'eventtype2') { sortBy = 'sourcevalue2' }
                sortedData = SortData(sortedData, Main.Instance.ReportPState3.sort[i] % 100, sortType, sortBy)
            }
        }

        // prepare footer object
        const footer: string[] = []

        if (data.length > 0) {
            for (let i: number = 0; i < Assets_.PLAYER_STATS_EVENTS; i++) {
                if (i === 1) { footer.push(Assets.s0[0]) } else if (i === 0) { footer.push(response.data.msg.message.overall.dateMin) } else if (i === 2) { footer.push(response.data.msg.message.overall.amountWagered.toFixed(2)) } else if (i === 3) { footer.push(Assets_.NA) } else if (i === 4) { footer.push(response.data.msg.message.overall.amountWon.toFixed(2)) } else if (i === 5) { footer.push(response.data.msg.message.overall.net.toFixed(2)) } else if (i === 6) { footer.push(response.data.msg.message.overall.points.toFixed(2)) } else if (i === 7) { footer.push('0.00') } else if (i === 8) { footer.push('0.00') } else if (i === 9) { footer.push(Assets_.NA) } else if (i === 10) { footer.push(Assets_.NA) } else if (i === 11) { footer.push(response.data.msg.message.overall.withdrawal.toFixed(2)) } else if (i === 12) { footer.push(response.data.msg.message.overall.deposit.toFixed(2)) }
            }

            for (let i: number = 0; i < Assets_.PLAYER_STATS_EVENTS; i++) {
                if (i === 1) { footer.push(Assets.a0[0]) } else if (i === 0) { footer.push(response.data.msg.message.overall.dateMax) } else if (i === 2 && response.data.msg.message.overall.counterWagers !== 0) {
                    footer.push((response.data.msg.message.overall.amountWagered / response.data.msg.message.overall.counterWagers).toFixed(2))
                } else if (i === 2) { footer.push(Assets_.NA) } else if (i === 3 && response.data.msg.message.overall.counterOdds !== 0) {
                    footer.push((response.data.msg.message.overall.odds / response.data.msg.message.overall.counterOdds).toFixed(2))
                } else if (i === 3) { footer.push(Assets_.NA) } else if (i === 4 && response.data.msg.message.overall.counterWins !== 0) {
                    footer.push((response.data.msg.message.overall.amountWon / response.data.msg.message.overall.counterWins).toFixed(2))
                } else if (i === 4) { footer.push(Assets_.NA) } else if (i === 5 && response.data.msg.message.overall.counterWagers !== 0) {
                    footer.push((response.data.msg.message.overall.net / response.data.msg.message.overall.counterWagers).toFixed(2))
                } else if (i === 5) { footer.push(Assets_.NA) } else if (i === 6 && response.data.msg.message.overall.counterWagers !== 0) {
                    footer.push((response.data.msg.message.overall.points / response.data.msg.message.overall.counterWagers).toFixed(2))
                } else if (i === 6) { footer.push(Assets_.NA) } else if (i === 7) { footer.push('0.00') } else if (i === 8) { footer.push('0.00') } else if (i === 9) { footer.push(Assets_.NA) } else if (i === 10) { footer.push(Assets_.NA) } else if (i === 11 && response.data.msg.message.overall.counterWithdrawal !== 0) {
                    footer.push((response.data.msg.message.overall.withdrawal / response.data.msg.message.overall.counterWithdrawal).toFixed(2))
                } else if (i === 11) { footer.push(Assets_.NA) } else if (i === 12 && response.data.msg.message.overall.counterDeposit !== 0) {
                    footer.push((response.data.msg.message.overall.deposit / response.data.msg.message.overall.counterDeposit).toFixed(2))
                } else if (i === 12) { footer.push(Assets_.NA) }
            }
        }

        sortedData.reverse()
        for (const item of sortedData) {
            const temp: number[] = TableUtils.getPercentageLevelSublevel(playerPoints)
            for (const Item of Main.Instance.DatabaseDataState.levelsAllStream) {
                if (Item['hierarchy'] === temp[0]) {
                    item.level = Item['name']
                }
            }
            item.sublevel = temp[1]
            item.percentage = temp[2]
            playerPoints -= item.points_total
        }
        Logic.Type.New(Main.Instance.ReportPState, {
            // countCalled: false,
            player,
            playerLastEventDate,
            playerCurrency,
            data: sortedData,
            pNum: 0,
            Data: sortedData,
            // Data: getData (sortedData, 0, Main.Instance.ReportPState.pSize),
            offset: '0',
            specificQuery: false,
            footer,
            Count: data.length,
        })
    }).catch((err) => alert(err))
}
/*
function getData(source: any[], offset: number, size: number) {
  return source.slice (offset, offset + size)
}
*/
export function getEvents(which: number) {
    const query: string = '?which=' + which.toString()
    let arg: string = ''
    if (Main.Instance.ReportPState.fromDate && Main.Instance.ReportPState.fromDate.length > 0) {
        arg += '&date1=' + Main.Instance.ReportPState.fromDate
    }

    if (Main.Instance.ReportPState.toDate && Main.Instance.ReportPState.toDate.length > 0) {
        arg += '&date2=' + Main.Instance.ReportPState.toDate
    }

    if (Main.Instance.ReportPState.fromDate2 && Main.Instance.ReportPState.fromDate2.length > 0) {
        arg += '&date3=' + Main.Instance.ReportPState.fromDate2
    }

    if (Main.Instance.ReportPState.toDate2 && Main.Instance.ReportPState.toDate2.length > 0) {
        arg += '&date4=' + Main.Instance.ReportPState.toDate2
    }

    if (Main.Instance.ReportPState.fromTime && Main.Instance.ReportPState.fromTime.length > 0) {
        arg += '&time1=' + Main.Instance.ReportPState.fromTime
    }

    if (Main.Instance.ReportPState.toTime && Main.Instance.ReportPState.toTime.length > 0) {
        arg += '&time2=' + Main.Instance.ReportPState.toTime
    }

    axios.get(Config.psEvents + query + arg).then((response) => {
        promostoreGetPlayers(which, response.data.msg.message)
    })
        .catch((err) => alert(err))
}

export function Toggle2(sql: string, id: string, toggle: string, callback: (id: string, toggle: string) => void) {
    axios.patch(Config.psToggle, { sql, id, toggle: toggle === 'true' ? true : false })
        .then((response) => callback(id, toggle))
}

export function Toggle(sql: string, id: string, toggle: string, callback?: () => void, toggle_?: boolean, row?: any) {
    // if (!toggle_ || toggle === 'false')
    if (row) {
        const data = Object.assign({}, row)
        data.active = !data.active
        insertAdminLog(Config.asAdminLogSaveEdit, 'User Management -> Manage Admin Users', data)
    }

    if (sql.startsWith('UPDATE lotto')) {
        axios.patch(Config.lsToggle, { sql, id, toggle }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (toggle_) {
                    axios.put(Config.lsToggle, { sql, id, toggle }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((response2) => {
                            if (callback) { callback() }
                        })
                } else if (callback) { callback() }
            })
            .catch((err) => alert(err))
    } else if (!sql.startsWith('UPDATE admin')) {

        axios.patch(Config.psToggle, { sql, id, toggle })
            .then((response) => {
                if (toggle_) {
                    axios.put(Config.psToggle, { sql, id, toggle })
                        .then((response2) => {
                            if (callback) { callback() }
                        })
                } else if (callback) {

                    callback()
                }
            })
            .catch((err) => alert(err))
    } else {
        
        axios.patch(Config.asToggle, { sql, id, toggle }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (toggle_) {
                    axios.put(Config.asToggle, { sql, id, toggle }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((response2) => {
                            if (callback) { callback() }
                        })
                } else if (callback) {


                    callback()
                }
            })
            .catch((err) => alert(err))

    }
}

export function Action(sql: string, id?: string, callback?: (arg?: string) => void, arg?: string) {

    if (!id) {
        if (sql.startsWith('UPDATE lotto')) {
            axios.put(Config.lsAction, { sql }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                .then((response) => {
                    if (callback && arg) { callback(arg) } else if (callback) { callback() }
                })
                .catch((err) => alert(err))
        } else if (!sql.startsWith('UPDATE admin')) {
            axios.put(Config.psAction, { sql })
                .then((response) => {
                    if (callback && arg) { callback(arg) } else if (callback) { callback() }
                })
                .catch((err) => alert(err))
        } else {
            axios.put(Config.asAction, { sql }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                .then((response) => {
                    if (callback && arg) { callback(arg) } else if (callback) { callback() }
                })
                .catch((err) => alert(err))
        }
    }

    if (sql.startsWith('UPDATE lotto')) {
        axios.put(Config.lsAction, { sql, id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (callback && arg) { callback(arg) } else if (callback) { callback() }
            })
            .catch((err) => alert(err))
    } else if (!sql.startsWith('UPDATE admin')) {
        axios.put(Config.psAction, { sql, id })
            .then((response) => {
                if (callback && arg) { callback(arg) } else if (callback) { callback() }
            })
            .catch((err) => alert(err))
    } else {
        axios.put(Config.asAction, { sql, id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (callback && arg) {

                    callback(arg)
                } else if (callback) {
                    callback()
                }
            })
            .catch((err) => alert(err))
    }
}

export function ActionSite(sql: string, site_id: string, callback?: (arg?: string) => void, arg?: string) {
    if (!sql.startsWith('UPDATE admin')) {
        axios.patch(Config.psAction, { sql, site_id })
            .then((response) => {
                if (callback && arg && !isNaN(response.data.returning)) { callback(arg) } else if (callback && !arg) { callback() }
            })
            .catch((err) => alert(err))
    } else {
        axios.patch(Config.asAction, { sql, site_id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (callback && arg && !isNaN(response.data.returning)) { callback(arg) } else if (callback && !arg) { callback() }
            })
            .catch((err) => alert(err))
    }
}

export function setDomain(domain: string) {
    if (!domain) { return }
    const subdomain: string = domain.split('.')[0].trim()
    if (!Main.Instance.LoginState.entity.trim().replace(/ /g, '').toLowerCase().startsWith(subdomain)) {
        alert(Assets.ThisShouldNotBePossible)
    } else {
        axios.patch(Config.asDomain, { subdomain, site_id: Main.Instance.FrontendStoreState.site_id })
            .then((response) => {
                if (parseInt(response.data.count) !== 0) {
                    alert(Assets.domainBelongsToAnotherSite)
                } else {
                    axios.put(Config.asDomain, { subdomain, site_id: Main.Instance.FrontendStoreState.site_id })
                        .then((response0) => {
                            alert(Assets.domainSuccessfullyUpdated)
                        })
                }
            })
    }
}
/*
export function createDomain (domain:string) {
  if (!domainExists(domain)) {
    axios.post(
        Config.asTestSite,
        {
        name: Main.Instance.LoginState.entity,
        site_id: Main.Instance.FrontendStoreState.site_id,
        show_game_info: true,
        show_version_info: true,
        show_debug_info: false,
        display_name: true,
        borders: true,
        groups : '{"' + Assets.Default + '"}',
        menus : '{"' + Assets.Default + '"}',
        menus_type : '{"0"}',
        subdomain: domain,
        },
        {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}}
    )

    Logic.Type.New (Main.Instance.FrontendStoreState, {
      title: Main.Instance.LoginState.entity,
      menus: [],
      menus_type: [],
      groups: [],
      show_version_info: true,
      show_game_info: true,
      show_debug_info: false,
      display_name: true,
      borders: true,
      subdomain: domain
    })

    let str: string = 'https://cloudflare.' + Config.server + '/subdomain?domain=' + Config.server + '&secret=' + Config.cloudflareSecret + '&subdomain=' + domain
    axios.post(str).then((response) => {getDomains(domain.trim())})
  }
}

export function domainExists (domain_:string) {
  if (domain_.length === 0
  || domain_.indexOf('.') !== -1 || domain_.indexOf('/') !== -1 || domain_.indexOf('!') !== -1
  || domain_.indexOf('?') !== -1 || domain_.indexOf('"') !== -1 || domain_.indexOf('\'') !== -1
  || domain_.indexOf(',') !== -1 || domain_.indexOf('\\') !== -1 || domain_.indexOf(' ') !== -1
  || domain_.indexOf(';') !== -1 || domain_.indexOf(':') !== -1 || domain_.indexOf('<') !== -1
  || domain_.indexOf('>') !== -1 || domain_.indexOf('*') !== -1 || domain_.indexOf('=') !== -1
  || domain_.indexOf('(') !== -1 || domain_.indexOf(')') !== -1 || domain_.indexOf('{') !== -1
  || domain_.indexOf('}') !== -1 || domain_.indexOf('[') !== -1 || domain_.indexOf(']') !== -1
  || domain_.indexOf('_') !== -1 || domain_.indexOf('-') !== -1 || domain_.indexOf('+') !== -1
  || domain_.indexOf('^') !== -1 || domain_.indexOf('&') !== -1 || domain_.indexOf('$') !== -1
  || domain_.indexOf('#') !== -1 || domain_.indexOf('@') !== -1 || domain_.indexOf('|') !== -1
  ) {
    alert (Assets.thisDomainIsInvalid)
    return true
  }

  let str: string = 'https://cloudflare.' + Config.server + '/subdomains?domain=' + Config.server + '&secret=' + Config.cloudflareSecret
  axios.get(str)
  .then((response) => {
    for (let i: number = 0; i < response.data.result.length; i++) {
      if (response.data.result[i].type !== 'A') {
        continue
      }

      let domain = response.data.result[i].name.split('.')[0].trim()
      if (domain === domain_) {
        alert (Assets.thisDomainAlreadyExists)
        return true
      }
    }
    return false
  })

  return false
}

export function getDomains (domain_?:string) {
  let str: string = 'https://cloudflare.' + Config.server + '/subdomains?domain=' + Config.server + '&secret=' + Config.cloudflareSecret

  axios.get(str)
  .then((response) => {
    let domains:any[] = []
    let domain_id:string
    for (let i:number = 0; response.data.result && i < response.data.result.length; i++) {
      if (response.data.result[i].type !== 'A') {
        continue
      }

      let domain = response.data.result[i].name.split('.')[0].trim()

      if (!Main.Instance.LoginState.entity.replace(/ /g,'').toLowerCase().startsWith(domain)) {
        continue
      }

      if (domain === 'admin' || domain === 'chat' || domain === 'cloudflare' || domain === 'gamanza' ||
          domain === 'games' || domain === 'git' || domain === 'goldminer' ||
          domain === 'media' || domain === 'roki' || domain === 'test-site' || domain === 'test-site-base' ||
          domain === 'wallet' || domain === 'wiki'|| domain === 'www' || domain === 'trttt' || domain === 'andrej'
      ) {
        continue
      }

      if (domain_ && domain === domain_ || !domain_ && domain === Main.Instance.FrontendStoreState.subdomain) {
        domain_id = domains.length.toString() + 1
      }

      domains.push({id:domains.length.toString() + 1, name: domain + '.' + Config.server})
    }

    Logic.Type.New (Main.Instance.DatabaseDataState, {domains: domains})

    if (domain_id) {
      Logic.Type.New (Main.Instance.FrontendStoreState, {domain_id: domain_id})
    }
  })
}
*/
/*
export function addDuplicate (instance: number, name: string, version: string, id: string,
                              callback: (a: number, b?: boolean) => void) {
  axios.post(DatabaseRoutes.get.CountGameInstances(), {
    name: name,
    version: version,
    id: id,
    site_id: Main.Instance.FrontendStoreState.site_id
  })
  .then ((response0) => {
    axios.post(DatabaseRoutes.get.GameInstance(), {
      name: name,
      version: version,
      id: id,
      site_id: Main.Instance.FrontendStoreState.site_id,
      instance: instance
    })
    .then ((response) => {
      axios.post(DatabaseRoutes.insert.GameDuplicate(), {
        name: name,
        version: version,
        id: id,
        site_id: Main.Instance.FrontendStoreState.site_id,
        badge: response.data.badge,
        group: response.data.group,
        index: response.data.index,
        size: response.data.size,
        active: response.data.active,
        instance: response0.data.count
      })
      .then (response_ => callback(1, false))
    })
  })
}
*/
/*
export function setBadge(text:string,gameName:string, gameVersion:string, instance:number, group:string, index:string) {
  axios.put(Config.asBadge, {
    badge: text, game_name: gameName, game_version: gameVersion,
    group, index, instance: instance, site_id: Main.Instance.FrontendStoreState.site_id})
}

export function setGroup (text:string, gameName:string, gameVersion:string, instance:number, index: string,
                          callback:(a:number,b?:boolean,c?:boolean) => void) {
  axios.put(Config.asGroup, {
    group:text, game_name: gameName, game_version: gameVersion, index:index,
    instance, site_id: Main.Instance.FrontendStoreState.site_id
  }).then((response) => callback(1, true, true))
}

export function setIndex (text:string, gameName:string, gameVersion:string, instance:number, group: string) {
  axios.put(Config.asIndex, {
    index: text, game_name: gameName, game_version: gameVersion, group,
    instance, site_id: Main.Instance.FrontendStoreState.site_id
  })
}

export function setSize (value:boolean,gameName:string,gameVersion:string,instance:number, group:string, index:string) {
  axios.put(Config.asSize, {
    size: value, game_name: gameName, game_version: gameVersion, group,
    instance, index, site_id: Main.Instance.FrontendStoreState.site_id
  })
}

export function setActive (value:boolean, gameName:string, gameVersion:string, instance:number, group: string,
                           index: string) {
  axios.put(Config.asActive, {
    active: value, game_name: gameName, game_version: gameVersion, group, instance, index,
    site_id: Main.Instance.FrontendStoreState.site_id})
}

function getPlayerID (callback?:() => void) {
  let str = Config.walletServer + '/user-data/' + '?user=' + Main.Instance.FrontendStoreState.username

  axios.get(str)
    .then((response) => {
      if (response.data.id) {
        Logic.Type.New (Main.Instance.FrontendStoreState, {Id: response.data.id})
        if (callback) {
          callback()
        }
      }
  })
}
*/

export function getRSTA(category?: number) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { RstAllStream: [] })
    const search: string | undefined = Main.Instance.SearchState.search_string &&
        Main.Instance.SearchState.search_string.length > 0 ?
        '\'%' + Main.Instance.SearchState.search_string.toLowerCase() + '%\''
        : undefined

    const search_exact: string | undefined = Main.Instance.SearchState.search_string &&
        Main.Instance.SearchState.search_string.length > 0 ?
        Main.Instance.SearchState.search_string
        : undefined

    let Search = ''
    if (search) { Search += '&search=' + search }
    if (search_exact) { Search += '&search_exact=' + search_exact }
    const stats: any[] = Object.assign([], Main.Instance.RSTState.stats)
    if (category) { stats[0].category = category }
    if (stats[0].category) { Search += '&category=' + stats[0].category }
    if (Main.Instance.RSTState.stats[0].item) { Search += '&item=' + Main.Instance.RSTState.stats[0].item }
    if (Main.Instance.RSTState.stats[0].item > 1 && Main.Instance.RSTState.stats[0].items) { Search += '&item_name=' + Main.Instance.RSTState.stats[0].items[Main.Instance.RSTState.stats[0].item - 2] }

    axios.get(Config.psAllRst
        + '?site_id=' + Main.Instance.FrontendStoreState.site_id
        + '&offset=' + Main.Instance.RSTState.offset
        + '&limit=' + Main.Instance.RSTState.pSize
        // + '&category=' + Main.Instance.RSTState.filter_category
        // + '&date=' + Main.Instance.RSTState.filter_date
        + '&date=' + Main.Instance.RSTState.stats[0].date
        + '&date1=' + Main.Instance.RSTState.stats[0].fromDate
        + '&date2=' + Main.Instance.RSTState.stats[0].toDate
        + Search,
        // + '&data=' + response3.data
    )
        .then((response5) => {
            if (response5.data) {
                if (Main.Instance.FrontendStoreState.Category) {
                    for (const item of response5.data) {
                        if (item === undefined) { continue }
                        if (item['category'] !== undefined) {
                            item['category_id'] = item['category']
                            item['category'] = Main.Instance.FrontendStoreState.Category[+item['category'] + 1]['name']
                        }
                        item['price'] = numberWithCommas(item['price'])
                        // item['valuexp'] = numberWithCommas(item['valuexp'])
                        item['balbefxp'] = numberWithCommas(item['balbefxp'])
                        item['balaftxp'] = numberWithCommas(item['balaftxp'])
                    }
                }

                if (stats[0].category > 1) {
                    stats[0].items = []
                    for (const item of response5.data) {
                        let found: boolean = false
                        if (item['category_id'] !== stats[0].category - 1) { continue }
                        for (const Item of stats[0].items) {
                            if (Item === item['item_name']) {
                                found = true
                                break
                            }
                        }
                        if (found === false) { stats[0].items.push(item['item_name']) }
                    }
                }

                delete (stats[0].data)
                Logic.Type.New(Main.Instance.DatabaseDataState, { RstAllStream: response5.data })
                Logic.Type.New(Main.Instance.RSTState, { stats })
            }
        })
}

export function getRSTransactions() {
    /*
      let search: string | undefined = Main.Instance.SearchState.search_string &&
                           Main.Instance.SearchState.search_string.length > 0 ?
                           '\'%' + Main.Instance.SearchState.search_string.toLowerCase() + '%\''
                           : undefined

      let search_exact: string | undefined = Main.Instance.SearchState.search_string &&
                                 Main.Instance.SearchState.search_string.length > 0 ?
                                 Main.Instance.SearchState.search_string
                                 : undefined

      let Search = ''
      if (search) Search += '&search=' + search
      if (search_exact) Search += '&search_exact=' + search_exact
    */
    const validationFromTime: boolean = utilsTimeValidEmptyNotValid(Main.Instance.RSTState.from_time)
    const validationToTime: boolean = utilsTimeValidEmptyNotValid(Main.Instance.RSTState.to_time)


    let Search: string = ''
    if (Main.Instance.RSTState.filter_player.length > 0) { Search += '&player=' + Main.Instance.RSTState.filter_player } else if (Main.Instance.SearchState.search_string) { Search += '&player=' + Main.Instance.SearchState.search_string }

    let time1: string
    let time2: string
    if (Main.Instance.RSTState.from_time) { time1 = Main.Instance.RSTState.from_time.replace(':', '').replace(':', '') }
    if (Main.Instance.RSTState.to_time) { time2 = Main.Instance.RSTState.to_time.replace(':', '').replace(':', '') }

    if (validationFromTime && time1) { Search += '&time1=' + time1 }
    if (validationToTime && time2) { Search += '&time2=' + time2 }
    if (Main.Instance.RSTState.from_date !== null) { Search += '&date1=' + moment.default(Main.Instance.RSTState.from_date).format(Assets_.dateDisplayFormat).trim() }
    if (Main.Instance.RSTState.to_date !== null) { Search += '&date2=' + moment.default(Main.Instance.RSTState.to_date).format(Assets_.dateDisplayFormat).trim() }
    if (Main.Instance.RSTState.filter_date.length > 0) { Search += '&item=' + Main.Instance.RSTState.filter_date }
    const str: string = Config.psPartRst
        + '?site_id=' + Main.Instance.FrontendStoreState.site_id
        + '&offset=' + Main.Instance.RSTState.offset
        + '&limit=' + Main.Instance.RSTState.pSize
        + '&sort=' + Main.Instance.RSTState.sort
        + '&Sort=' + Main.Instance.RSTState.Sort
        + '&category=' + Main.Instance.RSTState.filter_category
        // + '&date=' + Main.Instance.RSTState.filter_date
        + Search

    axios.get(str)
        .then((response) => {
            if (response.data && Main.Instance.FrontendStoreState.Category) {
                for (const item of response.data) {
                    if (item === undefined) { continue }
                    if (item['category'] !== undefined) { item['category'] = Main.Instance.FrontendStoreState.Category[+item['category'] + 1]['name'] }
                    item['price'] = numberWithCommas(item['price'])
                    item['valuexp'] = numberWithCommas(item['valuexp'])
                    item['balbefxp'] = numberWithCommas(item['balbefxp'])
                    item['balaftxp'] = numberWithCommas(item['balaftxp'])
                }
            }

            axios.get(Config.psCountRst
                + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                + '&category=' + Main.Instance.RSTState.filter_category
                // + '&date=' + Main.Instance.RSTState.filter_date
                + Search)
                .then((response2) => {
                    axios.get(Config.psBundleRst
                        + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                        + '&offset=' + Main.Instance.RSTState.offset
                        + '&limit=' + Main.Instance.RSTState.pSize
                        + '&sort=' + Main.Instance.RSTState.sort
                        + '&Sort=' + Main.Instance.RSTState.Sort
                        + '&category=' + Main.Instance.RSTState.filter_category
                        + '&date=' + Main.Instance.RSTState.filter_date
                        + Search)
                        .then((response3) => {
                            axios.get(Config.psCountBundleRst
                                + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                                + '&category=' + Main.Instance.RSTState.filter_category
                                + '&date=' + Main.Instance.RSTState.filter_date
                                + Search)
                                .then((response4) => {
                                    axios.get(Config.psAllRst
                                        + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                                        + '&offset=' + Main.Instance.RSTState.offset
                                        + '&limit=' + Main.Instance.RSTState.pSize
                                        // + '&category=' + Main.Instance.RSTState.filter_category
                                        // + '&item=' + Main.Instance.RSTState.filter_category

                                        + '&date=' + Main.Instance.RSTState.stats[0].date
                                        + '&date1=' + Main.Instance.RSTState.stats[0].fromDate
                                        + '&date2=' + Main.Instance.RSTState.stats[0].toDate
                                        + Search
                                        + '&data=' + response3.data)
                                        .then((response5) => {
                                            if (response5.data && Main.Instance.FrontendStoreState.Category) {
                                                for (const item of response5.data) {
                                                    if (item === undefined) { continue }
                                                    if (item['category'] !== undefined) {
                                                        item['category_id'] = item['category']
                                                        item['category'] = Main.Instance.FrontendStoreState.Category[+item['category'] + 1]['name']
                                                    }
                                                    item['price'] = numberWithCommas(item['price'])
                                                    // item['valuexp'] = numberWithCommas(item['valuexp'])
                                                    item['balbefxp'] = numberWithCommas(item['balbefxp'])
                                                    item['balaftxp'] = numberWithCommas(item['balaftxp'])
                                                }
                                            }

                                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                                rstStream: response.data,
                                                RstStream: response3.data,
                                                RstAllStream: response5.data
                                            })

                                            Logic.Type.New(Main.Instance.RSTState, {
                                                count: parseInt(response2.data.count),
                                                Count: parseInt(response4.data.count),
                                                countCalled: false
                                            })
                                        })
                                })
                        })
                })
        })
}

// !!! search_string
export function getPlayersAllTEST3(/*which: number*/) {
    /*
      let search:string = Main.Instance.SearchState.search_string &&
                          Main.Instance.SearchState.search_string.length > 0 ?
                          Main.Instance.SearchState.search_string.toLowerCase() :
                          'nothingtosearchfor'*/
    // let p: string =  Config.promostoreserver
    // let Which: string = '?which=' + which.toString()
    axios.get(Config.psLevelsAllDetailsBySite + '?site_id=' + Main.Instance.FrontendStoreState.site_id)
        .then((response0) => {
            if (response0.data) {
                const data: any[] = []
                for (const level of response0.data) {
                    data.push({
                        id: level.hierarchy,
                        level: level.hierarchy,
                        name: level.name,
                        prte: level.prte,
                        sublevels: level.sublevels,
                        level_value: level.level_value,
                        stagnation: level.stagnation,
                        reward_every: level.reward_every,
                        final_level: level.final_level,
                    })

                    if (level.final_level !== undefined && level.final_level.toString() === 'true') { break }
                }

                Logic.Type.New(Main.Instance.DatabaseDataState, { levelsAllDetailsStream: data })

                let flag: boolean = false
                const level_names: string[] = []
                const final_level: boolean[] = []
                const Sublevels: number[] = []

                for (const level of data) {
                    if (!flag) {
                        Sublevels.push(parseInt(level['sublevels']))
                        level_names.push(level['name'])
                        final_level.push(level['final_level'])
                        if (level['final_level']) {
                            flag = true
                        }
                    }
                }

                Logic.Type.New(Main.Instance.ReportLSState, {
                    sublevels: Sublevels,
                    countCalled: false,
                    levelNames: level_names,
                    finalLevel: final_level,
                })
            }
        })
}

export function getPlayersAllTEST2(which: number) {
    const Which: string = '?which=' + which.toString()

    axios.get(Config.psLevelsAllDetailsBySite + '?site_id=' + Main.Instance.FrontendStoreState.site_id)
        .then((response0) => {
            if (response0.data) {
                const data: any[] = []

                for (const level of response0.data) {
                    data.push({
                        id: level.hierarchy,
                        level: level.hierarchy,
                        name: level.name,
                        prte: level.prte,
                        sublevels: level.sublevels,
                        level_value: level.level_value,
                        stagnation: level.stagnation,
                        reward_every: level.reward_every,
                        final_level: level.final_level,
                    })

                    if (level.final_level !== undefined && level.final_level.toString() === 'true') { break }
                }

                let flag: boolean = false
                const level_names: string[] = []
                const final_level: boolean[] = []
                const Sublevels: number[] = []

                for (const level of data) {
                    if (!flag) {
                        Sublevels.push(parseInt(level['sublevels']))
                        level_names.push(level['name'])
                        final_level.push(level['final_level'])
                        if (level['final_level']) {
                            flag = true
                        }
                    }
                }

                axios.get(Config.psPlayerAll + Which)
                    .then((response1) => {
                        const data1: any[] = []

                        for (const player of response1.data.return) {
                            // if (data1.length === 0) console.log (player)
                            const total_points: number = parseInt(player.totalpoints)
                            const available: number = parseInt(player.available)
                            const Level: number = parseInt(player.level)
                            const sublevel: number = parseInt(player.sublevel)
                            const player_: string = player.player
                            if (parseInt(Main.Instance.ReportLSState.filter_level) > 0) {

                                if (Level !== parseInt(Main.Instance.ReportLSState.filter_level)) {
                                    continue
                                }
                            }

                            data1.push({
                                player: player_,
                                level: Level,
                                sublevel,
                                total_points,
                                available,
                            })
                        }

                        const colors: string[] = []
                        const Colors: string[] = []
                        const data_chart_1: any[] = []
                        const show: boolean[] = []
                        if (parseInt(Main.Instance.ReportLSState.filter_level) === 0) {
                            for (const item of level_names) {
                                data_chart_1.push({ name: item, avgSL: 0, avgTP: 0, set: false, level: 0, data: 0, players: [], show: false, total: [], available: [], sublevel: [] })
                            }
                            for (const level_data of data1) {
                                if (level_data.level > 0 && data_chart_1[level_data.level - 1]) {
                                    data_chart_1[level_data.level - 1].players.push(level_data.player)
                                    data_chart_1[level_data.level - 1].total.push(level_data.total_points)
                                    data_chart_1[level_data.level - 1].available.push(level_data.available)
                                    data_chart_1[level_data.level - 1].sublevel.push(level_data.sublevel)
                                    data_chart_1[level_data.level - 1].level = level_data.level
                                    data_chart_1[level_data.level - 1].data++
                                    data_chart_1[level_data.level - 1].avgSL += level_data.sublevel
                                    data_chart_1[level_data.level - 1].avgTP += level_data.total_points
                                }
                            }

                            for (const level_data of data1) {
                                if (level_data.level > 0 && data_chart_1[level_data.level - 1] && data_chart_1[level_data.level - 1].data > 0 &&
                                    data_chart_1[level_data.level - 1].set === false) {

                                    data_chart_1[level_data.level - 1].avgSL =
                                        Math.round(data_chart_1[level_data.level - 1].avgSL /
                                            data_chart_1[level_data.level - 1].data)

                                    data_chart_1[level_data.level - 1].avgTP =
                                        Math.round(data_chart_1[level_data.level - 1].avgTP /
                                            data_chart_1[level_data.level - 1].data)

                                    data_chart_1[level_data.level - 1].set = true
                                }
                            }

                            for (let i: number = 0; i < data_chart_1.length; i++) {
                                if (isPureScandibet()) {
                                    colors.push(Assets_.COLORS_5[i])
                                    Colors.push(Assets_.COLORS5[i])
                                } else {
                                    colors.push(Assets_.COLORS_2[i])
                                    Colors.push(Assets_.COLORS2[i])
                                }
                            }
                        } else {
                            let min: number = Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1] === 0 ? 0 :
                                Main.Instance.ReportLSState.sublevel_min % Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1]
                            let max: number = Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1] === 0 ? 0 :
                                Main.Instance.ReportLSState.sublevel_max % Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1]

                            if (min === 0 && Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1] > 0) {
                                min = 1
                            }

                            if (max === 0 && Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1] > 0) {
                                max = Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1]
                            }

                            if (Main.Instance.ReportLSState.sublevel_max === Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1]
                                && Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1] > 0) {
                                max = Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1]
                            }

                            if (Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1] === 0) {
                                data_chart_1.push({ name: '0', N: 0, players: [], total: [], available: [] })
                                show.push(false)
                            } else {
                                for (let i: number = min; i <= max; i++) {
                                    data_chart_1.push({ name: i.toString(), N: 0, players: [], total: [], available: [] })
                                    show.push(false)
                                }
                            }
                            for (const sublevel_data of data1) {
                                if (Sublevels[parseInt(Main.Instance.ReportLSState.filter_level) - 1] === 0) {
                                    data_chart_1[0].N++
                                    data_chart_1[0].players.push(sublevel_data.player)
                                    data_chart_1[0].total.push(sublevel_data.total_points)
                                    data_chart_1[0].available.push(sublevel_data.available)
                                } else {
                                    data_chart_1[sublevel_data.sublevel - min].N++
                                    data_chart_1[sublevel_data.sublevel - min].players.push(sublevel_data.player)
                                    data_chart_1[sublevel_data.sublevel - min].total.push(sublevel_data.total_points)
                                    data_chart_1[sublevel_data.sublevel - min].available.push(sublevel_data.available)
                                }
                            }
                        }

                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            levelsAllDetailsStream: data
                        })

                        Logic.Type.New(Main.Instance.ReportLSState, {
                            show,
                            sublevels: Sublevels,
                            count: parseInt(response1.data.return.length),
                            countCalled: false,
                            colors,
                            Colors,
                            data: data_chart_1,
                            levelNames: level_names,
                            finalLevel: final_level,
                        })
                    })
            }
        })
}
/*
export function insertPlayerTEST(items:any, callback:() => void) {
  let str0: string = Config.walletServer + '/count-player' + '?site=' + items['site'] + '&user=' + items['username']
  axios.get(str0).then((response0) => {
    if (parseInt(response0.data) === 0) {
      let str: string = Config.walletServer + '/player' + '?site=' + items['site'] + '&name=' + items['name'] +
                        '&mail=' + items['email'] + '&user=' + items['username'] + '&pass=' + items['password']
      if (callback) {
        axios.post(str).then((response) => {
        getPlayerID()
        callback()
        })
      } else {
        axios.post(str).then((response) => {
        getPlayerID()
        })
      }
    } else {
      alert (Assets.playerAlreadyInDatabase)
    }
  })
}

export function updatePlayerNoPasswordTEST(items:any, callback:() => void) {

  let str:string = Config.walletServer + '/player' + '?site=' + items['site'] + '&name=' + items['name'] +
                   '&mail=' + items['email'] + '&user=' + items['username']+ '&player=' + items['id']
                   + '&xp=' + items['xp'] + '&xpl=' + items['xpl'] // + '&bal=' + items['bal']
  if (callback) {
    axios.put(str).then((response) => {
      callback()
    })

  } else {
    axios.put(str)
  }
}

export function removePlayerTEST(id:string, callback:() => void) {
  let str:string =  Config.walletServer + '/player' + '?player=' + id
  axios.delete(str).then((response) => {
    callback()
  })
}
*/
export function addGroup(callback: () => void, callback2: (a?: boolean) => void) {
    axios.put(Config.asGroups, { site_id: Main.Instance.FrontendStoreState.site_id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => { callback2(); callback() })
}

export function deleteGroup(i: number, callback: () => void, callback2: (a?: boolean) => void) {
    axios.delete(Config.asGroups + '?group=' + i + '&site_id=' + Main.Instance.FrontendStoreState.site_id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => { callback2(true); callback() })
}

export function addMenu(callback: () => void) {
    axios.put(Config.asMenus, { site_id: Main.Instance.FrontendStoreState.site_id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
}

export function deleteMenu(i: number, callback: () => void) {
    axios.delete(Config.asMenus + '?menu=' + i + '&site_id=' + Main.Instance.FrontendStoreState.site_id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
}

export function patchRewardShopItem(id: string, value: string, old_value: string, callback: () => void) {
    axios.patch(Config.psShopItem, { id, value, old_value, site_id: Main.Instance.FrontendStoreState.site_id })

        .then((response) => {
            callback()
        }).catch((err) => alert(err))
}

export function insertRewardShopItem(items: any, callback?: () => void/*, callback2?:() => void*/) {
    axios.post(Config.psShopItem, items)
        .then((response) => {
            if (callback) {
                callback()
            }
        }).catch((err) => alert(err))
}

export function updateRewardShopItem(items: any, callback: () => void) {
    axios.put(Config.psShopItem, items)
        .then((response) => {
            callback()
        })
        .catch((err) => alert(err))
}

export function removeRewardShopItem(id: string, /*index: number,*/ callback: () => void) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        WSdeleteReward(+id)
    } else {
        axios.delete(Config.psShopItem + '?id=' + id) // + '&index=' + index + '&site_id=' + Main.Instance.FrontendStoreState.site_id)
            .then((response) => callback())
            .catch((err) => alert(err))
    }
}

export function removeCurrency(id: string, callback: () => void) {
    axios.delete(Config.psCurrency + '?id=' + id)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function loadData(callback?: (checkDomains?: boolean) => void) {
    if (+Main.Instance.FrontendStoreState.site_id > 0) {
        axios.get(Config.asTestSite + '?site_id=' + Main.Instance.FrontendStoreState.site_id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    let identifier = ''
                    if (response.data.subdomain) { identifier = response.data.subdomain.toLowerCase() }
                    axios.get(Config.asSettings + '?identifier=' + identifier, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((Response) => {
                            if (IsBuildScandibet()) { getPlayersAleacc() }
                            if (identifier === 'frontend' || identifier === 'backend' || !Config.Environment.STAGE && Response.data && Response.data.custom && Response.data.custom.skin_id && Response.data.custom.jwt) {
                                getGamesAleacc(Response.data.custom.skin_id, Response.data.custom.jwt)
                                /*
                                } else if (Response.data.games && Response.data.games2 && IsBuildOddyzzey()) { // this is a hack until we get this properly
                                    // let games: string = Response.data.games + Response.data.games2

                                    setGamesAleacc(JSON.parse(Response.data.games + Response.data.games2))
                                */
                            } else if (Config.environment === Config.Environment.STAGE && Response.data && Response.data.custom && Response.data.custom.ApiKey && Response.data.custom.ApiSecret && Response.data.custom.skin_id) {
                                getGamesAleaccStage(Response.data.custom.skin_id, Response.data.custom.ApiKey, Response.data.custom.ApiSecret)
                            }
                            getRewardShopItemsCategory(Main.Instance.FrontendStoreState.site_id)
                            axios.get(Config.psShopItem + '?site_id=' + Main.Instance.FrontendStoreState.site_id)
                                .then((rewardShopItems) => {

                                    if (Response.data && Response.data.custom  && Response.data.custom.authAleacc && Response.data.custom.authAleacc.username && Response.data.custom.authAleacc.password) {
                                        // if (Main.Instance.FrontendStoreState.authAleaccUsername)
                                        Logic.Type.New(Main.Instance.FrontendStoreState, {
                                            // jwt: Response.data.custom.jwt,
                                            // skin_id: Response.data.custom.skin_id,
                                            api_key: Response.data.apikey,
                                            blackFriday: response.data.custom && response.data.custom.blackFriday !== undefined ? response.data.custom.blackFriday : '',
                                            christmas: response.data.custom && response.data.custom.christmas !== undefined ? response.data.custom.christmas : '',
                                            activeBlackFriday: response.data.custom && response.data.custom.activeBlackFriday !== undefined ? response.data.custom.activeBlackFriday : false,
                                            activeChristmas: response.data.custom && response.data.custom.activeChristmas !== undefined ? response.data.custom.activeChristmas : false,
                                            custom: response.data.custom,
                                            images: response.data.images,
                                            authAleaccUsername: Response.data.custom.authAleacc.username,
                                            authAleaccPassword: Response.data.custom.authAleacc.password,
                                            translation: response.data.translation,
                                            title: response.data.name,
                                            titleSize: response.data.title_size,
                                            titleColor: response.data.title_color,
                                            coverWhole: response.data.cover_whole,
                                            borderWidth: response.data.border_width,
                                            shopItemHeight: response.data.shop_item_height,
                                            shopItemWidth: response.data.shop_item_width,
                                            borderRadius: response.data.border_radius,
                                            shopItemImageHeight: response.data.shop_item_image_height,
                                            menus_type: response.data.menus_type,
                                            menus: response.data.menus,
                                            groups: response.data.groups,
                                            show_version_info: response.data.show_version_info,
                                            show_game_info: response.data.show_game_info,
                                            show_debug_info: response.data.show_debug_info,
                                            display_name: response.data.display_name,
                                            borders: response.data.borders,
                                            subdomain: response.data.subdomain ? response.data.subdomain.trim() : '',
                                            shopItemDefaultFilename: response.data.default_image,
                                            minlevel: response.data.minlevel,
                                            mail: response.data.mail,
                                            notify: response.data.notify,
                                            logo: response.data.logo,
                                            logo2: response.data.logo2,
                                            games_folder: response.data.games_folder,
                                            shop_items: rewardShopItems.data,
                                            // tb_title: response.data.tb_title,
                                            // tb_content: response.data.tb_content,
                                            // main_title: response.data.main_title,
                                            // category1: response.data.category1,
                                            // category2: response.data.category2,
                                            // choose_category: response.data.choose_category,
                                            category: response.data.category,
                                            rs_background: response.data.rs_background,
                                            rs_popup_bg: response.data.rs_popup_bg,
                                            menu_active: response.data.menu_active,
                                            menu_inactive: response.data.menu_inactive,
                                        })

                                    } else {
                                        
                                        if (Response.data.custom.strapiPass !== undefined) {
                                            Cookies.remove('strapiPass', { path: '/' })
                                            Cookies.set('strapiPass', Response.data.custom.strapiPass.toString(), { path: '/' })
                                            getLoadedResources('Cookie - Set', 'strapiPass=')
                                            
                                            // document.cookie = 'strapiPass=' + Response.data.custom.strapiPass.toString()
                                        }
                                        Logic.Type.New(Main.Instance.FrontendStoreState, {
                                            blackFriday: response.data.custom && response.data.custom.blackFriday !== undefined ? response.data.custom.blackFriday : '',
                                            christmas: response.data.custom && response.data.custom.christmas !== undefined ? response.data.custom.christmas : '',
                                            activeBlackFriday: response.data.custom && response.data.custom.activeBlackFriday !== undefined ? response.data.custom.activeBlackFriday : false,
                                            activeChristmas: response.data.custom && response.data.custom.activeChristmas !== undefined ? response.data.custom.activeChristmas : false,
                                            // keyGet: Response.data.custom.keyGet,
                                            strapiPass: Response.data.custom.strapiPass,
                                            jwt: Response.data.custom ? Response.data.custom.jwt : '',
                                            skin_id: Response.data.custom ? Response.data.custom.skin_id : '',
                                            api_key: Response.data.custom ? Response.data.custom.apikey : '',
                                            custom: response.data.custom,
                                            images: response.data.images,
                                            translation: response.data.translation,
                                            title: response.data.name,
                                            titleSize: response.data.title_size,
                                            titleColor: response.data.title_color,
                                            coverWhole: response.data.cover_whole,
                                            borderWidth: response.data.border_width,
                                            shopItemHeight: response.data.shop_item_height,
                                            shopItemWidth: response.data.shop_item_width,
                                            borderRadius: response.data.border_radius,
                                            shopItemImageHeight: response.data.shop_item_image_height,
                                            menus_type: response.data.menus_type,
                                            menus: response.data.menus,
                                            groups: response.data.groups,
                                            show_version_info: response.data.show_version_info,
                                            show_game_info: response.data.show_game_info,
                                            show_debug_info: response.data.show_debug_info,
                                            display_name: response.data.display_name,
                                            borders: response.data.borders,
                                            subdomain: response.data.subdomain ? response.data.subdomain.trim() : '',
                                            shopItemDefaultFilename: response.data.default_image,
                                            minlevel: response.data.minlevel,
                                            mail: response.data.mail,
                                            notify: response.data.notify,
                                            logo: response.data.logo,
                                            logo2: response.data.logo2,
                                            games_folder: response.data.games_folder,
                                            shop_items: rewardShopItems.data,
                                            category: response.data.category,
                                            rs_background: response.data.rs_background,
                                            rs_popup_bg: response.data.rs_popup_bg,
                                            menu_active: response.data.menu_active,
                                            menu_inactive: response.data.menu_inactive,
                                        })
                                    }
                                }).catch((err) => alert(err))
                        })
                    if (callback) { callback(true) }
                }
            }).catch((err) => alert(err))
    }
}

export function getRewardShopItemsAll(site_id: string) {
    if (IsBuildOddyzzey()) {
    } else {
        axios.get(Config.psAllShopItems + '?site_id=' + site_id)
            .then((response) => Logic.Type.New(Main.Instance.DatabaseDataState, { rewardShopStreamAll: response.data }))
            .catch((err) => alert(err))
    }
}

export function getRewardShopItemsCategory(site_id: string) {
    axios.get(Config.psCategoryShopItems + '?site_id=' + site_id)
        .then((response) => {
            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { rewardShopStreamCategory: response.data })
            }
        }).catch((err) => alert(err))
}

export function handleLeaderboard(tournament?: any) {
    let query: any
    if (tournament === undefined) {
        tournament = Main.Instance.TournamentState.tournament
        query = {
            params: {
                recurring_type: +Main.Instance.TournamentState.recurringTypeRecurring,
                selection: Main.Instance.TournamentState.selection,

                valid_from: Main.Instance.TournamentState.valid_from,
                valid_to: Main.Instance.TournamentState.valid_to,
                daily: Main.Instance.TournamentState.daily,
                days_in_a_month: Main.Instance.TournamentState.days_in_a_month,
                days_in_a_week: Main.Instance.TournamentState.days_in_a_week,
                weeks: Main.Instance.TournamentState.weeks,
                months: Main.Instance.TournamentState.months,
                annual: Main.Instance.TournamentState.annual,

                tournament_type: Main.Instance.TournamentState.tournamentType,
                leaderboard_type: Main.Instance.TournamentState.leaderboard_type,
                leaderboard_type2: Main.Instance.TournamentState.leaderboard_type2,

                site_id: Main.Instance.FrontendStoreState.site_id,
                offset: Main.Instance.TournamentState.offset,
                limit: Main.Instance.TournamentState.pSize,
                id: Main.Instance.TournamentState.id,
                title: Main.Instance.TournamentState.title,
                // brands: Main.Instance.TournamentState.brands,
                // brand: Main.Instance.TournamentState.brand,
                currencies: Main.Instance.TournamentState.currencies,
                currency: [],
                // currency_rates: Main.Instance.CurrencyRatesState,
                main_currency: Main.Instance.TournamentState.main_currency,
                opt_in: Main.Instance.TournamentState.opt_in,
                opt_in_cost: Main.Instance.TournamentState.opt_in_cost,
                min_rounds: Main.Instance.TournamentState.min_rounds,
                max_rounds: Main.Instance.TournamentState.max_rounds,
                bet_amount_min: Main.Instance.TournamentState.bet_amount_min,
                bet_amount_max: Main.Instance.TournamentState.bet_amount_max,
                total_max0: Main.Instance.TournamentState.total_max0,
                total_max1: Main.Instance.TournamentState.total_max1,
                total_max2: Main.Instance.TournamentState.total_max2,
                total_max3: Main.Instance.TournamentState.total_max3,
                total_max4: Main.Instance.TournamentState.total_max4,
                part_of_wager: Main.Instance.TournamentState.part_of_wager,
                // sportsbook: Main.Instance.TournamentState.sportsbook,
                // casino: Main.Instance.TournamentState.casino,
                // prizes: Main.Instance.TournamentState.prizes,
                itipp: Main.Instance.TournamentState.itipp,
                recurring: Main.Instance.TournamentState.daily,
                // recurring_days: Main.Instance.TournamentState.recurring_days,
                recurring_types: Main.Instance.TournamentState.recurring_types,
                recurring_from: Main.Instance.TournamentState.recurringFromTime,
                recurring_to: Main.Instance.TournamentState.recurringToTime,
                recurring_notification: Main.Instance.TournamentState.notify_players,
                level_min: Main.Instance.TournamentState.level_min,
                level_max: Main.Instance.TournamentState.level_max,
                sublevel_min: Main.Instance.TournamentState.sublevel_min,
                sublevel_max: Main.Instance.TournamentState.sublevel_max,
            },
        }
    } else {
        query = {
            params: {
                recurring_type: 0,
                selection: 0,
                valid_from: tournament.valid_from,
                valid_to: tournament.valid_to,
                daily: tournament.daily,
                days_in_a_month: tournament.days_in_a_month,
                days_in_a_week: tournament.days_in_a_week,
                weeks: tournament.weeks,
                months: tournament.months,
                annual: tournament.annual,

                tournament_type: tournament.tournament_type,
                leaderboard_type: tournament.leaderboard_type,
                leaderboard_type2: tournament.leaderboard_type2,

                site_id: Main.Instance.FrontendStoreState.site_id,
                offset: tournament.offset,
                limit: tournament.limit,
                id: tournament.id,
                title: tournament.title,
                // brands: tournament.brands,
                // brand: tournament.brand,
                currencies: tournament.currencies,
                currency: tournament.currency,
                // currency_rates: Main.Instance.CurrencyRatesState,
                main_currency: tournament.main_currency,
                opt_in: tournament.opt_in,
                opt_in_cost: tournament.opt_in_cost,
                min_rounds: tournament.min_rounds,
                max_rounds: tournament.max_rounds,
                bet_amount_min: tournament.bet_amount_min,
                bet_amount_max: tournament.bet_amount_max,
                total_max0: tournament.total_max0,
                total_max1: tournament.total_max1,
                total_max2: tournament.total_max2,
                total_max3: tournament.total_max3,
                total_max4: tournament.total_max4,
                part_of_wager: tournament.part_of_wager,
                // sportsbook: tournament.sportsbook,
                // casino: tournament.casino,
                // prizes: tournament.prizes,
                itipp: tournament.itipp,
                recurring: tournament.recurring,
                // recurring_days: tournament.recurring_days,
                recurring_types: tournament.recurring_types,
                recurring_from: tournament.recurring_from,
                recurring_to: tournament.recurring_to,
                recurring_notification: tournament.recurring_notification,
                level_min: tournament.level_min,
                level_max: tournament.level_max,
                sublevel_min: tournament.sublevel_min,
                sublevel_max: tournament.sublevel_max,
            },
        }
    }

    if (tournament.tournament_type === Assets_.TOURNAMENT_TYPE.LottoBet) {

        axios({
            url: Config.lsLotteryLeaderboard,
            method: 'get',
            params: query,
            headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId },
        })
            .then((response) => {
                // Logic.Type.New (Main.Instance.TournamentState, {modeAdvanced: false, modeRecurring: false})
                Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentLeaderboard: response.data, tournament })
            })
    } else {
        if (tournament.tournament_type === Assets_.TOURNAMENT_TYPE.SportsBook) { query.params.type = 1 } else { query.params.type = 0 }
        axios.get(Config.psTournament, query)
            .then((response) => {
                // Logic.Type.New (Main.Instance.TournamentState, {modeAdvanced: false, modeRecurring: false})
                if (response.data) {
                    if (tournament.tournament_type === Assets_.TOURNAMENT_TYPE.SportsBook) {
                        if (response.data.resolved) { Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentLeaderboard: response.data.return.leaderboard, tournament }) }
                    } else {
                        if (response.data.resolved) { Logic.Type.New(Main.Instance.DatabaseDataState, { tournamentLeaderboard: response.data.return, tournament }) }
                    }
                }
            })

    }
    /*
        if (!Main.Instance.TournamentState.mode)
        handleEdit ([
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            JSON.stringify(tournament)
        ])

        if (tournament.recurring) {

            let RecurringType_: Select[] = []
            // let count: number = 1

            for (let item of tournament.recurring_types) {
                let item1: Select = {id: item, name: Assets.RecurringTypeShort[item - 1]}
                RecurringType_.push(item1)
                // count++
            }

            Logic.Type.New (Main.Instance.TournamentState, {
                leaderboard: undefined, modeLeaderboard: true, RecurringType_: RecurringType_, tournament: tournament})
        } else Logic.Type.New (Main.Instance.TournamentState, {leaderboard: undefined, modeLeaderboard: true})

        DbRoutes.leaderboardTournament(handleInsertUpdate(true))
        .then ((leaderboard) => {
            Logic.Type.New (Main.Instance.TournamentState, {leaderboard: leaderboard.data.return})
            // console.log (JSON.stringify(leaderboard))
        })
    */
}

export function tournamentsCount(/*callback:(a: any, b: any) => void*/) {
    if (IsBuildOddyzzey()) { wsGetTournaments() } else {
        axios.get(Config.psTournamentCount + '?site_id=' + Main.Instance.FrontendStoreState.site_id)
            .then((response) => {
                if (response.data.msg) {
                    const sql: string = '&limit=' + Main.Instance.TournamentState.pSize + '&offset=' + Main.Instance.TournamentState.offset
                    const Sql: string = '&limit=9999&offset=0'

                    axios.get(Config.psTournamentPart + '?site_id=' + Main.Instance.FrontendStoreState.site_id + sql)
                        .then((response0) => {
                            if (response0.data.msg) {
                                axios.get(Config.psTournamentPart + '?site_id=' + Main.Instance.FrontendStoreState.site_id + Sql)
                                    .then((response1) => {
                                        if (response1.data.msg) {
                                            Tournaments2Presentation(response0.data.msg, response1.data.msg)
                                            Logic.Type.New(Main.Instance.TournamentState, { count: parseInt(response.data.msg.count), countCalled: false })
                                        }
                                    })
                            }
                        })
                }
            })
    }
}

export function leaderboardTournament(tournament: any): Promise<any> {
    return axios.patch(Config.psTournament, tournament)
        // .then(results => {console.log (JSON.stringify(results))})
        .catch((e) => e)
}

export function updateTournament(tournament: any, callback?: () => void) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        WSUpdateTournament(tournament)
    } else {
        axios.put(Config.psTournament, tournament)
            .then((response) => callback())
            .catch((e) => e)
    }
}

export function insertTournament(tournament: any, callback?: () => void) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        WSInsertTournament(tournament)
    } else {
        axios.post(Config.psTournament, tournament)
            .then((response) => callback())
            .catch((e) => e)
    }
}

export function removeStore(id: string, callback?: () => void) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        WSdeleteStore(+id)
    }
}

export function removeChallenge(id: string, callback?: () => void) {
    if (IsBuildOddyzzey()) {
        WSdeleteChallenge(+id)
    }
}

export function removeMission(id: string, callback?: () => void) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        WSdeleteMission(+id)
    }
}

export function removeTournament(id: string, callback?: () => void) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        WSdeleteTournament(+id)
    } else {
        axios.delete(Config.psTournament + '?id=' + id)
            .then((response) => callback())
            .catch((e) => e)
    }
}

interface Select {
    id: string
    name: string,
}

function dateDiff(date1, date2): number {
    const diff = date2 - date1
    return isNaN(diff) ? NaN : Math.floor(diff / 86400000)
}

function getFormattedDate(d): string[] {
    // var d_names = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
    // var m_names = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
    const m_names = new Array('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec');

    // var d = new Date();
    // var curr_day = d.getDay();
    const curr_date = d.getDate();
    let sup = '';
    if (curr_date == 1 || curr_date == 21 || curr_date == 31) {
        sup = 'st';
    } else if (curr_date == 2 || curr_date == 22) {
        sup = 'nd';
    } else if (curr_date == 3 || curr_date == 23) {
        sup = 'rd';
    } else {
        sup = 'th';
    }

    const curr_month = d.getMonth();
    const curr_year = d.getFullYear();

    return [m_names[curr_month] + ' ' + curr_date, sup, ' ' + curr_year]
}

export function getCalendar(id: number, utc_date?: string) {
    axios.get(Config.psCalendar + '?id=' + id)
        .then((response) => {
            const date = new Date(response.data.date_start.toString())
            const dateEnd = new Date(response.data.date_end.toString())

            let idx: number
            if (utc_date) {
                const date2 = new Date(utc_date)
                idx = dateDiff(date, date2) + 1
                if (idx < 2) { idx = undefined }
            }
            const index: string = idx ? '&idx=' + idx : ''
            const limit: string = '&limit=' + Main.Instance.CalendarState.pSize
            const offset: string = '&offset=' + Main.Instance.CalendarState.offset
            axios.get(Config.psCalendarDay + '?calendar_id=' + id + limit + offset + index)
                .then((response2) => {
                    axios.get(Config.psCalendarDayCount + '?calendar_id=' + id + index)
                        .then((response3) => {
                            const calendarLanguages: Select[] = []

                            for (let i: number = response.data.languages.length - 1; i >= 0; i--) {
                                calendarLanguages.push({ id: i.toString(), name: response.data.languages[i] })
                            }
                            Logic.Type.New(Main.Instance.CalendarState, {
                                from: getFormattedDate(date),
                                to: getFormattedDate(dateEnd),
                                index: parseInt(response3.data.count) + 1,
                                pSize: Main.Instance.CalendarState.pSize ? Main.Instance.CalendarState.pSize : response.data.items_in_row,
                                count: parseInt(response3.data.count),
                                calendarLanguages,
                                calendarData: response.data,
                                calendarDay: response2.data,
                                countCalled: false
                            })
                        }).catch((error) => alert(error))
                }).catch((error) => alert(error))
        }).catch((error) => alert(error))
}

export function updateCalendar() {
    const data = Object.assign({}, Main.Instance.CalendarState.calendarData)
    data.background = ''
    data['default_language'] = Main.Instance.DatabaseDataState.default_language
    data['languages'] = []
    for (const item of Main.Instance.DatabaseDataState.languagesStreamAll) {
        data['languages'].push(item['name'])
    }
    axios.put(Config.psCalendar, data)
        .then((response) => Logic.Type.New(Main.Instance.CalendarState, { settings: !Main.Instance.CalendarState.settings }))
        .catch((error) => alert(error))
}

export function updateCalendarDay(calendar: any, callback: () => void) {
    axios.put(Config.psCalendarDay, calendar)
        .then((response) => callback())
        .catch((e) => e)
}

export function insertCalendarDay(calendar: any, callback: () => void) {
    axios.post(Config.psCalendarDay, calendar)
        .then((response) => {
            callback()
        })
        .catch((e) => e)
}

export function removeCalendarDay(id: string, callback: () => void) {
    axios.delete(Config.psCalendarDay + '?id=' + id)
        .then((response) => callback())
        .catch((err) => alert(err))
}

function getExternalId(externalid: string[]): string {
    let str: string = ''
    for (const item of externalid) {
        if (str.length > 0) { str += ',' }
        str += '\'' + item + '\''
    }
    return str
}

function drawFill(drawinfo: any[], externalid: any[], id: number, comboid: number[], response0?: any): Promise<any> {
    if (response0) {
        response0.data.comboid = comboid[id]
        drawinfo.push(response0.data)
        id++
        if (id < externalid.length) {
            if (externalid[id - 1].drawid === externalid[id].drawid) { return drawFill(drawinfo, externalid, id, comboid, response0) } else { return drawFill(drawinfo, externalid, id, comboid) }
        } else { return response0 }

    }
    return axios.get(Config.lsDraw + '?draw_id=' + externalid[id].drawid, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {

            response.data.comboid = comboid[id]
            drawinfo.push(response.data)
            id++
            if (id < externalid.length) {
                if (externalid[id - 1].drawid === externalid[id].drawid) { return drawFill(drawinfo, externalid, id, comboid, response) }
                return drawFill(drawinfo, externalid, id, comboid)
            } else { return response }
        })
}

function itemFill(data: any, id: number) {
    const item: any = data[id]
    for (const Item of Main.Instance.DatabaseDataState.lottoGameTypeStream) {
        if (+Item.id === item.customlt.gametypeid) {
            item.lottery = Item.name
            break
        }
    }

    item.c2 = item.customlt.countrycode
    item.datelt = item.datelt.substring(0, 10)
    item.timelt = item.timelt.substring(11, 19)
    item.pricelt = item.pricelt + ' ' + item.draws
    item.valuelt = item.valuelt + ' ' + item.draws

    item.draws = item.customlt.drawings.toString()
    item.s = item.customlt.lotteryBet.length
    item.ticket = item.combos // hidden, but showing with hover (id - numbers, c - combos)
    item.combos = item.combos.length / item.customlt.lotteryBet.length
    // quantity doesn't change but it is effectively draws * s * combos
    item.r = item.customlt.lotteryBets.regularNumbers
    item.rp = item.customlt.lotteryBet[0].regular.length // we can use [0] as all have it the same and [0] is guaranteed to exist
    item.b = item.customlt.lotteryBets.bonusNumbers
    item.bp = item.customlt.lotteryBet[0].bonus.length
    item.f = item.customlt.lotteryBets.refundNumbers
    item.fp = item.customlt.lotteryBet[0].refund.length
    item.result = Assets.PendingShort

    const externalid: string = getExternalId(item.externalid)
    axios.get(Config.lsBet + '?external_ids=' + externalid, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response0) => {
            item.betinfo = Object.assign([], response0.data)
            axios.get(Config.lsWinnersDirect + '?externalid=' + externalid, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                .then((response) => {
                    if (response.data && response.data.length > 0) {
                        item.externalid = Object.assign([], response.data)
                        item.drawinfo = []
                        drawFill(item.drawinfo, item.externalid, 0, item.ticket)
                            .then((response1) => {
                                id++
                                if (id < data.length) { itemFill(data, id) } else { itemFillFinish(data) }
                            })
                    } else {
                        id++
                        delete (item.drawinfo)
                        if (id < data.length) { itemFill(data, id) } else { itemFillFinish(data) }
                    }
                })
        })
}

function itemFillFinish(data: any) {
    let sql: string = Config.lsCountLotteryTransaction + '?site_id=' + Main.Instance.FrontendStoreState.site_id
    if (Main.Instance.LottoTransactionsState.playerid) { sql += '&player_id=' + Main.Instance.LottoTransactionsState.playerid }
    axios.get(sql, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response2) => {
            for (const item of data) {
                if (item.externalid) {
                    for (const Item of item.externalid) {
                        if (Item.payout !== null) {
                            if (Item.payout > 0) {
                                if (item.drawinfo && +item.draws > item.drawinfo.length) { item.result = Assets.WinPending } else { item.result = Assets.Win }
                                break
                            } else {
                                if (item.drawinfo && +item.draws > item.drawinfo.length) { item.result = Assets.LossPending } else { item.result = Assets.Loss }
                            }
                        }
                    }
                }
            }
            Logic.Type.New(Main.Instance.DatabaseDataState, { lottoTransactionsStream: data })
            Logic.Type.New(Main.Instance.LottoTransactionsState, { countCalled: false, count: parseInt(response2.data.count) })
        })
}

export function getLottoTransactions() {
    if (Main.Instance.FrontendStoreState.site_id) {
        let sql: string = Config.lsLotteryTransaction + '?site_id=' + Main.Instance.FrontendStoreState.site_id + '&presentation=1'
            + '&limit=' + Main.Instance.LottoTransactionsState.pSize + '&offset=' + Main.Instance.LottoTransactionsState.offset
        if (Main.Instance.LottoTransactionsState.playerid) { sql += '&player_id=' + Main.Instance.LottoTransactionsState.playerid }
        axios.get(sql, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response1) => {
                if (response1.data) {
                    if (response1.data.length) { itemFill(response1.data, 0) }
                }
            })
    }
}

export function getGZGTickets() {
    if (Main.Instance.GZG.raffle === false || Main.Instance.GZG.ID === undefined || Main.Instance.GZG.ID === 0) {
        Logic.Type.New(Main.Instance.GZG, { data2: undefined, Count: 0, countCalled: false })
    } else {
        let rest: string
        let Rest: string
        if (Main.Instance.GZG.gametype === false) {
            Rest = Config.ltRaffleTickets
            rest = Rest + '?limit=' + Main.Instance.GZG.PSize + '&offset=' + Main.Instance.GZG.Offset + '&ID=' + Main.Instance.GZG.ID
        } else if (Main.Instance.GZG.gametype === true) {
            Rest = Config.ltRafflePlaying
            rest = Rest + '?limit=999999999999&offset=0&ID=' + Main.Instance.GZG.ID
        }

        axios.get(rest, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                axios.patch(Rest, { ID: Main.Instance.GZG.ID }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                    .then((response0) => {
                        const response1: any[] = []

                        for (const item of response.data) {

                            const BOUGHT: any[] = Object.assign([], item.bought)
                            const EXPIRED: any[] = Object.assign([], item.expired)

                            const Bought: boolean[] = []
                            if (item && item.bought) {
                                let bought: string = ''
                                for (let i: number = 0; i < item.bought.length; i++) {
                                    if (+item.bought[i] === 0) { Bought.push(false) } else { Bought.push(true) }
                                    if (!Bought[i]) { continue }
                                    if (bought.length > 0) { bought += ',' }
                                    bought += item.bought[i].toString()
                                }
                                item.bought = bought
                            }

                            if (item && item.expired) {
                                let expired: string = ''
                                for (let i: number = 0; i < item.expired.length; i++) {
                                    if (!Bought[i]) { continue }
                                    if (expired.length > 0) { expired += ',' }
                                    expired += item.expired[i].toString()
                                }
                                item.expired = expired
                            }
                            let rgt: number = -1
                            if (item && item['Game Type']) {
                                let gametype: string = ''
                                for (let i: number = 0; i < item['Game Type'].length; i++) {
                                    if (!Bought[i]) { continue }
                                    if (+item['Game Type'][i] === Main.Instance.GZG.ID) { rgt = i }
                                    if (gametype.length > 0) { gametype += ',' }
                                    gametype += item['Game Type'][i].toString()
                                }
                                item['Game Type'] = gametype
                            }

                            if (Main.Instance.GZG.gametype === true && (rgt === -1 || +BOUGHT[rgt] === +EXPIRED[rgt])) { continue }

                            let pos: number = -1
                            if (item && item.raffleid) {
                                for (let i: number = 0; i < item.raffleid.length; i++) {
                                    if (+Main.Instance.GZG.data[Main.Instance.GZG.chosenTicket].id === +item.raffleid[i]) {
                                        pos = i
                                        break
                                    }
                                }
                            }

                            if (item && item['Raffle result'] && pos > -1) {
                                item['Raffle result'] = item['Raffle result'][pos] === true ? Assets.Win : Assets.Loss
                            }
                            response1.push(item)
                        }
                        Logic.Type.New(Main.Instance.GZG, { data2: response1, Count: response1.length, countCalled: false })
                    })
            })
    }
}

export function insertGameType(items: any, callback?: () => void, callback2?: () => void) {
    axios.post(getGameType(), items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (callback) {
                callback()
            }
        }).catch((err) => alert(err))
}

export function updateGameType(items: any, callback: () => void) {
    axios.put(getGameType(), items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            callback()
        })
        .catch((err) => alert(err))
}

function getGameType(): string {
    if (Main.Instance.GZG.raffle === false) { return Config.ltGameType }
    if (Main.Instance.GZG.raffle === true && Main.Instance.GZG.jackpotRaffle === false) { return Config.ltRaffleGameType }
    if (Main.Instance.GZG.raffle === true && Main.Instance.GZG.jackpotRaffle === true) { return Config.ltRaffleJackpotGameType }
    return ''
}

export function removeGameType(id: string, callback: () => void) {
    axios.delete(getGameType() + '?id=' + id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function getGZG(insertRaffleJackpotTicket?: number) {
    let rest: string
    let Rest: string
    if (insertRaffleJackpotTicket) {
        Rest = Config.ltRaffle
    } else if (Main.Instance.GZG.raffle === false && Main.Instance.GZG.gametype === true) {
        Rest = Config.ltGameType
    } else if (Main.Instance.GZG.raffle === false && Main.Instance.GZG.gametype === false) {
        Rest = Config.ltDraw
    } else if (Main.Instance.GZG.raffle === true && Main.Instance.GZG.gametype === true) {
        if (Main.Instance.GZG.jackpotRaffle === true) { Rest = Config.ltRaffleJackpotGameType } else { Rest = Config.ltRaffleGameType }
    } else if (Main.Instance.GZG.raffle === true && Main.Instance.GZG.gametype === false) {
        /*if (Main.Instance.GZG.jackpotRaffle) Rest = Config.ltRaffle
        else*/
        Rest = Config.ltRaffle
    }

    rest = Rest + '?limit=' + Main.Instance.GZG.pSize + '&offset=' + Main.Instance.GZG.offset + '&jackpot=' + Main.Instance.GZG.jackpotRaffle
    axios.get(rest, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            axios.patch(Rest, { jackpot: Main.Instance.GZG.jackpotRaffle }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                .then((response0) => {
                    for (const item of response.data) {
                        let currency: string
                        /*
                                        if (item && item.JR) {
                                            if (item.JR.toString() === 'true') item.JR = 'Yes'
                                            else item.JR = 'No'
                                        } else if (item && !item.JR) {
                                            item.JR = 'No'
                                        }
                        */
                        if (item && item.currency) {
                            currency = item.currency === 'EUR' ? '€' : item.currency === 'USD' ? '$' : item.currency
                        }

                        if (item && currency && item.stake && item['Win amount']) {
                            item.stake += ' ' + currency
                            item['Win amount'] = numberWithCommas(item['Win amount']) + ' ' + currency
                        }

                        if (item && currency && item.stake && item.win) {
                            item.stake += ' ' + currency
                            item.win = numberWithCommas(item.win) + ' ' + currency
                        }

                        if (item && item['Winner IDs']) {
                            let winner_ids: string = ''
                            for (const Item of item['Winner IDs']) {
                                if (winner_ids.length > 0) { winner_ids += ',' }
                                winner_ids += Item.toString()
                            }
                            item['Winner IDs'] = winner_ids
                        }

                        if (item && item['Serial numbers']) {
                            let serialNumbers: string = ''
                            for (const Item of item['Serial numbers']) {
                                if (serialNumbers.length > 0) { serialNumbers += ',' }
                                serialNumbers += Item.toString()
                            }
                            item['Serial numbers'] = serialNumbers
                        }

                        if (item && item.numbers) {
                            let numbers: string = ''
                            for (const Item of item.numbers) {
                                if (numbers.length > 0) { numbers += ',' }
                                numbers += Item.toString()
                            }
                            item.numbers = numbers
                        }

                        if (item && item[Assets.LotteryName] && item['Jackpot Size'] !== undefined && +item['Jackpot Size'] === 0 && currency) {

                            if (item[Assets.LotteryName] === 'Lottery 1') { item['Jackpot Size'] = numberWithCommas(560000) + ' ' + currency } else if (item[Assets.LotteryName] === 'Lottery 2') { item['Jackpot Size'] = numberWithCommas(235000) + ' ' + currency } else if (item[Assets.LotteryName] === 'Lottery 3') { item['Jackpot Size'] = numberWithCommas(767300) + ' ' + currency } else if (item[Assets.LotteryName] === 'Lottery 4') { item['Jackpot Size'] = numberWithCommas(1200000) + ' ' + currency }
                        }
                    }
                    if (insertRaffleJackpotTicket) {

                        const finalMessage: string = insertRaffleJackpotTicket === parseInt(response.data[0]['Winner IDs']) ?
                            Assets.c1 + ' ' + response.data[0]['Raffle name'] + '!' :
                            Assets.TicketID + response.data[0]['Winner IDs'] + ' ' + Assets.Won.toLowerCase() + ' ' + response.data[0]['Win amount']

                        alert(Assets.New + ' ' + response.data[0]['Raffle name'] + ' ' + Assets.Draw.toLowerCase() + ' ' + Assets.On.toLowerCase() + ' ' + response.data[0]['Raffle Datetime'] + '\n'
                            + response.data[0]['participants'] + Assets.gitdf + response.data[0]['stake'] + '\n'
                            + Assets.YourTestTicketIDIs + ' ' + insertRaffleJackpotTicket.toString() + '\n'
                            + finalMessage)
                    } else { Logic.Type.New(Main.Instance.GZG, { data: response.data, count: +response0.data.count, countCalled: false }) }
                })
        })
}

export function getLotto(transactions?: boolean) {
    if (transactions && Main.Instance.DatabaseDataState.lottoGameTypeStream) {
        getLottoTransactions()
    } else {

        let sql: string = Config.lsDrawings
        axios.get(sql, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response0000) => {
                sql = Config.lsGameType
                axios.get(sql, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                    .then((response00) => {
                        sql = Config.lsJackpot
                        axios.get(sql, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                            .then((response000) => {
                                sql = Config.lsLotteryCount + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                                axios.get(sql, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                                    .then((response0) => {
                                        sql = Config.lsLottery + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                                            + '&limit=' + Main.Instance.LottoState.pSize + '&offset=' + Main.Instance.LottoState.offset
                                        axios.get(sql, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                                            .then((response) => {
                                                for (const item of response.data) {
                                                    for (const Item of response000.data) {
                                                        item['jackpot'] = 0
                                                        item['jackpot_currency'] = Assets_.NA
                                                        if (+Item['gametypeid'] === +item['identification']) {
                                                            if (+Item['jackpotsize'] > 0) {
                                                                item['jackpot'] = +Item['jackpotsize']
                                                                item['jackpot_currency'] = Item['jackpotcurrency']
                                                                break
                                                            }
                                                        }
                                                    }
                                                }

                                                Logic.Type.New(Main.Instance.DatabaseDataState, {
                                                    lottoStream: response.data, lottoGameTypeStream: response00.data, lottoJackpotStream: response000.data, lottoDrawingStream: response0000.data
                                                })
                                                Logic.Type.New(Main.Instance.LottoState, { countCalled: false, count: parseInt(response0.data.count) })
                                                if (transactions) { getLottoTransactions() }

                                            }).catch((err) => alert(err))
                                    }).catch((err) => alert(err))
                            }).catch((err) => alert(err))
                    }).catch((err) => alert(err))
            }).catch((err) => console.error(err))
    }
}

export function getRewardShop() {
    if (IsBuildOddyzzey()) {

    } else {
        const search = Main.Instance.SearchState.search_string ? '&search=' + Main.Instance.SearchState.search_string : ''
        axios.get(Config.psCountShopItems + '?site_id=' + Main.Instance.FrontendStoreState.site_id + search +
            '&banner=' + parseInt(Main.Instance.RewardShopState.filter_banner) +
            '&category=' + parseInt(Main.Instance.RewardShopState.filter_category) +
            '&freeround=' + parseInt(Main.Instance.RewardShopState.filter_free_round) +
            '&active=' + parseInt(Main.Instance.RewardShopState.filter_active) +
            '&buyable=' + parseInt(Main.Instance.RewardShopState.filter_buyable) +
            '&newly=' + parseInt(Main.Instance.RewardShopState.filter_only_newly_registered),
        )

            .then((response) => {
                axios.get(Config.psPartShopItems + '?site_id=' + Main.Instance.FrontendStoreState.site_id + search +
                    '&banner=' + parseInt(Main.Instance.RewardShopState.filter_banner) +
                    '&category=' + parseInt(Main.Instance.RewardShopState.filter_category) +
                    '&freeround=' + parseInt(Main.Instance.RewardShopState.filter_free_round) +
                    '&active=' + parseInt(Main.Instance.RewardShopState.filter_active) +
                    '&buyable=' + parseInt(Main.Instance.RewardShopState.filter_buyable) +
                    '&newly=' + parseInt(Main.Instance.RewardShopState.filter_only_newly_registered) +
                    '&limit=' + Main.Instance.RewardShopState.pSize +
                    '&offset=' + Main.Instance.RewardShopState.offset +
                    '&sort=' + Main.Instance.RewardShopState.sort +
                    '&Sort=' + Main.Instance.RewardShopState.Sort,
                )
                    .then((response1) => {
                        axios.get(Config.psAllShopItems + '?site_id=' + Main.Instance.FrontendStoreState.site_id)
                            .then((response2) => {
                                Logic.Type.New(Main.Instance.DatabaseDataState, {
                                    rewardShopStream: response1.data,
                                    rewardShopStreamAll: response2.data,
                                    rewardShopCount: parseInt(response.data.count),
                                })
                            }).catch((err) => alert(err))
                    }).catch((err) => alert(err))
            }).catch((err) => alert(err))
    }
}

export function GiveCoins(coins: number) {
    if (Main.Instance.RSTState.filter_date2 === undefined || Main.Instance.RSTState.filter_date2.length === 0) {
        alert(Assets.p1); return
    }
    if (coins === 0) { alert(Assets.sc1); return }

    if (Main.Instance.DatabaseDataState.playersStream === undefined || Main.Instance.DatabaseDataState.playersStreamSelected === undefined) {
        alert(Assets.PlayersAreNotDefined + '!')
        return
    }

    const players: number[] = []
    for (let i: number = 0; i < Main.Instance.DatabaseDataState.playersStream.length; i++) {
        if (Main.Instance.DatabaseDataState.playersStreamSelected[i]) {
            players.push(Main.Instance.DatabaseDataState.playersStream[i]['player'])
        }
    }
    if (players.length === 0) { alert(Assets.sc2); return }
    if (confirm(Assets.DoYouWantToGive + ' ' + coins + ' ' + Assets.d1 + ' ' + players + '?')) { giveCoins(players, coins, 0) }
}

function giveCoins(player: number[], coins: number, ID: number) {
    // Config.psPlayerStatsXPLXP
    axios.get(Config.psPlayerStatsXPLXP + '?player=' + player[ID])
        .then((response) => {
            const dates = (new Date()).toISOString()
            const date = dates.substring(0, 10)
            const time = dates.substring(11, 19)
            if (response.data.return.name !== 'QueryResultError') {
                const xp: number = +response.data.return.xp + coins

                // let xpl: number = +response.data.return.xpl
                axios.put(Config.psPlayerStatsXPLXP, { player: player[ID].toString(), xp: xp.toString(), xpl: response.data.return.xpl, apikey: Main.Instance.FrontendStoreState.api_key })
                    .then((response1) => {
                        axios.post(Config.psRst, {
                            // mail: Main.Instance.IndexState.mail,
                            // languages: Main.Instance.IndexState.languages,
                            // default_language: Main.Instance.IndexState.default_language,
                            // notify: Main.Instance.IndexState.notify,
                            description: Main.Instance.RSTState.filter_date2,
                            issuer: Main.Instance.LoginState.Username + ' | ' + Main.Instance.LoginState.entity,
                            Category: 0,
                            namespace: 'promotions',
                            date,
                            time,
                            name: 'Support Added Coins',
                            price: coins,
                            quantity: 0,
                            idx: 0,
                            category: 0,
                            value: coins,
                            site_id: 4,
                            balance_before: +response.data.return.xp,
                            balance_after: xp,
                            player_id: player[ID],
                        })

                        if (ID < player.length - 1) { giveCoins(player, coins, ++ID) } else { alert(coins + Assets.d2 + player) }
                    })

            } else {
                const xp: number = coins
                const xpl: number = 0
                axios.post(Config.psRst, {
                    // mail: Main.Instance.IndexState.mail,
                    // languages: Main.Instance.IndexState.languages,
                    // default_language: Main.Instance.IndexState.default_language,
                    // notify: Main.Instance.IndexState.notify,
                    description: Main.Instance.RSTState.filter_date2,
                    issuer: Main.Instance.LoginState.Username + ' | ' + Main.Instance.LoginState.entity,
                    Category: 0,
                    namespace: 'promotions',
                    date,
                    time,
                    name: 'Support Added Coins',
                    price: coins,
                    quantity: 0,
                    idx: 0,
                    category: 0,
                    value: coins,
                    site_id: 4,
                    balance_before: xpl,
                    balance_after: xp,
                    player_id: player[ID],
                })

                if (ID < player.length - 1) { giveCoins(player, coins, ++ID) } else { alert(coins + Assets.d3 + player) }
            }
        })
}

export function RemoveCoins(coins: number) {
    if (Main.Instance.RSTState.filter_date2 === undefined || Main.Instance.RSTState.filter_date2.length === 0) {
        alert(Assets.d4); return
    }
    if (coins === 0) { alert(Assets.d5); return }

    if (Main.Instance.DatabaseDataState.playersStream === undefined || Main.Instance.DatabaseDataState.playersStreamSelected === undefined) {
        alert(Assets.PlayersAreNotDefined + '!')
        return
    }

    const players: number[] = []
    for (let i: number = 0; i < Main.Instance.DatabaseDataState.playersStream.length; i++) {
        if (Main.Instance.DatabaseDataState.playersStreamSelected[i]) {
            players.push(Main.Instance.DatabaseDataState.playersStream[i]['player'])
        }
    }

    if (players.length === 0) { alert(Assets.d6); return }
    if (confirm(Assets.DoYouWantToRemove + ' ' + coins + Assets.d7 + players + '?')) { removeCoins(players, coins, 0) }
}

function removeCoins(player: number[], coins: number, ID: number) {
    // Config.psPlayerStatsXPLXP
    axios.get(Config.psPlayerStatsXPLXP + '?player=' + player[ID])
        .then((response) => {
            let xp: number = +response.data.return.xp - coins
            if (xp < 0) {
                xp = 0
                coins = +response.data.return.xp
            }
            // let xpl: number = response.data.return.xpl
            axios.put(Config.psPlayerStatsXPLXP, { player: player[ID].toString(), xp: xp.toString(), xpl: response.data.return.xpl, apikey: Main.Instance.FrontendStoreState.api_key })
                .then((response1) => {

                    const dates = (new Date()).toISOString()
                    const date = dates.substring(0, 10)
                    const time = dates.substring(11, 19)

                    axios.post(Config.psRst, {
                        // mail: Main.Instance.IndexState.mail,
                        // languages: Main.Instance.IndexState.languages,
                        // default_language: Main.Instance.IndexState.default_language,
                        // notify: Main.Instance.IndexState.notify,
                        description: Main.Instance.RSTState.filter_date2,
                        issuer: Main.Instance.LoginState.Username + ' | ' + Main.Instance.LoginState.entity,
                        Category: 0,
                        namespace: 'promotions',
                        date,
                        time,
                        name: 'Support Removed Coins',
                        price: coins,
                        quantity: 0,
                        idx: 0,
                        category: 0,
                        value: coins,
                        site_id: 4,
                        balance_before: +response.data.return.xp,
                        balance_after: xp,
                        player_id: player[ID],
                    })

                    if (ID < player.length - 1) { giveCoins(player, coins, ++ID) } else { alert(coins + Assets.d8 + player) }
                })
        })
}


export function insertData() {
    axios.patch(Config.asTestSite, { site_id: Main.Instance.FrontendStoreState.site_id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response0) => {
            if (parseInt(response0.data.count) === 0) {
                insertAdminLog(Config.asAdminLogSaveInsert, 'Settings -> Generic Settings', Main.Instance.FrontendStoreState.custom)
                axios.post(
                    Config.asTestSite, {
                    christmas: Main.Instance.FrontendStoreState.christmas,
                    blackFriday: Main.Instance.FrontendStoreState.blackFriday,
                    activeBlackFriday: Main.Instance.FrontendStoreState.activeBlackFriday,
                    activeChristmas: Main.Instance.FrontendStoreState.activeChristmas,
                    custom: Main.Instance.FrontendStoreState.custom,
                    translation: Main.Instance.FrontendStoreState.translation,
                    images: Main.Instance.FrontendStoreState.images,
                    minlevel: Main.Instance.FrontendStoreState.minlevel,
                    mail: Main.Instance.FrontendStoreState.mail,
                    notify: Main.Instance.FrontendStoreState.notify,
                    games_folder: Main.Instance.FrontendStoreState.games_folder,
                    menu_active: Main.Instance.FrontendStoreState.menu_active ? Main.Instance.FrontendStoreState.menu_active : [],
                    menu_inactive: Main.Instance.FrontendStoreState.menu_inactive ? Main.Instance.FrontendStoreState.menu_inactive : [],
                    category: Main.Instance.FrontendStoreState.category ? Main.Instance.FrontendStoreState.category : [],
                    rsbackground: Main.Instance.FrontendStoreState.rs_background ? Main.Instance.FrontendStoreState.rs_background : '',
                    rspopupbg: Main.Instance.FrontendStoreState.rs_popup_bg ? Main.Instance.FrontendStoreState.rs_popup_bg : '',
                    site_id: Main.Instance.FrontendStoreState.site_id,
                    default_image: Main.Instance.FrontendStoreState.shopItemDefaultFilename,
                    logo: Main.Instance.FrontendStoreState.logo,
                    logo2: Main.Instance.FrontendStoreState.logo2,
                    name: Main.Instance.FrontendStoreState.title,
                    menus: Main.Instance.FrontendStoreState.menus,
                    menus_type: Main.Instance.FrontendStoreState.menus_type,
                    groups: Main.Instance.FrontendStoreState.groups,
                    show_version_info: Main.Instance.FrontendStoreState.show_version_info,
                    show_game_info: Main.Instance.FrontendStoreState.show_game_info,
                    show_debug_info: Main.Instance.FrontendStoreState.show_debug_info,
                    display_name: Main.Instance.FrontendStoreState.display_name,
                    borders: Main.Instance.FrontendStoreState.borders,
                    /*
                    subdomain: Main.Instance.DatabaseDataState.domains[parseInt(Main.Instance.FrontendStoreState.domain_id) - 1]['name'] ?
                        Main.Instance.DatabaseDataState.domains[parseInt(Main.Instance.FrontendStoreState.domain_id) - 1]['name'].split('.')[0] : 'unknown'
                    */
                },
                    { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } },
                )
                    .then((response) => {
                        alert(Assets.DataSavedSuccessInsert)
                    })
            } else {
                insertAdminLog(Config.asAdminLogSaveEdit, 'Settings -> Generic Settings', Main.Instance.FrontendStoreState.custom)
                axios.put(
                    Config.asTestSite, {
                    christmas: Main.Instance.FrontendStoreState.christmas,
                    blackFriday: Main.Instance.FrontendStoreState.blackFriday,
                    activeBlackFriday: Main.Instance.FrontendStoreState.activeBlackFriday,
                    activeChristmas: Main.Instance.FrontendStoreState.activeChristmas,
                    custom: Main.Instance.FrontendStoreState.custom,
                    translation: Main.Instance.FrontendStoreState.translation,
                    images: Main.Instance.FrontendStoreState.images,
                    minlevel: Main.Instance.FrontendStoreState.minlevel,
                    mail: Main.Instance.FrontendStoreState.mail,
                    notify: Main.Instance.FrontendStoreState.notify,
                    games_folder: Main.Instance.FrontendStoreState.games_folder,
                    menu_active: Main.Instance.FrontendStoreState.menu_active ? Main.Instance.FrontendStoreState.menu_active : [],
                    menu_inactive: Main.Instance.FrontendStoreState.menu_inactive ? Main.Instance.FrontendStoreState.menu_inactive : [],
                    category: Main.Instance.FrontendStoreState.category ? Main.Instance.FrontendStoreState.category : [],
                    rsbackground: Main.Instance.FrontendStoreState.rs_background ? Main.Instance.FrontendStoreState.rs_background : '',
                    rspopupbg: Main.Instance.FrontendStoreState.rs_popup_bg ? Main.Instance.FrontendStoreState.rs_popup_bg : '',
                    default_image: Main.Instance.FrontendStoreState.shopItemDefaultFilename,
                    logo: Main.Instance.FrontendStoreState.logo,
                    logo2: Main.Instance.FrontendStoreState.logo2,
                    site_id: Main.Instance.FrontendStoreState.site_id,
                    name: Main.Instance.FrontendStoreState.title,
                    menus: Main.Instance.FrontendStoreState.menus,
                    menus_type: Main.Instance.FrontendStoreState.menus_type,
                    groups: Main.Instance.FrontendStoreState.groups,
                    show_version_info: Main.Instance.FrontendStoreState.show_version_info,
                    show_game_info: Main.Instance.FrontendStoreState.show_game_info,
                    show_debug_info: Main.Instance.FrontendStoreState.show_debug_info,
                    display_name: Main.Instance.FrontendStoreState.display_name,
                    borders: Main.Instance.FrontendStoreState.borders,
                    /*subdomain: Main.Instance.DatabaseDataState.domains[
                    parseInt(Main.Instance.FrontendStoreState.domain_id) - 1]['name'] ?
                    Main.Instance.DatabaseDataState.domains[
                    parseInt(Main.Instance.FrontendStoreState.domain_id) - 1]['name'].split('.')[0] : 'unknown'*/
                },
                    { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                    .then((response) => {
                        if (response.status === 200) { alert(Assets.DataSavedSuccessUpdate) }
                    })
            }
        })
}

export function getContractualPartnerMaster(cp_id: string, proceed: boolean) {
    axios.get(Config.asCpMaster + '?cp_id=' + cp_id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (proceed) {
                getContractualPartnersByTypeAll(Assets_.OPERATOR, response.data.holding_id)
            }
        })
}

export function getContractualPartnersByTypeAll(type: number, force_master_id?: string) { // !!!
    let entity_id: string

    if (isUserMaster()) {
        entity_id = Main.Instance.LoginState.entityId
    }

    if (force_master_id) {
        entity_id = force_master_id
    }
    let sql: string = Config.asCpByTypeAll + '?type_id=' + type
    if (entity_id !== undefined) { sql += '&entity_id=' + entity_id }

    axios.get(sql, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (response.data) {
                if (type !== Assets_.SITE_OWNER) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream2: response.data })
                }
            }
        })
}

export function getSubEntityByTypeAll(type: number, force_entity_id?: number, callback?: (a: any[]) => void) {

    let entity_id: string
    let entity_id_master: string

    const force_entity: string = force_entity_id ? force_entity_id.toString() : undefined

    if (isUserMaster()) {
        entity_id_master = Main.Instance.LoginState.entityId
    } else if (isUserContractualPartner()) {
        entity_id = Main.Instance.LoginState.entityId
    }

    let query = '/se-all/?type_id=' + type
    if (entity_id) {
        query += '&entity_id=' + entity_id
    }
    if (entity_id_master) {
        query += '&entity_id_master=' + entity_id_master
    }
    if (force_entity) {
        query += '&force_entity_id=' + force_entity
    }
    axios.get(Config.adminServer + query, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
        .then((response) => {
            if (response.data) {
                if (!force_entity_id) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { subEntityAllStream: response.data })
                } else if (force_entity_id) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { sitesOperatorAllStream: response.data })
                }

                if (callback) {
                    callback(response.data)
                }
                /*
                      if (type !== Assets_.SITE_OWNER) {
                        Logic.Type.New (Main.Instance.DatabaseDataState, {subEntityAllStream: response.data})
                      } else {
                        Logic.Type.New (Main.Instance.DatabaseDataState, {subEntityAllStream2: response.data})
                      }
                */
            }
        })
}

export function getAllSitesByOperator(operator_id?: string) {
    const arg: string = isUserOperator() ? Main.Instance.LoginState.entityId : operator_id
    axios.get(Config.adminServer + '/sites-all-by-operator/?arg=' + arg, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
        .then((response) => {
            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { sitesOperatorAllStream: response.data })
            }
        })
}

export function getAllSitesBySiteOwner(site_owner_id?: string) {
    const arg: string = isUserSiteOwner() ? Main.Instance.LoginState.entityId : site_owner_id
    axios.get(Config.adminServer + '/sites-all-by-site-owner/?arg=' + arg, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
        .then((response) => {
            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { sitesOperatorAllStream: response.data })
            }
        })
}

export function getAllSitesByOperatorOrSiteOwner(contractual_partner_id?: string) {
    const arg: string = contractual_partner_id ? contractual_partner_id : Main.Instance.LoginState.entityId
    axios.get(Config.adminServer + '/sites-all-by-operator-or-site-owner/?arg=' + arg, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
        .then((response) => {
            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { sitesOperatorAllStream: response.data })
            }
        })
}

export function getParentsFromSite(site_id: string, callback: (c: any) => void, items?: any) {
    axios.get(Config.adminServer + '/site-parents/?site_id=' + site_id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
        .then((response) => {
            if (response.data && response.data['contractual_partner_id'] &&
                response.data['holding_id']) {
                Logic.Type.New(Main.Instance.ReusableState, {
                    operator_id: response.data['contractual_partner_id'],
                    holding_id: response.data['holding_id'],
                })
                if (items) {
                    callback(items)
                } else {
                    callback(undefined)
                }
            }
        })
}

export function getSubLevelsAllByLevel(level_id: string) {
    axios.get(Config.psSubLevelsAllByLevel + '?level_id=' + level_id)
        .then((response) => {
            if (response.data) {
                Logic.Type.New(
                    Main.Instance.DatabaseDataState, {
                    sublevelsAllStream: response.data,
                },
                )
            }
        })
}

export function getPointTypes(type: number, callback?: () => void) {
    axios.get(Config.psAllPointTypes)
        .then((response) => {
            if (response.data) {
                if (type === 0) { Logic.Type.New(Main.Instance.CategoryDetailState, { category_id: '0' }) }
                if (type === 1) { Logic.Type.New(Main.Instance.CRMPointState, { type_id: '0' }) }
                axios.get(Config.psAllSubPointTypes)
                    .then((response2) => {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            pointTypeStreamAll: response.data, subpointTypeStreamAll: response2.data
                        })
                    })
            }
        })

    if (callback) { callback() }
}

export function GetPointTypes(callback?: () => void) {
    axios.get(Config.psCountPointTypes)
        .then((response) => {
            if (response.data) {
                axios.get(Config.psPartPointTypes + '?offset=' + Main.Instance.CategoryDetailState.offset
                    + '&limit=' + Main.Instance.CategoryDetailState.pSize)
                    .then((response2) => {
                        if (response2.data) {
                            Logic.Type.New(Main.Instance.CategoryDetailState, { countCalled: false, count: parseInt(response.data.count) })
                            Logic.Type.New(Main.Instance.DatabaseDataState, { pointTypeStream: response2.data })
                        }
                    })
            }
        })

    if (callback) { callback() }
}

export function GetPointTypesAll(/*callback?:() => void*/) {
    axios.get(Config.psCountPointTypes)
        .then((response) => {
            if (response.data) {
                axios.get(Config.psPartPointTypes + '?offset=0&limit=9999')
                    .then((response2) => {
                        if (response2.data) {
                            // Logic.Type.New(Main.Instance.CategoryDetailState, {countCalled:false, count:parseInt(response.data.count)})
                            const pointTypeStreamAll: any[] = []
                            for (const item of response2.data) { pointTypeStreamAll.push({ id: item.id, name: item.category }) }
                            Logic.Type.New(Main.Instance.DatabaseDataState, { pointTypeStreamAll })
                        }
                    })
            }
        })

}


export function countSubPointTypesByPointType(point_type_id: string) {
    axios.get(Config.psCountSubPointTypesByPointType + '?point_type_id=' + point_type_id)
        .then((response) => {
            if (response.data) {
                axios.get(Config.psPartSubPointTypesByPointType + '?point_type_id=' + point_type_id
                    + '&offset=' + Main.Instance.CategoryDetailState.Offset + '&limit=' + Main.Instance.CategoryDetailState.PSize)
                    .then((response2) => {
                        if (response2.data) {
                            Logic.Type.New(Main.Instance.CategoryDetailState, { CountCalled: false, Count: parseInt(response.data.count) })
                            Logic.Type.New(Main.Instance.DatabaseDataState, { subPointTypeStream: response2.data })
                        }
                    })
            }
        })
}

export function getSubPointTypesByPointType(point_type_id: string, filter?: boolean) {
    axios.get(Config.psSubPointTypesByPointType + '?point_type_id=' + point_type_id)
        .then((response) => {
            if (response.data) {
                if (filter) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { subPointFilterTypeStreamAll: response.data })
                } else {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { subPointTypeStreamAll: response.data })
                }
            }
        })
}

export function getSubLevels2AllByLevel(level_id: string) {
    axios.get(Config.psSubLevelsAllByLevel + '?level_id=' + level_id)
        .then((response) => {
            if (response.data) {
                Logic.Type.New(
                    Main.Instance.DatabaseDataState, {
                    sublevels2AllStream: response.data,
                },
                )
            }
        })
}

export function getLevelsAll(filter: boolean, callback?: () => void) {
    axios.get(Config.psLevelsAll)
        .then((response) => {
            if (response.data) {
                if (filter) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { levelsAllFilterStream: response.data })
                } else {
                    if (!IsBuildOddyzzey()) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, { levelsAllStream: response.data })
                    }
                }
            }
        })

    if (callback) { callback() }
}

export function getLevelsAllDetailsBySite(site_id?: string) {
    const site = site_id !== undefined ? site_id : Main.Instance.FrontendStoreState.site_id

    axios.get(Config.psLevelsAllDetailsBySite + '?site_id=' + site)
        .then((response) => {
            if (response.data) {
                const data: any[] = []
                let bigLevels: number = 0
                let sublevels: number = 0
                let finalLevel: string = ''

                for (const level of response.data) {
                    data.push({
                        id: level.hierarchy,
                        level: level.hierarchy,
                        name: level.name,
                        prte: level.prte,
                        sublevels: level.sublevels,
                        level_value: level.level_value,
                        stagnation: level.stagnation,
                        reward_every: level.reward_every,
                        final_level: level.final_level,
                    })

                    if (level.tokens.tokens) {
                        bigLevels++
                        if (level['sublevels']) { sublevels += parseInt(level['sublevels']) }
                        if (level['final_level']) { finalLevel = level['name'] }
                    }
                }

                Logic.Type.New(Main.Instance.DatabaseDataState, { levelsAllDetailsStream: data, bigLevels, sublevels, finalLevel })
            }
        })
}

export function getLevelsAllBySite(type: number, site_id: string, filter: boolean, callback?: () => void) {
    axios.get(Config.psLevelsAllBySite + '?site_id=' + site_id)
        .then((response) => {
            if (response.data) {
                if (filter) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { levelsAllFilterStream: response.data })
                } else {
                    if (type === 0) { Logic.Type.New(Main.Instance.CRMLevelsState, { level_id: '0' }) }
                    if (type === 1) { Logic.Type.New(Main.Instance.CRMAchievementsState, { level_id: '0' }) }
                    // if (type === 2) Logic.Type.New(Main.Instance.CRMPlayerGroupsRewardsState, {rew3_chosen:'0',req2_chosen:'0'})
                    if (!IsBuildOddyzzey()) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, { levelsAllStream: response.data })
                    }
                }
            }
        })

    if (callback) { callback() }
}

export function insertCurrency(items: any, callback: () => void) {
    axios.post(Config.psCurrency, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function updateCurrency(items: any, callback: () => void) {
    axios.put(Config.psCurrency, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function RemoveCurrency(id: string, callback: () => void) {
    axios.delete(Config.psCurrency + '?id=' + id)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function updateCategory(items: any, callback: () => void) {
    axios.put(Config.psCategory, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function removeCategory(id: string, callback: () => void) {
    axios.delete(Config.psCategory + '?id=' + id)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function insertCategory(items: any, callback?: () => void) {
    axios.post(Config.psCategory, items)
        .then((response) => {
            if (response.data && response.data.toString() === 'duplicate') {
                alert(Assets.DuplicateCategory)
            } else if (callback) {
                callback()
            }
        }).catch((err) => alert(err))
}

export function updateType(items: any, callback: () => void) {
    axios.put(Config.psType, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function removeType(id: string, callback: () => void) {
    axios.delete(Config.psType + '?id=' + id)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function insertType(items: any, callback?: () => void) {
    axios.post(Config.psType, items)
        .then((response) => {
            if (response.data && response.data.toString() === 'duplicate') {
                alert(Assets.DuplicateType)
            } else if (callback) {
                callback()
            }
        }).catch((err) => alert(err))
}

export function GetCurrencyAll() {
    axios.get(Config.psCurrencyAll + '?site_id=' + Main.Instance.FrontendStoreState.site_id)
        .then((response) => {
            if (response.data) {
                if (response.data) {
                    let proceed = true
                    for (const item of response.data) {
                        if (item['main'].toString() === 'true') {
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                currenciesAllStream: response.data,
                                mainCurrency: item['name'].toString(),
                            })
                            proceed = false
                            break
                        }
                    }
                    if (proceed) {
                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                            currenciesAllStream: response.data,
                            mainCurrency: 'EUR'
                        })
                    }
                }
            }
        }).catch((err) => alert(err))
}

export function GetCurrency() {
    axios.get(Config.psCurrencyRates)
        .then((response0) => {
            if (response0.data) {
                const date: string = response0.data[0]['date'].toString()
                // Logic.Type.New(Main.Instance.DatabaseDataState, { lastDateCurrency: date })

                axios.get(Config.psCurrencyPart + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                    + '&offset=' + Main.Instance.CurrencyState.offset
                    + '&limit=' + Main.Instance.CurrencyState.pSize
                    + '&filter_active=' + Main.Instance.CurrencyState.filter_active
                    + '&date=' + date,
                )
                    .then((response) => {
                        if (response.data) {
                            axios.get(Config.psCurrencyCount + '?site_id=' + Main.Instance.FrontendStoreState.site_id + '&filter_active=' + Main.Instance.CurrencyState.filter_active)
                                .then((response2) => {
                                    if (response2.data) {
                                        Logic.Type.New(Main.Instance.CurrencyState, { countCalled: false, count: parseInt(response2.data.count) })
                                        Logic.Type.New(Main.Instance.DatabaseDataState, { currenciesStream: response.data, lastDateCurrency: date })
                                    }
                                }).catch((err) => alert(err))
                        }
                    }).catch((err) => alert(err))
            }
        }).catch((err) => alert(err))
}

export function insertLanguage(items: any, callback: () => void) {
    axios.post(Config.psLanguage, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function updateLanguage(items: any, callback: () => void) {
    axios.put(Config.psLanguage, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function RemoveLanguage(id: string, callback: () => void) {
    axios.delete(Config.psLanguage + '?id=' + id)
        .then((response) => callback())
        .catch((err) => alert(err))
}

function GetLanguagesAll() {
    axios.get(Config.psLanguagePart + '?site_id=' + Main.Instance.FrontendStoreState.site_id + '&limit=999999&offset=0&filter_active=0')
        .then((response) => {
            if (response.data) {
                const languages: any[] = []

                let language: number = 0
                let count: number = 0

                for (const item of response.data) {
                    let Count: number = 0
                    if (Main.Instance.DatabaseDataState.languagesAllStream) {
                        for (const Language of Main.Instance.DatabaseDataState.languagesAllStream) {
                            Count++
                            if (Count === item['name']) {
                                languages.push({ id: count + 1, name: Language['name'] })
                                break
                            }
                        }
                    }
                    if (item['main'] === true) {
                        language = count
                    }
                    count++
                }
                Logic.Type.New(Main.Instance.DatabaseDataState, { languagesStreamAll: response.data, language, languages })
            }
        }).catch((err) => alert(err))
}

function dynamicSort(property: any) {
    let sortOrder = 1;
    if (property[0] === '-') {
        sortOrder = -1;
        property = property.substr(1);
    }
    return (a: any, b: any) => {
        const result = ((a[property] && a[property].toLowerCase()) < (b[property] && b[property].toLowerCase())) ? -1 :
            ((a[property] && a[property].toLowerCase()) > (b[property] && b[property].toLowerCase())) ? 1 : 0;
        return result * sortOrder;
    }
}

export function GetAllLanguages(init?: boolean) {
    axios.get(Config.asLanguages, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { languagesAllStream: response.data })
                if (parseInt(Main.Instance.FrontendStoreState.site_id) > 0) { GetLanguagesAll() }
                if (init) { GetLanguages() }
            }
        })
}

export function insertLotteryItem(lotteryItem: any, callback: () => void) {
    axios.post(Config.lsLottery, lotteryItem, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
        .catch((e) => e)
}

export function updateLotteryItem(lotteryItem: any, callback: () => void) {
    axios.put(Config.lsLottery, lotteryItem, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
        .catch((e) => e)
}

export function removeLotteryItem(id: string, index: number, callback: () => void) {
    axios.delete(Config.lsLottery + '?id=' + id + '&index=' + index + '&site_id=' + Main.Instance.FrontendStoreState.site_id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function patchLotteryItem(id: string, value: string, old_value: string, callback: () => void) {
    axios.patch(Config.lsLottery, { id, value, old_value, site_id: Main.Instance.FrontendStoreState.site_id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            callback()
        }).catch((err) => alert(err))
}

export function Initialize() {
    if (!Main.Instance.DatabaseDataState.FlagsStreamAll) { GetSmallFlags() }
    if (!Main.Instance.CurrencyRatesState.crypto) { getCurrencyRates() }
    if (!Main.Instance.DatabaseDataState.currenciesAllStream) { GetCurrencyAll() }
    if (!Main.Instance.DatabaseDataState.currencyStream) { getCurrencyNames() }
    if (!Main.Instance.DatabaseDataState.pointTypeStreamAll) { GetPointTypesAll() }
    if (!Main.Instance.DatabaseDataState.subpointTypeStreamAll) { getPointTypes(0) }
    if (Main.Instance.DashboardState.countCalled === true) {
        Logic.Type.New(Main.Instance.DashboardState, { countCalled: false })
    }
}

export function InitializeSite() {
    if (!Main.Instance.DatabaseDataState.languagesAllStream || !Main.Instance.DatabaseDataState.languagesStreamAll) { GetAllLanguages(true) }
    loadData()
    GetCurrency()
    if (Socket1 && Socket1.socket) { getLevels() }
    getLevelsAllDetailsBySite()
    getLevelsAllBySite(3, Main.Instance.FrontendStoreState.site_id, false)

    if (!IsBuildScandibet()) {
        GetGames()
        GetBanner()
        // getLotto()
    }

    getAchievementsAllBySite(Main.Instance.FrontendStoreState.site_id, true)
    getAchievementsBySite(Main.Instance.FrontendStoreState.site_id)
    tournamentsCount()
}

export function GetLanguages() {
    axios.get(Config.psLanguagePart + '?site_id=' + Main.Instance.FrontendStoreState.site_id
        + '&offset=' + Main.Instance.LanguageState.offset
        + '&limit=' + Main.Instance.LanguageState.pSize
        + '&filter_active=' + Main.Instance.LanguageState.filter_active)
        .then((response) => {
            if (response.data) {
                for (const item of response.data) {
                    let count: number = 1
                    for (const language of Main.Instance.DatabaseDataState.languagesAllStream) {
                        if (count === item['code_id']) {
                            item['code'] = language['code']
                            item['path'] = '/' + item['path']
                            item['name'] = language['name']
                            item['native'] = language['native']
                            item['direction'] = language['direction']
                            break
                        }
                        count++
                    }
                }

                axios.get(Config.psLanguageCount + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                    + '&filter_active=' + Main.Instance.LanguageState.filter_active)
                    .then((response2) => {
                        if (response2.data) {
                            Logic.Type.New(Main.Instance.LanguageState, { countCalled: false, count: parseInt(response2.data.count) })
                            Logic.Type.New(Main.Instance.DatabaseDataState, { languagesStream: response.data })
                        }
                    }).catch((err) => alert(err))
            }
        }).catch((err) => alert(err))
}

export function GetBanner() {
    axios.get(Config.psBannerPart + '?site_id=' + Main.Instance.FrontendStoreState.site_id
        + '&offset=' + Main.Instance.BannerState.offset
        + '&limit=' + Main.Instance.BannerState.pSize
        + '&filter_active=' + Main.Instance.BannerState.filter_active,
    )
        .then((response) => {
            if (response.data) {
                axios.get(Config.psBannerCount + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                    + '&filter_active=' + Main.Instance.BannerState.filter_active)
                    .then((response2) => {
                        if (response2.data) {
                            axios.get(Config.psBanner + '?site_id=' + Main.Instance.FrontendStoreState.site_id)
                                .then((response3) => {
                                    if (response3.data) {
                                        const bannerStreamAll: any[] = []
                                        const bannerStreamAll2: any[] = []
                                        bannerStreamAll.push({ id: '0', name: Assets.SelectBanner, image: Assets_.zeroPng })
                                        bannerStreamAll2.push({ id: '0', name: Assets.Any, image: Assets_.zeroPng })
                                        for (const item of response3.data) {
                                            bannerStreamAll.push(item)
                                            bannerStreamAll2.push(item)
                                        }

                                        Logic.Type.New(Main.Instance.BannerState, { countCalled: false, count: parseInt(response2.data.count) })
                                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                                            bannerStream: response.data, bannerStreamAll, bannerStreamAll2
                                        })
                                    }
                                }).catch((err) => alert(err))
                        }
                    }).catch((err) => alert(err))
            }
        }).catch((err) => alert(err))
}

export function insertBanner(items: any, callback: () => void) {
    axios.post(Config.psBanner, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function updateBanner(items: any, callback: () => void) {
    axios.put(Config.psBanner, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function RemoveBanner(id: string, callback: () => void) {
    axios.delete(Config.psBanner + '?id=' + id)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function GetGames() {
    const str = Config.psGamePart + '?site_id=' + Main.Instance.FrontendStoreState.site_id
        + '&offset=' + Main.Instance.FrontendGamesState.offset
        + '&limit=' + Main.Instance.FrontendGamesState.pSize
        + '&filter_active=' + Main.Instance.FrontendGamesState.filter_active
    axios.get(str)
        .then((response) => {
            if (response.data) {
                axios.get(Config.psGameCount + '?site_id=' + Main.Instance.FrontendStoreState.site_id
                    + '&filter_active=' + Main.Instance.FrontendGamesState.filter_active)
                    .then((response2) => {
                        if (response2.data) {
                            axios.get(Config.psGame + '?site_id=' + Main.Instance.FrontendStoreState.site_id)
                                .then((response3) => {
                                    if (response3.data) {
                                        Logic.Type.New(Main.Instance.FrontendGamesState, { countCalled: false, count: parseInt(response2.data.count) })
                                        Logic.Type.New(Main.Instance.DatabaseDataState, {
                                            gamesStream: response.data, gamesStreamAll: response3.data
                                        })
                                    }
                                }).catch((err) => alert(err))
                        }
                    }).catch((err) => alert(err))
            }
        }).catch((err) => alert(err))
}

export function insertGames(items: any, callback: () => void) {
    axios.post(Config.psGame, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function updateGames(items: any, callback: () => void) {
    axios.put(Config.psGame, items)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function RemoveGames(id: string, callback: () => void) {
    axios.delete(Config.psGame + '?id=' + id)
        .then((response) => callback())
        .catch((err) => alert(err))
}

export function getLevels() {
    if (IsBuildOddyzzey()) {
        // wsGetLevels()
        WsGetLevels()
    } else {
        let mode: number = 0
        let entity_id: string
        let entity: string
        if (!isUserSystem()) {
            entity_id = Main.Instance.LoginState.entityId
            entity = Main.Instance.LoginState.entity
        }
        if (isUserMaster()) {
            mode = 1
        } else if (isUserContractualPartner()) {
            mode = 2
        } else if (isUserSubEntity()) {
            mode = 3
        }

        let filter_site_id = Main.Instance.FrontendStoreState.site_id

        if (mode !== 3 && parseInt(Main.Instance.FrontendStoreState.site_id) !== 0) {
            filter_site_id = Main.Instance.FrontendStoreState.site_id
        } else if (mode === 3) {
            filter_site_id = Main.Instance.LoginState.entityId
        }

        const filter_level_id = Main.Instance.CRMLevelsState.filter_level_id
        const search = Main.Instance.SearchState.search_string ? Main.Instance.SearchState.search_string : ''
        const filter_Level = Main.Instance.CRMLevelsState.filter_level
        const site_id = parseInt(Main.Instance.FrontendStoreState.site_id) !== 0 ? Main.Instance.FrontendStoreState.site_id : undefined

        const siteid: string = site_id ? '&site_id=' + site_id : ''

        axios.get(Config.psLevel
            + '?filter_site=' + filter_site_id
            + '&offset=' + Main.Instance.CRMLevelsState.offset
            + '&limit=' + Main.Instance.CRMLevelsState.pSize
            + '&sort=' + Main.Instance.CRMLevelsState.sort
            + '&Sort=' + Main.Instance.CRMLevelsState.Sort
            + '&filter_level=' + filter_level_id
            + '&search=' + search
            + '&filter_Level=' + filter_Level
            + '&site_desc=true'
            + '&level_desc=true'
            + '&hierarchy_desc=false'
            + '&mode=' + mode
            + '&entity_id=' + entity_id
            + '&entity=' + entity
            + siteid)
            .then((response) => {
                if (response.data) {
                    axios.get(Config.psCountLevel
                        + '?filter_site=' + filter_site_id
                        + '&filter_level=' + filter_level_id
                        + '&search=' + search
                        + '&filter_Level=' + filter_Level
                        + '&mode=' + mode
                        + '&entity_id=' + entity_id
                        + '&entity=' + entity
                        + siteid)
                        .then((response2) => {
                            if (response2.data) {
                                for (const levelItem of response.data) {
                                    if (levelItem['sub_level_value'] === undefined) {
                                        levelItem['sub_level_value'] = parseInt(levelItem['sublevels']) * parseInt(levelItem['sub_level_average_value']) + ' €'
                                    } else { levelItem['sub_level_value'] += ' €' }
                                    if (levelItem.tokens.tokens) {
                                        let sum: number = 0
                                        const Sum: any[] = levelItem.tokens.tokens
                                        for (const Item of Sum) {
                                            sum += parseInt(Item, 10)
                                        }
                                        levelItem.tokens = sum.toString()
                                    } else { levelItem.tokens = Assets_.NA }
                                }

                                Logic.Type.New(Main.Instance.DatabaseDataState, { levelsStream: response.data })
                                Logic.Type.New(Main.Instance.CRMLevelsState, { count: parseInt(response2.data.count), countCalled: false })
                            }
                        })
                }
            })
    }
}

export function updateLevel(items: any, callback?: () => void) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        WSupdateLevel(items)
    } else {
        axios.put(Config.psLevel, items)
            .then((response) => callback())
            .catch((err) => alert(err))
    }
}

export function removeLevel(id: string, callback?: () => void) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        WSdeleteLevel(+id)
    } else {
        axios.delete(Config.psLevel + '?id=' + id)
            .then((response) => callback())
            .catch((err) => alert(err))
    }
}

export function insertLevel(items: any, callback?: () => void) {
    if (IsBuildOddyzzey() || IsBuildMyChance()) {
        WSinsertLevel(items)
    } else {
        axios.post(Config.psLevel, items)
            .then((response) => {
                if (response.data && response.data.toString() === 'duplicate') {
                    alert(Assets.DuplicateLevelForSite)
                } else if (callback) {
                    callback()
                }
            }).catch((err) => alert(err))
    }
}

export function getAllLevelsSourceSite(callback: () => void) {
    axios.get(Config.psLevelsAllSourceSite + '/?site_id=' + Main.Instance.CRMLevelsState.site_id)
        .then((response) => {
            Logic.Type.New(Main.Instance.DatabaseDataState, { tempStream: response.data })
            callback()
        })
}

export function getAllSubLevelsSourceSite(callback: (a: string) => void, level_id: string, former_level_id: string, callback2: () => void) {
    axios.get(Config.psLevelsSubAllSourceSite + '?site_id=' +
        Main.Instance.CRMLevelsState.site_id + '&level_id=' + former_level_id)
        .then((response) => {

            Logic.Type.New(Main.Instance.DatabaseDataState, { temp2Stream: response.data })

            if (response.data.length > 0) {
                callback(level_id)
            } else {
                callback2()
            }
        })
}

export function insertCloneLevel(items: any, callback: (a: number, b: string) => void, former_level_id: string) {
    axios.post(Config.psLevelClone, items)
        .then((response) => {
            callback(parseInt(response.data.id), former_level_id)
        })
}

export function insertCloneSubLevel(items: any, callback: () => void) {
    axios.post(Config.psLevelSubClone, items)
        .then((response) => { callback() })
}

export function getAllPointsByAchievement(callback: (b: boolean) => boolean, callback2: (a?: boolean) => void, d: boolean) {
    axios.get(Config.psPointsInProgramAll + '?id=' +
        Main.Instance.CRMAchievementsState.point_program_id)
        .then((response) => {
            if (response.data.msg) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { pointProgramStreamAll: response.data.msg })
                if (callback(d)) {
                    callback2(d)
                }
            }
        })
}

export function updatePoint(point: Point, callback: () => void) {
    axios.put(Config.psPoint, point)
        .then((response) => callback())
        .catch((e) => e)
}

export function insertPoint(point: Point, callback: () => void) {
    axios.post(Config.psPoint, point)
        .then((response) => callback())
        .catch((e) => e)
}

export function removePoint(id: string, callback: () => void) {
    axios.delete(Config.psPoint + '?id=' + id)
        .then((response) => callback())
        .catch((e) => e)
}

export function getPointsByAchievement() {

    if (parseInt(Main.Instance.CRMPointState.type_id_filter) === 0) {
        let sql: string = Config.psPointsInProgram
        sql += '?id=' + Main.Instance.CRMAchievementsState.point_program_id
        // sql += 'sort=' + Main.Instance.CRMPointState.sort
        // sql += 'sorts=' + Main.Instance.CRMPointState.Sort
        sql += '&limit=' + Main.Instance.CRMPointState.pSize
        sql += '&offset=' + Main.Instance.CRMPointState.offset
        sql += '&entity=Scandibet' //  + Main.Instance.LoginState.entity
        axios.get(sql)
            .then((response) => {
                if (response.data.msg) {
                    let sql2: string = Config.psPointsInProgramCount
                    sql2 += '?id=' + Main.Instance.CRMAchievementsState.point_program_id
                    axios.get(sql2)
                        .then((response2) => {
                            if (response2.data.msg) {
                                if (Main.Instance.DatabaseDataState.pointTypeStreamDefault) {
                                    Logic.Type.New(Main.Instance.DatabaseDataState, { pointProgramStream: response.data.msg })
                                    Logic.Type.New(Main.Instance.CRMPointState, { count: +response2.data.msg.count, countCalled: false })

                                } else {
                                    axios.get(Config.psDefaultPointTypes + '?id=' + Main.Instance.CRMAchievementsState.point_program_id)
                                        .then((response3) => {
                                            if (response3.data) {
                                                Logic.Type.New(Main.Instance.DatabaseDataState, { pointProgramStream: response.data.msg, pointTypeStreamDefault: response3.data })
                                                Logic.Type.New(Main.Instance.CRMPointState, { count: +response2.data.msg.count, countCalled: false })
                                            }
                                        })
                                }
                            }
                        })
                }
            })

    } else {
        let sql: string = Config.psPointsInProgramFilter
        sql += '?id=' + Main.Instance.CRMAchievementsState.point_program_id
        // sql += 'sort=' + Main.Instance.CRMPointState.sort
        // sql += 'sorts=' + Main.Instance.CRMPointState.Sort
        sql += '&limit=' + Main.Instance.CRMPointState.pSize
        sql += '&offset=' + Main.Instance.CRMPointState.offset
        sql += '&filter=' + Main.Instance.CRMPointState.type_id_filter
        sql += '&filter2=' + Main.Instance.CRMPointState.type2_id_filter
        sql += '&entity=Scandibet'//  + Main.Instance.LoginState.entity
        axios.get(sql)
            .then((response) => {
                if (response.data.msg) {
                    let sql2: string = Config.psPointsInProgramCountFilter
                    sql2 += '?id=' + Main.Instance.CRMAchievementsState.point_program_id
                    sql2 += '&filter=' + Main.Instance.CRMPointState.type_id_filter
                    sql2 += '&filter2=' + Main.Instance.CRMPointState.type2_id_filter
                    axios.get(sql2)
                        .then((response2) => {
                            if (response2.data.msg) {
                                Logic.Type.New(Main.Instance.DatabaseDataState, { pointProgramStream: response.data.msg })
                                Logic.Type.New(Main.Instance.CRMPointState, { count: parseInt(response2.data.msg.count), countCalled: false })
                            }
                        })
                }
            })
    }
}

export function countPointsByAchievement(achievement_id: string) {
    if (parseInt(Main.Instance.CRMPointState.type_id_filter) === 0) {
        let sql2: string = Config.psPointsInProgramCount
        sql2 += '?id=' + Main.Instance.CRMAchievementsState.point_program_id
        axios.get(sql2)
            .then((response) => {
                if (response.data.msg) {
                    Logic.Type.New(Main.Instance.CRMPointState, { count: response.data.msg.count, countCalled: false })
                }
            })
    } else {
        let sql: string = Config.psPointsInProgramCountFilter
        sql += '?id=' + Main.Instance.CRMAchievementsState.point_program_id
        sql += '&filter=' + Main.Instance.CRMPointState.type_id_filter
        sql += '&filter2=' + Main.Instance.CRMPointState.type2_id_filter
        axios.get(sql)
            .then((response) => {
                if (response.data.msg) {
                    Logic.Type.New(Main.Instance.CRMPointState, { count: response.data.msg.count, countCalled: false })
                }
            })
    }
}

export function getAchievementsAllBySite(site_id: string, load_points?: boolean) {
    axios.get(Config.psAllAchievementsBySite + '?site_id=' + site_id)
        .then((response) => {
            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { achievementsAllStream: response.data })
                if (response.data.length === 1) {
                    Logic.Type.New(Main.Instance.CRMAchievementsState, {
                        point_program_id: response.data[0]['id'],
                    })
                    if (load_points) { getPointsByAchievement() }
                }
            }
        })
}

export function getAchievementsAllByOperator() {
    axios.get(Config.psAllAchievementsByOperator + '?operator_id=' + Main.Instance.LoginState.entityId)
        .then((response) => {
            Logic.Type.New(Main.Instance.DatabaseDataState, { achievementsAllStream: response.data })
            if (response.data.length === 1) {
                Logic.Type.New(Main.Instance.CRMAchievementsState, {
                    point_program_id: response.data[0]['id'],
                })
            }
        })
}

export function getAchievementsBySite(site_id: string) {
    const str = Config.psAchievementsBySite + '?site_id=' + site_id
        + '&offset=' + Main.Instance.CRMAchievementsState.offset
        + '&limit=' + Main.Instance.CRMAchievementsState.pSize
        + '&sort=' + Main.Instance.CRMAchievementsState.sort
        + '&Sort=' + Main.Instance.CRMAchievementsState.Sort
    axios.get(str)
        .then((response) => {
            if (response.data) {
                axios.get(Config.psCountAchievementBySite + '?site_id=' + site_id)
                    .then((response2) => {
                        if (response2.data && response2.data.count) {
                            Logic.Type.New(Main.Instance.DatabaseDataState, { achievementsStream: response.data })
                            Logic.Type.New(Main.Instance.CRMAchievementsState, {
                                count: response2.data.count ? parseInt(response2.data.count) : 0,
                                countCalled: false,
                                wagering: response.data[0] ? parseInt(response.data[0]['wagering']).toString() : '0',
                                losses: response.data[0] ? parseInt(response.data[0]['losses']).toString() : '0',
                            })
                        }
                    })
            }
        })
}

export function getAchievementsByOperator() {
    axios.get(Config.psAchievementsByOperator + '?entity_id=' + Main.Instance.LoginState.entityId
        + '&offset=' + Main.Instance.CRMAchievementsState.offset
        + '&limit=' + Main.Instance.CRMAchievementsState.pSize
        + '&sort=' + Main.Instance.CRMAchievementsState.sort
        + '&Sort=' + Main.Instance.CRMAchievementsState.Sort)
        .then((response) => {
            if (response.data) {
                axios.get(Config.psCountAchievementByOperator + '?entity_id=' + Main.Instance.LoginState.entityId)
                    .then((response2) => {
                        if (response2.data && response2.data.count) {
                            Logic.Type.New(Main.Instance.DatabaseDataState, { achievementsStream: response.data })
                            Logic.Type.New(Main.Instance.CRMAchievementsState, {
                                count: parseInt(response2.data.count),
                                countCalled: false,
                                wagering: parseInt(response.data[0]['wagering']).toString(),
                                losses: parseInt(response.data[0]['losses']).toString(),
                            })
                        }
                    })
            }
        })
}

export function getAchievementsAll() {
    axios.get(Config.psAchievementAll)
        .then((response) => {
            Logic.Type.New(Main.Instance.DatabaseDataState, { achievementsAllStream: response.data })

            if (response.data.length === 1) {
                Logic.Type.New(Main.Instance.CRMAchievementsState, { point_program_id: response.data[0]['id'] })
            }
        })
}

export function getAchievements() {
    axios.get(Config.psAchievementPart
        + '?offset=' + Main.Instance.CRMAchievementsState.offset
        + '&limit=' + Main.Instance.CRMAchievementsState.pSize
        + '&sort=' + Main.Instance.CRMAchievementsState.sort
        + '&Sort=' + Main.Instance.CRMAchievementsState.Sort)
        .then((response) => {
            if (response.data) {
                axios.get(Config.psCountAchievement + '?entity_id=' + Main.Instance.LoginState.entityId)
                    .then((response2) => {
                        if (response2.data && response2.data.count) {
                            if (parseInt(response2.data.count) === 1 && !isUserSystem()) {
                                Logic.Type.New(Main.Instance.CRMAchievementsState, {
                                    count: parseInt(response2.data.count),
                                    countCalled: false,
                                    wagering: parseInt(response.data[0]['wagering']).toString(),
                                    losses: parseInt(response.data[0]['losses']).toString(),
                                })
                            } else {
                                Logic.Type.New(Main.Instance.CRMAchievementsState, {
                                    count: parseInt(response2.data.count),
                                    countCalled: false,
                                })
                            }
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                achievementsStream: response.data
                            })
                        }
                    })
            }
        })
}

export function insertAchievement(items: any, callback: () => void) {
    axios.post(Config.psAchievement, items)
        .then((response) => {
            if (response.data && parseInt(response.data.count) === 1) {
                alert(Assets.Achievement + ' ' + Assets.alreadyInDatabase)
            } else {
                callback()
            }
        })
}

export function updateAchievement(items: any, callback: () => void) {
    axios.put(Config.psAchievement, items)
        .then((response) => callback())
}

export function removeAchievement(id: string, callback: () => void) {
    axios.delete(Config.psAchievement + '?id=' + id)
        .then((response) => callback())
}

export function removeGameProvider(id: string) {
    axios.delete(Config.asGameProvider + '?id=' + id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
}

export function insertGameProvider(items: any) {
    axios.post(Config.asGameProvider, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
}

export function updateGameProvider(items: any) {
    axios.put(Config.asGameProvider, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
}

export function getContractualPartnersAll() {
    axios.get(Config.asCpAllByType + '?type_id=' + (parseInt(Main.Instance.RegisterHoldingState.type_temp_id) + 1), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, {
                    contractualPartnersAllStream: response.data,
                })
            }
        })
}

export function countContractualPartnersAllByType1(callback1: () => void) {

    if (Main.Instance.RegisterHoldingState.id.length === 0) {
        axios.get(Config.asCpAllByType + '?type_id=1', { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback1()
                }
            })
    } else {
        axios.get(Config.asCpAllByTypeById + '?type_id=1&holding_id=' + Main.Instance.RegisterHoldingState.id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback1()
                }
            })
    }
}

export function selectContractualPartner(id: string, callback: () => void) {
    axios.put(Config.asCpSelect, { id, holding_id: Main.Instance.RegisterHoldingState.id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
}

export function deselectContractualPartner(id: string, callback: () => void) {
    axios.patch(Config.asCpSelect, { id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
}

export function countContractualPartnersAllByType(callback1: () => void, callback2: () => void, callback3: () => void, callback4: () => void, callback5: () => void) {
    if (Main.Instance.RegisterHoldingState.id.length === 0) {
        axios.get(Config.asCpAllByType + '?type_id=1', { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback1()
                }
            })
    } else {
        axios.get(Config.asCpAllByTypeById + '?type_id=1&holding_id=' + Main.Instance.RegisterHoldingState.id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback1()
                }
            })
    }

    if (Main.Instance.RegisterHoldingState.id.length === 0) {
        axios.get(Config.asCpAllByType + '?type_id=2', { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback2()
                }
            })
    } else {
        axios.get(Config.asCpAllByTypeById + '?type_id=2&holding_id=' + Main.Instance.RegisterHoldingState.id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback2()
                }
            })
    }

    if (Main.Instance.RegisterHoldingState.id.length === 0) {
        axios.get(Config.asCpAllByType + '?type_id=3', { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback3()
                }
            })
    } else {
        axios.get(Config.asCpAllByTypeById + '?type_id=3&holding_id=' + Main.Instance.RegisterHoldingState.id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback3()
                }
            })
    }

    if (Main.Instance.RegisterHoldingState.id.length === 0) {

        axios.get(Config.asCpAllByType + '?type_id=4', { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback4()
                }
            })
    } else {
        axios.get(Config.asCpAllByTypeById + '?type_id=4&holding_id=' + Main.Instance.RegisterHoldingState.id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback4()
                }
            })
    }

    if (Main.Instance.RegisterHoldingState.id.length === 0) {
        axios.get(Config.asCpAllByType + '?type_id=5', { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback5()
                }
            })
    } else {
        axios.get(Config.asCpAllByTypeById + '?type_id=5&holding_id=' + Main.Instance.RegisterHoldingState.id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                    callback5()
                }
            })
    }
}

export function getExtendedSitesAll(gg_rm_?: boolean) {
    let gg_rm: boolean
    if (!gg_rm_) { gg_rm = false } else { gg_rm = gg_rm_ }

    axios.get(Config.adminServer + '/sites-extended-all/?gg_rm=' + gg_rm, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
        .then((response) => {
            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { sitesOperatorAllStream: response.data })
            }
        })
}

export function getExtendedSitesAllByMaster(holding_id: string, gg_rm_?: boolean) {
    let gg_rm: boolean
    if (!gg_rm_) { gg_rm = false } else { gg_rm = gg_rm_ }

    axios.get(Config.adminServer + '/sites-extended-all-by-master/?gg_rm=' + gg_rm + '&holding_id=' + holding_id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
        .then((response) => {

            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { sitesOperatorAllStream: response.data })
            }
        })
}

export function getMastersAll() {
    axios.get(Config.adminServer + '/master-all/', { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
        .then((response) => {
            if (response.data) {
                Logic.Type.New(
                    Main.Instance.DatabaseDataState, {
                    masterAllStream: response.data,
                })
            }
        })
}

export function insertHolding(items: any, callback: () => void) {
    axios.post(Config.asMaster, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (response.data && response.data.count && parseInt(response.data.count) === 1) {
                alert(Assets.Master + ' ' + Assets.alreadyInDatabase)
            } else {
                if (!response.data.id) {
                    alert(Assets.somethingWentWrongInsert)
                } else {
                    Logic.Type.New(Main.Instance.RegisterHoldingState, { id: response.data.id })
                    callback()
                }
            }
        })
}

export function updateHolding(items: any, callback: () => void) {
    axios.put(Config.asMaster, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
}

export function removeHolding(id: string, callback: () => void) {
    axios.delete(Config.asMaster + '?id=' + id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
}

export function getHoldings() {

    if (!Main.Instance.SearchState.search_string ||
        Main.Instance.SearchState.search_string &&
        Main.Instance.SearchState.search_string.length === 0) {

        axios.patch(
            Config.asMaster,
            {
                offset: Main.Instance.RegisterHoldingState.offset,
                sort: Main.Instance.RegisterHoldingState.sort,
                Sort: Main.Instance.RegisterHoldingState.Sort,
                limit: Main.Instance.RegisterHoldingState.pSize.toString(),
            },
            { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } },
        )
            .then((response) => {
                if (response.data) {
                    axios.get(Config.asMaster, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((response2) => {
                            Logic.Type.New(Main.Instance.RegisterHoldingState, {
                                count: parseInt(response2.data.count), countCalled: false
                            })
                            Logic.Type.New(Main.Instance.DatabaseDataState, { masterStream: response.data })
                        })
                }
            })
    } else {

        const search_string = '%' + Main.Instance.SearchState.search_string.toLowerCase() + '%'

        axios.patch(
            Config.asMasterSearch,
            {
                offset: Main.Instance.RegisterHoldingState.offset,
                sort: Main.Instance.RegisterHoldingState.sort,
                Sort: Main.Instance.RegisterHoldingState.Sort,
                limit: Main.Instance.RegisterHoldingState.pSize.toString(),
                search: search_string,
            },
            { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } },
        )
            .then((response) => {
                if (response.data) {
                    axios.get(Config.asMasterSearch + '?search=' + search_string, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((response2) => {
                            Logic.Type.New(Main.Instance.RegisterHoldingState, { count: parseInt(response2.data.count), countCalled: false })
                            Logic.Type.New(Main.Instance.DatabaseDataState, { masterStream: response.data })
                        })
                }
            })
    }
}

export function getAllOperatorsByMaster(holding_id: string, gg_rm_?: boolean) {
    let gg_rm: boolean
    if (!gg_rm_) {
        gg_rm = false
    } else {
        gg_rm = gg_rm_
    }
    if (isUserSystem()) {
        axios.get(Config.adminServer + '/cp-all-operators-by-master/?arg=' + holding_id + '&gg_rm=' + gg_rm, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                }
            })
    }
}

export function getAllBrandOwnersByMaster(holding_id: string, gg_rm_?: boolean) {

    let gg_rm: boolean
    if (!gg_rm_) {
        gg_rm = false
    } else {
        gg_rm = gg_rm_
    }

    if (isUserSystem()) {
        axios.get(Config.adminServer + '/cp-all-brand-owners-by-master/?arg=' + holding_id + '&gg_rm=' + gg_rm, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
            .then((response) => Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream2: response.data }))
    }
}

export function getAllOperators(gg_rm_?: boolean) {

    if (isUserSystem()) {
        let gg_rm: boolean
        if (!gg_rm_) {
            gg_rm = false
        } else {
            gg_rm = gg_rm_
        }

        axios.get(Config.adminServer + '/cp-all-operators/?gg_rm=' + gg_rm, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                }
            })
    }
}

export function getAllBrandOwners(gg_rm_?: boolean) {

    if (isUserSystem()) {
        let gg_rm: boolean
        if (!gg_rm_) {
            gg_rm = false
        } else {
            gg_rm = gg_rm_
        }

        axios.get(Config.adminServer + '/cp-all-brand-owners/?gg_rm=' + gg_rm, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
            .then((response) => {
                if (response.data) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream2: response.data })
                }
            })
    }
}

export function getContractualPartners() {

    if (isUserSystem()) {
        if (parseInt(Main.Instance.RegisterContractualPartnerState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.patch(
                Config.asCP,
                {
                    offset: Main.Instance.RegisterContractualPartnerState.offset,
                    sort: Main.Instance.RegisterContractualPartnerState.sort,
                    Sort: Main.Instance.RegisterContractualPartnerState.Sort,
                    limit: Main.Instance.RegisterContractualPartnerState.pSize.toString(),
                },
                { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } },
            )
                .then((response) => {
                    if (response.data) {
                        axios.get(Config.asCP, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                            .then((response2) => {
                                Logic.Type.New(Main.Instance.RegisterContractualPartnerState, {
                                    count: parseInt(response2.data.count), countCalled: false
                                })
                                Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersStream: response.data })
                            })
                    }
                })
        } else if (parseInt(Main.Instance.RegisterContractualPartnerState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/cp-search/', {
                offset: Main.Instance.RegisterContractualPartnerState.offset,
                sort: Main.Instance.RegisterContractualPartnerState.sort,
                Sort: Main.Instance.RegisterContractualPartnerState.Sort,
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                limit: Main.Instance.RegisterContractualPartnerState.pSize.toString()
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        axios.get(Config.adminServer + '/cp-search/?search=' + Main.Instance.SearchState.search_string.toLowerCase(), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                            .then((response2) => {
                                Logic.Type.New(Main.Instance.RegisterContractualPartnerState, {
                                    count: parseInt(response2.data.count), countCalled: false
                                })
                                Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersStream: response.data })
                            })
                    }
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.patch(Config.adminServer + '/cp-filter/', {
                offset: Main.Instance.RegisterContractualPartnerState.offset,
                sort: Main.Instance.RegisterContractualPartnerState.sort,
                Sort: Main.Instance.RegisterContractualPartnerState.Sort,
                limit: Main.Instance.RegisterContractualPartnerState.pSize.toString(),
                type_id: Main.Instance.RegisterContractualPartnerState.type_id_filter
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        axios.get(Config.adminServer + '/cp-filter/?type_id=' + Main.Instance.RegisterContractualPartnerState.type_id_filter, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                            .then((response2) => {
                                Logic.Type.New(Main.Instance.RegisterContractualPartnerState, {
                                    count: parseInt(response2.data.count), countCalled: false
                                })
                                Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersStream: response.data })
                            })
                    }
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/cp-filter-search/', {
                offset: Main.Instance.RegisterContractualPartnerState.offset,
                sort: Main.Instance.RegisterContractualPartnerState.sort,
                Sort: Main.Instance.RegisterContractualPartnerState.Sort,
                limit: Main.Instance.RegisterContractualPartnerState.pSize.toString(),
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                type_id: Main.Instance.RegisterContractualPartnerState.type_id_filter
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        axios.get(Config.adminServer + '/cp-filter-search/?type_id=' + Main.Instance.RegisterContractualPartnerState.type_id_filter + '&search=' + Main.Instance.SearchState.search_string.toLowerCase(), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                            .then((response2) => {
                                Logic.Type.New(Main.Instance.RegisterContractualPartnerState, {
                                    count: parseInt(response2.data.count), countCalled: false
                                })
                                Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersStream: response.data })
                            })
                    }
                })
        }
    } else {
        if (parseInt(Main.Instance.RegisterContractualPartnerState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.patch(Config.adminServer + '/cp-/', {
                offset: Main.Instance.RegisterContractualPartnerState.offset,
                sort: Main.Instance.RegisterContractualPartnerState.sort,
                Sort: Main.Instance.RegisterContractualPartnerState.Sort,
                limit: Main.Instance.RegisterContractualPartnerState.pSize.toString(),
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        axios.get(Config.adminServer + '/cp-/?entity_id=' + Main.Instance.LoginState.entityId, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                        .then((response2) => {
                            Logic.Type.New(Main.Instance.RegisterContractualPartnerState, {
                                count: parseInt(response2.data.count), countCalled: false
                            })
                            Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersStream: response.data })
                        })
                    }
                })
        } else if (parseInt(Main.Instance.RegisterContractualPartnerState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/cp-search-/', {
                offset: Main.Instance.RegisterContractualPartnerState.offset,
                sort: Main.Instance.RegisterContractualPartnerState.sort,
                Sort: Main.Instance.RegisterContractualPartnerState.Sort,
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                limit: Main.Instance.RegisterContractualPartnerState.pSize.toString(),
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        axios.get(Config.adminServer + '/cp-search-/?entity_id=' + Main.Instance.LoginState.entityId + '&search=' + Main.Instance.SearchState.search_string.toLowerCase(), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                            .then((response2) => {
                                Logic.Type.New(Main.Instance.RegisterContractualPartnerState, {
                                    count: parseInt(response2.data.count), countCalled: false
                                })
                                Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersStream: response.data })
                            })
                    }
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.patch(Config.adminServer + '/cp-filter-/', {
                offset: Main.Instance.RegisterContractualPartnerState.offset,
                sort: Main.Instance.RegisterContractualPartnerState.sort,
                Sort: Main.Instance.RegisterContractualPartnerState.Sort,
                limit: Main.Instance.RegisterContractualPartnerState.pSize.toString(),
                type_id: Main.Instance.RegisterContractualPartnerState.type_id_filter,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        axios.get(Config.adminServer + '/cp-filter-/?entity_id=' + Main.Instance.LoginState.entityId +
                            '&type_id=' + Main.Instance.RegisterContractualPartnerState.type_id_filter)
                            .then((response2) => {
                                Logic.Type.New(Main.Instance.RegisterContractualPartnerState, {
                                    count: parseInt(response2.data.count), countCalled: false
                                })
                                Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersStream: response.data })
                            })
                    }
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/cp-filter-search-/', {
                offset: Main.Instance.RegisterContractualPartnerState.offset,
                sort: Main.Instance.RegisterContractualPartnerState.sort,
                Sort: Main.Instance.RegisterContractualPartnerState.Sort,
                limit: Main.Instance.RegisterContractualPartnerState.pSize.toString(),
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                type_id: Main.Instance.RegisterContractualPartnerState.type_id_filter,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        axios.get(Config.adminServer + '/cp-filter-search-/?entity_id=' + Main.Instance.LoginState.entityId + '&type_id=' + Main.Instance.RegisterContractualPartnerState.type_id_filter + '&search=' + Main.Instance.SearchState.search_string.toLowerCase(), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                            .then((response2) => {
                                Logic.Type.New(Main.Instance.RegisterContractualPartnerState, {
                                    count: parseInt(response2.data.count), countCalled: false
                                })
                                Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersStream: response.data })
                            })
                    }
                })
        }
    }
}

export function insertContractualPartner(items: any, callback: () => void) {
    axios.post(Config.asCP, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (response.data && parseInt(response.data.count) === 1) {
                alert(Assets.ContractualPartner + ' ' + Assets.alreadyInDatabase)
            } else {
                callback()
            }
        })
}

export function updateContractualPartner(items: any, callback: () => void) {
    axios.put(Config.asCP, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
}

export function removeContractualPartner(id: string, callback: () => void) {
    axios.delete(Config.asCP + '?id=' + id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
}

export function getContractualPartnersAllByType() {
    const str: string = isUserSystem() ? Config.asCpAllByType : '/cp-all-by-type-/'
    const type_id: string = Main.Instance.RegisterSubEntityState.type_id
    axios.get(Config.adminServer + str + '?type_id=' + type_id + '&entity_id=' + Main.Instance.LoginState.entityId, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (response.data) {
                if (parseInt(Main.Instance.RegisterSubEntityState.type_id) >= 2 &&
                    parseInt(Main.Instance.RegisterSubEntityState.type_id) <= 4) {
                    Logic.Type.New(Main.Instance.DatabaseDataState, { contractualPartnersAllStream: response.data })
                } else {
                    const typeid: string = parseInt(Main.Instance.RegisterSubEntityState.type_id) === 1 ? '5' : '1'
                    axios.get(Config.adminServer + str + '?type_id=' + typeid + '&entity_id=' + Main.Instance.LoginState.entityId, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((response2) => {
                            Logic.Type.New(Main.Instance.DatabaseDataState, {
                                contractualPartnersAllStream: response.data, contractualPartnersAllStream2: response2.data
                            })
                        })
                }
            }
        })
}

export function countSubEntity() {
    if (isUserSystem()) {
        if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.get(Config.adminServer + '/se/', { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        } else if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.get(Config.adminServer + '/se-search/?search=' + Main.Instance.SearchState.search_string.toLowerCase(), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.get(Config.adminServer + '/se-filter/?type_id=' + Main.Instance.RegisterSubEntityState.type_id_filter, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.get(Config.adminServer + '/se-filter-search/?type_id=' + Main.Instance.RegisterSubEntityState.type_id_filter + '&search=' + Main.Instance.SearchState.search_string.toLowerCase(), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        }
    } else if (isUserMaster()) {
        if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.get(Config.adminServer + '/se--/?entity_id=' + Main.Instance.LoginState.entityId, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        } else if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.get(Config.adminServer + '/se-search--/?entity_id=' + Main.Instance.LoginState.entityId + '&search=' + Main.Instance.SearchState.search_string.toLowerCase(), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.get(Config.adminServer + '/se-filter--/?entity_id=' + Main.Instance.LoginState.entityId + '&type_id=' + Main.Instance.RegisterSubEntityState.type_id_filter, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.get(Config.adminServer + '/se-filter-search--/?entity_id=' + Main.Instance.LoginState.entityId + '&type_id=' + Main.Instance.RegisterSubEntityState.type_id_filter + '&search=' + Main.Instance.SearchState.search_string.toLowerCase(), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        }

    } else if (isUserContractualPartner()) {
        if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.get(Config.adminServer + '/se-/?entity_id=' + Main.Instance.LoginState.entityId, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        } else if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.get(Config.adminServer + '/se-search-/?entity_id=' + Main.Instance.LoginState.entityId + '&search=' + Main.Instance.SearchState.search_string.toLowerCase(), { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.get(Config.adminServer + '/se-filter-/?entity_id=' + Main.Instance.LoginState.entityId + '&type_id=' + Main.Instance.RegisterSubEntityState.type_id_filter, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.get(Config.adminServer + '/se-filter-search-/?entity_id=' + Main.Instance.LoginState.entityId + '&search=' + Main.Instance.SearchState.search_string.toLowerCase() + '&type_id=' + Main.Instance.RegisterSubEntityState.type_id_filter, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    Logic.Type.New(Main.Instance.RegisterSubEntityState, {
                        count: parseInt(response.data.count), countCalled: false
                    })
                })
        }
    }
}

export function getSubEntity() {
    if (isUserSystem()) {
        if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.patch(Config.adminServer + '/se/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString()
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se-search/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString()
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.patch(Config.adminServer + '/se-filter/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se-filter-search/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        }
    } else if (isUserMaster()) {
        if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.patch(Config.adminServer + '/se--/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se-search--/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.patch(Config.adminServer + '/se-filter--/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se-filter-search--/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        }
    } else if (isUserContractualPartner()) {
        if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.patch(Config.adminServer + '/se-/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se-search-/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.patch(Config.adminServer + '/se-filter-/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se-filter-search-/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        }
    }
}

export function getSubEntity2() {
    if (isUserSystem()) {
        if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.patch(Config.adminServer + '/se2/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString()
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se2-search/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString()
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.patch(Config.adminServer + '/se2-filter/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se2-filter-search/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        }
    } else if (isUserMaster()) {
        if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.patch(Config.adminServer + '/se2--/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se2-search--/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.patch(Config.adminServer + '/se2-filter--/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se2-filter-search--/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        }
    } else if (isUserContractualPartner()) {
        if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
                Main.Instance.SearchState.search_string.length === 0)) {
            axios.patch(Config.adminServer + '/se2-/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (parseInt(Main.Instance.RegisterSubEntityState.type_id_filter) === 0 &&
            Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se2-search-/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (!Main.Instance.SearchState.search_string || Main.Instance.SearchState.search_string &&
            Main.Instance.SearchState.search_string.length === 0) {
            axios.patch(Config.adminServer + '/se2-filter-/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        } else if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length !== 0) {
            axios.patch(Config.adminServer + '/se2-filter-search-/', {
                offset: Main.Instance.RegisterSubEntityState.offset,
                limit: Main.Instance.RegisterSubEntityState.pSize.toString(),
                search: Main.Instance.SearchState.search_string.toLowerCase(),
                type_id: Main.Instance.RegisterSubEntityState.type_id_filter,
                sort: Main.Instance.RegisterSubEntityState.sort,
                Sort: Main.Instance.RegisterSubEntityState.Sort,
                entity_id: Main.Instance.LoginState.entityId
            },          { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
                .then((response) => {
                    if (response.data) {
                        Logic.Type.New(
                            Main.Instance.DatabaseDataState, {
                            subEntityStream: response.data,
                        },
                        )
                        // Logic.Type.New(Main.Instance.RegisterSubEntityState, {countCalled:false})
                    }
                })
        }
    }
}

/* insert */

export function insertSubEntity(items: any, callback: () => void) {
    if (Main.Instance.RegisterSubEntityState.ID.length > 0 &&
        parseInt(Main.Instance.RegisterSubEntityState.type_id) === 1) {
        axios.patch(Config.asSubEntityInsert, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data.count) {
                    if (response.data && parseInt(response.data.count) === 1) {
                        alert(Assets.SubEntityID + ' ' + Assets.alreadyInDB)
                    } else {
                        axios.post(Config.asSubEntity, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                            .then((response2) => {
                                if (response2.data && parseInt(response2.data.count) === 1) {
                                    alert(Assets.SubEntity + ' ' + Assets.alreadyInDatabase)
                                } else {
                                    callback()
                                }
                            })
                    }
                } else {
                }
            })
    } else {
        axios.post(Config.asSubEntity, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (response.data && parseInt(response.data.count) === 1) {
                    alert(Assets.SubEntity + ' ' + Assets.alreadyInDatabase)
                } else {
                    callback()
                }
            })
    }
}

/* update */

export function updateSubEntity(items: any, callback: () => void) {
    if (Main.Instance.RegisterSubEntityState.ID && Main.Instance.RegisterSubEntityState.ID.length > 0 &&
        parseInt(Main.Instance.RegisterSubEntityState.type_id) === 1) {
        axios.patch(Config.asSubEntity, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                if (!response.data[0]) {
                    axios.put(Config.asSubEntity, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((response2) => {
                            callback()
                        })
                } else if (parseInt(response.data[0].id) === parseInt(Main.Instance.RegisterSubEntityState.id)) {
                    axios.put(Config.asSubEntity, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                        .then((response2) => {
                            callback()
                        })
                } else {
                    alert(Assets.SubEntityID + ' ' + Assets.alreadyInDB)
                }
            })
    } else {
        axios.put(Config.asSubEntity, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
            .then((response) => {
                callback()
            })
    }
}

export function removeSubEntity(id: string, callback: () => void) {
    axios.delete(Config.asSubEntity + '?id=' + id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => callback())
}

/* Currency */
export function getCurrencyRates() {
    axios.get(Config.psCurrencyRates)
        .then((response) => {
            if (response.data) {

                const code: string[] = []
                const rate: string[] = []
                const date: string[] = []
                const crypto: boolean[] = []

                code.push(Assets.None)
                rate.push('0')
                date.push('0')
                crypto.push(undefined)

                response.data.forEach((item: { code: string, rate: string, date: string, crypto: boolean }) => {
                    code.push(item.code)
                    rate.push(item.rate.replace(',', '.'))
                    date.push(item.date)
                    crypto.push(item.crypto)
                })

                Logic.Type.New(Main.Instance.CurrencyRatesState, { date, code, rate, crypto })
                // Logic.Type.New (Main.Instance.DatabaseDataState, {currencyRatesStream: []})
                Logic.Type.New(Main.Instance.DatabaseDataState, { countCalledCurrency: false/*, currenciesStream:undefined*/ })
            }
        })
}

function getCountryId(id: number): number {
    for (let i: number = 0; i < Main.Instance.DatabaseDataState.FlagsStreamAll.length; i++) {
        if (+Main.Instance.DatabaseDataState.FlagsStreamAll[i]['id'] === id) { return i }
    }
    return 0
}

function RefreshStats() {
    getGZG(Main.Instance.GZG.winningTicket)
    getGZGTickets()
}

export function InsertRaffleTicket() {

    interface RaffleTicket {
        phone: string,
        bought: number[],
        expired: number[],
        rgametype: number[],
        country: string,
        raffleid: any[],
        won: any[],
    }

    const body: RaffleTicket = {
        phone: '+' + Main.Instance.DatabaseDataState.FlagsStreamAll[getCountryId(Main.Instance.GZG.countryID)]['phone'].split(' ')[0] + ' ' + Main.Instance.GZG.phone,
        bought: Main.Instance.GZG.bought.length === 0 ? [1] : Main.Instance.GZG.bought,
        expired: [0],
        rgametype: Main.Instance.GZG.rgametype,
        country: Main.Instance.DatabaseDataState.FlagsStreamAll[getCountryId(Main.Instance.GZG.countryID)]['name'],
        raffleid: [],
        won: [],
    }

    axios.post(Config.ltRaffleTickets, body, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            Logic.Type.New(Main.Instance.GZG, { winningTicket: +response.data.ticketid })
            if (Main.Instance.GZG.jackpotRaffle) { setTimeout(RefreshStats, 10000) } else { getGZGTickets() }
        })
}

export function getCurrencyNames() {
    axios.get(Config.psCurrencyNames)
        .then((response) => {
            if (response.data) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { currencyStream: response.data })
            }
        })
}

export function GetFlags() {
    axios.get(Config.asFlags, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((res) => {
            if (res.data) {
                axios.post(Config.asFlags, {}, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                    .then((res2) => {
                        if (res2.data) {
                            Logic.Type.New(Main.Instance.DatabaseDataState, { FlagsStreamAll: res.data, FlagsStreamAllOrder: res2.data })
                            Logic.Type.New(Main.Instance.FlagsState, { countCalled: false, count: res.data.length })
                        }
                    })
            }
        })
}

export function GetSmallFlags() {
    axios.patch(Config.asFlags, {} , { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((res) => {
            if (res.data) {
                axios.put(Config.asFlags, {}, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
                    .then((res2) => {
                        if (res2.data) {
                            Logic.Type.New(Main.Instance.DatabaseDataState, { FlagsStreamAll: res.data, FlagsStreamAllOrder: res2.data })
                            Logic.Type.New(Main.Instance.FlagsState, { countCalled: false, count: res.data.length })
                        }
                    })
            }
        })
}

/* Player groups */
/*
export function insertPlayerGroup(items:any, callback:()=> void) {
  axios.post(Config.psPlayerGroup, items)
  .then((response) => callback())
}

export function updatePlayerGroup(items:any,callback:()=> void) {
  axios.put(Config.psPlayerGroup, items)
  .then((response) => callback())
}

export function removePlayerGroup(id:string, callback:()=> void) {
  axios.delete(Config.psPlayerGroup + '?id=' + id)
  .then((response) => callback())
}
*/
/* Player groups */
/*
export function getPlayerGroupsAllBySite(site_id: string) {
  axios.get(Config.psAllPlayerGroupBySite + '?site_id=' + site_id)
  .then((response) => {
    if (response.data) {
      Logic.Type.New (
        Main.Instance.DatabaseDataState, {
          playerGroupsAllStream: response.data
        }
      )
    }
  })
}
*/

function getUsersCallback(source: number, target: number, group: number, response: any) {
    if (target === Assets_.SYSTEM) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { users1Stream: response.data })
    } else if (target === Assets_.MASTER) {
        if (source === Assets_.SYSTEM) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { users0Stream: response.data })
        } else if (source === Assets_.MASTER) {
            Logic.Type.New(Main.Instance.DatabaseDataState, { user0Stream: response.data })
        }
    } else if (target === Assets_.CONTRACTUAL_PARTNER) {
        if (source === Assets_.SYSTEM) {
            if (group === Assets_.OPERATOR) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users3Stream: response.data })
            } else if (group === Assets_.GAME_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users2Stream: response.data })
            } else if (group === Assets_.PAYMENT_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users8Stream: response.data })
            } else if (group === Assets_.COMPLIANCE_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users6Stream: response.data })
            } else if (group === Assets_.SITE_OWNER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users11Stream: response.data })
            }
        } else if (source === Assets_.MASTER) {
            if (group === Assets_.OPERATOR) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user3mStream: response.data })
            } else if (group === Assets_.GAME_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user2mStream: response.data })
            } else if (group === Assets_.PAYMENT_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user8mStream: response.data })
            } else if (group === Assets_.COMPLIANCE_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user6mStream: response.data })
            } else if (group === Assets_.SITE_OWNER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user11mStream: response.data })
            }
        } else if (source === Assets_.CONTRACTUAL_PARTNER) {
            if (group === Assets_.OPERATOR) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user3Stream: response.data })
            } else if (group === Assets_.GAME_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user2Stream: response.data })
            } else if (group === Assets_.PAYMENT_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user8Stream: response.data })
            } else if (group === Assets_.COMPLIANCE_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user6Stream: response.data })
            } else if (group === Assets_.SITE_OWNER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user11Stream: response.data })
            }
        }

    } else if (target === Assets_.SUB_ENTITY) {
        if (source === Assets_.SYSTEM) {
            if (group === Assets_.OPERATOR) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users4Stream: response.data })
            } else if (group === Assets_.GAME_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users5Stream: response.data })
            } else if (group === Assets_.PAYMENT_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users9Stream: response.data })
            } else if (group === Assets_.COMPLIANCE_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users7Stream: response.data })
            } else if (group === Assets_.SITE_OWNER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { users12Stream: response.data })
            }
        } else if (source === Assets_.MASTER) {
            if (group === Assets_.OPERATOR) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user4mStream: response.data })
            } else if (group === Assets_.GAME_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user5mStream: response.data })
            } else if (group === Assets_.PAYMENT_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user9mStream: response.data })
            } else if (group === Assets_.COMPLIANCE_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user7mStream: response.data })
            } else if (group === Assets_.SITE_OWNER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user12mStream: response.data })
            }
        } else if (source === Assets_.CONTRACTUAL_PARTNER) {
            if (group === Assets_.OPERATOR) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user4oStream: response.data })
            } else if (group === Assets_.GAME_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user5oStream: response.data })
            } else if (group === Assets_.PAYMENT_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user9oStream: response.data })
            } else if (group === Assets_.COMPLIANCE_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user7oStream: response.data })
            } else if (group === Assets_.SITE_OWNER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user12oStream: response.data })
            }
        } else if (source === Assets_.SUB_ENTITY) {
            if (group === Assets_.OPERATOR) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user4Stream: response.data })
            } else if (group === Assets_.GAME_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user5Stream: response.data })
            } else if (group === Assets_.PAYMENT_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user9Stream: response.data })
            } else if (group === Assets_.COMPLIANCE_PROVIDER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user7Stream: response.data })
            } else if (group === Assets_.SITE_OWNER) {
                Logic.Type.New(Main.Instance.DatabaseDataState, { user12Stream: response.data })
            }
        }
    }
}
/*
function countUsersCallback(source: number, target: number, group: number, response: any) {

    if (target === Assets_.SYSTEM) {
        Logic.Type.New(Main.Instance.CreateSystemUserState, {
            count: parseInt(response.data.count),
            countCalled: false
        })
    } else if (target === Assets_.MASTER) {
        Logic.Type.New(Main.Instance.CreateMasterUserState, {
            count: parseInt(response.data.count),
            countCalled: false
        })
    } else if (target === Assets_.CONTRACTUAL_PARTNER) {
        if (group === Assets_.OPERATOR) {
            Logic.Type.New(Main.Instance.CreateOperatorUserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        } else if (group === Assets_.GAME_PROVIDER) {
            Logic.Type.New(Main.Instance.CreateGameProviderUserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        } else if (group === Assets_.PAYMENT_PROVIDER) {
            Logic.Type.New(Main.Instance.CreatePaymentProviderUserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        } else if (group === Assets_.COMPLIANCE_PROVIDER) {
            Logic.Type.New(Main.Instance.CreateComplianceProviderUserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        } else if (group === Assets_.SITE_OWNER) {
            Logic.Type.New(Main.Instance.CreateBrandOwnerUserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        }
    } else if (target === Assets_.SUB_ENTITY) {
        if (group === Assets_.OPERATOR) {
            Logic.Type.New(Main.Instance.CreateSiteUserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        } else if (group === Assets_.GAME_PROVIDER) {
            Logic.Type.New(Main.Instance.CreateGameAssetProviderUserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        } else if (group === Assets_.PAYMENT_PROVIDER) {
            Logic.Type.New(Main.Instance.CreatePaymentSubProviderUserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        } else if (group === Assets_.COMPLIANCE_PROVIDER) {
            Logic.Type.New(Main.Instance.CreateComplianceSubProviderUserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        } else if (group === Assets_.SITE_OWNER) {
            Logic.Type.New(Main.Instance.CreateSite2UserState, {
                count: parseInt(response.data.count),
                countCalled: false
            })
        }
    }
}
*/

function countUsersCallback(source: number, target: number, group: number, count: number) {

    if (target === Assets_.SYSTEM) {
        Logic.Type.New(Main.Instance.CreateSystemUserState, {
            count,
            countCalled: false
        })
    } else if (target === Assets_.MASTER) {
        Logic.Type.New(Main.Instance.CreateMasterUserState, {
            count,
            countCalled: false
        })
    } else if (target === Assets_.CONTRACTUAL_PARTNER) {
        if (group === Assets_.OPERATOR) {
            Logic.Type.New(Main.Instance.CreateOperatorUserState, {
                count,
                countCalled: false
            })
        } else if (group === Assets_.GAME_PROVIDER) {
            Logic.Type.New(Main.Instance.CreateGameProviderUserState, {
                count,
                countCalled: false
            })
        } else if (group === Assets_.PAYMENT_PROVIDER) {
            Logic.Type.New(Main.Instance.CreatePaymentProviderUserState, {
                count,
                countCalled: false
            })
        } else if (group === Assets_.COMPLIANCE_PROVIDER) {
            Logic.Type.New(Main.Instance.CreateComplianceProviderUserState, {
                count,
                countCalled: false
            })
        } else if (group === Assets_.SITE_OWNER) {
            Logic.Type.New(Main.Instance.CreateBrandOwnerUserState, {
                count,
                countCalled: false
            })
        }
    } else if (target === Assets_.SUB_ENTITY) {
        if (group === Assets_.OPERATOR) {
            Logic.Type.New(Main.Instance.CreateSiteUserState, {
                count,
                countCalled: false
            })
        } else if (group === Assets_.GAME_PROVIDER) {
            Logic.Type.New(Main.Instance.CreateGameAssetProviderUserState, {
                count,
                countCalled: false
            })
        } else if (group === Assets_.PAYMENT_PROVIDER) {
            Logic.Type.New(Main.Instance.CreatePaymentSubProviderUserState, {
                count,
                countCalled: false
            })
        } else if (group === Assets_.COMPLIANCE_PROVIDER) {
            Logic.Type.New(Main.Instance.CreateComplianceSubProviderUserState, {
                count,
                countCalled: false
            })
        } else if (group === Assets_.SITE_OWNER) {
            Logic.Type.New(Main.Instance.CreateSite2UserState, {
                count,
                countCalled: false
            })
        }
    }
}

export function countUsers(filter_role: string, role1: number, role2: number, role3?: number, role4?: number) {
    let AndSearch: string = ''
    if (Main.Instance.SearchState.search_string && Main.Instance.SearchState.search_string.length > 0) {
        AndSearch = ' AND LOWER(username) LIKE \'%' + Main.Instance.SearchState.search_string.toLowerCase() + '%\''
    }

    let source: number

    if (isUserSystem()) {
        source = Assets_.SYSTEM
    } else if (isUserMaster()) {
        source = Assets_.MASTER
    } else if (isUserContractualPartner()) {
        source = Assets_.CONTRACTUAL_PARTNER
    } else if (isUserSubEntity()) {
        source = Assets_.SUB_ENTITY
    }

    let target: number

    if (role1 === Assets_.systemAdmin) {
        target = Assets_.SYSTEM
    } else if (role1 === Assets_.masterAdmin) {
        target = Assets_.MASTER
    } else if (role1 === Assets_.gameAdmin ||
        role1 === Assets_.operatorAdmin ||
        role1 === Assets_.paymentAdmin ||
        role1 === Assets_.complianceAdmin ||
        role1 === Assets_.operator2Admin) {
        target = Assets_.CONTRACTUAL_PARTNER
    } else if (role1 === Assets_.gameAssetAdmin ||
        role1 === Assets_.siteAdmin ||
        role1 === Assets_.paymentSubAdmin ||
        role1 === Assets_.complianceSubAdmin ||
        role1 === Assets_.site2Admin) {
        target = Assets_.SUB_ENTITY
    }

    let group: number

    if (role1 === Assets_.operatorAdmin || role1 === Assets_.siteAdmin) {
        group = Assets_.OPERATOR
    } else if (role1 === Assets_.gameAdmin || role1 === Assets_.gameAssetAdmin) {
        group = Assets_.GAME_PROVIDER
    } else if (role1 === Assets_.paymentAdmin || role1 === Assets_.paymentSubAdmin) {
        group = Assets_.PAYMENT_PROVIDER
    } else if (role1 === Assets_.complianceAdmin || role1 === Assets_.complianceSubAdmin) {
        group = Assets_.COMPLIANCE_PROVIDER
    } else if (role1 === Assets_.operator2Admin || role1 === Assets_.site2Admin) {
        group = Assets_.SITE_OWNER
    }

    let entity_id: string
    if (target !== Assets_.SYSTEM) {
        entity_id = Main.Instance.LoginState.entityId
    }
    // roles
    // let lj0:string = ' LEFT JOIN admin.roles ON roles.id = hashed.role'
    // join sub_entity directly
    const lj1: string = ' LEFT JOIN admin.sub_entity ON sub_entity.id = hashed.entity_id'
    /*
      // join sub_entity upwards
      let _lj1:string =
        ' LEFT JOIN admin.sub_entity ON sub_entity.contractual_partner_id = contractual_partners.id'
    */
    // join contractual_partners directly
    const lj2: string = ' LEFT JOIN admin.contractual_partners ON contractual_partners.id = hashed.entity_id'
    /*
      // join contractual_partners upwards
      let _lj2:string =
        ' LEFT JOIN admin.contractual_partners ON contractual_partners.holding_id = holding.entity_id'
    */
    // join contractual_partners downwards
    const lj2_: string =
        ' LEFT JOIN admin.contractual_partners ON contractual_partners.id = sub_entity.contractual_partner_id'

    // base join holding
    const lj3: string = ' LEFT JOIN admin.holding ON holding.id = hashed.entity_id'
    // join holding downwards
    const lj3_: string = ' LEFT JOIN admin.holding ON holding.id = contractual_partners.holding_id'

    // construct left join

    let lj: string = ''

    // then first add the direct join, as this is where we can start joining tables

    if (target === Assets_.MASTER) {
        lj += lj3
    } else if (target === Assets_.CONTRACTUAL_PARTNER) {
        lj += lj2
        // if (source === Assets_.MASTER) {
        lj += lj3_
        // }
    } else if (target === Assets_.SUB_ENTITY) {
        lj += lj1
        // if (source === Assets_.MASTER || source === Assets_.CONTRACTUAL_PARTNER) {
        lj += lj2_
        // if (source === Assets_.MASTER) {
        lj += lj3_
        // }
        // }
    }

    // left join used for getting data, not count
    const lj0: string = ' LEFT JOIN admin.roles ON roles.id = hashed.role' // + lj
    let param: any

    let sort: number[]
    let Sort: string[]

    if (role1 === 131) {
        sort = Main.Instance.CreateMasterUserState.sort
        Sort = Main.Instance.CreateMasterUserState.Sort
    } else if (role1 === 11) {
        sort = Main.Instance.CreateSystemUserState.sort
        Sort = Main.Instance.CreateSystemUserState.Sort
    } else if (role1 === 21) {
        sort = Main.Instance.CreateGameProviderUserState.sort
        Sort = Main.Instance.CreateGameProviderUserState.Sort
    } else if (role1 === 31) {
        sort = Main.Instance.CreateOperatorUserState.sort
        Sort = Main.Instance.CreateOperatorUserState.Sort
    } else if (role1 === 41) {
        sort = Main.Instance.CreateSiteUserState.sort
        Sort = Main.Instance.CreateSiteUserState.Sort
    } else if (role1 === 51) {
        sort = Main.Instance.CreateGameAssetProviderUserState.sort
        Sort = Main.Instance.CreateGameAssetProviderUserState.Sort
    } else if (role1 === 61) {
        sort = Main.Instance.CreateComplianceProviderUserState.sort
        Sort = Main.Instance.CreateComplianceProviderUserState.Sort
    } else if (role1 === 71) {
        sort = Main.Instance.CreateComplianceSubProviderUserState.sort
        Sort = Main.Instance.CreateComplianceSubProviderUserState.Sort
    } else if (role1 === 81) {
        sort = Main.Instance.CreatePaymentProviderUserState.sort
        Sort = Main.Instance.CreatePaymentProviderUserState.Sort
    } else if (role1 === 91) {
        sort = Main.Instance.CreatePaymentSubProviderUserState.sort
        Sort = Main.Instance.CreatePaymentSubProviderUserState.Sort
    } else if (role1 === 111) {
        sort = Main.Instance.CreateBrandOwnerUserState.sort
        Sort = Main.Instance.CreateBrandOwnerUserState.Sort
    } else if (role1 === 121) {
        sort = Main.Instance.CreateSite2UserState.sort
        Sort = Main.Instance.CreateSite2UserState.Sort
    }

    if (filter_role === '1') {
        param = {
            role1, AndSearch, entity_id, lj, lj0,
            source, group, target, sort, Sort
        }
    } else if (filter_role === '2') {
        param = {
            role1: role2, AndSearch, entity_id, lj, lj0,
            source, group, target, sort, Sort
        }
    } else if (filter_role === '3') {
        param = {
            role1: role3, AndSearch, entity_id, lj, lj0,
            source, group, target, sort, Sort
        }
    } else if (filter_role === '4') {
        param = {
            role1: role4, AndSearch, entity_id, lj, lj0,
            source, group, target, sort, Sort
        }
    } else /*if (!role3)*/ {
        param = {
            role1, role2, role3, role4, AndSearch, entity_id, lj, lj0,
            source, group, target, sort, Sort
        }
    } /*else if (role3) {
      param = {role1:role1, role2:role2, role3:role3, AndSearch: AndSearch, entity_id:entity_id, lj: lj, lj0:lj0,
              source: source, group:group, target:target}
  }*/


    if (param === undefined) {
        return
    }

    // axios.patch(Config.asNewUserCount, param, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
    // .then((response) => {

    axios.patch(Config.asNewUser, param, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response2) => {
            getUsersCallback(source, target, group, response2)
            countUsersCallback(source, target, group, response2.data.length)
        })

}

export function insertUser(items: any, callback: () => void) {

    axios.post(Config.asNewUser, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (response.data && parseInt(response.data.count) === 1) {
                alert(response.data.message)

            } else {
                const Items = Object.assign({}, items)
                Items.id = response.data.id
                insertAdminLog(Config.asAdminLogSaveInsert, 'User Management -> Manage Admin Users', Items)
                callback()
            }
        }).catch((e) => { console.log('error'); console.log(e) })
}

export function updateUser(items: any, callback: () => void) {
    axios.put(Config.asNewUser, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            insertAdminLog(Config.asAdminLogSaveEdit, 'User Management -> Manage Admin Users', items)
            callback()
        })
}

export function updateUserNoPassword(items: any, callback: () => void) {
    axios.put(Config.asNewUserNoPassword, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
        .then((response) => {
            if (response && response.data && response.data.resolved !== undefined && response.data.resolved === false) {
                alert(Assets.r1 + response.data.message)
            } else {

                insertAdminLog(Config.asAdminLogSaveEdit, 'User Management -> Manage Admin Users', items)
                callback()
            }
        })
}

export function removeUser(id: string, callback: () => void) {
    axios.delete(Config.asNewUser + '?id=' + id, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
    .then((response) => {
        insertAdminLog(Config.asAdminLogDelete, 'User Management -> Manage Admin Users' , {id})
        callback()
    })
}
/*
export function insertFreeRound(value: number) {
    axios.get('http://188.240.223.66:8888/free-rounds/?fr=' + value)
}
*/
export function updatePassword(items: any, callback: () => void) {
    axios.put(Config.asNewPassword, items, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId } })
    .then((response) => {
        if (response.status === 201) {
            alert(Assets.ThisUsernameIsAlreadyTaken)
        } else { callback() }
    })
}

export function getPlayersAleacc() {
    if (Main.Instance.DatabaseDataState.playersStream === undefined) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { playersStream: [] })
        axios.get(Config.psPlayerCurrency) // psPlayersCurrencies arin's functions
            .then((response) => {
                // if (response.data.return) Logic.Type.New (Main.Instance.DatabaseDataState, {playersStream: response.data.return})
                axios.get(Config.psPlayersCurrencies)
                    .then((response0) => {
                        if (response.data && response0.data.return) { Logic.Type.New(Main.Instance.DatabaseDataState, { playersStream: response.data, countriesDataStream: response0.data.return }) }
                    })
            })
    }
}
/*
export function GA() {
    axios.get('https://promostore.gamanza.com/aleacc-games-amx/?skin_id=55&amx=B23076DDDE4C2C4FC0738576BF4C38B4:LXHymAIohPXUEIL9mtL4t9sliKShiTyzjumAea7ddew=:1:1527171317')
    .then((response) => {
      // console.log(response)
    })
}
*/

export function UpdateGames(Games_: any) {
    // axios.put('http://localhost:5544/update-games/', {Games})
}

export function setGamesAleacc(GamesStreamAllSorted: any[]) {
    // let GamesStreamAllSorted: any[] = Object.assign ([], ga)
    // GamesStreamAllSorted.sort(dynamicSort(Assets.Name))

    if (!Main.Instance.DatabaseDataState.GamesStreamProvider) {
        const providers: number[] = []
        const gamesStreamProvider: any[] = []
        const gamesStreamProvider_: any[] = []
        const GamesStreamProvider: any[] = []
        for (const item of GamesStreamAllSorted) {
            let found: boolean = false
            for (const Item of gamesStreamProvider) {
                if (item['Provider'] === Item['name']) {
                    found = true
                    break
                }
            }
            if (!found) {
                gamesStreamProvider.push({ id: (GamesStreamProvider.length + 1).toString(), name: item['Provider'] })
            }
        }
        gamesStreamProvider.sort(dynamicSort('name'))
        GamesStreamProvider.push({ id: '0', name: Assets.AnyProvider })
        for (const item of gamesStreamProvider) {
            providers.push(GamesStreamProvider.length)
            gamesStreamProvider_.push({ id: GamesStreamProvider.length.toString(), name: item['name'] })
            GamesStreamProvider.push({ id: GamesStreamProvider.length.toString(), name: item['name'] })
        }
        let GamesStreamAll: any[] = []
        if (parseInt(Main.Instance.GamesState.filter_provider) > 0 ||
            parseInt(Main.Instance.GamesState.filter_freespins) > 0 ||
            parseInt(Main.Instance.GamesState.filter_flexible) > 0
        ) {
            for (const item of GamesStreamAllSorted) {
                const proceed: boolean[] = [false, false, false]
                if (parseInt(Main.Instance.GamesState.filter_provider) === 0) { proceed[0] = true }
                if (parseInt(Main.Instance.GamesState.filter_freespins) === 0) { proceed[1] = true }
                if (parseInt(Main.Instance.GamesState.filter_flexible) === 0) { proceed[2] = true }

                if (parseInt(Main.Instance.GamesState.filter_provider) > 0) {
                    if (item['Provider'] === GamesStreamProvider[parseInt(Main.Instance.GamesState.filter_provider)]['name']) {
                        proceed[0] = true
                    }
                }

                if ('true' === item['FreespinsEnabled'].toString()
                    && parseInt(Main.Instance.GamesState.filter_freespins) === 1
                    || 'false' === item['FreespinsEnabled'].toString()
                    && parseInt(Main.Instance.GamesState.filter_freespins) === 2
                ) {
                    proceed[1] = true
                }

                if ('true' === item['FlexibleFreespinsEnabled'].toString()
                    && parseInt(Main.Instance.GamesState.filter_freespins) === 1
                    || 'false' === item['FlexibleFreespinsEnabled'].toString()
                    && parseInt(Main.Instance.GamesState.filter_freespins) === 2
                ) {
                    proceed[2] = true
                }

                if (proceed[0] && proceed[1] && proceed[2]) { GamesStreamAll.push(item) }
            }
        } else { GamesStreamAll = GamesStreamAllSorted }
        Logic.Type.New(Main.Instance.DatabaseDataState, {
            GamesStreamProvider,
            gamesStreamProvider: gamesStreamProvider_,
            GamesStreamAll,
            GamesStream: GamesStreamAll.slice(
                parseInt(Main.Instance.GamesState.offset),
                parseInt(Main.Instance.GamesState.offset) + Main.Instance.GamesState.pSize,
            ),
        })
        Logic.Type.New(Main.Instance.GamesState, { providers, count: GamesStreamAll.length, countCalled: false })

    } else {
        let GamesStreamAll: any[] = []
        if (parseInt(Main.Instance.GamesState.filter_provider) > 0 ||
            parseInt(Main.Instance.GamesState.filter_freespins) > 0 ||
            parseInt(Main.Instance.GamesState.filter_flexible) > 0) {
            for (const item of GamesStreamAllSorted) {
                const proceed: boolean[] = [false, false, false]
                if (parseInt(Main.Instance.GamesState.filter_provider) === 0) { proceed[0] = true }
                if (parseInt(Main.Instance.GamesState.filter_freespins) === 0) { proceed[1] = true }
                if (parseInt(Main.Instance.GamesState.filter_flexible) === 0) { proceed[2] = true }

                if (parseInt(Main.Instance.GamesState.filter_provider) > 0) {
                    if (item['Provider'] === Main.Instance.DatabaseDataState.GamesStreamProvider[
                        parseInt(Main.Instance.GamesState.filter_provider)]['name']) {
                        proceed[0] = true
                    }
                }

                if ('true' === item['FreespinsEnabled'].toString()
                    && parseInt(Main.Instance.GamesState.filter_freespins) === 1
                    || 'false' === item['FreespinsEnabled'].toString()
                    && parseInt(Main.Instance.GamesState.filter_freespins) === 2
                ) {
                    proceed[1] = true
                }

                if ('true' === item['FlexibleFreespinsEnabled'].toString()
                    && parseInt(Main.Instance.GamesState.filter_freespins) === 1
                    || 'false' === item['FlexibleFreespinsEnabled'].toString()
                    && parseInt(Main.Instance.GamesState.filter_freespins) === 2
                ) {
                    proceed[2] = true
                }

                if (proceed[0] && proceed[1] && proceed[2]) { GamesStreamAll.push(item) }
            }
        } else { GamesStreamAll = GamesStreamAllSorted }

        Logic.Type.New(Main.Instance.DatabaseDataState, {
            GamesStreamAll,
            GamesStream: GamesStreamAll.slice(
                parseInt(Main.Instance.GamesState.offset),
                parseInt(Main.Instance.GamesState.offset) + Main.Instance.GamesState.pSize,
            ),
        })
        Logic.Type.New(Main.Instance.GamesState, { count: GamesStreamAll.length, countCalled: false })
    }

}

export function getGamesAleacc(skin_id: number, jwt: string) {
    if (skin_id !== undefined && skin_id !== null && jwt !== undefined && jwt !== null && Main.Instance.DatabaseDataState.GamesStreamAll === undefined) {
        axios.get(Config.psAleaccGames + '?skin_id=' + skin_id + '&jwt=' + jwt)
            .then((response) => {
                if (response.data && response.status === 200) { setGamesAleacc(response.data) }
            })
    }
}

export function getGamesAleaccStage(skin_id: number, key: string, secret: string) {

    if (skin_id !== undefined && skin_id !== null && key !== undefined && key !== null && secret !== undefined && secret !== null && Main.Instance.DatabaseDataState.GamesStreamAll === undefined) {
        alert(Config.psAleaccGamesStage + '?skin_id=' + skin_id + '&key=' + key + '&secret=' + secret)
        axios.get(Config.psAleaccGamesStage + '?skin_id=' + skin_id + '&key=' + key + '&secret=' + secret)
            .then((response) => {
                if (response.data && response.status === 200) { setGamesAleacc(response.data) }
            })
    }
}

export function GiveRewardTest(reward: any) {
    if (reward.RewardType === 'MatchedDeposit' && reward.index_saved === undefined || parseFloat(Main.Instance.RewardShopState.index_saved) === 0) {
        alert(Assets.d9)
    }

    axios.post(Config.psGiveRewardTest, {
        reward,
        amount: +Main.Instance.RewardShopState.index_saved,
        currency: Main.Instance.RewardShopState.free_round_saved,
        // ,percentage: +Main.Instance.RewardShopState.rewardFor_saved
    })
        .then((response) => {
            if (response.data.resolved) { alert(Assets.r2 + ' ' + reward.PlayerId) } else { alert(response.data.return) }
        })

}

export function CoinsOnRegistrationChanged(value: number) {
    const custom = Object.assign(Main.Instance.FrontendStoreState.custom)
    custom['coinsGivenOnRegistration'] = +value
    Logic.Type.New(Main.Instance.FrontendStoreState, { custom })

    axios.put(Config.adminServer + '/test-site-custom/', { custom, site_id: Main.Instance.FrontendStoreState.site_id }, { headers: { 'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId }})
}
/*
export function InsertPlayerGroup(items: any, callback:() => void) {
    axios.post(Config.csRules, items, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}})
    .then((response) => callback())
}

export function UpdatePlayerGroup(items: any, callback:() => void) {
    axios.put(Config.csRules, {data: items, id: Main.Instance.PlayerGroupsInternal.id}, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}})
    .then((response) => callback())
}

export function RemovePlayerGroup(id:string, callback:()=> void) {
    axios.delete(Config.csRules + '?id=' + id, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}})
    .then((response) => callback())
}


function getCRMSQL(args, Data, which) {
    axios.get (Config.csSQL, {params: {args: JSON.stringify(args)}, headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}})
    .then((responseSQL) => {
      const calculatedData: PlayerData[] = []
      for (const item of Data) {
          for (const Item of responseSQL.data) {
              if (item.id === parseInt(Item.playerid)) {
                  calculatedData.push (item)
              }
          }
      }
      const crmPlayerDataStream: Array<{id: string, data: PlayerData[]}> = Object.assign([], Main.Instance.DatabaseDataState.crmPlayerDataStream)
      crmPlayerDataStream[which].data = calculatedData
      Logic.Type.New (Main.Instance.DatabaseDataState, {crmPlayerDataStream})
      // console.log ('SQL ' + which + ' ' +  calculatedData.length)
      // Logic.Type.New (Main.Instance.PlayerGroupsInternal, {calculatedData})
    })
  }

export function getCRM() {
    // axios.get (Config.csEvents).then((responseEvents) => {
        // console.log ()
        // console.log (Config.csGames)
        // GetFlags()
    axios.get (Config.csRules, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}}).then((responseRules) => {
        axios.get (Config.csRulesCount, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}}).then((responseRulesCount) => {
            axios.get (Config.csGames, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}}).then((responseGames) => {
                // console.log (responseGames)
                axios.get (Config.csPlayers, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}}).then((responsePlayers) => {
                    // console.log (responsePlayers)
                    axios.get (Config.csCountries, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}}).then((responseCountries) => {
                        // console.log (responseCountries)
                        axios.get (Config.csCurrencies, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}}).then((responseCurrencies) => {
                            // console.log (responseCurrencies)
                            axios.get (Config.csTimezones, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}}).then((responseTimezones) => {
                                // console.log (responseTimezones)
                                const crmPlayerDataStream: Array<{id: string, data: PlayerData[]}> = []
                                for (const item of responseRules.data) {
                                    crmPlayerDataStream.push ({id: item.id, data: []})
                                }

                                Logic.Type.New (Main.Instance.DatabaseDataState, {
                                    // crmEventsStream: responseEvents.data,
                                    crmGamesStream: responseGames.data,
                                    crmTimezonesStream: responseTimezones.data,
                                    crmPlayersStream: responsePlayers.data,
                                    crmCountriesStream: responseCountries.data,
                                    crmCurrenciesStream: responseCurrencies.data,
                                    crmRulesStream: responseRules.data,
                                    crmPlayerDataStream,
                                })
                                Logic.Type.New (Main.Instance.PlayerGroupsInternal, {count: +responseRulesCount.data.count, countCalled: false})
                                // console.log (Main.Instance.DatabaseDataState.crmPlayersStream)
                                // console.log (Main.Instance.DatabaseDataState.crmEventsStream)
                                populateRealData(0)
                            })
                        })
                    })
                })
            })
        })
    })
    // })
}
*/
/*
function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
    }
    return age
}
*/

// export function getCRMRules() {} // gets rules
// export function getCRM() {} // gets everything

{
    /*
    function getCRMSQL(args, Data, which) {
    axios.get (Config.csSQL, {params: {args: JSON.stringify(args)}, headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}})
    .then((responseSQL) => {
        const calculatedData: PlayerData[] = []
        for (const item of Data) {
            for (const Item of responseSQL.data) {
                if (item.id === parseInt(Item.playerid)) {
                    calculatedData.push (item)
                }
            }
        }
        const crmPlayerDataStream: Array<{id: string, data: PlayerData[]}> = Object.assign([], Main.Instance.DatabaseDataState.crmPlayerDataStream)
        crmPlayerDataStream[which].data = calculatedData
        Logic.Type.New (Main.Instance.DatabaseDataState, {crmPlayerDataStream})
        // console.log ('SQL ' + which + ' ' +  calculatedData.length)
        // Logic.Type.New (Main.Instance.PlayerGroupsInternal, {calculatedData})
    })
    */
}

/*
export function getCRMRules() {
    axios.get (Config.csRules, {headers: {'x-api-key': Main.Instance.LoginState.token, 'x-api-user': Main.Instance.LoginState.entityId}}).then((responseRules) => {
        const crmPlayerDataStream: Array<{id: string, data: PlayerData[]}> = []

        // here we fill it with empty arrays
        for (const item of responseRules.data) {
            crmPlayerDataStream.push ({id: item.id, data: []})
        }

        // we set the state with rules
        Logic.Type.New (Main.Instance.DatabaseDataState, {
            crmRulesStream: responseRules.data,
            crmPlayerDataStream,
        })
        // console.log (Main.Instance.DatabaseDataState.crmRulesStream.length + ' rules')
        // after setting the state, we need to populate it with recursive function call (I assume here that indeed we have all the data)
        populateRealData(0)

        // Logic.Type.New(Main.Instance.PlayerGroupsInternal, {countCalled:false})
    })
}
*/
/*
export function getNonPendingWithdrawals() {

    Socket1.socket.Send(Config.amWithdrawalsGet, {
        status: Main.Instance.DatabaseDataState.onlyWithdrawalRequestStatus,
        page: 1,
        limit: Main.Instance.DatabaseDataState.withdrawalsLimit
    })
    if (!Main.Instance.DatabaseDataState.WithdrawalRequest2) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { 
            withdrawalRequestTemp: [],
            WithdrawalRequest2: true,
            withdrawalsPage: 1
        })
    }
}
*/
/*
export function getWallet(status: TransactionStatus) {
    if (status) {
        Logic.Type.New(Main.Instance.DatabaseDataState, {
            wallet: true,
            walletStatus: status,
            allWithdrawalHistory: false
        })
        Socket1.socket.Send(Config.amWithdrawalsGet, { status })
    } else {
        Logic.Type.New(Main.Instance.DatabaseDataState, {
            wallet: true,
            walletStatus: TransactionStatus.APPROVED,
            allWithdrawalHistory: true,
            allWithdrawalHistoryCSV: status === null ? true : false
        })
        // console.log ('status: ' + status)
        // console.log ('allWithdrawalHistoryCSV '  + Main.Instance.DatabaseDataState.allWithdrawalHistoryCSV)
        Socket1.socket.Send(Config.amWithdrawalsGet, { status: Main.Instance.DatabaseDataState.walletStatus })
        // console.log ('new status:' + TransactionStatus[TransactionStatus.APPROVED])
    }
}
*/
/*
function GetTimestamps(pending: WithdrawalHistory, approved: string, rejected: string, canceled: string, executed: string, completed: string, deniedbybank: string): WithdrawalHistory {
    // console.log (pending)
    if (approved) {
        const Approved: string = Config.getTZ(approved, Assets_.SwissTime)
        pending.times[TransactionStatusIndex.APPROVED] = {
            utc: approved,
            date: Approved.substring(0, 10),
            time: Approved.substring(11, 19)
        }
    }

    if (rejected) {
        const Rejected: string = Config.getTZ(rejected, Assets_.SwissTime)
        pending.times[TransactionStatusIndex.REJECTED] = {
            utc: rejected,
            date: Rejected.substring(0, 10),
            time: Rejected.substring(11, 19)
        }
    }

    if (canceled) {
        const Canceled: string = Config.getTZ(canceled, Assets_.SwissTime)
        pending.times[TransactionStatusIndex.CANCELED] = {
            utc: canceled,
            date: Canceled.substring(0, 10),
            time: Canceled.substring(11, 19)
        }
    }

    if (executed) {
        const Executed: string = Config.getTZ(executed, Assets_.SwissTime)
        pending.times[TransactionStatusIndex.EXECUTED] = {
            utc: executed,
            date: Executed.substring(0, 10),
            time: Executed.substring(11, 19)
        }
    }

    if (completed) {
        const Completed: string = Config.getTZ(completed, Assets_.SwissTime)
        pending.times[TransactionStatusIndex.COMPLETED] = {
            utc: completed,
            date: Completed.substring(0, 10),
            time: Completed.substring(11, 19)
        }
    }

    if (deniedbybank) {
        const Deniedbybank: string = Config.getTZ(deniedbybank, Assets_.SwissTime)
        pending.times[TransactionStatusIndex.DENIEDBYBANK] = {
            utc: deniedbybank,
            date: Deniedbybank.substring(0, 10),
            time: Deniedbybank.substring(11, 19)
        }
    }
    return pending
}
*/
/*
function getTimestamps(approved: string, rejected: string, canceled: string, executed: string, completed: string, deniedbybank: string): string {
    let s: string = ','
    if (approved) {
        const Approved: string = Config.getTZ(approved, Assets_.SwissTime)
        s += approved + ',' + Approved.substring(0, 10) + ',' + Approved.substring(11, 19)
    } else {
        s += ',,'
    }
    s += ','
    if (rejected) {
        const Rejected: string = Config.getTZ(rejected, Assets_.SwissTime)
        s += rejected + ',' + Rejected.substring(0, 10) + ',' + Rejected.substring(11, 19)
    } else {
        s += ',,'
    }
    s += ','
    if (canceled) {
        const Canceled: string = Config.getTZ(canceled, Assets_.SwissTime)
        s += canceled + ',' + Canceled.substring(0, 10) + ',' + Canceled.substring(11, 19)
    } else {
        s += ',,'
    }
    s += ','
    if (executed) {
        const Executed: string = Config.getTZ(executed, Assets_.SwissTime)
        s += executed + ',' + Executed.substring(0, 10) + ',' + Executed.substring(11, 19)
    } else {
        s += ',,'
    }
    s += ','
    if (completed) {
        const Completed: string = Config.getTZ(completed, Assets_.SwissTime)
        s += completed + ',' + Completed.substring(0, 10) + ',' + Completed.substring(11, 19)
    } else {
        s += ',,'
    }
    s += ','
    if (deniedbybank) {
        const Deniedbybank: string = Config.getTZ(deniedbybank, Assets_.SwissTime)
        s += deniedbybank + ',' + Deniedbybank.substring(0, 10) + ',' + Deniedbybank.substring(11, 19)
    } else {
        s += ',,'
    }
    return s
}
*/
/*
function addWallet(s: string, S: WithdrawalHistory[], ID: number, w: WithdrawalRequest[]) {
    if (ID < w.length) {
        if ((!Main.Instance.DatabaseDataState.allWithdrawalHistory ||
            Main.Instance.DatabaseDataState.walletStatus === TransactionStatus.APPROVED) && ID === 0) {
            // console.log ('STARTED')
            // s = 'TransactionID,PlayerID,Amount,Timestamp,Status' + '\n'
            s = 'TransactionID,PlayerID,Amount,Pending UTC,Pending Swiss Date,Pending Swiss Time,Approved UTC,Approved Swiss Date,Approved Swiss Time,Rejected UTC,Rejected Swiss Date,Rejected Swiss Time,Canceled UTC,Canceled Swiss Date,Canceled Swiss Time,Executed UTC,Executed Swiss Date,Executed Swiss Time,Completed UTC,Completed Swiss Date,Completed Swiss Time,DeniedByBank UTC,DeniedByBank Swiss Date,DeniedByBank Swiss Time' + '\n'
        }
        //  console.log (ID, w.length)
        // console.log (w[ID])
        const Timestamp: string = new Date(w[ID].created * 1000).toISOString()
        const timestamp: string = Timestamp.substring(0, 10) + ' ' + Timestamp.substring(11, 19)
        const timestampSwissTime: string = Config.getTZ(timestamp, Assets_.SwissTime)
        // s += w[ID].transactionId + ',' + w[ID].playerId + ',' + w[ID].amount + ',' + timestamp + ',' + TransactionStatus[3] + '\n'
        s += w[ID].transactionId + ',' + w[ID].playerId + ',' + w[ID].amount + ',' + timestamp + ',' + timestampSwissTime.substring(0, 10) + ',' + timestampSwissTime.substring(11, 19)
        if (Main.Instance.DatabaseDataState.walletStatus === TransactionStatus.PENDING) {
            s += getTimestamps(undefined, undefined, undefined, undefined, undefined, undefined) + '\n'
            S.push({
                transactionId: w[ID].transactionId,
                playerId: w[ID].playerId,
                amount: w[ID].amount,
                times: [{}, {}, { utc: timestamp, date: timestampSwissTime.substring(0, 10), time: timestampSwissTime.substring(11, 19) }, {}, {}, {}, {}]
            })
            ID++
            return addWallet(s, S, ID, w)
        } else {
            S.push({
                transactionId: w[ID].transactionId,
                playerId: w[ID].playerId,
                amount: w[ID].amount,
                times: [{}, {}, { utc: timestamp, date: timestampSwissTime.substring(0, 10), time: timestampSwissTime.substring(11, 19) }, {}, {}, {}, {}]
            })
            Logic.Type.New(Main.Instance.DatabaseDataState, { WithdrawalHistory: true, s, S })
            // console.log ('before getting history')
            Socket1.socket.Send(Config.amWithdrawalHistoryGet, { transactionId: w[ID].transactionId })
        }
    } else {
        // console.log ('FINALLY')
        if (!Main.Instance.DatabaseDataState.allWithdrawalHistory ||
            Main.Instance.DatabaseDataState.walletStatus === TransactionStatus.DENIEDBYBANK) {
            // click
            // console.log (s)
            let ss: string = ''
            if (Main.Instance.DatabaseDataState.allWithdrawalHistoryCSV) {
                ss = generateWithdrawalsReport(S)
            }
            const element = document.createElement('a')
            const file = new Blob([Main.Instance.DatabaseDataState.allWithdrawalHistoryCSV ? ss : s], { type: 'text/csv' })
            element.href = URL.createObjectURL(file)
            element.download = (Main.Instance.DatabaseDataState.allWithdrawalHistory ? Assets.All : TransactionStatus[Main.Instance.DatabaseDataState.walletStatus]) + ' ' + (new Date()).toISOString().substring(0, 19).replace(':', '-').replace(':', '-').replace('T', ' ') + (Assets_._csv)
            // element.click()
            element.dispatchEvent(new MouseEvent(`click`, { bubbles: true, cancelable: true, view: window }))
            Logic.Type.New(Main.Instance.DatabaseDataState, { Wallet: false, allWithdrawalHistory: false })
        } else {
            Logic.Type.New(Main.Instance.DatabaseDataState, {
                // s,
                wallet: true,
                walletStatus: Main.Instance.DatabaseDataState.walletStatus + 1
            })
            // console.log (Main.Instance.DatabaseDataState.s)
            // console.log ('new status: ' + TransactionStatus[Main.Instance.DatabaseDataState.walletStatus])
            // console.log ('wallet: ' + Main.Instance.DatabaseDataState.wallet)
            // console.log ('wh: ' + Main.Instance.DatabaseDataState.WithdrawalHistory)
            Socket1.socket.Send(Config.amWithdrawalsGet, {
                status: Main.Instance.DatabaseDataState.walletStatus
            })
        }
    }
}
*/
/*
export function getPlayersInfo() {
    Socket1.socket.Send(Config.amGetPlayersInfo, {})
}
*/
/*
interface Stats {
    date: string
    pn: number
    pv: number
    cn: number
    cv: number
    xn: number
    xv: number
}
*/
/*
function byDate(a, b): number {
    return a.date > b.date ? 1 : -1
}
*/
/*
function generateWithdrawalsReport(S: WithdrawalHistory[]): string {
    let s: string = 'Date,Pending Withdrawals number,Pending Withdrawals value,Completed Withdrawals number,Completed Withdrawals value,Cancelled Withdrawals number,Cancelled Withdrawals value' + '\n'
    const stats: Stats[] = []
    const completed: WithdrawalHistory[] = []
    for (const item of S) {
        if (item.times) {
            for (let i: number = 0; i < item.times.length; i++) {
                if (item.times === undefined || item.times[i].date === undefined) { continue }
                let found: boolean = false
                for (const Item of stats) {
                    if (Item.date === item.times[i].date) {
                        found = true
                        break
                    }
                }
                if (!found) {
                    stats.push({ date: item.times[i].date, pn: 0, pv: 0, cn: 0, cv: 0, xn: 0, xv: 0 })
                }
                if (i === TransactionStatusIndex.COMPLETED && item.times[i].date === '2019-07-15') {
                    completed.push(item)
                }
            }
        }
    }
    // console.log (completed)
    // console.log (stats)
    for (const ITEM of stats) {
        for (const item of S) {
            if (item.times && item.times[TransactionStatusIndex.DENIEDBYBANK] && item.times[TransactionStatusIndex.DENIEDBYBANK].date === ITEM.date) {
                ITEM.xn++
                ITEM.xv += item.amount
            } else if (item.times && item.times[TransactionStatusIndex.CANCELED] && item.times[TransactionStatusIndex.CANCELED].date === ITEM.date) {
                ITEM.xn++
                ITEM.xv += item.amount
            } else if (item.times && item.times[TransactionStatusIndex.REJECTED] && item.times[TransactionStatusIndex.REJECTED].date === ITEM.date) {
                ITEM.xn++
                ITEM.xv += item.amount
            } else if (item.times && item.times[TransactionStatusIndex.COMPLETED] && item.times[TransactionStatusIndex.COMPLETED].date === ITEM.date) {
                ITEM.cn++
                ITEM.cv += item.amount
            } // else
            if (item.times && item.times[TransactionStatusIndex.PENDING] && item.times[TransactionStatusIndex.PENDING].date === ITEM.date) {
                ITEM.pn++
                ITEM.pv += item.amount
            }
        }
    }
    for (const ITEM of stats) {
        ITEM.xv = parseFloat(ITEM.xv.toFixed(2))
        ITEM.cv = parseFloat(ITEM.cv.toFixed(2))
        ITEM.pv = parseFloat(ITEM.pv.toFixed(2))
    }
    // console.log (stats)
    //  let s: string = 'Date,Pending Withdrawals number,Pending Withdrawals value,Completed Withdrawals number,Completed Withdrawals value,Cancelled Withdrawals number,Cancelled Withdrawals value' + '\n'

    //     stats = stats.sort(byDate)

    for (const ITEM of stats.sort(byDate)) {
        s += ITEM.date + ',' + ITEM.pn + ',' + ITEM.pv + ',' + ITEM.cn + ',' + ITEM.cv + ',' + ITEM.xn + ',' + ITEM.xv + '\n'
    }

    return s
}
*/
/*
function findIndex(date: string, stats: Stats[]): number {
    for (let i: number = 0; i < stats.length; i++) {
        if (date === stats[i].date) {
            return i
        }
    }
    return -1
}
*/

export function getGameSessions(playerId?: string, a3?: string, a4?: string) {
    
    const filters = {
        playerId: playerId ? playerId : Main.Instance.DatabaseDataState.playerCard.playerId,
        page: Main.Instance.PlayerCardState.gameSessionPage + 1,
        pageSize: Main.Instance.PlayerCardState.gameSessionLimit,
        gameSessionStatus: Main.Instance.DatabaseDataState.gs ? Main.Instance.DatabaseDataState.gs : undefined,
        dateFrom: a3 ? a3 : Main.Instance.DatabaseDataState.d3 ? Main.Instance.DatabaseDataState.d3.format(Assets_.dateDisplayFormat) + ' ' + Main.Instance.DatabaseDataState.t3 : undefined,
        dateTo: a4 ? a4 : Main.Instance.DatabaseDataState.d4 ? Main.Instance.DatabaseDataState.d4.format(Assets_.dateDisplayFormat) + ' ' + Main.Instance.DatabaseDataState.t4 : undefined
    }
    Socket1.socket.Send(Config.walletGameSessionsGet, filters)
    getLoadedResources('Socket1 - Send', Config.walletGameSessionsGet)
    Socket1.socket.Get<RouteClasses.Route>(Config.walletGameSessionsGet).loading = 'init'
    if (Main.Instance.PlayerCardState.gameSessions) {
        Logic.Type.New(Main.Instance.PlayerCardState, {
            GameSessionsGet: true,
            gettingGameSessions: true,
            GameSessions: false,
            gameSessionsTransactions: undefined,
            gameSessionSelectedId: undefined
        })
    }

}

export function getGameSessionsTransactions() {
    
    if (Main.Instance.PlayerCardState.gameSessionsTransactions) {
        Logic.Type.New(Main.Instance.PlayerCardState, {
            GameSessionsTransactionsGet: true,
            selectingGameSessionId: true,
            gameSessionsTransactions: undefined
        })
    }
    /*
        const filters: ITransactionFilters = {
            transactionStatus: Main.Instance.DatabaseDataState.ts ? [Main.Instance.DatabaseDataState.ts] : undefined,
            transactionType: Main.Instance.DatabaseDataState.tt ? [Main.Instance.DatabaseDataState.tt] : undefined,
            dateFrom: Main.Instance.DatabaseDataState.d1 ? Main.Instance.DatabaseDataState.d1.format(Assets_.dateDisplayFormat) + ' ' + Main.Instance.DatabaseDataState.t1 : undefined,
            dateTo: Main.Instance.DatabaseDataState.d2 ? Main.Instance.DatabaseDataState.d2.format(Assets_.dateDisplayFormat) + ' ' + Main.Instance.DatabaseDataState.t2 : undefined
        }
    */

    Socket1.socket.Send(Config.walletGameTransactionsGet, {
        gameSessionId: Main.Instance.PlayerCardState.gameSessionSelectedId,
        page: Main.Instance.PlayerCardState.gameSessionTransactionsPage + 1,
        pageSize: Main.Instance.PlayerCardState.gameSessionTransactionsLimit
    })
 
    getLoadedResources('Socket1 - Send', Config.walletGameTransactionsGet)
    Socket1.socket.Get<RouteClasses.Route>(Config.walletGameTransactionsGet).loading = 'init'

    // Main.Instance.PlayerCardState.gameSessionsTransactions = []
    /*
        Socket1.socket.Send(Config.amGameSessionTransactionsGet, {
            gameSessionId: Main.Instance.PlayerCardState.gameSessionSelectedId,
            filters,
            page: Main.Instance.PlayerCardState.gameSessionTransactionsPage + 1,
            limit: Main.Instance.PlayerCardState.gameSessionTransactionsLimit
        })
    */
}

export function getBonusCampaignReports(campaignId: number, bonusId: number, bonusCode: string, playerId: string, dateFrom: string, dateTo: string) {
    if (Main.Instance.DatabaseDataState.bonusCampaignReports && !Main.Instance.DatabaseDataState.BonusCampaignReportsGet) {
        Logic.Type.New(Main.Instance.DatabaseDataState, { BonusCampaignReportsGet: true })
    }

    const args = {
        limit: Main.Instance.DatabaseDataState.bonusCampaignReportsLimit,
        page: Main.Instance.DatabaseDataState.bonusCampaignReportsPage + 1,
        campaignId: campaignId ? campaignId : undefined,
        bonusId: bonusId ? bonusId : undefined,
        bonusCode: bonusCode !== Assets.All ? bonusCode : undefined,
        playerId: playerId !== '0' && playerId.length > 0 ? playerId : undefined,
        dateFrom,
        dateTo
    }
    // Socket1.socket.Send(Config.amBonusTriggeredInfoGet, args)
    // getLoadedResources('Socket1 - Send', Config.amBonusTriggeredInfoGet)
    Socket1.socket.Send(Config.bonusBonusTriggeredInfo, args)
    getLoadedResources('Socket1 - Send', Config.bonusBonusTriggeredInfo)
}

/*
export function getBonus() {
    Logic.Type.New(Main.Instance.DatabaseDataState, { BonusGet: true })
    wsBasicGet(Config.amBonus)
}
*/

export function getBonusInfo(playerId: string) {
    // if (Main.Instance.PlayerCardState.bonusInfo && !Main.Instance.PlayerCardState.BonusInfoGet) {
    Logic.Type.New(Main.Instance.PlayerCardState, { BonusInfoGet: true })
    // }
    // Socket1.socket.Send(Config.amBonusGetAll, { playerId })
    Socket1.socket.Send(Config.bonusPlayerBonusHistory, { playerId })
    getLoadedResources('Socket1 - Send', Config.bonusPlayerBonusHistory)
}

/*
export function activateBonus(playerId: string, bonusId: number) {
    if (confirm(Assets.activateBonus + Assets._with_ + Assets.ID + ' ' + bonusId + '?')) {
        Logic.Type.New(Main.Instance.PlayerCardState, { BonusActivate: true })
        Socket1.socket.Send(Config.amBonusActivate, { playerId, bonusId })

    }
}
*/

export function cancelBonus(playerId: string, bonusId?: number, walletId?: number) {
    if (confirm(Assets.cancelAllBonus + Assets._with_ + Assets.ID + ' ' + bonusId + '?')) {
        Logic.Type.New(Main.Instance.PlayerCardState, { BonusCancel: true })
        // Socket1.socket.Send(Config.amBonusCancel, { playerId, bonusId })
        if (bonusId) {
            Socket1.socket.Send(Config.bonusCancelBonus, { eventId: 'eventId', bonusInstanceId: +bonusId })
        } else {
            Socket1.socket.Send(Config.bonusCancelBonus, { eventId: 'eventId', walletId, playerId })
        }
        

    }
}

export function cancelAllBonuses(playerId: string) {
    if (confirm(Assets.cancelAllBonuses)) {
        Logic.Type.New(Main.Instance.PlayerCardState, { BonusCancelAll: true })
        // Socket1.socket.Send(Config.amBonusCancelAll, { playerId })
        Socket1.socket.Send(Config.bonusCancelBonusAll, { playerId, eventId: playerId })
    }
}

export function addBonusManualCode(playerId: string, bonusCode: string, comment?: string) {
    Logic.Type.New(Main.Instance.PlayerCardState, { BonusAddManualCode: true })
    // Socket1.socket.Send(Config.amBonusAddManualCode, { playerId, bonusCode })
    Socket1.socket.Send(Config.bonusBonusAddManualCode, { createdBy: Main.Instance.LoginState.id, playerId, bonusCode, comment: comment ? comment : undefined, eventId: 'eventId' })
}

/*
export function addBonusManualDeposit(playerId: string, bonusId: number, amount: number) {
    Logic.Type.New(Main.Instance.PlayerCardState, { BonusAddManualDeposit: true })
    Socket1.socket.Send(Config.bonusBonusAddManualDeposit, { playerId, bonusId, grantedAmount: amount, eventId: 'eventId' })
}
*/
export function addBonusManual(playerId: string, amount: number, bonusId: number, wr?: number, qualifyingShareAmount?: number, comment?: string/*, baseWageringRequirement: number, wageringRequirements: BonusDataWageringRequirement[]*/) {
    // const baseWageringRequirement: number = 30
    // const wageringRequirements: BonusDataWageringRequirement[] = [
    //     { category: 1, /*wrx: 30,*/ contribution: 100 },
    //     { category: 2, /*wrx: 90,*/ contribution: 33.33 },
    //     { category: 3, /*wrx: 90,*/ contribution: 33.33 },
    //     { category: 4, /*wrx: 90,*/ contribution: 33.33 },
    //     { category: 5, /*wrx: 90,*/ contribution: 33.33 },
    //     { category: 6, /*wrx: 90,*/ contribution: 33.33 },
    //     { category: 7, /*wrx: 90,*/ contribution: 33.33 }
    // ]
    Logic.Type.New(Main.Instance.PlayerCardState, { BonusAddManual: true })
    // Socket1.socket.Send(Config.amBonusAddManual, { playerId, amount, baseWageringRequirement, wageringRequirements })
    Socket1.socket.Send(Config.bonusBonusAddManualCustom, { createdBy: Main.Instance.LoginState.id, playerId, amount, eventId: 'eventId', bonusId, wageringReq: wr ? wr : undefined, qualifyingShareAmount: qualifyingShareAmount ? qualifyingShareAmount : undefined, comment: comment ? comment : undefined  })
}

export function getDashboardBackendIssues(filters: IIssuesFilters) {

    // Logic.Type.New (Main.Instance.DatabaseDataState, {DashboardBackend: true})
    // Socket1.socket.Send (Config.amGetIssues, {filters})
    // filters.resolved = false
    /*
        filters.minIssueType = Main.Instance.DatabaseDataState.issuesFilterIssueTypeDB === 999 ?
            IssueTypes.DashboardBackend :
            Main.Instance.DatabaseDataState.issuesFilterIssueTypeDB as any
        filters.maxIssueType = Main.Instance.DatabaseDataState.issuesFilterIssueTypeDB === 999 ?
            IssueTypes.Other2 - 1 :
            Main.Instance.DatabaseDataState.issuesFilterIssueTypeDB as any
    */

    Logic.Type.New(Main.Instance.DatabaseDataState, {
        issues0Page: 1,
        // whichIssuesToGet: TimelineEntrySubType.DashboardBackend
    })
    getPaginatedIssues(
        filters,
        1,
        Main.Instance.DatabaseDataState.issues0Limit,
        TimelineEntrySubType.DashboardBackend,
        Main.Instance.DatabaseDataState.issuesFilterIssueTypeDB
    )
}

export function getAllIssues(filters: IIssuesFilters, page: number, limit: number) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { AllIssuesFilter: true })
    Socket1.socket.Send(Config.amGetIssues, { filters, page, limit })
    getLoadedResources('Socket1 - Send', Config.amGetIssues, JSON.stringify(filters))
}

export function getPaginatedIssues(filters: IIssuesFilters, page: number, limit: number, whichIssuesToGet: TimelineEntrySubType, issueType: number) {
    if (/*!Main.Instance.DatabaseDataState.isGettingIssues && */!Main.Instance.DatabaseDataState.IssuesGet) {
        if (filters.minIssueType && filters.maxIssueType) {
            const issueType = getIssueTypes(filters.minIssueType, filters.maxIssueType)
            filters.issueType = issueType;
            delete(filters.minIssueType);
            delete(filters.maxIssueType)
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { IssuesGet: true, whichIssuesToGet, issueType })
        Socket1.socket.Send(Config.amGetIssues, { filters, page, limit })
        getLoadedResources('Socket1 - Send', Config.amGetIssues, JSON.stringify(filters))
    }
}

function convertToUnix(which: string, from: boolean): number {
    if (which === undefined) { return undefined }
    const time: number = Math.floor((new Date(which)).getTime() / 1000)
    return from ? time : time + 24 * 60 * 60 - 1
}

export function dashboardBackendCount() {
    // console.log('SEND')
    Logic.Type.New(Main.Instance.DatabaseDataState, { IssuesCount: 101 })
    Socket1.socket.Send(Config.amGetIssuesCount, { filters: {} })
    getLoadedResources('Socket1 - Send', Config.amGetIssuesCount)
}

export function getTournamentLeaderboard(tournamentId: number, tournamentDate: number) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { TournamentLeaderboardGet: true })
    Socket1.socket.Send(Config.amGetTournamentLeaderboard, { tournamentId, tournamentDate })
    getLoadedResources('Socket1 - Send', Config.amGetTournamentLeaderboard)
}
export function getChancesLeaderboard(/* page: number, limit: number */dateFrom, dateTo) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { missionLeaderboardGet: true })

    Socket1.socket.Send(Config.amGetMissionLeaderboard, { dateFrom, dateTo })
    getLoadedResources('Socket1 - Send', Config.amGetMissionLeaderboard)
}

export function changePlayerLevel(id: string, levelId: number) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { isChangingPlayerLevel: true })
    Socket1.socket.Send(Config.amChangePlayerLevel, { id, levelId })
    insertAdminLog(Config.asAdminLogSaveEdit, 'Gamification -> Change Player Level', { id, levelId })
}

export function getGameReportsReal(gameId, yearFrom, yearTo, monthFrom, monthTo, dayFrom, dayTo) {

    if (Main.Instance.DatabaseDataState.gameReportsRealGet === false) {
        
        Socket1.socket.Send(Config.walletGameReportsReal, {gameId, yearFrom, yearTo, monthFrom, monthTo, dayFrom, dayTo})
        getLoadedResources('Socket1 - Send', Config.walletGameReportsReal)
        Logic.Type.New(Main.Instance.DatabaseDataState, { gameReportsRealGet: true })
        Socket1.socket.Get<RouteClasses.Route>(Config.walletGameReportsReal).loading  = 'loading'
    }
}

export function getGameReportsTest(gameId, yearFrom, yearTo, monthFrom, monthTo, dayFrom, dayTo) {

    if (Main.Instance.DatabaseDataState.gameReportsTestGet === false) {
        Socket1.socket.Send(Config.walletGameReportsTest, {gameId, yearFrom, yearTo, monthFrom, monthTo, dayFrom, dayTo})
        getLoadedResources('Socket1 - Send', Config.walletGameReportsTest)
        Socket1.socket.Get<RouteClasses.Route>(Config.walletGameReportsTest).loading  = 'loading'
        Logic.Type.New(Main.Instance.DatabaseDataState, { gameReportsTestGet: true })
    }
}

export function getPlayerReports(playerId, yearFrom, yearTo, monthFrom, monthTo, dayFrom, dayTo) {
    
    if (Main.Instance.DatabaseDataState.playerReportsGet === false) {
        Socket1.socket.Send(Config.walletPlayerReports, {playerId, yearFrom, yearTo, monthFrom, monthTo, dayFrom, dayTo})
        getLoadedResources('Socket1 - Send', Config.walletPlayerReports)
        Socket1.socket.Get<RouteClasses.Route>(Config.walletPlayerReports).loading  = 'loading'
        Logic.Type.New(Main.Instance.DatabaseDataState, { playerReportsGet: true })
    }
}

export function getUsersInfoFiltered(limit?: number, page?: number, filter?) { 
    if (Main.Instance.DatabaseDataState.usersInfoFilteredGet === false) {
        const filters = filter ? filter : {}
        getLoadedResources('Socket1 - Send', Config.amGetUsersInfoFiltered)
        Socket1.socket.Get<RouteClasses.Route>(Config.amGetUsersInfoFiltered).loading  = 'loading'
        Socket1.socket.Send(Config.amGetUsersInfoFiltered, {filters})
        Logic.Type.New(Main.Instance.DatabaseDataState, { usersInfoFilteredGet: true })
        
    }
}

export function getStorePurchases(limit: number, page: number, playerId?) {
    if (Main.Instance.DatabaseDataState.storePurchasesGet === false) {
        getLoadedResources('Socket1 - Send', Config.amGetStorePurchases)
        Socket1.socket.Get<RouteClasses.Route>(Config.amGetStorePurchases).loading  = 'init'
        if (playerId) {
            Socket1.socket.Send(Config.amGetStorePurchases, {limit, page, playerId})
        } else {
            Socket1.socket.Send(Config.amGetStorePurchases, {limit, page})
        }
        Logic.Type.New(Main.Instance.DatabaseDataState, { storePurchasesGet: true })
    }
}

export function getUserInfo(id) {
    if (id && Main.Instance.DatabaseDataState.userInfoGet === false) {
        getLoadedResources('Socket1 - Send', Config.amGetUserInfo)
        Socket1.socket.Get<RouteClasses.Route>(Config.amGetUserInfo).loading  = 'init'
        Socket1.socket.Send(Config.amGetUserInfo, {id})    
        Logic.Type.New(Main.Instance.DatabaseDataState, { userInfoGet: true})

    }
}

export function thereIsNoneGeneratedPaymentFiles(): boolean {
    if (Main.Instance.DatabaseDataState.paymentProcessed === undefined || Main.Instance.DatabaseDataState.paymentProcessed === null) {return false}
    if (Main.Instance.DatabaseDataState.paymentProcessed.length === 0) { return true }
    const item: PaymentProcessed = Main.Instance.DatabaseDataState.paymentProcessed[Main.Instance.DatabaseDataState.paymentProcessed.length - 1]
    if (item.data && item.data.status === PaymentProcessedStatus.Generated) { return false}
/*
    for (const item of Main.Instance.DatabaseDataState.paymentProcessed) {
        if (item.data.status === PaymentProcessedStatus.Generated) {
            return false
        }
    }
*/
    return true
}

export function insertUpdateBonus(bonus: BonusNew) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { bonusNewUpdate: true })
    if (!bonus.senderId) {
        bonus.senderId = 'admin'
    }
    if (!bonus.id) {
        bonus.id = bonus.bonusId 
        delete(bonus.bonusId)
    }
    Socket1.socket.Send(Config.bonusBonusSave, bonus )
    getLoadedResources('Socket1 - Send', Config.bonusBonusSave)
    insertAdminLog(Config.asAdminLogSaveInsert, 'Bonus Section -> Bonus', bonus)
}

export function insertUpdateBunusCampaign(bonusCampaign: BonusCampaignNew) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { bonusCampaignNewUpdate: true })
    if (bonusCampaign.id) {
        Socket1.socket.Send(Config.bonusBonusCampaignUpdate, bonusCampaign )
        getLoadedResources('Socket1 - Send', Config.bonusBonusCampaignUpdate)
        insertAdminLog(Config.asAdminLogSaveEdit, 'Bonus Section -> Bonus Campaign', bonusCampaign)    
    } else {
        Socket1.socket.Send(Config.bonusBonusCampaignSave, bonusCampaign )
        getLoadedResources('Socket1 - Send', Config.bonusBonusCampaignSave)
        insertAdminLog(Config.asAdminLogSaveInsert, 'Bonus Section -> Bonus Campaign', bonusCampaign)
    }
    
}

export function insertUpdateFreeGame(freeGame:FreeGame) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { freeGameSettingsUpdate: true })
    Socket1.socket.Send(Config.bonusFreeGamesSave, freeGame )
    getLoadedResources('Socket1 - Send', Config.bonusFreeGamesSave)
    insertAdminLog(Config.asAdminLogSaveInsert, 'Bonus Section -> Free Games', freeGame)
}

export function deleteBonus(id: number) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { bonusNewDelete: true })
    Socket1.socket.Send(Config.bonusBonusDelete, {id} )
    getLoadedResources('Socket1 - Send', Config.bonusBonusDelete)
    insertAdminLog(Config.asAdminLogDelete, 'Bonus Section -> Bonus', {id})
}

export function deleteBonusCampaign(id: number) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { bonusCampaignNewDelete: true })
    Socket1.socket.Send(Config.bonusBonusCampaignDelete, {id} )
    getLoadedResources('Socket1 - Send', Config.bonusBonusCampaignDelete)
    insertAdminLog(Config.asAdminLogDelete, 'Bonus Section -> Bonus Campaign', {id})
}

export function deleteFreeGame(gameId: number) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { freeGameSettingsDelete: true })
    Socket1.socket.Send(Config.bonusFreeGamesDelete, {gameId} )
    getLoadedResources('Socket1 - Send', Config.bonusFreeGamesDelete)
    insertAdminLog(Config.asAdminLogDelete, 'Bonus Section -> Free Games', {id: gameId})
}


export function setGloballyExcludedTags() {
    Logic.Type.New(Main.Instance.DatabaseDataState, { globallyExcludedTagsSet: true })
    Socket1.socket.Send(Config.bonusGloballyExcludedTagsSet, {tags: Main.Instance.DatabaseDataState.globallyExcludedTags, eventId: 'event_id'} )
    getLoadedResources('Socket1 - Send', Config.bonusGloballyExcludedTagsSet)
    insertAdminLog(Config.asAdminLogDelete, 'Settings -> Bonus Settings', {tags: Main.Instance.DatabaseDataState.globallyExcludedTags})
}
export function activateBonus(bonusId: number, active: boolean) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { bonusActivate: true })
    Socket1.socket.Send(Config.bonusActivateBonus, {bonusId, activeStatus: active ? 1 : 0, eventId: 'event_id'} )
    getLoadedResources('Socket1 - Send', Config.bonusActivateBonus)
    insertAdminLog(Config.asAdminLogDelete, 'Bonus Section -> Bonus', {id: bonusId, active})
}

export function updatePaymentData(data) {
    Logic.Type.New(Main.Instance.DatabaseDataState, { updatePaymentData: true })
    Socket1.socket.Send(Config.amUpdatePaymentData, data)
    getLoadedResources('Socket1 - Send', Config.amUpdatePaymentData)
    insertAdminLog(Config.asAdminLogSaveEdit, 'Account Store -> Player Card', data)
}
